import 'regenerator-runtime/runtime';
import { OffscreenCanvasCreator, PARSED_COLOR_TYPE, DefaultCamera, Camera, MutationEvent, ElementEvent, parseColor, Shape, LineCap, parsePath, convertToPath, LineJoin, DisplayObject, CanvasConfig, ContextService, RenderingContext, RenderingPluginContribution, CanvasEvent, SceneGraphService, Rectangle, GeometryAABBUpdater, globalContainer } from '@antv/g';
import { singleton, inject, Syringe, injectable, Module } from 'mana-syringe';
import { __decorate, __metadata, __spreadArray, __read } from 'tslib';
import { isNil, clamp, min, max, isNumber } from '@antv/util';
import { EventEmitter } from 'eventemitter3';
import earcut from 'earcut';
import TinySDF from '@mapbox/tiny-sdf';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var Renderable3D = /*#__PURE__*/_createClass(function Renderable3D() {
  _classCallCheck(this, Renderable3D);

  this.pickingId = void 0;
  this.encodedPickingColor = void 0;
  this.meshes = [];
});
Renderable3D.tag = 'c-renderable-3d';

var PickingIdGenerator = /*#__PURE__*/function () {
  function PickingIdGenerator() {
    _classCallCheck(this, PickingIdGenerator);

    this.counter = 0;
    this.id2DisplayObjectMap = {};
  }

  _createClass(PickingIdGenerator, [{
    key: "getId",
    value: function getId(displayObject) {
      var id = this.counter++;
      this.id2DisplayObjectMap[id] = displayObject;
      return id;
    }
  }, {
    key: "getById",
    value: function getById(id) {
      return this.id2DisplayObjectMap[id];
    }
  }, {
    key: "reset",
    value: function reset() {
      this.counter = 0;
      this.id2DisplayObjectMap = {};
    }
  }, {
    key: "decodePickingColor",
    value: function decodePickingColor(color) {
      var _color = _slicedToArray(color, 3),
          i1 = _color[0],
          i2 = _color[1],
          i3 = _color[2];

      var index = i1 + i2 * 256 + i3 * 65536 - 1;
      return index;
    }
  }, {
    key: "encodePickingColor",
    value: function encodePickingColor(featureIdx) {
      return [featureIdx + 1 & 255, featureIdx + 1 >> 8 & 255, featureIdx + 1 >> 8 >> 8 & 255];
    }
  }]);

  return PickingIdGenerator;
}();

PickingIdGenerator = __decorate([singleton()], PickingIdGenerator);

var ResourceType;

(function (ResourceType) {
  ResourceType[ResourceType["Buffer"] = 0] = "Buffer";
  ResourceType[ResourceType["Texture"] = 1] = "Texture";
  ResourceType[ResourceType["RenderTarget"] = 2] = "RenderTarget";
  ResourceType[ResourceType["Sampler"] = 3] = "Sampler";
  ResourceType[ResourceType["Program"] = 4] = "Program";
  ResourceType[ResourceType["Bindings"] = 5] = "Bindings";
  ResourceType[ResourceType["InputLayout"] = 6] = "InputLayout";
  ResourceType[ResourceType["InputState"] = 7] = "InputState";
  ResourceType[ResourceType["RenderPipeline"] = 8] = "RenderPipeline";
  ResourceType[ResourceType["ComputePipeline"] = 9] = "ComputePipeline";
  ResourceType[ResourceType["Readback"] = 10] = "Readback";
  ResourceType[ResourceType["QueryPool"] = 11] = "QueryPool";
})(ResourceType || (ResourceType = {}));

var CompareMode;

(function (CompareMode) {
  CompareMode[CompareMode["Never"] = 512] = "Never";
  CompareMode[CompareMode["Less"] = 513] = "Less";
  CompareMode[CompareMode["Equal"] = 514] = "Equal";
  CompareMode[CompareMode["LessEqual"] = 515] = "LessEqual";
  CompareMode[CompareMode["Greater"] = 516] = "Greater";
  CompareMode[CompareMode["NotEqual"] = 517] = "NotEqual";
  CompareMode[CompareMode["GreaterEqual"] = 518] = "GreaterEqual";
  CompareMode[CompareMode["Always"] = 519] = "Always";
})(CompareMode || (CompareMode = {}));

var FrontFaceMode;

(function (FrontFaceMode) {
  FrontFaceMode[FrontFaceMode["CCW"] = 2305] = "CCW";
  FrontFaceMode[FrontFaceMode["CW"] = 2304] = "CW";
})(FrontFaceMode || (FrontFaceMode = {}));

var CullMode;

(function (CullMode) {
  CullMode[CullMode["None"] = 0] = "None";
  CullMode[CullMode["Front"] = 1] = "Front";
  CullMode[CullMode["Back"] = 2] = "Back";
  CullMode[CullMode["FrontAndBack"] = 3] = "FrontAndBack";
})(CullMode || (CullMode = {}));

var BlendFactor;

(function (BlendFactor) {
  BlendFactor[BlendFactor["Zero"] = 0] = "Zero";
  BlendFactor[BlendFactor["One"] = 1] = "One";
  BlendFactor[BlendFactor["Src"] = 768] = "Src";
  BlendFactor[BlendFactor["OneMinusSrc"] = 769] = "OneMinusSrc";
  BlendFactor[BlendFactor["Dst"] = 774] = "Dst";
  BlendFactor[BlendFactor["OneMinusDst"] = 775] = "OneMinusDst";
  BlendFactor[BlendFactor["SrcAlpha"] = 770] = "SrcAlpha";
  BlendFactor[BlendFactor["OneMinusSrcAlpha"] = 771] = "OneMinusSrcAlpha";
  BlendFactor[BlendFactor["DstAlpha"] = 772] = "DstAlpha";
  BlendFactor[BlendFactor["OneMinusDstAlpha"] = 773] = "OneMinusDstAlpha";
})(BlendFactor || (BlendFactor = {}));

var BlendMode;

(function (BlendMode) {
  BlendMode[BlendMode["Add"] = 32774] = "Add";
  BlendMode[BlendMode["Subtract"] = 32778] = "Subtract";
  BlendMode[BlendMode["ReverseSubtract"] = 32779] = "ReverseSubtract";
})(BlendMode || (BlendMode = {}));

var WrapMode;

(function (WrapMode) {
  WrapMode[WrapMode["Clamp"] = 0] = "Clamp";
  WrapMode[WrapMode["Repeat"] = 1] = "Repeat";
  WrapMode[WrapMode["Mirror"] = 2] = "Mirror";
})(WrapMode || (WrapMode = {}));

var TexFilterMode;

(function (TexFilterMode) {
  TexFilterMode[TexFilterMode["Point"] = 0] = "Point";
  TexFilterMode[TexFilterMode["Bilinear"] = 1] = "Bilinear";
})(TexFilterMode || (TexFilterMode = {}));

var MipFilterMode;

(function (MipFilterMode) {
  MipFilterMode[MipFilterMode["NoMip"] = 0] = "NoMip";
  MipFilterMode[MipFilterMode["Nearest"] = 1] = "Nearest";
  MipFilterMode[MipFilterMode["Linear"] = 2] = "Linear";
})(MipFilterMode || (MipFilterMode = {}));

var PrimitiveTopology;

(function (PrimitiveTopology) {
  PrimitiveTopology[PrimitiveTopology["Points"] = 0] = "Points";
  PrimitiveTopology[PrimitiveTopology["Triangles"] = 1] = "Triangles";
  PrimitiveTopology[PrimitiveTopology["TriangleStrip"] = 2] = "TriangleStrip";
  PrimitiveTopology[PrimitiveTopology["Lines"] = 3] = "Lines";
  PrimitiveTopology[PrimitiveTopology["LineStrip"] = 4] = "LineStrip";
})(PrimitiveTopology || (PrimitiveTopology = {}));
/**
 * @see https://www.w3.org/TR/webgpu/#buffer-usage
 */


var BufferUsage;

(function (BufferUsage) {
  BufferUsage[BufferUsage["MAP_READ"] = 1] = "MAP_READ";
  BufferUsage[BufferUsage["MAP_WRITE"] = 2] = "MAP_WRITE";
  BufferUsage[BufferUsage["COPY_SRC"] = 4] = "COPY_SRC";
  BufferUsage[BufferUsage["COPY_DST"] = 8] = "COPY_DST";
  BufferUsage[BufferUsage["INDEX"] = 16] = "INDEX";
  BufferUsage[BufferUsage["VERTEX"] = 32] = "VERTEX";
  BufferUsage[BufferUsage["UNIFORM"] = 64] = "UNIFORM";
  BufferUsage[BufferUsage["STORAGE"] = 128] = "STORAGE";
  BufferUsage[BufferUsage["INDIRECT"] = 256] = "INDIRECT";
  BufferUsage[BufferUsage["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
})(BufferUsage || (BufferUsage = {}));

var BufferFrequencyHint;

(function (BufferFrequencyHint) {
  BufferFrequencyHint[BufferFrequencyHint["Static"] = 1] = "Static";
  BufferFrequencyHint[BufferFrequencyHint["Dynamic"] = 2] = "Dynamic";
})(BufferFrequencyHint || (BufferFrequencyHint = {}));

var VertexBufferFrequency;

(function (VertexBufferFrequency) {
  VertexBufferFrequency[VertexBufferFrequency["PerVertex"] = 1] = "PerVertex";
  VertexBufferFrequency[VertexBufferFrequency["PerInstance"] = 2] = "PerInstance";
})(VertexBufferFrequency || (VertexBufferFrequency = {}));

var TextureDimension;

(function (TextureDimension) {
  TextureDimension[TextureDimension["n2D"] = 0] = "n2D";
  TextureDimension[TextureDimension["n2DArray"] = 1] = "n2DArray";
  TextureDimension[TextureDimension["n3D"] = 2] = "n3D";
  TextureDimension[TextureDimension["Cube"] = 3] = "Cube";
})(TextureDimension || (TextureDimension = {}));

var TextureUsage;

(function (TextureUsage) {
  TextureUsage[TextureUsage["Sampled"] = 1] = "Sampled";
  TextureUsage[TextureUsage["RenderTarget"] = 2] = "RenderTarget";
})(TextureUsage || (TextureUsage = {}));

var ChannelWriteMask;

(function (ChannelWriteMask) {
  ChannelWriteMask[ChannelWriteMask["None"] = 0] = "None";
  ChannelWriteMask[ChannelWriteMask["Red"] = 1] = "Red";
  ChannelWriteMask[ChannelWriteMask["Green"] = 2] = "Green";
  ChannelWriteMask[ChannelWriteMask["Blue"] = 4] = "Blue";
  ChannelWriteMask[ChannelWriteMask["Alpha"] = 8] = "Alpha";
  ChannelWriteMask[ChannelWriteMask["RGB"] = 7] = "RGB";
  ChannelWriteMask[ChannelWriteMask["AllChannels"] = 15] = "AllChannels";
})(ChannelWriteMask || (ChannelWriteMask = {}));

var StencilOp;

(function (StencilOp) {
  StencilOp[StencilOp["Keep"] = 7680] = "Keep";
  StencilOp[StencilOp["Zero"] = 0] = "Zero";
  StencilOp[StencilOp["Replace"] = 7681] = "Replace";
  StencilOp[StencilOp["Invert"] = 5386] = "Invert";
  StencilOp[StencilOp["IncrementClamp"] = 7682] = "IncrementClamp";
  StencilOp[StencilOp["DecrementClamp"] = 7683] = "DecrementClamp";
  StencilOp[StencilOp["IncrementWrap"] = 34055] = "IncrementWrap";
  StencilOp[StencilOp["DecrementWrap"] = 34056] = "DecrementWrap";
})(StencilOp || (StencilOp = {}));

function makeTextureDescriptor2D(pixelFormat, width, height, numLevels) {
  var dimension = TextureDimension.n2D,
      depth = 1;
  var usage = TextureUsage.Sampled;
  return {
    dimension: dimension,
    pixelFormat: pixelFormat,
    width: width,
    height: height,
    depth: depth,
    numLevels: numLevels,
    usage: usage
  };
}
var SamplerFormatKind;

(function (SamplerFormatKind) {
  SamplerFormatKind[SamplerFormatKind["Float"] = 0] = "Float";
  SamplerFormatKind[SamplerFormatKind["Uint"] = 1] = "Uint";
  SamplerFormatKind[SamplerFormatKind["Sint"] = 2] = "Sint";
  SamplerFormatKind[SamplerFormatKind["Depth"] = 3] = "Depth";
})(SamplerFormatKind || (SamplerFormatKind = {}));

var ViewportOrigin;

(function (ViewportOrigin) {
  ViewportOrigin[ViewportOrigin["LowerLeft"] = 0] = "LowerLeft";
  ViewportOrigin[ViewportOrigin["UpperLeft"] = 1] = "UpperLeft";
})(ViewportOrigin || (ViewportOrigin = {}));

var ClipSpaceNearZ;

(function (ClipSpaceNearZ) {
  ClipSpaceNearZ[ClipSpaceNearZ["NegativeOne"] = 0] = "NegativeOne";
  ClipSpaceNearZ[ClipSpaceNearZ["Zero"] = 1] = "Zero";
})(ClipSpaceNearZ || (ClipSpaceNearZ = {}));

var QueryPoolType;

(function (QueryPoolType) {
  QueryPoolType[QueryPoolType["OcclusionConservative"] = 0] = "OcclusionConservative";
})(QueryPoolType || (QueryPoolType = {}));

var FormatTypeFlags;

(function (FormatTypeFlags) {
  FormatTypeFlags[FormatTypeFlags["U8"] = 1] = "U8";
  FormatTypeFlags[FormatTypeFlags["U16"] = 2] = "U16";
  FormatTypeFlags[FormatTypeFlags["U32"] = 3] = "U32";
  FormatTypeFlags[FormatTypeFlags["S8"] = 4] = "S8";
  FormatTypeFlags[FormatTypeFlags["S16"] = 5] = "S16";
  FormatTypeFlags[FormatTypeFlags["S32"] = 6] = "S32";
  FormatTypeFlags[FormatTypeFlags["F16"] = 7] = "F16";
  FormatTypeFlags[FormatTypeFlags["F32"] = 8] = "F32"; // Compressed texture formats.

  FormatTypeFlags[FormatTypeFlags["BC1"] = 65] = "BC1";
  FormatTypeFlags[FormatTypeFlags["BC2"] = 66] = "BC2";
  FormatTypeFlags[FormatTypeFlags["BC3"] = 67] = "BC3";
  FormatTypeFlags[FormatTypeFlags["BC4_UNORM"] = 68] = "BC4_UNORM";
  FormatTypeFlags[FormatTypeFlags["BC4_SNORM"] = 69] = "BC4_SNORM";
  FormatTypeFlags[FormatTypeFlags["BC5_UNORM"] = 70] = "BC5_UNORM";
  FormatTypeFlags[FormatTypeFlags["BC5_SNORM"] = 71] = "BC5_SNORM"; // Special-case packed texture formats.

  FormatTypeFlags[FormatTypeFlags["U16_PACKED_5551"] = 97] = "U16_PACKED_5551"; // Depth/stencil texture formats.

  FormatTypeFlags[FormatTypeFlags["D24"] = 129] = "D24";
  FormatTypeFlags[FormatTypeFlags["D32F"] = 130] = "D32F";
  FormatTypeFlags[FormatTypeFlags["D24S8"] = 131] = "D24S8";
  FormatTypeFlags[FormatTypeFlags["D32FS8"] = 132] = "D32FS8";
})(FormatTypeFlags || (FormatTypeFlags = {}));

var FormatCompFlags;

(function (FormatCompFlags) {
  FormatCompFlags[FormatCompFlags["R"] = 1] = "R";
  FormatCompFlags[FormatCompFlags["RG"] = 2] = "RG";
  FormatCompFlags[FormatCompFlags["RGB"] = 3] = "RGB";
  FormatCompFlags[FormatCompFlags["RGBA"] = 4] = "RGBA";
  FormatCompFlags[FormatCompFlags["A"] = 5] = "A";
  FormatCompFlags[FormatCompFlags["MAT3"] = 6] = "MAT3";
  FormatCompFlags[FormatCompFlags["MAT4"] = 7] = "MAT4";
})(FormatCompFlags || (FormatCompFlags = {}));

function getFormatCompFlagsComponentCount(n) {
  // The number of components is the flag value. Easy.
  return n;
}
var FormatFlags;

(function (FormatFlags) {
  FormatFlags[FormatFlags["None"] = 0] = "None";
  FormatFlags[FormatFlags["Normalized"] = 1] = "Normalized";
  FormatFlags[FormatFlags["sRGB"] = 2] = "sRGB";
  FormatFlags[FormatFlags["Depth"] = 4] = "Depth";
  FormatFlags[FormatFlags["Stencil"] = 8] = "Stencil";
  FormatFlags[FormatFlags["RenderTarget"] = 16] = "RenderTarget";
})(FormatFlags || (FormatFlags = {}));

function makeFormat(type, comp, flags) {
  return type << 16 | comp << 8 | flags;
}
var Format;

(function (Format) {
  Format[Format["ALPHA"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.A, FormatFlags.None)] = "ALPHA";
  Format[Format["F16_RG"] = makeFormat(FormatTypeFlags.F16, FormatCompFlags.RG, FormatFlags.None)] = "F16_RG";
  Format[Format["F16_RGB"] = makeFormat(FormatTypeFlags.F16, FormatCompFlags.RGB, FormatFlags.None)] = "F16_RGB";
  Format[Format["F16_RGBA"] = makeFormat(FormatTypeFlags.F16, FormatCompFlags.RGBA, FormatFlags.None)] = "F16_RGBA";
  Format[Format["F32_R"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.R, FormatFlags.None)] = "F32_R";
  Format[Format["F32_RG"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.RG, FormatFlags.None)] = "F32_RG";
  Format[Format["F32_RGB"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.RGB, FormatFlags.None)] = "F32_RGB";
  Format[Format["F32_RGBA"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.RGBA, FormatFlags.None)] = "F32_RGBA";
  Format[Format["F32_MAT3"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.MAT3, FormatFlags.None)] = "F32_MAT3";
  Format[Format["F32_MAT4"] = makeFormat(FormatTypeFlags.F32, FormatCompFlags.MAT4, FormatFlags.None)] = "F32_MAT4";
  Format[Format["U8_R"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.R, FormatFlags.None)] = "U8_R";
  Format[Format["U8_R_NORM"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.R, FormatFlags.Normalized)] = "U8_R_NORM";
  Format[Format["U8_RG"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RG, FormatFlags.None)] = "U8_RG";
  Format[Format["U8_RG_NORM"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RG, FormatFlags.Normalized)] = "U8_RG_NORM";
  Format[Format["U8_RGB"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGB, FormatFlags.None)] = "U8_RGB";
  Format[Format["U8_RGB_NORM"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGB, FormatFlags.Normalized)] = "U8_RGB_NORM";
  Format[Format["U8_RGB_SRGB"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGB, FormatFlags.sRGB | FormatFlags.Normalized)] = "U8_RGB_SRGB";
  Format[Format["U8_RGBA"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGBA, FormatFlags.None)] = "U8_RGBA";
  Format[Format["U8_RGBA_NORM"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGBA, FormatFlags.Normalized)] = "U8_RGBA_NORM";
  Format[Format["U8_RGBA_SRGB"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGBA, FormatFlags.sRGB | FormatFlags.Normalized)] = "U8_RGBA_SRGB";
  Format[Format["U16_R"] = makeFormat(FormatTypeFlags.U16, FormatCompFlags.R, FormatFlags.None)] = "U16_R";
  Format[Format["U16_R_NORM"] = makeFormat(FormatTypeFlags.U16, FormatCompFlags.R, FormatFlags.Normalized)] = "U16_R_NORM";
  Format[Format["U16_RG_NORM"] = makeFormat(FormatTypeFlags.U16, FormatCompFlags.RG, FormatFlags.Normalized)] = "U16_RG_NORM";
  Format[Format["U16_RGBA_NORM"] = makeFormat(FormatTypeFlags.U16, FormatCompFlags.RGBA, FormatFlags.Normalized)] = "U16_RGBA_NORM";
  Format[Format["U16_RGB"] = makeFormat(FormatTypeFlags.U16, FormatCompFlags.RGB, FormatFlags.None)] = "U16_RGB";
  Format[Format["U32_R"] = makeFormat(FormatTypeFlags.U32, FormatCompFlags.R, FormatFlags.None)] = "U32_R";
  Format[Format["U32_RG"] = makeFormat(FormatTypeFlags.U32, FormatCompFlags.RG, FormatFlags.None)] = "U32_RG";
  Format[Format["S8_R"] = makeFormat(FormatTypeFlags.S8, FormatCompFlags.R, FormatFlags.None)] = "S8_R";
  Format[Format["S8_R_NORM"] = makeFormat(FormatTypeFlags.S8, FormatCompFlags.R, FormatFlags.Normalized)] = "S8_R_NORM";
  Format[Format["S8_RG_NORM"] = makeFormat(FormatTypeFlags.S8, FormatCompFlags.RG, FormatFlags.Normalized)] = "S8_RG_NORM";
  Format[Format["S8_RGB_NORM"] = makeFormat(FormatTypeFlags.S8, FormatCompFlags.RGB, FormatFlags.Normalized)] = "S8_RGB_NORM";
  Format[Format["S8_RGBA_NORM"] = makeFormat(FormatTypeFlags.S8, FormatCompFlags.RGBA, FormatFlags.Normalized)] = "S8_RGBA_NORM";
  Format[Format["S16_R"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.R, FormatFlags.None)] = "S16_R";
  Format[Format["S16_RG"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.RG, FormatFlags.None)] = "S16_RG";
  Format[Format["S16_RG_NORM"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.RG, FormatFlags.Normalized)] = "S16_RG_NORM";
  Format[Format["S16_RGB_NORM"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.RGB, FormatFlags.Normalized)] = "S16_RGB_NORM";
  Format[Format["S16_RGBA"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.RGBA, FormatFlags.None)] = "S16_RGBA";
  Format[Format["S16_RGBA_NORM"] = makeFormat(FormatTypeFlags.S16, FormatCompFlags.RGBA, FormatFlags.Normalized)] = "S16_RGBA_NORM";
  Format[Format["S32_R"] = makeFormat(FormatTypeFlags.S32, FormatCompFlags.R, FormatFlags.None)] = "S32_R"; // Packed texture formats.

  Format[Format["U16_RGBA_5551"] = makeFormat(FormatTypeFlags.U16_PACKED_5551, FormatCompFlags.RGBA, FormatFlags.Normalized)] = "U16_RGBA_5551"; // Compressed

  Format[Format["BC1"] = makeFormat(FormatTypeFlags.BC1, FormatCompFlags.RGBA, FormatFlags.None)] = "BC1";
  Format[Format["BC1_SRGB"] = makeFormat(FormatTypeFlags.BC1, FormatCompFlags.RGBA, FormatFlags.sRGB)] = "BC1_SRGB";
  Format[Format["BC2"] = makeFormat(FormatTypeFlags.BC2, FormatCompFlags.RGBA, FormatFlags.None)] = "BC2";
  Format[Format["BC2_SRGB"] = makeFormat(FormatTypeFlags.BC2, FormatCompFlags.RGBA, FormatFlags.sRGB)] = "BC2_SRGB";
  Format[Format["BC3"] = makeFormat(FormatTypeFlags.BC3, FormatCompFlags.RGBA, FormatFlags.None)] = "BC3";
  Format[Format["BC3_SRGB"] = makeFormat(FormatTypeFlags.BC3, FormatCompFlags.RGBA, FormatFlags.sRGB)] = "BC3_SRGB";
  Format[Format["BC4_UNORM"] = makeFormat(FormatTypeFlags.BC4_UNORM, FormatCompFlags.R, FormatFlags.None)] = "BC4_UNORM";
  Format[Format["BC4_SNORM"] = makeFormat(FormatTypeFlags.BC4_SNORM, FormatCompFlags.R, FormatFlags.None)] = "BC4_SNORM";
  Format[Format["BC5_UNORM"] = makeFormat(FormatTypeFlags.BC5_UNORM, FormatCompFlags.RG, FormatFlags.None)] = "BC5_UNORM";
  Format[Format["BC5_SNORM"] = makeFormat(FormatTypeFlags.BC5_SNORM, FormatCompFlags.RG, FormatFlags.None)] = "BC5_SNORM"; // Depth/Stencil

  Format[Format["D24"] = makeFormat(FormatTypeFlags.D24, FormatCompFlags.R, FormatFlags.Depth)] = "D24";
  Format[Format["D24_S8"] = makeFormat(FormatTypeFlags.D24S8, FormatCompFlags.RG, FormatFlags.Depth | FormatFlags.Stencil)] = "D24_S8";
  Format[Format["D32F"] = makeFormat(FormatTypeFlags.D32F, FormatCompFlags.R, FormatFlags.Depth)] = "D32F";
  Format[Format["D32F_S8"] = makeFormat(FormatTypeFlags.D32FS8, FormatCompFlags.RG, FormatFlags.Depth | FormatFlags.Stencil)] = "D32F_S8"; // Special RT formats for preferred backend support.

  Format[Format["U8_RGB_RT"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGB, FormatFlags.RenderTarget)] = "U8_RGB_RT";
  Format[Format["U8_RGBA_RT"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGBA, FormatFlags.RenderTarget)] = "U8_RGBA_RT";
  Format[Format["U8_RGBA_RT_SRGB"] = makeFormat(FormatTypeFlags.U8, FormatCompFlags.RGBA, FormatFlags.RenderTarget | FormatFlags.sRGB)] = "U8_RGBA_RT_SRGB";
})(Format || (Format = {}));

function getFormatCompFlags(fmt) {
  return fmt >>> 8 & 0xff;
}
function getFormatTypeFlags(fmt) {
  return fmt >>> 16 & 0xff;
}
function getFormatFlags(fmt) {
  return fmt & 0xff;
}
function getFormatTypeFlagsByteSize(typeFlags) {
  switch (typeFlags) {
    case FormatTypeFlags.F32:
    case FormatTypeFlags.U32:
    case FormatTypeFlags.S32:
      return 4;

    case FormatTypeFlags.U16:
    case FormatTypeFlags.S16:
    case FormatTypeFlags.F16:
      return 2;

    case FormatTypeFlags.U8:
    case FormatTypeFlags.S8:
      return 1;

    default:
      throw 'whoops';
  }
}
/**
 * Gets the byte size for an individual component.
 * e.g. for F32_RGB, this will return "4", since F32 has 4 bytes.
 */

function getFormatCompByteSize(fmt) {
  return getFormatTypeFlagsByteSize(getFormatTypeFlags(fmt));
}
function getFormatComponentCount(fmt) {
  return getFormatCompFlagsComponentCount(getFormatCompFlags(fmt));
}
function getFormatByteSize(fmt) {
  var typeByteSize = getFormatTypeFlagsByteSize(getFormatTypeFlags(fmt));
  var componentCount = getFormatCompFlagsComponentCount(getFormatCompFlags(fmt));
  return typeByteSize * componentCount;
}
function setFormatFlags(fmt, flags) {
  return fmt & 0xffffff00 | flags;
}
function setFormatComponentCount(fmt, compFlags) {
  return fmt & 0xffff00ff | compFlags << 8;
}
function getFormatSamplerKind(fmt) {
  var flags = getFormatFlags(fmt);
  if (!!(flags & FormatFlags.Depth)) return SamplerFormatKind.Depth;
  if (!!(flags & FormatFlags.Normalized)) return SamplerFormatKind.Float;
  var typeFlags = getFormatTypeFlags(fmt);
  if (typeFlags === FormatTypeFlags.F16 || typeFlags === FormatTypeFlags.F32) return SamplerFormatKind.Float;else if (typeFlags === FormatTypeFlags.U8 || typeFlags === FormatTypeFlags.U16 || typeFlags === FormatTypeFlags.U32) return SamplerFormatKind.Uint;else if (typeFlags === FormatTypeFlags.S8 || typeFlags === FormatTypeFlags.S16 || typeFlags === FormatTypeFlags.S32) return SamplerFormatKind.Sint;else throw 'whoops';
}

/**
 * @see https://github.com/gpuweb/cts/blob/main/src/webgpu/constants.ts
 */
var GPUTextureUsage;

(function (GPUTextureUsage) {
  GPUTextureUsage[GPUTextureUsage["COPY_SRC"] = 1] = "COPY_SRC";
  GPUTextureUsage[GPUTextureUsage["COPY_DST"] = 2] = "COPY_DST";
  GPUTextureUsage[GPUTextureUsage["TEXTURE_BINDING"] = 4] = "TEXTURE_BINDING"; // SAMPLED= 0x04,

  GPUTextureUsage[GPUTextureUsage["STORAGE_BINDING"] = 8] = "STORAGE_BINDING";
  GPUTextureUsage[GPUTextureUsage["STORAGE"] = 8] = "STORAGE";
  GPUTextureUsage[GPUTextureUsage["RENDER_ATTACHMENT"] = 16] = "RENDER_ATTACHMENT";
})(GPUTextureUsage || (GPUTextureUsage = {})); // @see https://www.w3.org/TR/webgpu/#typedefdef-gpumapmodeflags


var GPUMapMode;

(function (GPUMapMode) {
  GPUMapMode[GPUMapMode["READ"] = 1] = "READ";
  GPUMapMode[GPUMapMode["WRITE"] = 2] = "WRITE";
})(GPUMapMode || (GPUMapMode = {}));

/**
 * ported from @luma.gl/constants
 *
 * Standard WebGL and WebGL2 constants
 * These constants are also defined on the WebGLRenderingContext interface.
 */
var GL;

(function (GL) {
  // Clearing buffers
  // Constants passed to clear() to clear buffer masks.
  GL[GL["DEPTH_BUFFER_BIT"] = 256] = "DEPTH_BUFFER_BIT";
  GL[GL["STENCIL_BUFFER_BIT"] = 1024] = "STENCIL_BUFFER_BIT";
  GL[GL["COLOR_BUFFER_BIT"] = 16384] = "COLOR_BUFFER_BIT"; // Rendering primitives
  // Constants passed to drawElements() or drawArrays() to specify what kind of primitive to render.

  GL[GL["POINTS"] = 0] = "POINTS";
  GL[GL["LINES"] = 1] = "LINES";
  GL[GL["LINE_LOOP"] = 2] = "LINE_LOOP";
  GL[GL["LINE_STRIP"] = 3] = "LINE_STRIP";
  GL[GL["TRIANGLES"] = 4] = "TRIANGLES";
  GL[GL["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
  GL[GL["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN"; // Blending modes
  // Constants passed to blendFunc() or blendFuncSeparate() to specify the blending mode (for both, RBG and alpha, or separately).

  GL[GL["ZERO"] = 0] = "ZERO";
  GL[GL["ONE"] = 1] = "ONE";
  GL[GL["SRC_COLOR"] = 768] = "SRC_COLOR";
  GL[GL["ONE_MINUS_SRC_COLOR"] = 769] = "ONE_MINUS_SRC_COLOR";
  GL[GL["SRC_ALPHA"] = 770] = "SRC_ALPHA";
  GL[GL["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
  GL[GL["DST_ALPHA"] = 772] = "DST_ALPHA";
  GL[GL["ONE_MINUS_DST_ALPHA"] = 773] = "ONE_MINUS_DST_ALPHA";
  GL[GL["DST_COLOR"] = 774] = "DST_COLOR";
  GL[GL["ONE_MINUS_DST_COLOR"] = 775] = "ONE_MINUS_DST_COLOR";
  GL[GL["SRC_ALPHA_SATURATE"] = 776] = "SRC_ALPHA_SATURATE";
  GL[GL["CONSTANT_COLOR"] = 32769] = "CONSTANT_COLOR";
  GL[GL["ONE_MINUS_CONSTANT_COLOR"] = 32770] = "ONE_MINUS_CONSTANT_COLOR";
  GL[GL["CONSTANT_ALPHA"] = 32771] = "CONSTANT_ALPHA";
  GL[GL["ONE_MINUS_CONSTANT_ALPHA"] = 32772] = "ONE_MINUS_CONSTANT_ALPHA"; // Blending equations
  // Constants passed to blendEquation() or blendEquationSeparate() to control
  // how the blending is calculated (for both, RBG and alpha, or separately).

  GL[GL["FUNC_ADD"] = 32774] = "FUNC_ADD";
  GL[GL["FUNC_SUBTRACT"] = 32778] = "FUNC_SUBTRACT";
  GL[GL["FUNC_REVERSE_SUBTRACT"] = 32779] = "FUNC_REVERSE_SUBTRACT"; // Getting GL parameter information
  // Constants passed to getParameter() to specify what information to return.

  GL[GL["BLEND_EQUATION"] = 32777] = "BLEND_EQUATION";
  GL[GL["BLEND_EQUATION_RGB"] = 32777] = "BLEND_EQUATION_RGB";
  GL[GL["BLEND_EQUATION_ALPHA"] = 34877] = "BLEND_EQUATION_ALPHA";
  GL[GL["BLEND_DST_RGB"] = 32968] = "BLEND_DST_RGB";
  GL[GL["BLEND_SRC_RGB"] = 32969] = "BLEND_SRC_RGB";
  GL[GL["BLEND_DST_ALPHA"] = 32970] = "BLEND_DST_ALPHA";
  GL[GL["BLEND_SRC_ALPHA"] = 32971] = "BLEND_SRC_ALPHA";
  GL[GL["BLEND_COLOR"] = 32773] = "BLEND_COLOR";
  GL[GL["ARRAY_BUFFER_BINDING"] = 34964] = "ARRAY_BUFFER_BINDING";
  GL[GL["ELEMENT_ARRAY_BUFFER_BINDING"] = 34965] = "ELEMENT_ARRAY_BUFFER_BINDING";
  GL[GL["LINE_WIDTH"] = 2849] = "LINE_WIDTH";
  GL[GL["ALIASED_POINT_SIZE_RANGE"] = 33901] = "ALIASED_POINT_SIZE_RANGE";
  GL[GL["ALIASED_LINE_WIDTH_RANGE"] = 33902] = "ALIASED_LINE_WIDTH_RANGE";
  GL[GL["CULL_FACE_MODE"] = 2885] = "CULL_FACE_MODE";
  GL[GL["FRONT_FACE"] = 2886] = "FRONT_FACE";
  GL[GL["DEPTH_RANGE"] = 2928] = "DEPTH_RANGE";
  GL[GL["DEPTH_WRITEMASK"] = 2930] = "DEPTH_WRITEMASK";
  GL[GL["DEPTH_CLEAR_VALUE"] = 2931] = "DEPTH_CLEAR_VALUE";
  GL[GL["DEPTH_FUNC"] = 2932] = "DEPTH_FUNC";
  GL[GL["STENCIL_CLEAR_VALUE"] = 2961] = "STENCIL_CLEAR_VALUE";
  GL[GL["STENCIL_FUNC"] = 2962] = "STENCIL_FUNC";
  GL[GL["STENCIL_FAIL"] = 2964] = "STENCIL_FAIL";
  GL[GL["STENCIL_PASS_DEPTH_FAIL"] = 2965] = "STENCIL_PASS_DEPTH_FAIL";
  GL[GL["STENCIL_PASS_DEPTH_PASS"] = 2966] = "STENCIL_PASS_DEPTH_PASS";
  GL[GL["STENCIL_REF"] = 2967] = "STENCIL_REF";
  GL[GL["STENCIL_VALUE_MASK"] = 2963] = "STENCIL_VALUE_MASK";
  GL[GL["STENCIL_WRITEMASK"] = 2968] = "STENCIL_WRITEMASK";
  GL[GL["STENCIL_BACK_FUNC"] = 34816] = "STENCIL_BACK_FUNC";
  GL[GL["STENCIL_BACK_FAIL"] = 34817] = "STENCIL_BACK_FAIL";
  GL[GL["STENCIL_BACK_PASS_DEPTH_FAIL"] = 34818] = "STENCIL_BACK_PASS_DEPTH_FAIL";
  GL[GL["STENCIL_BACK_PASS_DEPTH_PASS"] = 34819] = "STENCIL_BACK_PASS_DEPTH_PASS";
  GL[GL["STENCIL_BACK_REF"] = 36003] = "STENCIL_BACK_REF";
  GL[GL["STENCIL_BACK_VALUE_MASK"] = 36004] = "STENCIL_BACK_VALUE_MASK";
  GL[GL["STENCIL_BACK_WRITEMASK"] = 36005] = "STENCIL_BACK_WRITEMASK";
  GL[GL["VIEWPORT"] = 2978] = "VIEWPORT";
  GL[GL["SCISSOR_BOX"] = 3088] = "SCISSOR_BOX";
  GL[GL["COLOR_CLEAR_VALUE"] = 3106] = "COLOR_CLEAR_VALUE";
  GL[GL["COLOR_WRITEMASK"] = 3107] = "COLOR_WRITEMASK";
  GL[GL["UNPACK_ALIGNMENT"] = 3317] = "UNPACK_ALIGNMENT";
  GL[GL["PACK_ALIGNMENT"] = 3333] = "PACK_ALIGNMENT";
  GL[GL["MAX_TEXTURE_SIZE"] = 3379] = "MAX_TEXTURE_SIZE";
  GL[GL["MAX_VIEWPORT_DIMS"] = 3386] = "MAX_VIEWPORT_DIMS";
  GL[GL["SUBPIXEL_BITS"] = 3408] = "SUBPIXEL_BITS";
  GL[GL["RED_BITS"] = 3410] = "RED_BITS";
  GL[GL["GREEN_BITS"] = 3411] = "GREEN_BITS";
  GL[GL["BLUE_BITS"] = 3412] = "BLUE_BITS";
  GL[GL["ALPHA_BITS"] = 3413] = "ALPHA_BITS";
  GL[GL["DEPTH_BITS"] = 3414] = "DEPTH_BITS";
  GL[GL["STENCIL_BITS"] = 3415] = "STENCIL_BITS";
  GL[GL["POLYGON_OFFSET_UNITS"] = 10752] = "POLYGON_OFFSET_UNITS";
  GL[GL["POLYGON_OFFSET_FACTOR"] = 32824] = "POLYGON_OFFSET_FACTOR";
  GL[GL["TEXTURE_BINDING_2D"] = 32873] = "TEXTURE_BINDING_2D";
  GL[GL["SAMPLE_BUFFERS"] = 32936] = "SAMPLE_BUFFERS";
  GL[GL["SAMPLES"] = 32937] = "SAMPLES";
  GL[GL["SAMPLE_COVERAGE_VALUE"] = 32938] = "SAMPLE_COVERAGE_VALUE";
  GL[GL["SAMPLE_COVERAGE_INVERT"] = 32939] = "SAMPLE_COVERAGE_INVERT";
  GL[GL["COMPRESSED_TEXTURE_FORMATS"] = 34467] = "COMPRESSED_TEXTURE_FORMATS";
  GL[GL["VENDOR"] = 7936] = "VENDOR";
  GL[GL["RENDERER"] = 7937] = "RENDERER";
  GL[GL["VERSION"] = 7938] = "VERSION";
  GL[GL["IMPLEMENTATION_COLOR_READ_TYPE"] = 35738] = "IMPLEMENTATION_COLOR_READ_TYPE";
  GL[GL["IMPLEMENTATION_COLOR_READ_FORMAT"] = 35739] = "IMPLEMENTATION_COLOR_READ_FORMAT";
  GL[GL["BROWSER_DEFAULT_WEBGL"] = 37444] = "BROWSER_DEFAULT_WEBGL"; // Buffers
  // Constants passed to bufferData(), bufferSubData(), bindBuffer(), or
  // getBufferParameter().

  GL[GL["STATIC_DRAW"] = 35044] = "STATIC_DRAW";
  GL[GL["STREAM_DRAW"] = 35040] = "STREAM_DRAW";
  GL[GL["DYNAMIC_DRAW"] = 35048] = "DYNAMIC_DRAW";
  GL[GL["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
  GL[GL["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
  GL[GL["BUFFER_SIZE"] = 34660] = "BUFFER_SIZE";
  GL[GL["BUFFER_USAGE"] = 34661] = "BUFFER_USAGE"; // Vertex attributes
  // Constants passed to getVertexAttrib().

  GL[GL["CURRENT_VERTEX_ATTRIB"] = 34342] = "CURRENT_VERTEX_ATTRIB";
  GL[GL["VERTEX_ATTRIB_ARRAY_ENABLED"] = 34338] = "VERTEX_ATTRIB_ARRAY_ENABLED";
  GL[GL["VERTEX_ATTRIB_ARRAY_SIZE"] = 34339] = "VERTEX_ATTRIB_ARRAY_SIZE";
  GL[GL["VERTEX_ATTRIB_ARRAY_STRIDE"] = 34340] = "VERTEX_ATTRIB_ARRAY_STRIDE";
  GL[GL["VERTEX_ATTRIB_ARRAY_TYPE"] = 34341] = "VERTEX_ATTRIB_ARRAY_TYPE";
  GL[GL["VERTEX_ATTRIB_ARRAY_NORMALIZED"] = 34922] = "VERTEX_ATTRIB_ARRAY_NORMALIZED";
  GL[GL["VERTEX_ATTRIB_ARRAY_POINTER"] = 34373] = "VERTEX_ATTRIB_ARRAY_POINTER";
  GL[GL["VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"] = 34975] = "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"; // Culling
  // Constants passed to cullFace().

  GL[GL["CULL_FACE"] = 2884] = "CULL_FACE";
  GL[GL["FRONT"] = 1028] = "FRONT";
  GL[GL["BACK"] = 1029] = "BACK";
  GL[GL["FRONT_AND_BACK"] = 1032] = "FRONT_AND_BACK"; // Enabling and disabling
  // Constants passed to enable() or disable().

  GL[GL["BLEND"] = 3042] = "BLEND";
  GL[GL["DEPTH_TEST"] = 2929] = "DEPTH_TEST";
  GL[GL["DITHER"] = 3024] = "DITHER";
  GL[GL["POLYGON_OFFSET_FILL"] = 32823] = "POLYGON_OFFSET_FILL";
  GL[GL["SAMPLE_ALPHA_TO_COVERAGE"] = 32926] = "SAMPLE_ALPHA_TO_COVERAGE";
  GL[GL["SAMPLE_COVERAGE"] = 32928] = "SAMPLE_COVERAGE";
  GL[GL["SCISSOR_TEST"] = 3089] = "SCISSOR_TEST";
  GL[GL["STENCIL_TEST"] = 2960] = "STENCIL_TEST"; // Errors
  // Constants returned from getError().

  GL[GL["NO_ERROR"] = 0] = "NO_ERROR";
  GL[GL["INVALID_ENUM"] = 1280] = "INVALID_ENUM";
  GL[GL["INVALID_VALUE"] = 1281] = "INVALID_VALUE";
  GL[GL["INVALID_OPERATION"] = 1282] = "INVALID_OPERATION";
  GL[GL["OUT_OF_MEMORY"] = 1285] = "OUT_OF_MEMORY";
  GL[GL["CONTEXT_LOST_WEBGL"] = 37442] = "CONTEXT_LOST_WEBGL"; // Front face directions
  // Constants passed to frontFace().

  GL[GL["CW"] = 2304] = "CW";
  GL[GL["CCW"] = 2305] = "CCW"; // Hints
  // Constants passed to hint()

  GL[GL["DONT_CARE"] = 4352] = "DONT_CARE";
  GL[GL["FASTEST"] = 4353] = "FASTEST";
  GL[GL["NICEST"] = 4354] = "NICEST";
  GL[GL["GENERATE_MIPMAP_HINT"] = 33170] = "GENERATE_MIPMAP_HINT"; // Data types

  GL[GL["BYTE"] = 5120] = "BYTE";
  GL[GL["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
  GL[GL["SHORT"] = 5122] = "SHORT";
  GL[GL["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
  GL[GL["INT"] = 5124] = "INT";
  GL[GL["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
  GL[GL["FLOAT"] = 5126] = "FLOAT";
  GL[GL["DOUBLE"] = 5130] = "DOUBLE"; // Pixel formats

  GL[GL["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
  GL[GL["ALPHA"] = 6406] = "ALPHA";
  GL[GL["RGB"] = 6407] = "RGB";
  GL[GL["RGBA"] = 6408] = "RGBA";
  GL[GL["LUMINANCE"] = 6409] = "LUMINANCE";
  GL[GL["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA"; // Pixel types
  // UNSIGNED_BYTE = 0x1401,

  GL[GL["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
  GL[GL["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
  GL[GL["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5"; // Shaders
  // Constants passed to createShader() or getShaderParameter()

  GL[GL["FRAGMENT_SHADER"] = 35632] = "FRAGMENT_SHADER";
  GL[GL["VERTEX_SHADER"] = 35633] = "VERTEX_SHADER";
  GL[GL["COMPILE_STATUS"] = 35713] = "COMPILE_STATUS";
  GL[GL["DELETE_STATUS"] = 35712] = "DELETE_STATUS";
  GL[GL["LINK_STATUS"] = 35714] = "LINK_STATUS";
  GL[GL["VALIDATE_STATUS"] = 35715] = "VALIDATE_STATUS";
  GL[GL["ATTACHED_SHADERS"] = 35717] = "ATTACHED_SHADERS";
  GL[GL["ACTIVE_ATTRIBUTES"] = 35721] = "ACTIVE_ATTRIBUTES";
  GL[GL["ACTIVE_UNIFORMS"] = 35718] = "ACTIVE_UNIFORMS";
  GL[GL["MAX_VERTEX_ATTRIBS"] = 34921] = "MAX_VERTEX_ATTRIBS";
  GL[GL["MAX_VERTEX_UNIFORM_VECTORS"] = 36347] = "MAX_VERTEX_UNIFORM_VECTORS";
  GL[GL["MAX_VARYING_VECTORS"] = 36348] = "MAX_VARYING_VECTORS";
  GL[GL["MAX_COMBINED_TEXTURE_IMAGE_UNITS"] = 35661] = "MAX_COMBINED_TEXTURE_IMAGE_UNITS";
  GL[GL["MAX_VERTEX_TEXTURE_IMAGE_UNITS"] = 35660] = "MAX_VERTEX_TEXTURE_IMAGE_UNITS";
  GL[GL["MAX_TEXTURE_IMAGE_UNITS"] = 34930] = "MAX_TEXTURE_IMAGE_UNITS";
  GL[GL["MAX_FRAGMENT_UNIFORM_VECTORS"] = 36349] = "MAX_FRAGMENT_UNIFORM_VECTORS";
  GL[GL["SHADER_TYPE"] = 35663] = "SHADER_TYPE";
  GL[GL["SHADING_LANGUAGE_VERSION"] = 35724] = "SHADING_LANGUAGE_VERSION";
  GL[GL["CURRENT_PROGRAM"] = 35725] = "CURRENT_PROGRAM"; // Depth or stencil tests
  // Constants passed to depthFunc() or stencilFunc().

  GL[GL["NEVER"] = 512] = "NEVER";
  GL[GL["ALWAYS"] = 519] = "ALWAYS";
  GL[GL["LESS"] = 513] = "LESS";
  GL[GL["EQUAL"] = 514] = "EQUAL";
  GL[GL["LEQUAL"] = 515] = "LEQUAL";
  GL[GL["GREATER"] = 516] = "GREATER";
  GL[GL["GEQUAL"] = 518] = "GEQUAL";
  GL[GL["NOTEQUAL"] = 517] = "NOTEQUAL"; // Stencil actions
  // Constants passed to stencilOp().

  GL[GL["KEEP"] = 7680] = "KEEP";
  GL[GL["REPLACE"] = 7681] = "REPLACE";
  GL[GL["INCR"] = 7682] = "INCR";
  GL[GL["DECR"] = 7683] = "DECR";
  GL[GL["INVERT"] = 5386] = "INVERT";
  GL[GL["INCR_WRAP"] = 34055] = "INCR_WRAP";
  GL[GL["DECR_WRAP"] = 34056] = "DECR_WRAP"; // Textures
  // Constants passed to texParameteri(),
  // texParameterf(), bindTexture(), texImage2D(), and others.

  GL[GL["NEAREST"] = 9728] = "NEAREST";
  GL[GL["LINEAR"] = 9729] = "LINEAR";
  GL[GL["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
  GL[GL["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
  GL[GL["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
  GL[GL["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
  GL[GL["TEXTURE_MAG_FILTER"] = 10240] = "TEXTURE_MAG_FILTER";
  GL[GL["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
  GL[GL["TEXTURE_WRAP_S"] = 10242] = "TEXTURE_WRAP_S";
  GL[GL["TEXTURE_WRAP_T"] = 10243] = "TEXTURE_WRAP_T";
  GL[GL["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
  GL[GL["TEXTURE"] = 5890] = "TEXTURE";
  GL[GL["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
  GL[GL["TEXTURE_BINDING_CUBE_MAP"] = 34068] = "TEXTURE_BINDING_CUBE_MAP";
  GL[GL["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
  GL[GL["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
  GL[GL["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
  GL[GL["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
  GL[GL["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
  GL[GL["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
  GL[GL["MAX_CUBE_MAP_TEXTURE_SIZE"] = 34076] = "MAX_CUBE_MAP_TEXTURE_SIZE"; // TEXTURE0 - 31 0x84C0 - 0x84DF A texture unit.

  GL[GL["TEXTURE0"] = 33984] = "TEXTURE0";
  GL[GL["ACTIVE_TEXTURE"] = 34016] = "ACTIVE_TEXTURE";
  GL[GL["REPEAT"] = 10497] = "REPEAT";
  GL[GL["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
  GL[GL["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT"; // Emulation

  GL[GL["TEXTURE_WIDTH"] = 4096] = "TEXTURE_WIDTH";
  GL[GL["TEXTURE_HEIGHT"] = 4097] = "TEXTURE_HEIGHT"; // Uniform types

  GL[GL["FLOAT_VEC2"] = 35664] = "FLOAT_VEC2";
  GL[GL["FLOAT_VEC3"] = 35665] = "FLOAT_VEC3";
  GL[GL["FLOAT_VEC4"] = 35666] = "FLOAT_VEC4";
  GL[GL["INT_VEC2"] = 35667] = "INT_VEC2";
  GL[GL["INT_VEC3"] = 35668] = "INT_VEC3";
  GL[GL["INT_VEC4"] = 35669] = "INT_VEC4";
  GL[GL["BOOL"] = 35670] = "BOOL";
  GL[GL["BOOL_VEC2"] = 35671] = "BOOL_VEC2";
  GL[GL["BOOL_VEC3"] = 35672] = "BOOL_VEC3";
  GL[GL["BOOL_VEC4"] = 35673] = "BOOL_VEC4";
  GL[GL["FLOAT_MAT2"] = 35674] = "FLOAT_MAT2";
  GL[GL["FLOAT_MAT3"] = 35675] = "FLOAT_MAT3";
  GL[GL["FLOAT_MAT4"] = 35676] = "FLOAT_MAT4";
  GL[GL["SAMPLER_2D"] = 35678] = "SAMPLER_2D";
  GL[GL["SAMPLER_CUBE"] = 35680] = "SAMPLER_CUBE"; // Shader precision-specified types

  GL[GL["LOW_FLOAT"] = 36336] = "LOW_FLOAT";
  GL[GL["MEDIUM_FLOAT"] = 36337] = "MEDIUM_FLOAT";
  GL[GL["HIGH_FLOAT"] = 36338] = "HIGH_FLOAT";
  GL[GL["LOW_INT"] = 36339] = "LOW_INT";
  GL[GL["MEDIUM_INT"] = 36340] = "MEDIUM_INT";
  GL[GL["HIGH_INT"] = 36341] = "HIGH_INT"; // Framebuffers and renderbuffers

  GL[GL["FRAMEBUFFER"] = 36160] = "FRAMEBUFFER";
  GL[GL["RENDERBUFFER"] = 36161] = "RENDERBUFFER";
  GL[GL["RGBA4"] = 32854] = "RGBA4";
  GL[GL["RGB5_A1"] = 32855] = "RGB5_A1";
  GL[GL["RGB565"] = 36194] = "RGB565";
  GL[GL["DEPTH_COMPONENT16"] = 33189] = "DEPTH_COMPONENT16";
  GL[GL["STENCIL_INDEX"] = 6401] = "STENCIL_INDEX";
  GL[GL["STENCIL_INDEX8"] = 36168] = "STENCIL_INDEX8";
  GL[GL["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
  GL[GL["RENDERBUFFER_WIDTH"] = 36162] = "RENDERBUFFER_WIDTH";
  GL[GL["RENDERBUFFER_HEIGHT"] = 36163] = "RENDERBUFFER_HEIGHT";
  GL[GL["RENDERBUFFER_INTERNAL_FORMAT"] = 36164] = "RENDERBUFFER_INTERNAL_FORMAT";
  GL[GL["RENDERBUFFER_RED_SIZE"] = 36176] = "RENDERBUFFER_RED_SIZE";
  GL[GL["RENDERBUFFER_GREEN_SIZE"] = 36177] = "RENDERBUFFER_GREEN_SIZE";
  GL[GL["RENDERBUFFER_BLUE_SIZE"] = 36178] = "RENDERBUFFER_BLUE_SIZE";
  GL[GL["RENDERBUFFER_ALPHA_SIZE"] = 36179] = "RENDERBUFFER_ALPHA_SIZE";
  GL[GL["RENDERBUFFER_DEPTH_SIZE"] = 36180] = "RENDERBUFFER_DEPTH_SIZE";
  GL[GL["RENDERBUFFER_STENCIL_SIZE"] = 36181] = "RENDERBUFFER_STENCIL_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE"] = 36048] = "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_OBJECT_NAME"] = 36049] = "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME";
  GL[GL["FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL"] = 36050] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL";
  GL[GL["FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE"] = 36051] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE";
  GL[GL["COLOR_ATTACHMENT0"] = 36064] = "COLOR_ATTACHMENT0";
  GL[GL["DEPTH_ATTACHMENT"] = 36096] = "DEPTH_ATTACHMENT";
  GL[GL["STENCIL_ATTACHMENT"] = 36128] = "STENCIL_ATTACHMENT";
  GL[GL["DEPTH_STENCIL_ATTACHMENT"] = 33306] = "DEPTH_STENCIL_ATTACHMENT";
  GL[GL["NONE"] = 0] = "NONE";
  GL[GL["FRAMEBUFFER_COMPLETE"] = 36053] = "FRAMEBUFFER_COMPLETE";
  GL[GL["FRAMEBUFFER_INCOMPLETE_ATTACHMENT"] = 36054] = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
  GL[GL["FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"] = 36055] = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
  GL[GL["FRAMEBUFFER_INCOMPLETE_DIMENSIONS"] = 36057] = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
  GL[GL["FRAMEBUFFER_UNSUPPORTED"] = 36061] = "FRAMEBUFFER_UNSUPPORTED";
  GL[GL["FRAMEBUFFER_BINDING"] = 36006] = "FRAMEBUFFER_BINDING";
  GL[GL["RENDERBUFFER_BINDING"] = 36007] = "RENDERBUFFER_BINDING";
  GL[GL["READ_FRAMEBUFFER"] = 36008] = "READ_FRAMEBUFFER";
  GL[GL["DRAW_FRAMEBUFFER"] = 36009] = "DRAW_FRAMEBUFFER";
  GL[GL["MAX_RENDERBUFFER_SIZE"] = 34024] = "MAX_RENDERBUFFER_SIZE";
  GL[GL["INVALID_FRAMEBUFFER_OPERATION"] = 1286] = "INVALID_FRAMEBUFFER_OPERATION"; // Pixel storage modes
  // Constants passed to pixelStorei().

  GL[GL["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
  GL[GL["UNPACK_PREMULTIPLY_ALPHA_WEBGL"] = 37441] = "UNPACK_PREMULTIPLY_ALPHA_WEBGL";
  GL[GL["UNPACK_COLORSPACE_CONVERSION_WEBGL"] = 37443] = "UNPACK_COLORSPACE_CONVERSION_WEBGL"; // /////////////////////////////////////////////////////
  // Additional constants defined WebGL 2
  // These constants are defined on the WebGL2RenderingContext interface.
  // All WebGL 1 constants are also available in a WebGL 2 context.
  // /////////////////////////////////////////////////////
  // Getting GL parameter information
  // Constants passed to getParameter()
  // to specify what information to return.

  GL[GL["READ_BUFFER"] = 3074] = "READ_BUFFER";
  GL[GL["UNPACK_ROW_LENGTH"] = 3314] = "UNPACK_ROW_LENGTH";
  GL[GL["UNPACK_SKIP_ROWS"] = 3315] = "UNPACK_SKIP_ROWS";
  GL[GL["UNPACK_SKIP_PIXELS"] = 3316] = "UNPACK_SKIP_PIXELS";
  GL[GL["PACK_ROW_LENGTH"] = 3330] = "PACK_ROW_LENGTH";
  GL[GL["PACK_SKIP_ROWS"] = 3331] = "PACK_SKIP_ROWS";
  GL[GL["PACK_SKIP_PIXELS"] = 3332] = "PACK_SKIP_PIXELS";
  GL[GL["TEXTURE_BINDING_3D"] = 32874] = "TEXTURE_BINDING_3D";
  GL[GL["UNPACK_SKIP_IMAGES"] = 32877] = "UNPACK_SKIP_IMAGES";
  GL[GL["UNPACK_IMAGE_HEIGHT"] = 32878] = "UNPACK_IMAGE_HEIGHT";
  GL[GL["MAX_3D_TEXTURE_SIZE"] = 32883] = "MAX_3D_TEXTURE_SIZE";
  GL[GL["MAX_ELEMENTS_VERTICES"] = 33000] = "MAX_ELEMENTS_VERTICES";
  GL[GL["MAX_ELEMENTS_INDICES"] = 33001] = "MAX_ELEMENTS_INDICES";
  GL[GL["MAX_TEXTURE_LOD_BIAS"] = 34045] = "MAX_TEXTURE_LOD_BIAS";
  GL[GL["MAX_FRAGMENT_UNIFORM_COMPONENTS"] = 35657] = "MAX_FRAGMENT_UNIFORM_COMPONENTS";
  GL[GL["MAX_VERTEX_UNIFORM_COMPONENTS"] = 35658] = "MAX_VERTEX_UNIFORM_COMPONENTS";
  GL[GL["MAX_ARRAY_TEXTURE_LAYERS"] = 35071] = "MAX_ARRAY_TEXTURE_LAYERS";
  GL[GL["MIN_PROGRAM_TEXEL_OFFSET"] = 35076] = "MIN_PROGRAM_TEXEL_OFFSET";
  GL[GL["MAX_PROGRAM_TEXEL_OFFSET"] = 35077] = "MAX_PROGRAM_TEXEL_OFFSET";
  GL[GL["MAX_VARYING_COMPONENTS"] = 35659] = "MAX_VARYING_COMPONENTS";
  GL[GL["FRAGMENT_SHADER_DERIVATIVE_HINT"] = 35723] = "FRAGMENT_SHADER_DERIVATIVE_HINT";
  GL[GL["RASTERIZER_DISCARD"] = 35977] = "RASTERIZER_DISCARD";
  GL[GL["VERTEX_ARRAY_BINDING"] = 34229] = "VERTEX_ARRAY_BINDING";
  GL[GL["MAX_VERTEX_OUTPUT_COMPONENTS"] = 37154] = "MAX_VERTEX_OUTPUT_COMPONENTS";
  GL[GL["MAX_FRAGMENT_INPUT_COMPONENTS"] = 37157] = "MAX_FRAGMENT_INPUT_COMPONENTS";
  GL[GL["MAX_SERVER_WAIT_TIMEOUT"] = 37137] = "MAX_SERVER_WAIT_TIMEOUT";
  GL[GL["MAX_ELEMENT_INDEX"] = 36203] = "MAX_ELEMENT_INDEX"; // Textures
  // Constants passed to texParameteri(),
  // texParameterf(), bindTexture(), texImage2D(), and others.

  GL[GL["RED"] = 6403] = "RED";
  GL[GL["RGB8"] = 32849] = "RGB8";
  GL[GL["RGBA8"] = 32856] = "RGBA8";
  GL[GL["RGB10_A2"] = 32857] = "RGB10_A2";
  GL[GL["TEXTURE_3D"] = 32879] = "TEXTURE_3D";
  GL[GL["TEXTURE_WRAP_R"] = 32882] = "TEXTURE_WRAP_R";
  GL[GL["TEXTURE_MIN_LOD"] = 33082] = "TEXTURE_MIN_LOD";
  GL[GL["TEXTURE_MAX_LOD"] = 33083] = "TEXTURE_MAX_LOD";
  GL[GL["TEXTURE_BASE_LEVEL"] = 33084] = "TEXTURE_BASE_LEVEL";
  GL[GL["TEXTURE_MAX_LEVEL"] = 33085] = "TEXTURE_MAX_LEVEL";
  GL[GL["TEXTURE_COMPARE_MODE"] = 34892] = "TEXTURE_COMPARE_MODE";
  GL[GL["TEXTURE_COMPARE_FUNC"] = 34893] = "TEXTURE_COMPARE_FUNC";
  GL[GL["SRGB"] = 35904] = "SRGB";
  GL[GL["SRGB8"] = 35905] = "SRGB8";
  GL[GL["SRGB8_ALPHA8"] = 35907] = "SRGB8_ALPHA8";
  GL[GL["COMPARE_REF_TO_TEXTURE"] = 34894] = "COMPARE_REF_TO_TEXTURE";
  GL[GL["RGBA32F"] = 34836] = "RGBA32F";
  GL[GL["RGB32F"] = 34837] = "RGB32F";
  GL[GL["RGBA16F"] = 34842] = "RGBA16F";
  GL[GL["RGB16F"] = 34843] = "RGB16F";
  GL[GL["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
  GL[GL["TEXTURE_BINDING_2D_ARRAY"] = 35869] = "TEXTURE_BINDING_2D_ARRAY";
  GL[GL["R11F_G11F_B10F"] = 35898] = "R11F_G11F_B10F";
  GL[GL["RGB9_E5"] = 35901] = "RGB9_E5";
  GL[GL["RGBA32UI"] = 36208] = "RGBA32UI";
  GL[GL["RGB32UI"] = 36209] = "RGB32UI";
  GL[GL["RGBA16UI"] = 36214] = "RGBA16UI";
  GL[GL["RGB16UI"] = 36215] = "RGB16UI";
  GL[GL["RGBA8UI"] = 36220] = "RGBA8UI";
  GL[GL["RGB8UI"] = 36221] = "RGB8UI";
  GL[GL["RGBA32I"] = 36226] = "RGBA32I";
  GL[GL["RGB32I"] = 36227] = "RGB32I";
  GL[GL["RGBA16I"] = 36232] = "RGBA16I";
  GL[GL["RGB16I"] = 36233] = "RGB16I";
  GL[GL["RGBA8I"] = 36238] = "RGBA8I";
  GL[GL["RGB8I"] = 36239] = "RGB8I";
  GL[GL["RED_INTEGER"] = 36244] = "RED_INTEGER";
  GL[GL["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
  GL[GL["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
  GL[GL["R8"] = 33321] = "R8";
  GL[GL["RG8"] = 33323] = "RG8";
  GL[GL["R16F"] = 33325] = "R16F";
  GL[GL["R32F"] = 33326] = "R32F";
  GL[GL["RG16F"] = 33327] = "RG16F";
  GL[GL["RG32F"] = 33328] = "RG32F";
  GL[GL["R8I"] = 33329] = "R8I";
  GL[GL["R8UI"] = 33330] = "R8UI";
  GL[GL["R16I"] = 33331] = "R16I";
  GL[GL["R16UI"] = 33332] = "R16UI";
  GL[GL["R32I"] = 33333] = "R32I";
  GL[GL["R32UI"] = 33334] = "R32UI";
  GL[GL["RG8I"] = 33335] = "RG8I";
  GL[GL["RG8UI"] = 33336] = "RG8UI";
  GL[GL["RG16I"] = 33337] = "RG16I";
  GL[GL["RG16UI"] = 33338] = "RG16UI";
  GL[GL["RG32I"] = 33339] = "RG32I";
  GL[GL["RG32UI"] = 33340] = "RG32UI";
  GL[GL["R8_SNORM"] = 36756] = "R8_SNORM";
  GL[GL["RG8_SNORM"] = 36757] = "RG8_SNORM";
  GL[GL["RGB8_SNORM"] = 36758] = "RGB8_SNORM";
  GL[GL["RGBA8_SNORM"] = 36759] = "RGBA8_SNORM";
  GL[GL["RGB10_A2UI"] = 36975] = "RGB10_A2UI";
  /* covered by extension
  COMPRESSED_R11_EAC  = 0x9270,
  COMPRESSED_SIGNED_R11_EAC = 0x9271,
  COMPRESSED_RG11_EAC = 0x9272,
  COMPRESSED_SIGNED_RG11_EAC  = 0x9273,
  COMPRESSED_RGB8_ETC2  = 0x9274,
  COMPRESSED_SRGB8_ETC2 = 0x9275,
  COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2  = 0x9276,
  COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC  = 0x9277,
  COMPRESSED_RGBA8_ETC2_EAC = 0x9278,
  COMPRESSED_SRGB8_ALPHA8_ETC2_EAC  = 0x9279,
  */

  GL[GL["TEXTURE_IMMUTABLE_FORMAT"] = 37167] = "TEXTURE_IMMUTABLE_FORMAT";
  GL[GL["TEXTURE_IMMUTABLE_LEVELS"] = 33503] = "TEXTURE_IMMUTABLE_LEVELS"; // Pixel types

  GL[GL["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
  GL[GL["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
  GL[GL["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
  GL[GL["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
  GL[GL["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
  GL[GL["HALF_FLOAT"] = 5131] = "HALF_FLOAT";
  GL[GL["RG"] = 33319] = "RG";
  GL[GL["RG_INTEGER"] = 33320] = "RG_INTEGER";
  GL[GL["INT_2_10_10_10_REV"] = 36255] = "INT_2_10_10_10_REV"; // Queries

  GL[GL["CURRENT_QUERY"] = 34917] = "CURRENT_QUERY";
  GL[GL["QUERY_RESULT"] = 34918] = "QUERY_RESULT";
  GL[GL["QUERY_RESULT_AVAILABLE"] = 34919] = "QUERY_RESULT_AVAILABLE";
  GL[GL["ANY_SAMPLES_PASSED"] = 35887] = "ANY_SAMPLES_PASSED";
  GL[GL["ANY_SAMPLES_PASSED_CONSERVATIVE"] = 36202] = "ANY_SAMPLES_PASSED_CONSERVATIVE"; // Draw buffers

  GL[GL["MAX_DRAW_BUFFERS"] = 34852] = "MAX_DRAW_BUFFERS";
  GL[GL["DRAW_BUFFER0"] = 34853] = "DRAW_BUFFER0";
  GL[GL["DRAW_BUFFER1"] = 34854] = "DRAW_BUFFER1";
  GL[GL["DRAW_BUFFER2"] = 34855] = "DRAW_BUFFER2";
  GL[GL["DRAW_BUFFER3"] = 34856] = "DRAW_BUFFER3";
  GL[GL["DRAW_BUFFER4"] = 34857] = "DRAW_BUFFER4";
  GL[GL["DRAW_BUFFER5"] = 34858] = "DRAW_BUFFER5";
  GL[GL["DRAW_BUFFER6"] = 34859] = "DRAW_BUFFER6";
  GL[GL["DRAW_BUFFER7"] = 34860] = "DRAW_BUFFER7";
  GL[GL["DRAW_BUFFER8"] = 34861] = "DRAW_BUFFER8";
  GL[GL["DRAW_BUFFER9"] = 34862] = "DRAW_BUFFER9";
  GL[GL["DRAW_BUFFER10"] = 34863] = "DRAW_BUFFER10";
  GL[GL["DRAW_BUFFER11"] = 34864] = "DRAW_BUFFER11";
  GL[GL["DRAW_BUFFER12"] = 34865] = "DRAW_BUFFER12";
  GL[GL["DRAW_BUFFER13"] = 34866] = "DRAW_BUFFER13";
  GL[GL["DRAW_BUFFER14"] = 34867] = "DRAW_BUFFER14";
  GL[GL["DRAW_BUFFER15"] = 34868] = "DRAW_BUFFER15";
  GL[GL["MAX_COLOR_ATTACHMENTS"] = 36063] = "MAX_COLOR_ATTACHMENTS";
  GL[GL["COLOR_ATTACHMENT1"] = 36065] = "COLOR_ATTACHMENT1";
  GL[GL["COLOR_ATTACHMENT2"] = 36066] = "COLOR_ATTACHMENT2";
  GL[GL["COLOR_ATTACHMENT3"] = 36067] = "COLOR_ATTACHMENT3";
  GL[GL["COLOR_ATTACHMENT4"] = 36068] = "COLOR_ATTACHMENT4";
  GL[GL["COLOR_ATTACHMENT5"] = 36069] = "COLOR_ATTACHMENT5";
  GL[GL["COLOR_ATTACHMENT6"] = 36070] = "COLOR_ATTACHMENT6";
  GL[GL["COLOR_ATTACHMENT7"] = 36071] = "COLOR_ATTACHMENT7";
  GL[GL["COLOR_ATTACHMENT8"] = 36072] = "COLOR_ATTACHMENT8";
  GL[GL["COLOR_ATTACHMENT9"] = 36073] = "COLOR_ATTACHMENT9";
  GL[GL["COLOR_ATTACHMENT10"] = 36074] = "COLOR_ATTACHMENT10";
  GL[GL["COLOR_ATTACHMENT11"] = 36075] = "COLOR_ATTACHMENT11";
  GL[GL["COLOR_ATTACHMENT12"] = 36076] = "COLOR_ATTACHMENT12";
  GL[GL["COLOR_ATTACHMENT13"] = 36077] = "COLOR_ATTACHMENT13";
  GL[GL["COLOR_ATTACHMENT14"] = 36078] = "COLOR_ATTACHMENT14";
  GL[GL["COLOR_ATTACHMENT15"] = 36079] = "COLOR_ATTACHMENT15"; // Samplers

  GL[GL["SAMPLER_3D"] = 35679] = "SAMPLER_3D";
  GL[GL["SAMPLER_2D_SHADOW"] = 35682] = "SAMPLER_2D_SHADOW";
  GL[GL["SAMPLER_2D_ARRAY"] = 36289] = "SAMPLER_2D_ARRAY";
  GL[GL["SAMPLER_2D_ARRAY_SHADOW"] = 36292] = "SAMPLER_2D_ARRAY_SHADOW";
  GL[GL["SAMPLER_CUBE_SHADOW"] = 36293] = "SAMPLER_CUBE_SHADOW";
  GL[GL["INT_SAMPLER_2D"] = 36298] = "INT_SAMPLER_2D";
  GL[GL["INT_SAMPLER_3D"] = 36299] = "INT_SAMPLER_3D";
  GL[GL["INT_SAMPLER_CUBE"] = 36300] = "INT_SAMPLER_CUBE";
  GL[GL["INT_SAMPLER_2D_ARRAY"] = 36303] = "INT_SAMPLER_2D_ARRAY";
  GL[GL["UNSIGNED_INT_SAMPLER_2D"] = 36306] = "UNSIGNED_INT_SAMPLER_2D";
  GL[GL["UNSIGNED_INT_SAMPLER_3D"] = 36307] = "UNSIGNED_INT_SAMPLER_3D";
  GL[GL["UNSIGNED_INT_SAMPLER_CUBE"] = 36308] = "UNSIGNED_INT_SAMPLER_CUBE";
  GL[GL["UNSIGNED_INT_SAMPLER_2D_ARRAY"] = 36311] = "UNSIGNED_INT_SAMPLER_2D_ARRAY";
  GL[GL["MAX_SAMPLES"] = 36183] = "MAX_SAMPLES";
  GL[GL["SAMPLER_BINDING"] = 35097] = "SAMPLER_BINDING"; // Buffers

  GL[GL["PIXEL_PACK_BUFFER"] = 35051] = "PIXEL_PACK_BUFFER";
  GL[GL["PIXEL_UNPACK_BUFFER"] = 35052] = "PIXEL_UNPACK_BUFFER";
  GL[GL["PIXEL_PACK_BUFFER_BINDING"] = 35053] = "PIXEL_PACK_BUFFER_BINDING";
  GL[GL["PIXEL_UNPACK_BUFFER_BINDING"] = 35055] = "PIXEL_UNPACK_BUFFER_BINDING";
  GL[GL["COPY_READ_BUFFER"] = 36662] = "COPY_READ_BUFFER";
  GL[GL["COPY_WRITE_BUFFER"] = 36663] = "COPY_WRITE_BUFFER";
  GL[GL["COPY_READ_BUFFER_BINDING"] = 36662] = "COPY_READ_BUFFER_BINDING";
  GL[GL["COPY_WRITE_BUFFER_BINDING"] = 36663] = "COPY_WRITE_BUFFER_BINDING"; // Data types

  GL[GL["FLOAT_MAT2x3"] = 35685] = "FLOAT_MAT2x3";
  GL[GL["FLOAT_MAT2x4"] = 35686] = "FLOAT_MAT2x4";
  GL[GL["FLOAT_MAT3x2"] = 35687] = "FLOAT_MAT3x2";
  GL[GL["FLOAT_MAT3x4"] = 35688] = "FLOAT_MAT3x4";
  GL[GL["FLOAT_MAT4x2"] = 35689] = "FLOAT_MAT4x2";
  GL[GL["FLOAT_MAT4x3"] = 35690] = "FLOAT_MAT4x3";
  GL[GL["UNSIGNED_INT_VEC2"] = 36294] = "UNSIGNED_INT_VEC2";
  GL[GL["UNSIGNED_INT_VEC3"] = 36295] = "UNSIGNED_INT_VEC3";
  GL[GL["UNSIGNED_INT_VEC4"] = 36296] = "UNSIGNED_INT_VEC4";
  GL[GL["UNSIGNED_NORMALIZED"] = 35863] = "UNSIGNED_NORMALIZED";
  GL[GL["SIGNED_NORMALIZED"] = 36764] = "SIGNED_NORMALIZED"; // Vertex attributes

  GL[GL["VERTEX_ATTRIB_ARRAY_INTEGER"] = 35069] = "VERTEX_ATTRIB_ARRAY_INTEGER";
  GL[GL["VERTEX_ATTRIB_ARRAY_DIVISOR"] = 35070] = "VERTEX_ATTRIB_ARRAY_DIVISOR"; // Transform feedback

  GL[GL["TRANSFORM_FEEDBACK_BUFFER_MODE"] = 35967] = "TRANSFORM_FEEDBACK_BUFFER_MODE";
  GL[GL["MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS"] = 35968] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS";
  GL[GL["TRANSFORM_FEEDBACK_VARYINGS"] = 35971] = "TRANSFORM_FEEDBACK_VARYINGS";
  GL[GL["TRANSFORM_FEEDBACK_BUFFER_START"] = 35972] = "TRANSFORM_FEEDBACK_BUFFER_START";
  GL[GL["TRANSFORM_FEEDBACK_BUFFER_SIZE"] = 35973] = "TRANSFORM_FEEDBACK_BUFFER_SIZE";
  GL[GL["TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN"] = 35976] = "TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN";
  GL[GL["MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS"] = 35978] = "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS";
  GL[GL["MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS"] = 35979] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS";
  GL[GL["INTERLEAVED_ATTRIBS"] = 35980] = "INTERLEAVED_ATTRIBS";
  GL[GL["SEPARATE_ATTRIBS"] = 35981] = "SEPARATE_ATTRIBS";
  GL[GL["TRANSFORM_FEEDBACK_BUFFER"] = 35982] = "TRANSFORM_FEEDBACK_BUFFER";
  GL[GL["TRANSFORM_FEEDBACK_BUFFER_BINDING"] = 35983] = "TRANSFORM_FEEDBACK_BUFFER_BINDING";
  GL[GL["TRANSFORM_FEEDBACK"] = 36386] = "TRANSFORM_FEEDBACK";
  GL[GL["TRANSFORM_FEEDBACK_PAUSED"] = 36387] = "TRANSFORM_FEEDBACK_PAUSED";
  GL[GL["TRANSFORM_FEEDBACK_ACTIVE"] = 36388] = "TRANSFORM_FEEDBACK_ACTIVE";
  GL[GL["TRANSFORM_FEEDBACK_BINDING"] = 36389] = "TRANSFORM_FEEDBACK_BINDING"; // Framebuffers and renderbuffers

  GL[GL["FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING"] = 33296] = "FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING";
  GL[GL["FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE"] = 33297] = "FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_RED_SIZE"] = 33298] = "FRAMEBUFFER_ATTACHMENT_RED_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_GREEN_SIZE"] = 33299] = "FRAMEBUFFER_ATTACHMENT_GREEN_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_BLUE_SIZE"] = 33300] = "FRAMEBUFFER_ATTACHMENT_BLUE_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE"] = 33301] = "FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE"] = 33302] = "FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE";
  GL[GL["FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE"] = 33303] = "FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE";
  GL[GL["FRAMEBUFFER_DEFAULT"] = 33304] = "FRAMEBUFFER_DEFAULT"; // DEPTH_STENCIL_ATTACHMENT  = 0x821A,
  // DEPTH_STENCIL = 0x84F9,

  GL[GL["DEPTH24_STENCIL8"] = 35056] = "DEPTH24_STENCIL8";
  GL[GL["DRAW_FRAMEBUFFER_BINDING"] = 36006] = "DRAW_FRAMEBUFFER_BINDING";
  GL[GL["READ_FRAMEBUFFER_BINDING"] = 36010] = "READ_FRAMEBUFFER_BINDING";
  GL[GL["RENDERBUFFER_SAMPLES"] = 36011] = "RENDERBUFFER_SAMPLES";
  GL[GL["FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER"] = 36052] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER";
  GL[GL["FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"] = 36182] = "FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"; // Uniforms

  GL[GL["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
  GL[GL["UNIFORM_BUFFER_BINDING"] = 35368] = "UNIFORM_BUFFER_BINDING";
  GL[GL["UNIFORM_BUFFER_START"] = 35369] = "UNIFORM_BUFFER_START";
  GL[GL["UNIFORM_BUFFER_SIZE"] = 35370] = "UNIFORM_BUFFER_SIZE";
  GL[GL["MAX_VERTEX_UNIFORM_BLOCKS"] = 35371] = "MAX_VERTEX_UNIFORM_BLOCKS";
  GL[GL["MAX_FRAGMENT_UNIFORM_BLOCKS"] = 35373] = "MAX_FRAGMENT_UNIFORM_BLOCKS";
  GL[GL["MAX_COMBINED_UNIFORM_BLOCKS"] = 35374] = "MAX_COMBINED_UNIFORM_BLOCKS";
  GL[GL["MAX_UNIFORM_BUFFER_BINDINGS"] = 35375] = "MAX_UNIFORM_BUFFER_BINDINGS";
  GL[GL["MAX_UNIFORM_BLOCK_SIZE"] = 35376] = "MAX_UNIFORM_BLOCK_SIZE";
  GL[GL["MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS"] = 35377] = "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS";
  GL[GL["MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS"] = 35379] = "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS";
  GL[GL["UNIFORM_BUFFER_OFFSET_ALIGNMENT"] = 35380] = "UNIFORM_BUFFER_OFFSET_ALIGNMENT";
  GL[GL["ACTIVE_UNIFORM_BLOCKS"] = 35382] = "ACTIVE_UNIFORM_BLOCKS";
  GL[GL["UNIFORM_TYPE"] = 35383] = "UNIFORM_TYPE";
  GL[GL["UNIFORM_SIZE"] = 35384] = "UNIFORM_SIZE";
  GL[GL["UNIFORM_BLOCK_INDEX"] = 35386] = "UNIFORM_BLOCK_INDEX";
  GL[GL["UNIFORM_OFFSET"] = 35387] = "UNIFORM_OFFSET";
  GL[GL["UNIFORM_ARRAY_STRIDE"] = 35388] = "UNIFORM_ARRAY_STRIDE";
  GL[GL["UNIFORM_MATRIX_STRIDE"] = 35389] = "UNIFORM_MATRIX_STRIDE";
  GL[GL["UNIFORM_IS_ROW_MAJOR"] = 35390] = "UNIFORM_IS_ROW_MAJOR";
  GL[GL["UNIFORM_BLOCK_BINDING"] = 35391] = "UNIFORM_BLOCK_BINDING";
  GL[GL["UNIFORM_BLOCK_DATA_SIZE"] = 35392] = "UNIFORM_BLOCK_DATA_SIZE";
  GL[GL["UNIFORM_BLOCK_ACTIVE_UNIFORMS"] = 35394] = "UNIFORM_BLOCK_ACTIVE_UNIFORMS";
  GL[GL["UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES"] = 35395] = "UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES";
  GL[GL["UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER"] = 35396] = "UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER";
  GL[GL["UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER"] = 35398] = "UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER"; // Sync objects

  GL[GL["OBJECT_TYPE"] = 37138] = "OBJECT_TYPE";
  GL[GL["SYNC_CONDITION"] = 37139] = "SYNC_CONDITION";
  GL[GL["SYNC_STATUS"] = 37140] = "SYNC_STATUS";
  GL[GL["SYNC_FLAGS"] = 37141] = "SYNC_FLAGS";
  GL[GL["SYNC_FENCE"] = 37142] = "SYNC_FENCE";
  GL[GL["SYNC_GPU_COMMANDS_COMPLETE"] = 37143] = "SYNC_GPU_COMMANDS_COMPLETE";
  GL[GL["UNSIGNALED"] = 37144] = "UNSIGNALED";
  GL[GL["SIGNALED"] = 37145] = "SIGNALED";
  GL[GL["ALREADY_SIGNALED"] = 37146] = "ALREADY_SIGNALED";
  GL[GL["TIMEOUT_EXPIRED"] = 37147] = "TIMEOUT_EXPIRED";
  GL[GL["CONDITION_SATISFIED"] = 37148] = "CONDITION_SATISFIED";
  GL[GL["WAIT_FAILED"] = 37149] = "WAIT_FAILED";
  GL[GL["SYNC_FLUSH_COMMANDS_BIT"] = 1] = "SYNC_FLUSH_COMMANDS_BIT"; // Miscellaneous constants

  GL[GL["COLOR"] = 6144] = "COLOR";
  GL[GL["DEPTH"] = 6145] = "DEPTH";
  GL[GL["STENCIL"] = 6146] = "STENCIL";
  GL[GL["MIN"] = 32775] = "MIN";
  GL[GL["MAX"] = 32776] = "MAX";
  GL[GL["DEPTH_COMPONENT24"] = 33190] = "DEPTH_COMPONENT24";
  GL[GL["STREAM_READ"] = 35041] = "STREAM_READ";
  GL[GL["STREAM_COPY"] = 35042] = "STREAM_COPY";
  GL[GL["STATIC_READ"] = 35045] = "STATIC_READ";
  GL[GL["STATIC_COPY"] = 35046] = "STATIC_COPY";
  GL[GL["DYNAMIC_READ"] = 35049] = "DYNAMIC_READ";
  GL[GL["DYNAMIC_COPY"] = 35050] = "DYNAMIC_COPY";
  GL[GL["DEPTH_COMPONENT32F"] = 36012] = "DEPTH_COMPONENT32F";
  GL[GL["DEPTH32F_STENCIL8"] = 36013] = "DEPTH32F_STENCIL8";
  GL[GL["INVALID_INDEX"] = 4294967295] = "INVALID_INDEX";
  GL[GL["TIMEOUT_IGNORED"] = -1] = "TIMEOUT_IGNORED";
  GL[GL["MAX_CLIENT_WAIT_TIMEOUT_WEBGL"] = 37447] = "MAX_CLIENT_WAIT_TIMEOUT_WEBGL"; // Constants defined in WebGL extensions
  // ANGLE_instanced_arrays

  GL[GL["VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE"] = 35070] = "VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE"; // WEBGL_debug_renderer_info

  GL[GL["UNMASKED_VENDOR_WEBGL"] = 37445] = "UNMASKED_VENDOR_WEBGL";
  GL[GL["UNMASKED_RENDERER_WEBGL"] = 37446] = "UNMASKED_RENDERER_WEBGL"; // EXT_texture_filter_anisotropic

  GL[GL["MAX_TEXTURE_MAX_ANISOTROPY_EXT"] = 34047] = "MAX_TEXTURE_MAX_ANISOTROPY_EXT";
  GL[GL["TEXTURE_MAX_ANISOTROPY_EXT"] = 34046] = "TEXTURE_MAX_ANISOTROPY_EXT"; // WEBGL_compressed_texture_s3tc

  GL[GL["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
  GL[GL["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
  GL[GL["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
  GL[GL["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT"; // WEBGL_compressed_texture_es3

  GL[GL["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
  GL[GL["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
  GL[GL["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
  GL[GL["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
  GL[GL["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
  GL[GL["COMPRESSED_RGBA8_ETC2_EAC"] = 37493] = "COMPRESSED_RGBA8_ETC2_EAC";
  GL[GL["COMPRESSED_SRGB8_ETC2"] = 37494] = "COMPRESSED_SRGB8_ETC2";
  GL[GL["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37495] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
  GL[GL["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37496] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
  GL[GL["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37497] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"; // WEBGL_compressed_texture_pvrtc

  GL[GL["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
  GL[GL["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
  GL[GL["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
  GL[GL["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"; // WEBGL_compressed_texture_etc1

  GL[GL["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL"; // WEBGL_compressed_texture_atc

  GL[GL["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
  GL[GL["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
  GL[GL["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"; // WEBGL_depth_texture

  GL[GL["UNSIGNED_INT_24_8_WEBGL"] = 34042] = "UNSIGNED_INT_24_8_WEBGL"; // OES_texture_half_float

  GL[GL["HALF_FLOAT_OES"] = 36193] = "HALF_FLOAT_OES"; // WEBGL_color_buffer_float

  GL[GL["RGBA32F_EXT"] = 34836] = "RGBA32F_EXT";
  GL[GL["RGB32F_EXT"] = 34837] = "RGB32F_EXT";
  GL[GL["FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT"] = 33297] = "FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT";
  GL[GL["UNSIGNED_NORMALIZED_EXT"] = 35863] = "UNSIGNED_NORMALIZED_EXT"; // EXT_blend_minmax

  GL[GL["MIN_EXT"] = 32775] = "MIN_EXT";
  GL[GL["MAX_EXT"] = 32776] = "MAX_EXT"; // EXT_sRGB

  GL[GL["SRGB_EXT"] = 35904] = "SRGB_EXT";
  GL[GL["SRGB_ALPHA_EXT"] = 35906] = "SRGB_ALPHA_EXT";
  GL[GL["SRGB8_ALPHA8_EXT"] = 35907] = "SRGB8_ALPHA8_EXT";
  GL[GL["FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING_EXT"] = 33296] = "FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING_EXT"; // OES_standard_derivatives

  GL[GL["FRAGMENT_SHADER_DERIVATIVE_HINT_OES"] = 35723] = "FRAGMENT_SHADER_DERIVATIVE_HINT_OES"; // WEBGL_draw_buffers

  GL[GL["COLOR_ATTACHMENT0_WEBGL"] = 36064] = "COLOR_ATTACHMENT0_WEBGL";
  GL[GL["COLOR_ATTACHMENT1_WEBGL"] = 36065] = "COLOR_ATTACHMENT1_WEBGL";
  GL[GL["COLOR_ATTACHMENT2_WEBGL"] = 36066] = "COLOR_ATTACHMENT2_WEBGL";
  GL[GL["COLOR_ATTACHMENT3_WEBGL"] = 36067] = "COLOR_ATTACHMENT3_WEBGL";
  GL[GL["COLOR_ATTACHMENT4_WEBGL"] = 36068] = "COLOR_ATTACHMENT4_WEBGL";
  GL[GL["COLOR_ATTACHMENT5_WEBGL"] = 36069] = "COLOR_ATTACHMENT5_WEBGL";
  GL[GL["COLOR_ATTACHMENT6_WEBGL"] = 36070] = "COLOR_ATTACHMENT6_WEBGL";
  GL[GL["COLOR_ATTACHMENT7_WEBGL"] = 36071] = "COLOR_ATTACHMENT7_WEBGL";
  GL[GL["COLOR_ATTACHMENT8_WEBGL"] = 36072] = "COLOR_ATTACHMENT8_WEBGL";
  GL[GL["COLOR_ATTACHMENT9_WEBGL"] = 36073] = "COLOR_ATTACHMENT9_WEBGL";
  GL[GL["COLOR_ATTACHMENT10_WEBGL"] = 36074] = "COLOR_ATTACHMENT10_WEBGL";
  GL[GL["COLOR_ATTACHMENT11_WEBGL"] = 36075] = "COLOR_ATTACHMENT11_WEBGL";
  GL[GL["COLOR_ATTACHMENT12_WEBGL"] = 36076] = "COLOR_ATTACHMENT12_WEBGL";
  GL[GL["COLOR_ATTACHMENT13_WEBGL"] = 36077] = "COLOR_ATTACHMENT13_WEBGL";
  GL[GL["COLOR_ATTACHMENT14_WEBGL"] = 36078] = "COLOR_ATTACHMENT14_WEBGL";
  GL[GL["COLOR_ATTACHMENT15_WEBGL"] = 36079] = "COLOR_ATTACHMENT15_WEBGL";
  GL[GL["DRAW_BUFFER0_WEBGL"] = 34853] = "DRAW_BUFFER0_WEBGL";
  GL[GL["DRAW_BUFFER1_WEBGL"] = 34854] = "DRAW_BUFFER1_WEBGL";
  GL[GL["DRAW_BUFFER2_WEBGL"] = 34855] = "DRAW_BUFFER2_WEBGL";
  GL[GL["DRAW_BUFFER3_WEBGL"] = 34856] = "DRAW_BUFFER3_WEBGL";
  GL[GL["DRAW_BUFFER4_WEBGL"] = 34857] = "DRAW_BUFFER4_WEBGL";
  GL[GL["DRAW_BUFFER5_WEBGL"] = 34858] = "DRAW_BUFFER5_WEBGL";
  GL[GL["DRAW_BUFFER6_WEBGL"] = 34859] = "DRAW_BUFFER6_WEBGL";
  GL[GL["DRAW_BUFFER7_WEBGL"] = 34860] = "DRAW_BUFFER7_WEBGL";
  GL[GL["DRAW_BUFFER8_WEBGL"] = 34861] = "DRAW_BUFFER8_WEBGL";
  GL[GL["DRAW_BUFFER9_WEBGL"] = 34862] = "DRAW_BUFFER9_WEBGL";
  GL[GL["DRAW_BUFFER10_WEBGL"] = 34863] = "DRAW_BUFFER10_WEBGL";
  GL[GL["DRAW_BUFFER11_WEBGL"] = 34864] = "DRAW_BUFFER11_WEBGL";
  GL[GL["DRAW_BUFFER12_WEBGL"] = 34865] = "DRAW_BUFFER12_WEBGL";
  GL[GL["DRAW_BUFFER13_WEBGL"] = 34866] = "DRAW_BUFFER13_WEBGL";
  GL[GL["DRAW_BUFFER14_WEBGL"] = 34867] = "DRAW_BUFFER14_WEBGL";
  GL[GL["DRAW_BUFFER15_WEBGL"] = 34868] = "DRAW_BUFFER15_WEBGL";
  GL[GL["MAX_COLOR_ATTACHMENTS_WEBGL"] = 36063] = "MAX_COLOR_ATTACHMENTS_WEBGL";
  GL[GL["MAX_DRAW_BUFFERS_WEBGL"] = 34852] = "MAX_DRAW_BUFFERS_WEBGL"; // OES_vertex_array_object

  GL[GL["VERTEX_ARRAY_BINDING_OES"] = 34229] = "VERTEX_ARRAY_BINDING_OES"; // EXT_disjoint_timer_query

  GL[GL["QUERY_COUNTER_BITS_EXT"] = 34916] = "QUERY_COUNTER_BITS_EXT";
  GL[GL["CURRENT_QUERY_EXT"] = 34917] = "CURRENT_QUERY_EXT";
  GL[GL["QUERY_RESULT_EXT"] = 34918] = "QUERY_RESULT_EXT";
  GL[GL["QUERY_RESULT_AVAILABLE_EXT"] = 34919] = "QUERY_RESULT_AVAILABLE_EXT";
  GL[GL["TIME_ELAPSED_EXT"] = 35007] = "TIME_ELAPSED_EXT";
  GL[GL["TIMESTAMP_EXT"] = 36392] = "TIMESTAMP_EXT";
  GL[GL["GPU_DISJOINT_EXT"] = 36795] = "GPU_DISJOINT_EXT";
})(GL || (GL = {}));

function assert(b) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!b) {
    console.error(new Error().stack);
    throw new Error("Assert fail: ".concat(message));
  }
}
function assertExists(v) {
  if (v !== undefined && v !== null) return v;else throw new Error('Missing object');
}

function colorEqual(c0, c1) {
  return c0.r === c1.r && c0.g === c1.g && c0.b === c1.b && c0.a === c1.a;
}
function colorCopy(dst, src) {
  dst.r = src.r;
  dst.g = src.g;
  dst.b = src.b;
  dst.a = src.a;
}
function colorNewCopy(src) {
  var r = src.r,
      g = src.g,
      b = src.b,
      a = src.a;
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}

function colorNewFromRGBA(r, g, b) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.0;
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
var TransparentBlack = colorNewFromRGBA(0, 0, 0, 0);
var OpaqueBlack = colorNewFromRGBA(0, 0, 0, 1);
var TransparentWhite = colorNewFromRGBA(1, 1, 1, 0);
var OpaqueWhite = colorNewFromRGBA(1, 1, 1, 1);

function isPowerOfTwo(n) {
  return n && (n & n - 1) === 0;
}
function fallbackUndefined(v, fallback) {
  return v !== null && v !== undefined ? v : fallback;
}
function nullify(v) {
  return v === undefined ? null : v;
}
function fillArray(L, n, v) {
  L.length = n;
  L.fill(v);
}
function align(n, multiple) {
  var mask = multiple - 1;
  return n + mask & ~mask;
}
function alignNonPowerOfTwo(n, multiple) {
  return ((n + multiple - 1) / multiple | 0) * multiple;
} // @see https://github.com/d3/d3-array#bisectRight

function bisectRight(L, e, compare) {
  var lo = 0,
      hi = L.length;

  while (lo < hi) {
    var mid = lo + (hi - lo >>> 1);
    var cmp = compare(e, L[mid]);
    if (cmp < 0) hi = mid;else lo = mid + 1;
  }

  return lo;
}
function spliceBisectRight(L, e, compare) {
  var idx = bisectRight(L, e, compare);
  L.splice(idx, 0, e);
}
function setBitFlagEnabled(v, mask, enabled) {
  if (enabled) v |= mask;else v &= ~mask;
  return v;
}
function nArray(n, c) {
  var d = new Array(n);

  for (var i = 0; i < n; i++) {
    d[i] = c();
  }

  return d;
}
function prependLineNo(str) {
  var lineStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var lines = str.split('\n');
  return lines.map(function (s, i) {
    return "".concat(leftPad('' + (lineStart + i), 4, ' '), "  ").concat(s);
  }).join('\n');
}
function leftPad(S, spaces) {
  var ch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

  while (S.length < spaces) {
    S = "".concat(ch).concat(S);
  }

  return S;
}

function copyChannelBlendState(dst, src) {
  dst.blendDstFactor = src.blendDstFactor;
  dst.blendSrcFactor = src.blendSrcFactor;
  dst.blendMode = src.blendMode;
}

function copyAttachmentState(dst, src) {
  if (dst === undefined) {
    dst = {
      rgbBlendState: {},
      alphaBlendState: {},
      channelWriteMask: 0
    };
  }

  copyChannelBlendState(dst.rgbBlendState, src.rgbBlendState);
  copyChannelBlendState(dst.alphaBlendState, src.alphaBlendState);
  dst.channelWriteMask = src.channelWriteMask;
  return dst;
}

function copyAttachmentsState(dst, src) {
  if (dst.length !== src.length) dst.length = src.length;

  for (var i = 0; i < src.length; i++) {
    dst[i] = copyAttachmentState(dst[i], src[i]);
  }
}

function setMegaStateFlags(dst, src) {
  if (src.attachmentsState !== undefined) {
    copyAttachmentsState(dst.attachmentsState, src.attachmentsState);
  }

  if (src.blendConstant !== undefined) {
    colorCopy(dst.blendConstant, src.blendConstant);
  }

  dst.depthCompare = fallbackUndefined(src.depthCompare, dst.depthCompare);
  dst.depthWrite = fallbackUndefined(src.depthWrite, dst.depthWrite);
  dst.stencilCompare = fallbackUndefined(src.stencilCompare, dst.stencilCompare);
  dst.stencilWrite = fallbackUndefined(src.stencilWrite, dst.stencilWrite);
  dst.stencilPassOp = fallbackUndefined(src.stencilPassOp, dst.stencilPassOp);
  dst.stencilRef = fallbackUndefined(src.stencilRef, dst.stencilRef);
  dst.cullMode = fallbackUndefined(src.cullMode, dst.cullMode);
  dst.frontFace = fallbackUndefined(src.frontFace, dst.frontFace);
  dst.polygonOffset = fallbackUndefined(src.polygonOffset, dst.polygonOffset);
}
function copyMegaState(src) {
  var dst = Object.assign({}, src); // Copy fields that need copying.

  dst.attachmentsState = [];
  copyAttachmentsState(dst.attachmentsState, src.attachmentsState);
  dst.blendConstant = colorNewCopy(dst.blendConstant);
  return dst;
}
function makeMegaState() {
  var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var src = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMegaState;
  var dst = copyMegaState(src);
  if (other !== null) setMegaStateFlags(dst, other);
  return dst;
}
function copyAttachmentStateFromSimple(dst, src) {
  if (src.channelWriteMask !== undefined) {
    dst.channelWriteMask = src.channelWriteMask;
  }

  if (src.rgbBlendMode !== undefined) {
    dst.rgbBlendState.blendMode = src.rgbBlendMode;
  }

  if (src.alphaBlendMode !== undefined) {
    dst.alphaBlendState.blendMode = src.alphaBlendMode;
  }

  if (src.rgbBlendSrcFactor !== undefined) {
    dst.rgbBlendState.blendSrcFactor = src.rgbBlendSrcFactor;
  }

  if (src.alphaBlendSrcFactor !== undefined) {
    dst.alphaBlendState.blendSrcFactor = src.alphaBlendSrcFactor;
  }

  if (src.rgbBlendDstFactor !== undefined) {
    dst.rgbBlendState.blendDstFactor = src.rgbBlendDstFactor;
  }

  if (src.alphaBlendDstFactor !== undefined) {
    dst.alphaBlendState.blendDstFactor = src.alphaBlendDstFactor;
  }
}
function setAttachmentStateSimple(dst, simple) {
  if (dst.attachmentsState === undefined) {
    dst.attachmentsState = [];
    copyAttachmentsState(dst.attachmentsState, defaultMegaState.attachmentsState);
  }

  copyAttachmentStateFromSimple(dst.attachmentsState[0], simple);
  return dst;
}
var defaultBlendState = {
  blendMode: BlendMode.Add,
  blendSrcFactor: BlendFactor.One,
  blendDstFactor: BlendFactor.Zero
};
var defaultMegaState = {
  attachmentsState: [{
    channelWriteMask: ChannelWriteMask.RGB,
    rgbBlendState: defaultBlendState,
    alphaBlendState: defaultBlendState
  }],
  blendConstant: colorNewCopy(TransparentBlack),
  depthWrite: true,
  depthCompare: CompareMode.LessEqual,
  // depthCompare: reverseDepthForCompareMode(CompareMode.LessEqual),
  // stencilCompare: CompareMode.Never,
  stencilCompare: CompareMode.Always,
  stencilWrite: false,
  stencilPassOp: StencilOp.Keep,
  stencilRef: 0,
  cullMode: CullMode.None,
  frontFace: FrontFaceMode.CCW,
  polygonOffset: false
};
var fullscreenMegaState = makeMegaState({
  depthCompare: CompareMode.Always,
  depthWrite: false
}, defaultMegaState);

function arrayEqual(a, b, e) {
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; i++) {
    if (!e(a[i], b[i])) return false;
  }

  return true;
}
function arrayCopy(a, copyFunc) {
  var b = Array(a.length);

  for (var i = 0; i < a.length; i++) {
    b[i] = copyFunc(a[i]);
  }

  return b;
}

function bufferBindingEquals(a, b) {
  return a.buffer === b.buffer && a.wordCount === b.wordCount;
}

function samplerBindingEquals(a, b) {
  if (a === null) return b === null;
  if (b === null) return false;
  return a.sampler === b.sampler && a.texture === b.texture;
}

function bindingLayoutDescriptorEqual(a, b) {
  if (a.numSamplers !== b.numSamplers) return false;
  if (a.numUniformBuffers !== b.numUniformBuffers) return false;
  return true;
}
function bindingsDescriptorEquals(a, b) {
  if (a.samplerBindings.length !== b.samplerBindings.length) return false;
  if (!arrayEqual(a.samplerBindings, b.samplerBindings, samplerBindingEquals)) return false;
  if (!arrayEqual(a.uniformBufferBindings, b.uniformBufferBindings, bufferBindingEquals)) return false;
  if (!bindingLayoutEquals(a.bindingLayout, b.bindingLayout)) return false;
  return true;
}

function channelBlendStateEquals(a, b) {
  return a.blendMode == b.blendMode && a.blendSrcFactor === b.blendSrcFactor && a.blendDstFactor === b.blendDstFactor;
}

function attachmentStateEquals(a, b) {
  if (!channelBlendStateEquals(a.rgbBlendState, b.rgbBlendState)) return false;
  if (!channelBlendStateEquals(a.alphaBlendState, b.alphaBlendState)) return false;
  if (a.channelWriteMask !== b.channelWriteMask) return false;
  return true;
}

function megaStateDescriptorEquals(a, b) {
  if (!arrayEqual(a.attachmentsState, b.attachmentsState, attachmentStateEquals)) return false;
  if (!colorEqual(a.blendConstant, b.blendConstant)) return false;
  return a.depthCompare === b.depthCompare && a.depthWrite === b.depthWrite && a.stencilCompare === b.stencilCompare && a.stencilWrite === b.stencilWrite && a.stencilPassOp === b.stencilPassOp && a.stencilRef === b.stencilRef && a.cullMode === b.cullMode && a.frontFace === b.frontFace && a.polygonOffset === b.polygonOffset;
}

function bindingLayoutEquals(a, b) {
  return a.numSamplers === b.numSamplers && a.numUniformBuffers === b.numUniformBuffers;
}

function programEquals(a, b) {
  return a.id === b.id;
}

function formatEquals(a, b) {
  return a === b;
}

function renderPipelineDescriptorEquals(a, b) {
  if (a.topology !== b.topology) return false;
  if (a.inputLayout !== b.inputLayout) return false;
  if (a.sampleCount !== b.sampleCount) return false;
  if (!megaStateDescriptorEquals(a.megaStateDescriptor, b.megaStateDescriptor)) return false;
  if (!programEquals(a.program, b.program)) return false;
  if (!arrayEqual(a.bindingLayouts, b.bindingLayouts, bindingLayoutEquals)) return false;
  if (!arrayEqual(a.colorAttachmentFormats, b.colorAttachmentFormats, formatEquals)) return false;
  if (a.depthStencilAttachmentFormat !== b.depthStencilAttachmentFormat) return false;
  return true;
}
function vertexAttributeDescriptorEquals(a, b) {
  return a.bufferIndex === b.bufferIndex && a.bufferByteOffset === b.bufferByteOffset && a.location === b.location && a.format === b.format;
}
function inputLayoutBufferDescriptorEquals(a, b) {
  if (isNil(a)) return isNil(b);
  if (isNil(b)) return false;
  return a.byteStride === b.byteStride && a.frequency === b.frequency;
}
function inputLayoutDescriptorEquals(a, b) {
  if (a.indexBufferFormat !== b.indexBufferFormat) return false;
  if (!arrayEqual(a.vertexBufferDescriptors, b.vertexBufferDescriptors, inputLayoutBufferDescriptorEquals)) return false;
  if (!arrayEqual(a.vertexAttributeDescriptors, b.vertexAttributeDescriptors, vertexAttributeDescriptorEquals)) return false;
  return true;
}
function samplerDescriptorEquals(a, b) {
  return a.wrapS === b.wrapS && a.wrapT === b.wrapT && a.minFilter === b.minFilter && a.magFilter === b.magFilter && a.mipFilter === b.mipFilter && a.minLOD === b.minLOD && a.maxLOD === b.maxLOD;
}
function samplerBindingCopy(a) {
  var sampler = a.sampler;
  var texture = a.texture;
  var lateBinding = a.lateBinding;
  return {
    sampler: sampler,
    texture: texture,
    lateBinding: lateBinding
  };
}
function bufferBindingCopy(a) {
  var buffer = a.buffer;
  var wordCount = a.wordCount;
  return {
    buffer: buffer,
    wordCount: wordCount
  };
}
function bindingsDescriptorCopy(a) {
  var bindingLayout = a.bindingLayout;
  var samplerBindings = arrayCopy(a.samplerBindings, samplerBindingCopy);
  var uniformBufferBindings = arrayCopy(a.uniformBufferBindings, bufferBindingCopy);
  return {
    bindingLayout: bindingLayout,
    samplerBindings: samplerBindings,
    uniformBufferBindings: uniformBufferBindings,
    pipeline: a.pipeline
  };
}
function bindingLayoutSamplerDescriptorCopy(a) {
  var dimension = a.dimension,
      formatKind = a.formatKind;
  return {
    dimension: dimension,
    formatKind: formatKind
  };
}
function bindingLayoutDescriptorCopy(a) {
  var numSamplers = a.numSamplers;
  var numUniformBuffers = a.numUniformBuffers;
  var samplerEntries = a.samplerEntries !== undefined ? arrayCopy(a.samplerEntries, bindingLayoutSamplerDescriptorCopy) : undefined;
  return {
    numSamplers: numSamplers,
    numUniformBuffers: numUniformBuffers,
    samplerEntries: samplerEntries
  };
}
function renderPipelineDescriptorCopy(a) {
  var bindingLayouts = arrayCopy(a.bindingLayouts, bindingLayoutDescriptorCopy);
  var inputLayout = a.inputLayout;
  var program = a.program;
  var topology = a.topology;
  var megaStateDescriptor = copyMegaState(a.megaStateDescriptor);
  var colorAttachmentFormats = a.colorAttachmentFormats.slice();
  var depthStencilAttachmentFormat = a.depthStencilAttachmentFormat;
  var sampleCount = a.sampleCount;
  return {
    bindingLayouts: bindingLayouts,
    inputLayout: inputLayout,
    megaStateDescriptor: megaStateDescriptor,
    program: program,
    topology: topology,
    colorAttachmentFormats: colorAttachmentFormats,
    depthStencilAttachmentFormat: depthStencilAttachmentFormat,
    sampleCount: sampleCount
  };
}
function vertexAttributeDescriptorCopy(a) {
  var location = a.location;
  var format = a.format;
  var bufferIndex = a.bufferIndex;
  var bufferByteOffset = a.bufferByteOffset;
  var byteStride = a.byteStride;
  var divisor = a.divisor;
  return {
    location: location,
    format: format,
    bufferIndex: bufferIndex,
    bufferByteOffset: bufferByteOffset,
    byteStride: byteStride,
    divisor: divisor
  };
}
function inputLayoutBufferDescriptorCopy(a) {
  if (!isNil(a)) {
    var byteStride = a.byteStride;
    var frequency = a.frequency;
    return {
      byteStride: byteStride,
      frequency: frequency
    };
  } else {
    return a;
  }
}
function inputLayoutDescriptorCopy(a) {
  var vertexAttributeDescriptors = arrayCopy(a.vertexAttributeDescriptors, vertexAttributeDescriptorCopy);
  var vertexBufferDescriptors = arrayCopy(a.vertexBufferDescriptors, inputLayoutBufferDescriptorCopy);
  var indexBufferFormat = a.indexBufferFormat;
  return {
    vertexAttributeDescriptors: vertexAttributeDescriptors,
    vertexBufferDescriptors: vertexBufferDescriptors,
    indexBufferFormat: indexBufferFormat
  };
}

var Endianness;

(function (Endianness) {
  Endianness[Endianness["LITTLE_ENDIAN"] = 0] = "LITTLE_ENDIAN";
  Endianness[Endianness["BIG_ENDIAN"] = 1] = "BIG_ENDIAN";
})(Endianness || (Endianness = {}));

var test = new Uint16Array([0xfeff]);
var testView = new DataView(test.buffer);
var systemEndianness = testView.getUint8(0) == 0xff ? Endianness.LITTLE_ENDIAN : Endianness.BIG_ENDIAN;

var _UNIFORM_SETTERS;

var UNIFORM_NAME_REGEXP = /([^[]*)(\[[0-9]+\])?/;
function parseUniformName(name) {
  // Shortcut to avoid redundant or bad matches
  if (name[name.length - 1] !== ']') {
    return {
      name: name,
      length: 1,
      isArray: false
    };
  }

  var matches = name.match(UNIFORM_NAME_REGEXP);

  if (!matches || matches.length < 2) {
    throw new Error("Failed to parse GLSL uniform name ".concat(name));
  }

  return {
    name: matches[1],
    length: Number(matches[2]) || 1,
    isArray: Boolean(matches[2])
  };
}
function getUniformSetter(gl, location, info) {
  var setter = UNIFORM_SETTERS[info.type];

  if (!setter) {
    throw new Error("Unknown GLSL uniform type ".concat(info.type));
  }

  return setter().bind(null, gl, location);
}

function getSamplerSetter() {
  var cache = null;
  return function (gl, location, value) {
    var update = cache !== value;

    if (update) {
      gl.uniform1i(location, value);
      cache = value;
    }

    return update;
  };
}

function getArraySetter(functionName, toArray, size, uniformSetter) {
  var cache = null;
  var cacheLength = null;
  return function (gl, location, value) {
    var arrayValue = toArray(value, size);
    var length = arrayValue.length;
    var update = false;

    if (cache === null) {
      cache = new Float32Array(length);
      cacheLength = length;
      update = true;
    } else {
      assert(cacheLength === length, 'Uniform length cannot change.');

      for (var i = 0; i < length; ++i) {
        if (arrayValue[i] !== cache[i]) {
          update = true;
          break;
        }
      }
    }

    if (update) {
      uniformSetter(gl, functionName, location, arrayValue);
      cache.set(arrayValue);
    }

    return update;
  };
}

function setVectorUniform(gl, functionName, location, value) {
  gl[functionName](location, value);
}

function setMatrixUniform(gl, functionName, location, value) {
  gl[functionName](location, false, value);
}

var FLOAT_ARRAY = {};
var INT_ARRAY = {};
var UINT_ARRAY = {};
var array1 = [0];

function toTypedArray(value, uniformLength, Type, cache) {
  // convert boolean uniforms to Number
  if (uniformLength === 1 && typeof value === 'boolean') {
    value = value ? 1 : 0;
  }

  if (Number.isFinite(value)) {
    array1[0] = value;
    value = array1;
  }

  var length = value.length;

  if (value instanceof Type) {
    return value;
  }

  var result = cache[length];

  if (!result) {
    result = new Type(length);
    cache[length] = result;
  }

  for (var i = 0; i < length; i++) {
    result[i] = value[i];
  }

  return result;
}

function toFloatArray(value, uniformLength) {
  return toTypedArray(value, uniformLength, Float32Array, FLOAT_ARRAY);
}

function toIntArray(value, uniformLength) {
  return toTypedArray(value, uniformLength, Int32Array, INT_ARRAY);
}

function toUIntArray(value, uniformLength) {
  return toTypedArray(value, uniformLength, Uint32Array, UINT_ARRAY);
}

var UNIFORM_SETTERS = (_UNIFORM_SETTERS = {}, _defineProperty(_UNIFORM_SETTERS, GL.FLOAT, getArraySetter.bind(null, 'uniform1fv', toFloatArray, 1, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_VEC2, getArraySetter.bind(null, 'uniform2fv', toFloatArray, 2, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_VEC3, getArraySetter.bind(null, 'uniform3fv', toFloatArray, 3, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_VEC4, getArraySetter.bind(null, 'uniform4fv', toFloatArray, 4, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.INT, getArraySetter.bind(null, 'uniform1iv', toIntArray, 1, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.INT_VEC2, getArraySetter.bind(null, 'uniform2iv', toIntArray, 2, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.INT_VEC3, getArraySetter.bind(null, 'uniform3iv', toIntArray, 3, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.INT_VEC4, getArraySetter.bind(null, 'uniform4iv', toIntArray, 4, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.BOOL, getArraySetter.bind(null, 'uniform1iv', toIntArray, 1, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.BOOL_VEC2, getArraySetter.bind(null, 'uniform2iv', toIntArray, 2, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.BOOL_VEC3, getArraySetter.bind(null, 'uniform3iv', toIntArray, 3, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.BOOL_VEC4, getArraySetter.bind(null, 'uniform4iv', toIntArray, 4, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT2, getArraySetter.bind(null, 'uniformMatrix2fv', toFloatArray, 4, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT3, getArraySetter.bind(null, 'uniformMatrix3fv', toFloatArray, 9, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT4, getArraySetter.bind(null, 'uniformMatrix4fv', toFloatArray, 16, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_2D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_CUBE, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT, getArraySetter.bind(null, 'uniform1uiv', toUIntArray, 1, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_VEC2, getArraySetter.bind(null, 'uniform2uiv', toUIntArray, 2, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_VEC3, getArraySetter.bind(null, 'uniform3uiv', toUIntArray, 3, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_VEC4, getArraySetter.bind(null, 'uniform4uiv', toUIntArray, 4, setVectorUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT2x3, getArraySetter.bind(null, 'uniformMatrix2x3fv', toFloatArray, 6, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT2x4, getArraySetter.bind(null, 'uniformMatrix2x4fv', toFloatArray, 8, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT3x2, getArraySetter.bind(null, 'uniformMatrix3x2fv', toFloatArray, 6, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT3x4, getArraySetter.bind(null, 'uniformMatrix3x4fv', toFloatArray, 12, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT4x2, getArraySetter.bind(null, 'uniformMatrix4x2fv', toFloatArray, 8, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.FLOAT_MAT4x3, getArraySetter.bind(null, 'uniformMatrix4x3fv', toFloatArray, 12, setMatrixUniform)), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_2D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_CUBE, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_3D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_2D_SHADOW, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_2D_ARRAY, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_2D_ARRAY_SHADOW, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.SAMPLER_CUBE_SHADOW, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.INT_SAMPLER_2D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.INT_SAMPLER_3D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.INT_SAMPLER_CUBE, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.INT_SAMPLER_2D_ARRAY, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_SAMPLER_2D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_SAMPLER_3D, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_SAMPLER_CUBE, getSamplerSetter), _defineProperty(_UNIFORM_SETTERS, GL.UNSIGNED_INT_SAMPLER_2D_ARRAY, getSamplerSetter), _UNIFORM_SETTERS);

var DynamicUniformBuffer = /*#__PURE__*/function () {
  function DynamicUniformBuffer(device) {
    _classCallCheck(this, DynamicUniformBuffer);

    this.device = void 0;
    this.uniformBufferWordAlignment = void 0;
    this.uniformBufferMaxPageWordSize = void 0;
    this.currentBufferWordSize = -1;
    this.currentWordOffset = 0;
    this.buffer = null;
    this.shadowBufferF32 = null;
    this.shadowBufferU8 = null;
    this.device = device;
    var limits = device.queryLimits();
    this.uniformBufferWordAlignment = limits.uniformBufferWordAlignment;
    this.uniformBufferMaxPageWordSize = limits.uniformBufferMaxPageWordSize;
  }

  _createClass(DynamicUniformBuffer, [{
    key: "isSupportedUBO",
    value: function isSupportedUBO() {
      // UBO not supported in WebGL1
      return this.device.queryVendorInfo().platformString !== 'WebGL1';
    }
  }, {
    key: "findPageIndex",
    value: function findPageIndex(wordOffset) {
      return wordOffset / this.uniformBufferMaxPageWordSize | 0;
    }
  }, {
    key: "allocateChunk",
    value: function allocateChunk(wordCount) {
      wordCount = alignNonPowerOfTwo(wordCount, this.uniformBufferWordAlignment);
      assert(wordCount < this.uniformBufferMaxPageWordSize);
      var wordOffset = this.currentWordOffset; // If we straddle the page, then put it at the start of the next one.

      if (this.findPageIndex(wordOffset) !== this.findPageIndex(wordOffset + wordCount - 1)) wordOffset = alignNonPowerOfTwo(wordOffset, this.uniformBufferMaxPageWordSize);
      this.currentWordOffset = wordOffset + wordCount;
      this.ensureShadowBuffer(wordOffset, wordCount);
      return wordOffset;
    }
  }, {
    key: "ensureShadowBuffer",
    value: function ensureShadowBuffer(wordOffset, wordCount) {
      if (this.shadowBufferU8 === null || this.shadowBufferF32 === null) {
        var newWordCount = alignNonPowerOfTwo(this.currentWordOffset, this.uniformBufferMaxPageWordSize);
        this.shadowBufferU8 = new Uint8Array(newWordCount * 4);
        this.shadowBufferF32 = new Float32Array(this.shadowBufferU8.buffer);
      } else if (wordOffset + wordCount >= this.shadowBufferF32.length) {
        assert(wordOffset < this.currentWordOffset && wordOffset + wordCount <= this.currentWordOffset); // Grow logarithmically, aligned to page size.

        var _newWordCount = alignNonPowerOfTwo(Math.max(this.currentWordOffset, this.shadowBufferF32.length * 2), this.uniformBufferMaxPageWordSize);

        var newBuffer = new Uint8Array(_newWordCount * 4);
        newBuffer.set(this.shadowBufferU8, 0);
        this.shadowBufferU8 = newBuffer;
        this.shadowBufferF32 = new Float32Array(this.shadowBufferU8.buffer);
        if (!(this.currentWordOffset <= _newWordCount)) throw new Error("Assert fail: this.currentWordOffset [".concat(this.currentWordOffset, "] <= newWordCount [").concat(_newWordCount, "]"));
      }
    }
    /**
     * Return the CPU data buffer used internally. Fill this in to submit data to the CPU. Write to
     * it with the offset that was returned from {@see allocateChunk}.
     */

  }, {
    key: "mapBufferF32",
    value: function mapBufferF32() {
      return assertExists(this.shadowBufferF32);
    }
  }, {
    key: "prepareToRender",
    value: function prepareToRender() {
      if (this.shadowBufferF32 === null) {
        return;
      }

      var shadowBufferF32 = assertExists(this.shadowBufferF32);

      if (shadowBufferF32.length !== this.currentBufferWordSize) {
        this.currentBufferWordSize = shadowBufferF32.length;

        if (this.buffer !== null) {
          this.buffer.destroy();
        }

        this.buffer = this.device.createBuffer({
          viewOrSize: this.currentBufferWordSize,
          usage: BufferUsage.UNIFORM,
          hint: BufferFrequencyHint.Dynamic
        });
      }

      var wordCount = alignNonPowerOfTwo(this.currentWordOffset, this.uniformBufferMaxPageWordSize);
      if (!(wordCount <= this.currentBufferWordSize)) throw new Error("Assert fail: wordCount [".concat(wordCount, "] (").concat(this.currentWordOffset, " aligned ").concat(this.uniformBufferMaxPageWordSize, ") <= this.currentBufferWordSize [").concat(this.currentBufferWordSize, "]"));

      if (this.isSupportedUBO()) {
        var buffer = assertExists(this.buffer);
        buffer.setSubData(0, this.shadowBufferU8, 0, wordCount * 4);
      } // Reset the offset for next frame.


      this.currentWordOffset = 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.buffer !== null) this.buffer.destroy();
      this.shadowBufferF32 = null;
      this.shadowBufferU8 = null;
    }
  }]);

  return DynamicUniformBuffer;
}();

// Jenkins One-at-a-Time hash from http://www.burtleburtle.net/bob/hash/doobs.html
function hashCodeNumberUpdate(hash, v) {
  hash += v;
  hash += hash << 10;
  hash += hash >>> 6;
  return hash >>> 0;
}
function hashCodeNumberFinish(hash) {
  hash += hash << 3;
  hash ^= hash >>> 11;
  hash += hash << 15;
  return hash >>> 0;
} // Pass this as a hash function to use a one-bucket HashMap (equivalent to linear search in an array),
// which can be efficient for small numbers of items.

function nullHashFunc(k) {
  return 0;
}

var HashBucket = /*#__PURE__*/_createClass(function HashBucket() {
  _classCallCheck(this, HashBucket);

  this.keys = [];
  this.values = [];
});

var HashMap = /*#__PURE__*/function () {
  function HashMap(keyEqualFunc, keyHashFunc) {
    _classCallCheck(this, HashMap);

    this.keyEqualFunc = void 0;
    this.keyHashFunc = void 0;
    this.buckets = new Map();
    this.keyEqualFunc = keyEqualFunc;
    this.keyHashFunc = keyHashFunc;
  }

  _createClass(HashMap, [{
    key: "findBucketIndex",
    value: function findBucketIndex(bucket, k) {
      for (var i = 0; i < bucket.keys.length; i++) {
        if (this.keyEqualFunc(k, bucket.keys[i])) return i;
      }

      return -1;
    }
  }, {
    key: "findBucket",
    value: function findBucket(k) {
      var bw = this.keyHashFunc(k);
      return this.buckets.get(bw);
    }
  }, {
    key: "get",
    value: function get(k) {
      var bucket = this.findBucket(k);
      if (bucket === undefined) return null;
      var bi = this.findBucketIndex(bucket, k);
      if (bi < 0) return null;
      return bucket.values[bi];
    }
  }, {
    key: "add",
    value: function add(k, v) {
      var bw = this.keyHashFunc(k);
      if (this.buckets.get(bw) === undefined) this.buckets.set(bw, new HashBucket());
      var bucket = this.buckets.get(bw);
      bucket.keys.push(k);
      bucket.values.push(v);
    }
  }, {
    key: "delete",
    value: function _delete(k) {
      var bucket = this.findBucket(k);
      if (bucket === undefined) return;
      var bi = this.findBucketIndex(bucket, k);
      if (bi === -1) return;
      bucket.keys.splice(bi, 1);
      bucket.values.splice(bi, 1);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.buckets.clear();
    }
  }, {
    key: "size",
    value: function size() {
      var acc = 0;

      var _iterator = _createForOfIteratorHelper(this.buckets.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bucket = _step.value;
          acc += bucket.values.length;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return acc;
    }
  }, {
    key: "values",
    value: /*#__PURE__*/regeneratorRuntime.mark(function values() {
      var _iterator2, _step2, bucket, j;

      return regeneratorRuntime.wrap(function values$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.buckets.values());
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 14;
                break;
              }

              bucket = _step2.value;
              j = bucket.values.length - 1;

            case 6:
              if (!(j >= 0)) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return bucket.values[j];

            case 9:
              j--;
              _context.next = 6;
              break;

            case 12:
              _context.next = 3;
              break;

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 19:
              _context.prev = 19;

              _iterator2.f();

              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, values, this, [[1, 16, 19, 22]]);
    })
  }]);

  return HashMap;
}();

function programDescriptorSimpleEquals(a, b) {
  assert(a.preprocessedVert !== '' && b.preprocessedVert !== '');
  assert(a.preprocessedFrag !== '' && b.preprocessedFrag !== '');
  return a.preprocessedVert === b.preprocessedVert && a.preprocessedFrag === b.preprocessedFrag;
}

function programDescriptorSimpleCopy(a) {
  var preprocessedVert = a.preprocessedVert;
  var preprocessedFrag = a.preprocessedFrag;
  var vert = a.vert;
  var frag = a.frag;
  return {
    preprocessedVert: preprocessedVert,
    preprocessedFrag: preprocessedFrag,
    vert: vert,
    frag: frag
  };
}

function renderBindingLayoutHash(hash, a) {
  hash = hashCodeNumberUpdate(hash, a.numUniformBuffers);
  hash = hashCodeNumberUpdate(hash, a.numSamplers);
  return hash;
}

function blendStateHash(hash, a) {
  hash = hashCodeNumberUpdate(hash, a.blendMode);
  hash = hashCodeNumberUpdate(hash, a.blendSrcFactor);
  hash = hashCodeNumberUpdate(hash, a.blendDstFactor);
  return hash;
}

function attachmentStateHash(hash, a) {
  hash = blendStateHash(hash, a.rgbBlendState);
  hash = blendStateHash(hash, a.alphaBlendState);
  hash = hashCodeNumberUpdate(hash, a.channelWriteMask);
  return hash;
}

function colorHash(hash, a) {
  hash = hashCodeNumberUpdate(hash, a.r << 24 | a.g << 16 | a.b << 8 | a.a);
  return hash;
}

function megaStateDescriptorHash(hash, a) {
  for (var i = 0; i < a.attachmentsState.length; i++) {
    hash = attachmentStateHash(hash, a.attachmentsState[i]);
  }

  hash = colorHash(hash, a.blendConstant);
  hash = hashCodeNumberUpdate(hash, a.depthCompare);
  hash = hashCodeNumberUpdate(hash, a.depthWrite ? 1 : 0);
  hash = hashCodeNumberUpdate(hash, a.stencilCompare);
  hash = hashCodeNumberUpdate(hash, a.stencilPassOp);
  hash = hashCodeNumberUpdate(hash, a.stencilWrite ? 1 : 0);
  hash = hashCodeNumberUpdate(hash, a.cullMode);
  hash = hashCodeNumberUpdate(hash, a.frontFace ? 1 : 0);
  hash = hashCodeNumberUpdate(hash, a.polygonOffset ? 1 : 0);
  return hash;
}

function renderPipelineDescriptorHash(a) {
  var hash = 0;
  hash = hashCodeNumberUpdate(hash, a.program.id);
  if (a.inputLayout !== null) hash = hashCodeNumberUpdate(hash, a.inputLayout.id);

  for (var i = 0; i < a.bindingLayouts.length; i++) {
    hash = renderBindingLayoutHash(hash, a.bindingLayouts[i]);
  }

  hash = megaStateDescriptorHash(hash, a.megaStateDescriptor);

  for (var _i = 0; _i < a.colorAttachmentFormats.length; _i++) {
    hash = hashCodeNumberUpdate(hash, a.colorAttachmentFormats[_i] || 0);
  }

  hash = hashCodeNumberUpdate(hash, a.depthStencilAttachmentFormat || 0);
  return hashCodeNumberFinish(hash);
}

function bindingsDescriptorHash(a) {
  var hash = 0;

  for (var i = 0; i < a.samplerBindings.length; i++) {
    var binding = a.samplerBindings[i];
    if (binding !== null && binding.texture !== null) hash = hashCodeNumberUpdate(hash, binding.texture.id);
  }

  for (var _i2 = 0; _i2 < a.uniformBufferBindings.length; _i2++) {
    var _binding = a.uniformBufferBindings[_i2];

    if (_binding !== null && _binding.buffer !== null) {
      hash = hashCodeNumberUpdate(hash, _binding.buffer.id);
      hash = hashCodeNumberUpdate(hash, _binding.wordCount);
    }
  }

  return hashCodeNumberFinish(hash);
}

var RenderCache = /*#__PURE__*/function () {
  function RenderCache(device) {
    _classCallCheck(this, RenderCache);

    this.device = void 0;
    this.bindingsCache = new HashMap(bindingsDescriptorEquals, bindingsDescriptorHash);
    this.renderPipelinesCache = new HashMap(renderPipelineDescriptorEquals, renderPipelineDescriptorHash);
    this.inputLayoutsCache = new HashMap(inputLayoutDescriptorEquals, nullHashFunc);
    this.programCache = new HashMap(programDescriptorSimpleEquals, nullHashFunc);
    this.samplerCache = new HashMap(samplerDescriptorEquals, nullHashFunc);
    this.device = device;
  }

  _createClass(RenderCache, [{
    key: "createBindings",
    value: function createBindings(descriptor) {
      var bindings = this.bindingsCache.get(descriptor);

      if (bindings === null) {
        var descriptorCopy = bindingsDescriptorCopy(descriptor);
        bindings = this.device.createBindings(descriptorCopy);
        this.bindingsCache.add(descriptorCopy, bindings);
      }

      return bindings;
    }
  }, {
    key: "createRenderPipeline",
    value: function createRenderPipeline(descriptor) {
      var renderPipeline = this.renderPipelinesCache.get(descriptor);

      if (renderPipeline === null) {
        var descriptorCopy = renderPipelineDescriptorCopy(descriptor);
        renderPipeline = this.device.createRenderPipeline(descriptorCopy);
        this.renderPipelinesCache.add(descriptorCopy, renderPipeline);
      }

      return renderPipeline;
    }
  }, {
    key: "createInputLayout",
    value: function createInputLayout(descriptor) {
      var inputLayout = this.inputLayoutsCache.get(descriptor);

      if (inputLayout === null) {
        var descriptorCopy = inputLayoutDescriptorCopy(descriptor);
        inputLayout = this.device.createInputLayout(descriptorCopy);
        this.inputLayoutsCache.add(descriptorCopy, inputLayout);
      }

      return inputLayout;
    }
  }, {
    key: "createProgramSimple",
    value: function createProgramSimple(programDescriptorSimple) {
      var program = this.programCache.get(programDescriptorSimple);

      if (program === null) {
        var descriptorCopy = programDescriptorSimpleCopy(programDescriptorSimple);
        program = this.device.createProgramSimple(descriptorCopy);
        this.programCache.add(descriptorCopy, program);
      }

      return program;
    }
  }, {
    key: "createProgram",
    value: function createProgram(programDescriptor) {
      programDescriptor.ensurePreprocessed(this.device.queryVendorInfo());
      return this.createProgramSimple(programDescriptor);
    }
  }, {
    key: "createSampler",
    value: function createSampler(descriptor) {
      var sampler = this.samplerCache.get(descriptor);

      if (sampler === null) {
        sampler = this.device.createSampler(descriptor);
        this.samplerCache.add(descriptor, sampler);
      }

      return sampler;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.bindingsCache.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var bindings = _step.value;
          bindings.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.renderPipelinesCache.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var renderPipeline = _step2.value;
          renderPipeline.destroy();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.inputLayoutsCache.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var inputLayout = _step3.value;
          inputLayout.destroy();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(this.programCache.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var program = _step4.value;
          program.destroy();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(this.samplerCache.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var sampler = _step5.value;
          sampler.destroy();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.bindingsCache.clear();
      this.renderPipelinesCache.clear();
      this.inputLayoutsCache.clear();
      this.programCache.clear();
      this.samplerCache.clear();
    }
  }]);

  return RenderCache;
}();

var RGAttachmentSlot;

(function (RGAttachmentSlot) {
  RGAttachmentSlot[RGAttachmentSlot["Color0"] = 0] = "Color0";
  RGAttachmentSlot[RGAttachmentSlot["Color1"] = 1] = "Color1";
  RGAttachmentSlot[RGAttachmentSlot["Color2"] = 2] = "Color2";
  RGAttachmentSlot[RGAttachmentSlot["Color3"] = 3] = "Color3";
  RGAttachmentSlot[RGAttachmentSlot["ColorMax"] = 3] = "ColorMax";
  RGAttachmentSlot[RGAttachmentSlot["DepthStencil"] = 4] = "DepthStencil";
})(RGAttachmentSlot || (RGAttachmentSlot = {}));

var IdentityViewportCoords = {
  x: 0,
  y: 0,
  w: 1,
  h: 1
};

var RenderGraphPass = /*#__PURE__*/function () {
  function RenderGraphPass() {
    _classCallCheck(this, RenderGraphPass);

    this.renderTargetIDs = [];
    this.resolveTextureOutputIDs = [];
    this.resolveTextureOutputExternalTextures = [];
    this.resolveTextureInputIDs = [];
    this.renderTargetExtraRefs = [];
    this.viewport = IdentityViewportCoords;
    this.resolveTextureInputTextures = [];
    this.renderTargets = [];
    this.descriptor = {
      colorAttachment: [],
      colorResolveTo: [],
      colorStore: [],
      depthStencilAttachment: null,
      depthStencilResolveTo: null,
      depthStencilStore: true,
      colorClearColor: ['load'],
      depthClearValue: 'load',
      stencilClearValue: 'load',
      occlusionQueryPool: null
    };
    this.viewportX = 0;
    this.viewportY = 0;
    this.viewportW = 0;
    this.viewportH = 0;
    this.execFunc = null;
    this.postFunc = null;
    this.debugName = void 0;
    this.debugThumbnails = [];
  }

  _createClass(RenderGraphPass, [{
    key: "setDebugName",
    value: function setDebugName(debugName) {
      this.debugName = debugName;
    }
  }, {
    key: "pushDebugThumbnail",
    value: function pushDebugThumbnail(attachmentSlot) {
      this.debugThumbnails[attachmentSlot] = true;
    }
  }, {
    key: "setViewport",
    value: function setViewport(viewport) {
      this.viewport = viewport;
    }
  }, {
    key: "attachRenderTargetID",
    value: function attachRenderTargetID(attachmentSlot, renderTargetID) {
      assert(this.renderTargetIDs[attachmentSlot] === undefined);
      this.renderTargetIDs[attachmentSlot] = renderTargetID;
    }
  }, {
    key: "attachResolveTexture",
    value: function attachResolveTexture(resolveTextureID) {
      this.resolveTextureInputIDs.push(resolveTextureID);
    }
  }, {
    key: "attachOcclusionQueryPool",
    value: function attachOcclusionQueryPool(queryPool) {
      this.descriptor.occlusionQueryPool = queryPool;
    }
  }, {
    key: "resolveToExternalTexture",
    value: function resolveToExternalTexture(attachmentSlot, texture) {
      this.resolveTextureOutputExternalTextures[attachmentSlot] = texture;
    }
  }, {
    key: "exec",
    value: function exec(func) {
      assert(this.execFunc === null);
      this.execFunc = func;
    }
  }, {
    key: "post",
    value: function post(func) {
      assert(this.postFunc === null);
      this.postFunc = func;
    }
  }, {
    key: "addExtraRef",
    value: function addExtraRef(slot) {
      this.renderTargetExtraRefs[slot] = true;
    }
  }]);

  return RenderGraphPass;
}();

var RGRenderTarget = /*#__PURE__*/function () {
  function RGRenderTarget(device, desc) {
    _classCallCheck(this, RGRenderTarget);

    this.debugName = void 0;
    this.dimension = TextureDimension.n2D;
    this.depth = 1;
    this.numLevels = 1;
    this.pixelFormat = void 0;
    this.width = 0;
    this.height = 0;
    this.sampleCount = 0;
    this.usage = TextureUsage.RenderTarget;
    this.immutable = true;
    this.needsClear = true;
    this.texture = null;
    this.attachment = void 0;
    this.age = 0;
    this.pixelFormat = desc.pixelFormat;
    this.width = desc.width;
    this.height = desc.height;
    this.sampleCount = desc.sampleCount;
    assert(this.sampleCount >= 1);

    if (this.sampleCount > 1) {
      // MSAA render targets must be backed by attachments.
      this.attachment = device.createRenderTarget(this);
    } else {
      // Single-sampled textures can be backed by regular textures.
      this.texture = device.createTexture(this);
      device.setResourceName(this.texture, this.debugName);
      this.attachment = device.createRenderTargetFromTexture(this.texture);
    }

    device.setResourceName(this.attachment, this.debugName);
  }

  _createClass(RGRenderTarget, [{
    key: "matchesDescription",
    value: function matchesDescription(desc) {
      return this.pixelFormat === desc.pixelFormat && this.width === desc.width && this.height === desc.height && this.sampleCount === desc.sampleCount;
    }
  }, {
    key: "reset",
    value: function reset(desc) {
      assert(this.matchesDescription(desc));
      this.age = 0;
    }
  }, {
    key: "destroy",
    value: function destroy(device) {
      if (this.texture !== null) {
        this.texture.destroy();
      }

      this.attachment.destroy();
    }
  }]);

  return RGRenderTarget;
}();

// we record an extra single-sampled texture here.

var SingleSampledTexture = /*#__PURE__*/function () {
  function SingleSampledTexture(device, desc) {
    _classCallCheck(this, SingleSampledTexture);

    this.dimension = TextureDimension.n2D;
    this.depth = 1;
    this.numLevels = 1;
    this.usage = TextureUsage.RenderTarget;
    this.pixelFormat = void 0;
    this.width = 0;
    this.height = 0;
    this.texture = void 0;
    this.age = 0;
    this.immutable = true;
    this.pixelFormat = desc.pixelFormat;
    this.width = desc.width;
    this.height = desc.height;
    this.texture = device.createTexture(this);
  }

  _createClass(SingleSampledTexture, [{
    key: "matchesDescription",
    value: function matchesDescription(desc) {
      return this.pixelFormat === desc.pixelFormat && this.width === desc.width && this.height === desc.height;
    }
  }, {
    key: "reset",
    value: function reset(desc) {
      assert(this.matchesDescription(desc));
      this.age = 0;
    }
  }, {
    key: "destroy",
    value: function destroy(device) {
      this.texture.destroy();
    }
  }]);

  return SingleSampledTexture;
}();

var _Symbol$species;
_Symbol$species = Symbol.species;

var GraphImpl = /*#__PURE__*/_createClass(function GraphImpl() {
  _classCallCheck(this, GraphImpl);

  this[_Symbol$species] = void 0;
  this.renderTargetDescriptions = [];
  this.resolveTextureRenderTargetIDs = [];
  this.passes = [];
  this.renderTargetDebugNames = [];
});

var RenderGraph = /*#__PURE__*/function () {
  // For scope callbacks.
  //#region Resource Creation & Caching
  function RenderGraph(device) {
    _classCallCheck(this, RenderGraph);

    this.device = void 0;
    this.currentPass = null;
    this.renderTargetDeadPool = [];
    this.singleSampledTextureDeadPool = [];
    this.currentGraph = null;
    this.renderTargetOutputCount = [];
    this.renderTargetResolveCount = [];
    this.resolveTextureUseCount = [];
    this.renderTargetAliveForID = [];
    this.singleSampledTextureForResolveTextureID = [];
    this.device = device;
  }

  _createClass(RenderGraph, [{
    key: "acquireRenderTargetForDescription",
    value: function acquireRenderTargetForDescription(desc) {
      for (var i = 0; i < this.renderTargetDeadPool.length; i++) {
        var freeRenderTarget = this.renderTargetDeadPool[i];

        if (freeRenderTarget.matchesDescription(desc)) {
          // Pop it off the list.
          freeRenderTarget.reset(desc);
          this.renderTargetDeadPool.splice(i--, 1);
          return freeRenderTarget;
        }
      } // Allocate a new render target.


      return new RGRenderTarget(this.device, desc);
    }
  }, {
    key: "acquireSingleSampledTextureForDescription",
    value: function acquireSingleSampledTextureForDescription(desc) {
      for (var i = 0; i < this.singleSampledTextureDeadPool.length; i++) {
        var freeSingleSampledTexture = this.singleSampledTextureDeadPool[i];

        if (freeSingleSampledTexture.matchesDescription(desc)) {
          // Pop it off the list.
          freeSingleSampledTexture.reset(desc);
          this.singleSampledTextureDeadPool.splice(i--, 1);
          return freeSingleSampledTexture;
        }
      } // Allocate a new resolve texture.


      return new SingleSampledTexture(this.device, desc);
    } //#endregion
    //#region Graph Builder

  }, {
    key: "beginGraphBuilder",
    value: function beginGraphBuilder() {
      assert(this.currentGraph === null);
      this.currentGraph = new GraphImpl();
    }
  }, {
    key: "pushPass",
    value: function pushPass(setupFunc) {
      var pass = new RenderGraphPass();
      setupFunc(pass);
      this.currentGraph.passes.push(pass);
    }
  }, {
    key: "createRenderTargetID",
    value: function createRenderTargetID(desc, debugName) {
      this.currentGraph.renderTargetDebugNames.push(debugName);
      return this.currentGraph.renderTargetDescriptions.push(desc) - 1;
    }
  }, {
    key: "createResolveTextureID",
    value: function createResolveTextureID(renderTargetID) {
      return this.currentGraph.resolveTextureRenderTargetIDs.push(renderTargetID) - 1;
    }
    /**
     * 查找最靠近输出的一个关联目标 RT 的 RGPass
     */

  }, {
    key: "findMostRecentPassThatAttachedRenderTarget",
    value: function findMostRecentPassThatAttachedRenderTarget(renderTargetID) {
      for (var i = this.currentGraph.passes.length - 1; i >= 0; i--) {
        var pass = this.currentGraph.passes[i];
        if (pass.renderTargetIDs.includes(renderTargetID)) return pass;
      }

      return null;
    }
  }, {
    key: "resolveRenderTargetPassAttachmentSlot",
    value: function resolveRenderTargetPassAttachmentSlot(pass, attachmentSlot) {
      var renderPass = pass;

      if (renderPass.resolveTextureOutputIDs[attachmentSlot] === undefined) {
        var renderTargetID = renderPass.renderTargetIDs[attachmentSlot];
        var resolveTextureID = this.createResolveTextureID(renderTargetID);
        renderPass.resolveTextureOutputIDs[attachmentSlot] = resolveTextureID;
      }

      return renderPass.resolveTextureOutputIDs[attachmentSlot];
    }
  }, {
    key: "findPassForResolveRenderTarget",
    value: function findPassForResolveRenderTarget(renderTargetID) {
      // Find the last pass that rendered to this render target, and resolve it now.
      // If you wanted a previous snapshot copy of it, you should have created a separate,
      // intermediate pass to copy that out. Perhaps we should have a helper for that use case?
      // If there was no pass that wrote to this RT, well there's no point in resolving it, is there?
      var renderPass = assertExists(this.findMostRecentPassThatAttachedRenderTarget(renderTargetID)); // Check which attachment we're in. This could possibly be explicit from the user, but it's
      // easy enough to find...

      var attachmentSlot = renderPass.renderTargetIDs.indexOf(renderTargetID); // Check that the pass isn't resolving its attachment to another texture. Can't do both!

      assert(renderPass.resolveTextureOutputExternalTextures[attachmentSlot] === undefined);
      return renderPass;
    }
  }, {
    key: "resolveRenderTarget",
    value: function resolveRenderTarget(renderTargetID) {
      var renderPass = this.findPassForResolveRenderTarget(renderTargetID);
      var attachmentSlot = renderPass.renderTargetIDs.indexOf(renderTargetID);
      return this.resolveRenderTargetPassAttachmentSlot(renderPass, attachmentSlot);
    }
  }, {
    key: "resolveRenderTargetToExternalTexture",
    value: function resolveRenderTargetToExternalTexture(renderTargetID, texture) {
      var renderPass = this.findPassForResolveRenderTarget(renderTargetID);
      var attachmentSlot = renderPass.renderTargetIDs.indexOf(renderTargetID); // We shouldn't be resolving to a resolve texture ID in this case.

      assert(renderPass.resolveTextureOutputIDs[attachmentSlot] === undefined);
      renderPass.resolveTextureOutputExternalTextures[attachmentSlot] = texture;
    }
  }, {
    key: "getRenderTargetDescription",
    value: function getRenderTargetDescription(renderTargetID) {
      return assertExists(this.currentGraph.renderTargetDescriptions[renderTargetID]);
    } //#endregion
    //#region Scheduling

  }, {
    key: "scheduleAddUseCount",
    value: function scheduleAddUseCount(graph, pass) {
      for (var slot = 0; slot < pass.renderTargetIDs.length; slot++) {
        var renderTargetID = pass.renderTargetIDs[slot];
        if (renderTargetID === undefined) continue;
        this.renderTargetOutputCount[renderTargetID]++;
        if (pass.renderTargetExtraRefs[slot]) this.renderTargetOutputCount[renderTargetID]++;
      }

      for (var i = 0; i < pass.resolveTextureInputIDs.length; i++) {
        var resolveTextureID = pass.resolveTextureInputIDs[i];
        if (resolveTextureID === undefined) continue;
        this.resolveTextureUseCount[resolveTextureID]++;
        var _renderTargetID = graph.resolveTextureRenderTargetIDs[resolveTextureID];
        this.renderTargetResolveCount[_renderTargetID]++;
      }
    }
  }, {
    key: "acquireRenderTargetForID",
    value: function acquireRenderTargetForID(graph, renderTargetID) {
      if (renderTargetID === undefined) return null;
      assert(this.renderTargetOutputCount[renderTargetID] > 0);

      if (!this.renderTargetAliveForID[renderTargetID]) {
        var desc = graph.renderTargetDescriptions[renderTargetID];
        var newRenderTarget = this.acquireRenderTargetForDescription(desc);
        newRenderTarget.debugName = graph.renderTargetDebugNames[renderTargetID];
        this.renderTargetAliveForID[renderTargetID] = newRenderTarget;
      }

      return this.renderTargetAliveForID[renderTargetID];
    }
  }, {
    key: "releaseRenderTargetForID",
    value: function releaseRenderTargetForID(renderTargetID, forOutput) {
      if (renderTargetID === undefined) return null;
      var renderTarget = assertExists(this.renderTargetAliveForID[renderTargetID]);

      if (forOutput) {
        assert(this.renderTargetOutputCount[renderTargetID] > 0);
        this.renderTargetOutputCount[renderTargetID]--;
      } else {
        assert(this.renderTargetResolveCount[renderTargetID] > 0);
        this.renderTargetResolveCount[renderTargetID]--;
      }

      if (this.renderTargetOutputCount[renderTargetID] === 0 && this.renderTargetResolveCount[renderTargetID] === 0) {
        // This was the last reference to this RT -- steal it from the alive list, and put it back into the pool.
        renderTarget.needsClear = true;
        delete this.renderTargetAliveForID[renderTargetID];
        this.renderTargetDeadPool.push(renderTarget);
      }

      return renderTarget;
    }
  }, {
    key: "acquireResolveTextureInputTextureForID",
    value: function acquireResolveTextureInputTextureForID(graph, resolveTextureID) {
      var renderTargetID = graph.resolveTextureRenderTargetIDs[resolveTextureID];
      assert(this.resolveTextureUseCount[resolveTextureID] > 0);
      this.resolveTextureUseCount[resolveTextureID]--;
      var renderTarget = assertExists(this.releaseRenderTargetForID(renderTargetID, false));

      if (this.singleSampledTextureForResolveTextureID[resolveTextureID] !== undefined) {
        // The resolved texture belonging to this RT is backed by our own single-sampled texture.
        var singleSampledTexture = this.singleSampledTextureForResolveTextureID[resolveTextureID];

        if (this.resolveTextureUseCount[resolveTextureID] === 0) {
          // Release this single-sampled texture back to the pool, if this is the last use of it.
          this.singleSampledTextureDeadPool.push(singleSampledTexture);
        }

        return singleSampledTexture.texture;
      } else {
        // The resolved texture belonging to this RT is backed by our render target.
        return assertExists(renderTarget.texture);
      }
    }
  }, {
    key: "determineResolveParam",
    value: function determineResolveParam(graph, pass, slot) {
      var renderTargetID = pass.renderTargetIDs[slot];
      var resolveTextureOutputID = pass.resolveTextureOutputIDs[slot];
      var externalTexture = pass.resolveTextureOutputExternalTextures[slot]; // We should have either an output ID or an external texture, not both.

      var hasResolveTextureOutputID = resolveTextureOutputID !== undefined;
      var hasExternalTexture = externalTexture !== undefined;
      assert(!(hasResolveTextureOutputID && hasExternalTexture));
      var resolveTo = null;
      var store = false;

      if (this.renderTargetOutputCount[renderTargetID] > 1) {
        // A future pass is going to render to this RT, we need to store the results.
        store = true;
      }

      if (hasResolveTextureOutputID) {
        assert(graph.resolveTextureRenderTargetIDs[resolveTextureOutputID] === renderTargetID);
        assert(this.resolveTextureUseCount[resolveTextureOutputID] > 0);
        assert(this.renderTargetOutputCount[renderTargetID] > 0);
        var renderTarget = assertExists(this.renderTargetAliveForID[renderTargetID]); // If we're the last user of this RT, then we don't need to resolve -- the texture itself will be enough.
        // Note that this isn't exactly an exactly correct algorithm. If we have pass A writing to RenderTargetA,
        // pass B resolving RenderTargetA to ResolveTextureA, and pass C writing to RenderTargetA, then we don't
        // strictly need to copy, but in order to determine that at the time of pass A, we'd need a much fancier
        // schedule than just tracking refcounts...

        if (renderTarget.texture !== null && this.renderTargetOutputCount[renderTargetID] === 1) {
          resolveTo = null;
          store = true;
        } else {
          if (!this.singleSampledTextureForResolveTextureID[resolveTextureOutputID]) {
            var desc = assertExists(graph.renderTargetDescriptions[renderTargetID]);
            this.singleSampledTextureForResolveTextureID[resolveTextureOutputID] = this.acquireSingleSampledTextureForDescription(desc);
            this.device.setResourceName(this.singleSampledTextureForResolveTextureID[resolveTextureOutputID].texture, renderTarget.debugName + " (Resolve ".concat(resolveTextureOutputID, ")"));
          }

          resolveTo = this.singleSampledTextureForResolveTextureID[resolveTextureOutputID].texture;
        }
      } else if (hasExternalTexture) {
        resolveTo = externalTexture;
      } else {
        resolveTo = null;
      }

      return {
        resolveTo: resolveTo,
        store: store
      };
    }
  }, {
    key: "schedulePass",
    value: function schedulePass(graph, pass) {
      var depthStencilRenderTargetID = pass.renderTargetIDs[RGAttachmentSlot.DepthStencil];

      for (var slot = RGAttachmentSlot.Color0; slot <= RGAttachmentSlot.ColorMax; slot++) {
        var colorRenderTargetID = pass.renderTargetIDs[slot];
        var colorRenderTarget = this.acquireRenderTargetForID(graph, colorRenderTargetID);
        pass.renderTargets[slot] = colorRenderTarget;
        pass.descriptor.colorAttachment[slot] = colorRenderTarget !== null ? colorRenderTarget.attachment : null;

        var _this$determineResolv = this.determineResolveParam(graph, pass, slot),
            _resolveTo = _this$determineResolv.resolveTo,
            _store = _this$determineResolv.store;

        pass.descriptor.colorResolveTo[slot] = _resolveTo;
        pass.descriptor.colorStore[slot] = _store;
        pass.descriptor.colorClearColor[slot] = colorRenderTarget !== null && colorRenderTarget.needsClear ? graph.renderTargetDescriptions[colorRenderTargetID].colorClearColor : 'load';
      }

      var depthStencilRenderTarget = this.acquireRenderTargetForID(graph, depthStencilRenderTargetID);
      pass.renderTargets[RGAttachmentSlot.DepthStencil] = depthStencilRenderTarget;
      pass.descriptor.depthStencilAttachment = depthStencilRenderTarget !== null ? depthStencilRenderTarget.attachment : null;

      var _this$determineResolv2 = this.determineResolveParam(graph, pass, RGAttachmentSlot.DepthStencil),
          resolveTo = _this$determineResolv2.resolveTo,
          store = _this$determineResolv2.store;

      pass.descriptor.depthStencilResolveTo = resolveTo;
      pass.descriptor.depthStencilStore = store;
      pass.descriptor.depthClearValue = depthStencilRenderTarget !== null && depthStencilRenderTarget.needsClear ? graph.renderTargetDescriptions[depthStencilRenderTargetID].depthClearValue : 'load';
      pass.descriptor.stencilClearValue = depthStencilRenderTarget !== null && depthStencilRenderTarget.needsClear ? graph.renderTargetDescriptions[depthStencilRenderTargetID].stencilClearValue : 'load';
      var rtWidth = 0;
      var rtHeight = 0;
      var rtSampleCount = 0;

      for (var i = 0; i < pass.renderTargets.length; i++) {
        var renderTarget = pass.renderTargets[i];
        if (!renderTarget) continue;

        if (rtWidth === 0) {
          rtWidth = renderTarget.width;
          rtHeight = renderTarget.height;
          rtSampleCount = renderTarget.sampleCount;
        }

        assert(renderTarget.width === rtWidth);
        assert(renderTarget.height === rtHeight);
        assert(renderTarget.sampleCount === rtSampleCount);
        renderTarget.needsClear = false;
      }

      if (rtWidth > 0 && rtHeight > 0) {
        var x = rtWidth * pass.viewport.x;
        var y = rtHeight * pass.viewport.y;
        var w = rtWidth * pass.viewport.w;
        var h = rtHeight * pass.viewport.h;
        pass.viewportX = x;
        pass.viewportY = y;
        pass.viewportW = w;
        pass.viewportH = h;
      }

      for (var _i = 0; _i < pass.resolveTextureInputIDs.length; _i++) {
        var resolveTextureID = pass.resolveTextureInputIDs[_i];
        pass.resolveTextureInputTextures[_i] = this.acquireResolveTextureInputTextureForID(graph, resolveTextureID);
      }

      for (var _i2 = 0; _i2 < pass.renderTargetIDs.length; _i2++) {
        this.releaseRenderTargetForID(pass.renderTargetIDs[_i2], true);
      }

      for (var _slot = 0; _slot < pass.renderTargetExtraRefs.length; _slot++) {
        if (pass.renderTargetExtraRefs[_slot]) this.releaseRenderTargetForID(pass.renderTargetIDs[_slot], true);
      }
    }
  }, {
    key: "scheduleGraph",
    value: function scheduleGraph(graph) {
      assert(this.renderTargetOutputCount.length === 0);
      assert(this.renderTargetResolveCount.length === 0);
      assert(this.resolveTextureUseCount.length === 0); // Go through and increment the age of everything in our dead pools to mark that it's old.

      for (var i = 0; i < this.renderTargetDeadPool.length; i++) {
        this.renderTargetDeadPool[i].age++;
      }

      for (var _i3 = 0; _i3 < this.singleSampledTextureDeadPool.length; _i3++) {
        this.singleSampledTextureDeadPool[_i3].age++;
      } // Schedule our resources -- first, count up all uses of resources, then hand them out.
      // Initialize our accumulators.


      fillArray(this.renderTargetOutputCount, graph.renderTargetDescriptions.length, 0);
      fillArray(this.renderTargetResolveCount, graph.renderTargetDescriptions.length, 0);
      fillArray(this.resolveTextureUseCount, graph.resolveTextureRenderTargetIDs.length, 0); // Count.

      for (var _i4 = 0; _i4 < graph.passes.length; _i4++) {
        this.scheduleAddUseCount(graph, graph.passes[_i4]);
      } // Now hand out resources.


      for (var _i5 = 0; _i5 < graph.passes.length; _i5++) {
        this.schedulePass(graph, graph.passes[_i5]);
      } // Double-check that all resources were handed out.


      for (var _i6 = 0; _i6 < this.renderTargetOutputCount.length; _i6++) {
        assert(this.renderTargetOutputCount[_i6] === 0);
      }

      for (var _i7 = 0; _i7 < this.renderTargetResolveCount.length; _i7++) {
        assert(this.renderTargetResolveCount[_i7] === 0);
      }

      for (var _i8 = 0; _i8 < this.resolveTextureUseCount.length; _i8++) {
        assert(this.resolveTextureUseCount[_i8] === 0);
      }

      for (var _i9 = 0; _i9 < this.renderTargetAliveForID.length; _i9++) {
        assert(this.renderTargetAliveForID[_i9] === undefined);
      } // Now go through and kill anything that's over our age threshold (hasn't been used in a bit)


      var ageThreshold = 1;

      for (var _i10 = 0; _i10 < this.renderTargetDeadPool.length; _i10++) {
        if (this.renderTargetDeadPool[_i10].age >= ageThreshold) {
          this.renderTargetDeadPool[_i10].destroy(this.device);

          this.renderTargetDeadPool.splice(_i10--, 1);
        }
      }

      for (var _i11 = 0; _i11 < this.singleSampledTextureDeadPool.length; _i11++) {
        if (this.singleSampledTextureDeadPool[_i11].age >= ageThreshold) {
          this.singleSampledTextureDeadPool[_i11].destroy(this.device);

          this.singleSampledTextureDeadPool.splice(_i11--, 1);
        }
      } // Clear out our transient scheduling state.


      this.renderTargetResolveCount.length = 0;
      this.renderTargetOutputCount.length = 0;
      this.resolveTextureUseCount.length = 0;
    } //#endregion
    //#region Execution

  }, {
    key: "execPass",
    value: function execPass(pass) {
      assert(this.currentPass === null);
      this.currentPass = pass;
      var renderPass = this.device.createRenderPass(pass.descriptor);
      renderPass.beginDebugGroup(pass.debugName);
      renderPass.setViewport(pass.viewportX, pass.viewportY, pass.viewportW, pass.viewportH);
      if (pass.execFunc !== null) pass.execFunc(renderPass, this);
      renderPass.endDebugGroup();
      this.device.submitPass(renderPass);
      if (pass.postFunc !== null) pass.postFunc(this);
      this.currentPass = null;
    }
  }, {
    key: "execGraph",
    value: function execGraph(graph) {
      var _this = this;

      this.scheduleGraph(graph);
      graph.passes.forEach(function (pass) {
        _this.execPass(pass);
      }); // Clear our transient scope state.

      this.singleSampledTextureForResolveTextureID.length = 0;
    }
  }, {
    key: "execute",
    value: function execute() {
      var graph = assertExists(this.currentGraph);
      this.execGraph(graph);
      this.currentGraph = null;
    }
  }, {
    key: "getDebug",
    value: function getDebug() {
      return this;
    } //#endregion
    //#region GfxrGraphBuilderDebug

  }, {
    key: "getPasses",
    value: function getPasses() {
      return this.currentGraph.passes;
    }
  }, {
    key: "getPassDebugThumbnails",
    value: function getPassDebugThumbnails(pass) {
      return pass.debugThumbnails;
    }
  }, {
    key: "getPassRenderTargetID",
    value: function getPassRenderTargetID(pass, slot) {
      return pass.renderTargetIDs[slot];
    }
  }, {
    key: "getRenderTargetIDDebugName",
    value: function getRenderTargetIDDebugName(renderTargetID) {
      return this.currentGraph.renderTargetDebugNames[renderTargetID];
    } //#endregion
    //#region GfxrPassScope

  }, {
    key: "getResolveTextureForID",
    value: function getResolveTextureForID(resolveTextureID) {
      var currentGraphPass = this.currentPass;
      var i = currentGraphPass.resolveTextureInputIDs.indexOf(resolveTextureID);
      assert(i >= 0);
      return assertExists(currentGraphPass.resolveTextureInputTextures[i]);
    }
  }, {
    key: "getRenderTargetAttachment",
    value: function getRenderTargetAttachment(slot) {
      var currentGraphPass = this.currentPass;
      var renderTarget = currentGraphPass.renderTargets[slot];
      if (!renderTarget) return null;
      return renderTarget.attachment;
    }
  }, {
    key: "getRenderTargetTexture",
    value: function getRenderTargetTexture(slot) {
      var currentGraphPass = this.currentPass;
      var renderTarget = currentGraphPass.renderTargets[slot];
      if (!renderTarget) return null;
      return renderTarget.texture;
    } //#endregion

  }, {
    key: "newGraphBuilder",
    value: function newGraphBuilder() {
      this.beginGraphBuilder();
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // At the time this is called, we shouldn't have anything alive.
      for (var i = 0; i < this.renderTargetAliveForID.length; i++) {
        assert(this.renderTargetAliveForID[i] === undefined);
      }

      for (var _i12 = 0; _i12 < this.singleSampledTextureForResolveTextureID.length; _i12++) {
        assert(this.singleSampledTextureForResolveTextureID[_i12] === undefined);
      }

      for (var _i13 = 0; _i13 < this.renderTargetDeadPool.length; _i13++) {
        this.renderTargetDeadPool[_i13].destroy(this.device);
      }

      for (var _i14 = 0; _i14 < this.singleSampledTextureDeadPool.length; _i14++) {
        this.singleSampledTextureDeadPool[_i14].destroy(this.device);
      }
    }
  }]);

  return RenderGraph;
}();

// ordering within the rough groups (e.g. you might use BACKGROUND + 1, or BACKGROUND + 2).
// TRANSLUCENT is meant to be used as a bitflag. It's special as it changes the behavior of the generic sort key
// functions like makeSortKey and setSortKeyDepth.

var RendererLayer;

(function (RendererLayer) {
  RendererLayer[RendererLayer["BACKGROUND"] = 0] = "BACKGROUND";
  RendererLayer[RendererLayer["ALPHA_TEST"] = 16] = "ALPHA_TEST";
  RendererLayer[RendererLayer["OPAQUE"] = 32] = "OPAQUE";
  RendererLayer[RendererLayer["TRANSLUCENT"] = 128] = "TRANSLUCENT";
})(RendererLayer || (RendererLayer = {}));

var MAX_DEPTH = 0x10000;
var DEPTH_BITS = 16;
function makeDepthKey(depth, flipDepth) {
  var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_DEPTH;
  // Input depth here is: 0 is the closest to the camera, positive values are further away. Negative values (behind camera) are clamped to 0.
  // normalizedDepth: 0.0 is closest to camera, 1.0 is farthest from camera.
  // These values are flipped if flipDepth is set.
  var normalizedDepth = clamp(depth, 0, maxDepth) / maxDepth;
  if (flipDepth) normalizedDepth = 1.0 - normalizedDepth;
  var depthKey = normalizedDepth * ((1 << DEPTH_BITS) - 1);
  return depthKey & 0xffff;
} // Common sort key kinds.
// Indexed:     TLLLLLLL IIIIIIII IIIIIIII IIIIIIII
// Opaque:      0LLLLLLL PPPPPPPP PPPPPPPP DDDDDDDD
// Translucent: 1LLLLLLL DDDDDDDD DDDDDDDD BBBBBBBB

function getSortKeyLayer(sortKey) {
  return sortKey >>> 24 & 0xff;
}
function setSortKeyLayer(sortKey, layer) {
  return (sortKey & 0x00ffffff | (layer & 0xff) << 24) >>> 0;
}
function setSortKeyProgramKey(sortKey, programKey) {
  var isTransparent = !!(sortKey >>> 31 & 1);
  if (isTransparent) return sortKey;else return (sortKey & 0xff0000ff | (programKey & 0xffff) << 8) >>> 0;
}
function setSortKeyBias(sortKey, bias) {
  var isTransparent = !!(sortKey >>> 31 & 1);
  if (isTransparent) return (sortKey & 0xffffff00 | bias & 0xff) >>> 0;else return sortKey;
}
function makeSortKeyOpaque(layer, programKey) {
  return setSortKeyLayer(setSortKeyProgramKey(0, programKey), layer);
}
function setSortKeyOpaqueDepth(sortKey, depthKey) {
  assert(depthKey >= 0);
  return (sortKey & 0xffffff00 | depthKey >>> 8 & 0xff) >>> 0;
}
function makeSortKeyTranslucent(layer) {
  return setSortKeyLayer(0, layer);
}
function setSortKeyTranslucentDepth(sortKey, depthKey) {
  assert(depthKey >= 0);
  return (sortKey & 0xff0000ff | depthKey << 8) >>> 0;
}
function makeSortKey(layer) {
  var programKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (layer & RendererLayer.TRANSLUCENT) return makeSortKeyTranslucent(layer);else return makeSortKeyOpaque(layer, programKey);
}
function setSortKeyDepthKey(sortKey, depthKey) {
  var isTranslucent = !!(sortKey >>> 31 & 1);
  return isTranslucent ? setSortKeyTranslucentDepth(sortKey, depthKey) : setSortKeyOpaqueDepth(sortKey, depthKey);
}
function setSortKeyDepth(sortKey, depth) {
  var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_DEPTH;
  var isTranslucent = !!(sortKey >>> 31 & 1);
  var depthKey = makeDepthKey(depth, isTranslucent, maxDepth);
  return isTranslucent ? setSortKeyTranslucentDepth(sortKey, depthKey) : setSortKeyOpaqueDepth(sortKey, depthKey);
}
function getSortKeyDepth(sortKey) {
  var isTranslucent = !!(sortKey >>> 31 & 1);
  if (isTranslucent) return sortKey >>> 8 & 0xffff;else {
    return sortKey >>> 8 & 0xfffc | sortKey & 0x03;
  }
}

/**
 * Common utilities
 * @module glMatrix
 */
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function create() {
  var out = new ARRAY_TYPE(16);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mul = multiply;

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create$1() {
  var out = new ARRAY_TYPE(3);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function fromValues$1(x, y, z) {
  var out = new ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create$1();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function create$2() {
  var out = new ARRAY_TYPE(2);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to normalize
 * @returns {vec2} out
 */

function normalize(out, a) {
  var x = a[0],
      y = a[1];
  var len = x * x + y * y;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach$1 = function () {
  var vec = create$2();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
}();

var mtxOpenGLFromD3D = fromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 0, -1, 1); // Converts a projection matrix from D3D-style Z range [0, 1] to OpenGL-style Z range [-1, 1]

function projectionMatrixOpenGLFromD3D(m) {
  mul(m, mtxOpenGLFromD3D, m);
}

var mtxD3DFromOpenGL = fromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0.5, 0, 0, 0, 0.5, 1); // Converts a projection matrix from OpenGL-style Z range [-1, 1] to D3D-style Z range [0, 1]

function projectionMatrixD3DFromOpenGL(m) {
  mul(m, mtxD3DFromOpenGL, m);
}
/**
 * Convert a projection matrix {@param m} between differing clip spaces.
 *
 * There are two kinds of clip-space conventions in active use in graphics APIs, differing in the
 * range of the Z axis: OpenGL (and thus GL ES and WebGL) use a Z range of [-1, 1] which matches
 * the X and Y axis ranges. Direct3D, Vulkan, Metal, and WebGPU all use a Z range of [0, 1], which
 * differs from the X and Y axis ranges, but makes sense from the perspective of a camera: a camera
 * can see to the left and right of it, above and below it, but only in front and not behind it.
 *
 * The [0, 1] convention for Z range also has better characteristics for "reversed depth". Since
 * floating point numbers have higher precision around 0 than around 1. We then get to choose where
 * to put the extra precise bits: close to the near plane, or close to the far plane.
 *
 * With OpenGL's [-1, 1] convention, both -1 and 1 have similar amounts of precision, so we don't
 * get to make the same choice, and our higher precision around 0 is stuck in the middle of the
 * scene, which doesn't particularly help.
 *
 * The gl-matrix library has two different kinds of entry points: {@method mat4.perpsective} will
 * generate a matrix with a [-1, 1] clip space, corresponding to {@see ClipSpaceNearZ.NegativeOne},
 * but {@method mat4.perspectiveZO} will generate a matrix with a [0, 1] clip space, corresponding
 * to {@see ClipSpaceNearZ.Zero}.
 *
 * This function does nothing if {@param dst} and {@param src} are the same.
 */


function projectionMatrixConvertClipSpaceNearZ(m, dst, src) {
  if (dst === src) return;
  if (dst === ClipSpaceNearZ.NegativeOne) projectionMatrixOpenGLFromD3D(m);else if (dst === ClipSpaceNearZ.Zero) projectionMatrixD3DFromOpenGL(m);
}

function fillVec3v(d, offs, v) {
  var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  d[offs + 0] = v[0];
  d[offs + 1] = v[1];
  d[offs + 2] = v[2];
  d[offs + 3] = v3;
  return 4;
}
function fillVec4(d, offs, v0) {
  var v1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var v2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var v3 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  d[offs + 0] = v0;
  d[offs + 1] = v1;
  d[offs + 2] = v2;
  d[offs + 3] = v3;
  return 4;
}
function fillVec4v(d, offs, v) {
  d[offs + 0] = v[0];
  d[offs + 1] = v[1];
  d[offs + 2] = v[2];
  d[offs + 3] = v[3];
  return 4;
}
function fillColor(d, offs, c) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : c.a;
  d[offs + 0] = c.r;
  d[offs + 1] = c.g;
  d[offs + 2] = c.b;
  d[offs + 3] = a;
  return 4;
} // All of our matrices are row-major.

function fillMatrix4x4(d, offs, m) {
  // d[offs + 0] = m[0];
  // d[offs + 1] = m[4];
  // d[offs + 2] = m[8];
  // d[offs + 3] = m[12];
  // d[offs + 4] = m[1];
  // d[offs + 5] = m[5];
  // d[offs + 6] = m[9];
  // d[offs + 7] = m[13];
  // d[offs + 8] = m[2];
  // d[offs + 9] = m[6];
  // d[offs + 10] = m[10];
  // d[offs + 11] = m[14];
  // d[offs + 12] = m[3];
  // d[offs + 13] = m[7];
  // d[offs + 14] = m[11];
  // d[offs + 15] = m[15];
  d[offs + 0] = m[0];
  d[offs + 1] = m[1];
  d[offs + 2] = m[2];
  d[offs + 3] = m[3];
  d[offs + 4] = m[4];
  d[offs + 5] = m[5];
  d[offs + 6] = m[6];
  d[offs + 7] = m[7];
  d[offs + 8] = m[8];
  d[offs + 9] = m[9];
  d[offs + 10] = m[10];
  d[offs + 11] = m[11];
  d[offs + 12] = m[12];
  d[offs + 13] = m[13];
  d[offs + 14] = m[14];
  d[offs + 15] = m[15];
  return 4 * 4;
} // export function fillMatrix4x3(d: Float32Array, offs: number, m: ReadonlyMat4): number {
//   d[offs + 0] = m[0];
//   d[offs + 1] = m[4];
//   d[offs + 2] = m[8];
//   d[offs + 3] = m[12];
//   d[offs + 4] = m[1];
//   d[offs + 5] = m[5];
//   d[offs + 6] = m[9];
//   d[offs + 7] = m[13];
//   d[offs + 8] = m[2];
//   d[offs + 9] = m[6];
//   d[offs + 10] = m[10];
//   d[offs + 11] = m[14];
//   return 4 * 3;
// }
// export function fillMatrix3x2(d: Float32Array, offs: number, m: ReadonlyMat2d): number {
//   // 3x2 matrices are actually sent across as 4x2.
//   const ma = m[0],
//     mb = m[1];
//   const mc = m[2],
//     md = m[3];
//   const mx = m[4],
//     my = m[5];
//   d[offs + 0] = ma;
//   d[offs + 1] = mc;
//   d[offs + 2] = mx;
//   d[offs + 3] = 0;
//   d[offs + 4] = mb;
//   d[offs + 5] = md;
//   d[offs + 6] = my;
//   d[offs + 7] = 0;
//   return 4 * 2;
// }
// export function fillMatrix4x2(d: Float32Array, offs: number, m: ReadonlyMat4): number {
//   // The bottom two rows are basically just ignored in a 4x2.
//   d[offs + 0] = m[0];
//   d[offs + 1] = m[4];
//   d[offs + 2] = m[8];
//   d[offs + 3] = m[12];
//   d[offs + 4] = m[1];
//   d[offs + 5] = m[5];
//   d[offs + 6] = m[9];
//   d[offs + 7] = m[13];
//   return 4 * 2;
// }

var RenderInstFlags;

(function (RenderInstFlags) {
  RenderInstFlags[RenderInstFlags["Indexed"] = 1] = "Indexed";
  RenderInstFlags[RenderInstFlags["AllowSkippingIfPipelineNotReady"] = 2] = "AllowSkippingIfPipelineNotReady"; // Mostly for error checking.

  RenderInstFlags[RenderInstFlags["Template"] = 4] = "Template";
  RenderInstFlags[RenderInstFlags["Draw"] = 8] = "Draw"; // Which flags are inherited from templates...

  RenderInstFlags[RenderInstFlags["InheritedFlags"] = 3] = "InheritedFlags";
})(RenderInstFlags || (RenderInstFlags = {}));

var RenderInst = /*#__PURE__*/function () {
  // Debugging pointer for whomever wants it...
  // Pipeline building.
  // Bindings building.
  function RenderInst() {
    _classCallCheck(this, RenderInst);

    this.sortKey = 0;
    this.debug = null;
    this.renderPipelineDescriptor = void 0;
    this.uniformBuffer = void 0;
    this.uniforms = [];
    this.bindingDescriptors = nArray(1, function () {
      return {
        bindingLayout: null,
        samplerBindings: [],
        uniformBufferBindings: []
      };
    });
    this.dynamicUniformBufferByteOffsets = nArray(4, function () {
      return 0;
    });
    this.flags = 0;
    this.inputState = null;
    this.drawStart = 0;
    this.drawCount = 0;
    this.drawInstanceCount = 0;
    this.renderPipelineDescriptor = {
      bindingLayouts: [],
      inputLayout: null,
      megaStateDescriptor: copyMegaState(defaultMegaState),
      program: null,
      topology: PrimitiveTopology.Triangles,
      colorAttachmentFormats: [],
      depthStencilAttachmentFormat: null,
      sampleCount: 1
    };
    this.reset();
  }
  /**
   * Resets a render inst to be boring, so it can re-enter the pool.
   * Normally, you should not need to call this.
   */


  _createClass(RenderInst, [{
    key: "reset",
    value: function reset() {
      this.sortKey = 0;
      this.flags = RenderInstFlags.AllowSkippingIfPipelineNotReady;
      this.inputState = null;
      this.renderPipelineDescriptor.inputLayout = null;
    }
    /**
     * Copies the fields from another render inst {@param o} to this render inst.
     * Normally, you should not need to call this.
     */

  }, {
    key: "setFromTemplate",
    value: function setFromTemplate(o) {
      setMegaStateFlags(this.renderPipelineDescriptor.megaStateDescriptor, o.renderPipelineDescriptor.megaStateDescriptor);

      this.renderPipelineDescriptor.program = o.renderPipelineDescriptor.program;
      this.renderPipelineDescriptor.inputLayout = o.renderPipelineDescriptor.inputLayout;
      this.renderPipelineDescriptor.topology = o.renderPipelineDescriptor.topology;
      this.renderPipelineDescriptor.colorAttachmentFormats.length = Math.max(this.renderPipelineDescriptor.colorAttachmentFormats.length, o.renderPipelineDescriptor.colorAttachmentFormats.length);

      for (var i = 0; i < o.renderPipelineDescriptor.colorAttachmentFormats.length; i++) {
        this.renderPipelineDescriptor.colorAttachmentFormats[i] = o.renderPipelineDescriptor.colorAttachmentFormats[i];
      }

      this.renderPipelineDescriptor.depthStencilAttachmentFormat = o.renderPipelineDescriptor.depthStencilAttachmentFormat;
      this.renderPipelineDescriptor.sampleCount = o.renderPipelineDescriptor.sampleCount;
      this.inputState = o.inputState;
      this.uniformBuffer = o.uniformBuffer;
      this.uniforms = _toConsumableArray(o.uniforms);
      this.drawCount = o.drawCount;
      this.drawStart = o.drawStart;
      this.drawInstanceCount = o.drawInstanceCount;
      this.flags = this.flags & ~RenderInstFlags.InheritedFlags | o.flags & RenderInstFlags.InheritedFlags;
      this.sortKey = o.sortKey;
      var tbd = this.bindingDescriptors[0],
          obd = o.bindingDescriptors[0];
      if (obd.bindingLayout !== null) this.setBindingLayout(obd.bindingLayout);

      for (var _i = 0; _i < Math.min(tbd.uniformBufferBindings.length, obd.uniformBufferBindings.length); _i++) {
        tbd.uniformBufferBindings[_i].wordCount = o.bindingDescriptors[0].uniformBufferBindings[_i].wordCount;
      }

      this.setSamplerBindingsFromTextureMappings(obd.samplerBindings);

      for (var _i2 = 0; _i2 < o.dynamicUniformBufferByteOffsets.length; _i2++) {
        this.dynamicUniformBufferByteOffsets[_i2] = o.dynamicUniformBufferByteOffsets[_i2];
      }
    }
    /**
     * Set the {@see Program} that this render inst will render with. This is part of the automatic
     * pipeline building facilities. At render time, a pipeline will be automatically and constructed from
     * the pipeline parameters.
     */

  }, {
    key: "setProgram",
    value: function setProgram(program) {
      this.renderPipelineDescriptor.program = program;
    }
    /**
     * Set the {@see MegaStateDescriptor} that this render inst will render with. This is part of the automatic
     * pipeline building facilities. At render time, a pipeline will be automatically and constructed from
     * the pipeline parameters.
     */

  }, {
    key: "setMegaStateFlags",
    value: function setMegaStateFlags$1(r) {
      setMegaStateFlags(this.renderPipelineDescriptor.megaStateDescriptor, r);

      return this.renderPipelineDescriptor.megaStateDescriptor;
    }
    /**
     * Retrieve the {@see MegaStateDescriptor} property bag that this will render with. This is similar to
     * {@see setMegaStateFlags} but allows you to set fields directly on the internal property bag, rather than
     * merge them. This can be slightly more efficient.
     */

  }, {
    key: "getMegaStateFlags",
    value: function getMegaStateFlags() {
      return this.renderPipelineDescriptor.megaStateDescriptor;
    }
    /**
     * Sets both the {@see InputLayout} and {@see InputState} to be used by this render instance.
     * The {@see InputLayout} is used to construct the pipeline as part of the automatic pipeline building
     * facilities, while {@see InputState} is used for the render.
     */

  }, {
    key: "setInputLayoutAndState",
    value: function setInputLayoutAndState(inputLayout, inputState) {
      this.inputState = inputState;
      this.renderPipelineDescriptor.inputLayout = inputLayout;
    }
  }, {
    key: "setBindingLayout",
    value: function setBindingLayout(bindingLayout) {
      assert(bindingLayout.numUniformBuffers < this.dynamicUniformBufferByteOffsets.length);
      this.renderPipelineDescriptor.bindingLayouts[0] = bindingLayout;
      this.bindingDescriptors[0].bindingLayout = bindingLayout;

      for (var i = this.bindingDescriptors[0].uniformBufferBindings.length; i < bindingLayout.numUniformBuffers; i++) {
        this.bindingDescriptors[0].uniformBufferBindings.push({
          buffer: null,
          wordCount: 0
        });
      }

      for (var _i3 = this.bindingDescriptors[0].samplerBindings.length; _i3 < bindingLayout.numSamplers; _i3++) {
        this.bindingDescriptors[0].samplerBindings.push({
          sampler: null,
          texture: null,
          lateBinding: null
        });
      }
    }
    /**
     * Sets the {@see BindingLayoutDescriptor}s that this render inst will render with.
     */

  }, {
    key: "setBindingLayouts",
    value: function setBindingLayouts(bindingLayouts) {
      assert(bindingLayouts.length <= this.bindingDescriptors.length);
      assert(bindingLayouts.length === 1);
      this.setBindingLayout(bindingLayouts[0]);
    }
  }, {
    key: "drawIndexes",
    value: function drawIndexes(indexCount) {
      var indexStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.flags = setBitFlagEnabled(this.flags, RenderInstFlags.Indexed, true);
      this.drawCount = indexCount;
      this.drawStart = indexStart;
      this.drawInstanceCount = 1;
    }
  }, {
    key: "drawIndexesInstanced",
    value: function drawIndexesInstanced(indexCount, instanceCount) {
      var indexStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.flags = setBitFlagEnabled(this.flags, RenderInstFlags.Indexed, true);
      this.drawCount = indexCount;
      this.drawStart = indexStart;
      this.drawInstanceCount = instanceCount;
    }
  }, {
    key: "drawPrimitives",
    value: function drawPrimitives(primitiveCount) {
      var primitiveStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.flags = setBitFlagEnabled(this.flags, RenderInstFlags.Indexed, false);
      this.drawCount = primitiveCount;
      this.drawStart = primitiveStart;
      this.drawInstanceCount = 1;
    }
    /**
     * account for WebGL1
     */

  }, {
    key: "setUniforms",
    value: function setUniforms(bufferIndex, uniforms) {
      // use later in WebGL1
      this.uniforms[bufferIndex] = uniforms; // calc buffer size

      var offset = 0;
      var uboBuffer = [];
      uniforms.forEach(function (uniform) {
        var name = uniform.name,
            value = uniform.value;
        var array = typeof value === 'number' ? [value] : value;
        var formatByteSize = array.length > 4 ? 4 : array.length; // std140 UBO layout

        var emptySpace = 4 - offset % 4;

        if (emptySpace !== 4) {
          if (emptySpace >= formatByteSize) ; else {
            offset += emptySpace;

            for (var j = 0; j < emptySpace; j++) {
              uboBuffer.push(0); // padding
            }
          }
        }

        offset += array.length;
        uboBuffer.push.apply(uboBuffer, _toConsumableArray(array));
      }); // padding

      var emptySpace = 4 - uboBuffer.length % 4;

      if (emptySpace !== 4) {
        for (var j = 0; j < emptySpace; j++) {
          uboBuffer.push(0);
        }
      } // upload UBO


      var offs = this.allocateUniformBuffer(bufferIndex, uboBuffer.length);
      var d = this.mapUniformBufferF32(bufferIndex);

      for (var i = 0; i < uboBuffer.length; i += 4) {
        offs += fillVec4(d, offs, uboBuffer[i], uboBuffer[i + 1], uboBuffer[i + 2], uboBuffer[i + 3]);
      }
    }
  }, {
    key: "setUniformBuffer",
    value: function setUniformBuffer(uniformBuffer) {
      this.uniformBuffer = uniformBuffer;
    }
    /**
     * Allocates {@param wordCount} words from the uniform buffer and assigns it to the buffer
     * slot at index {@param bufferIndex}. As a convenience, this also directly returns the same
     * offset into the uniform buffer, in words, that would be returned by a subsequent call to
     * {@see getUniformBufferOffset}.
     */

  }, {
    key: "allocateUniformBuffer",
    value: function allocateUniformBuffer(bufferIndex, wordCount) {
      assert(this.bindingDescriptors[0].bindingLayout.numUniformBuffers < this.dynamicUniformBufferByteOffsets.length);
      this.dynamicUniformBufferByteOffsets[bufferIndex] = this.uniformBuffer.allocateChunk(wordCount) << 2;
      var dst = this.bindingDescriptors[0].uniformBufferBindings[bufferIndex];
      dst.wordCount = wordCount;
      return this.getUniformBufferOffset(bufferIndex);
    }
    /**
     * Returns the offset into the uniform buffer, in words, that is assigned to the buffer slot
     * at index {@param bufferIndex}, to be used with e.g. {@see mapUniformBufferF32}.
     */

  }, {
    key: "getUniformBufferOffset",
    value: function getUniformBufferOffset(bufferIndex) {
      var wordOffset = this.dynamicUniformBufferByteOffsets[bufferIndex] >>> 2;
      return wordOffset;
    }
    /**
     * Directly sets the uniform buffer assigned to the buffer slot at index {@param bufferIndex}
     * to be {@param wordOffset}. Use this if you have already allocated a uniform buffer chunk through
     * some other means and wish to directly assign it to this render inst.
     */

  }, {
    key: "setUniformBufferOffset",
    value: function setUniformBufferOffset(bufferIndex, wordOffset, wordCount) {
      this.dynamicUniformBufferByteOffsets[bufferIndex] = wordOffset << 2;
      var dst = this.bindingDescriptors[0].uniformBufferBindings[bufferIndex];
      dst.wordCount = wordCount;
    }
    /**
     * This is a convenience wrapper for {@see RenderDynamicUniformBuffer.mapBufferF32}, but uses
     * the values previously assigned for the uniform buffer slot at index {@param bufferIndex}.
     * Like {@see RenderDynamicUniformBuffer.mapBufferF32}, this does not return a slice for the
     * buffer; you need to write to it with the correct uniform buffer offset; this will usually be
     * returned by {@see allocateUniformBuffer}.
     */

  }, {
    key: "mapUniformBufferF32",
    value: function mapUniformBufferF32(bufferIndex) {
      return this.uniformBuffer.mapBufferF32();
    }
    /**
     * Retrieve the {@see RenderDynamicUniformBuffer} that this render inst will use to allocate.
     */

  }, {
    key: "getUniformBuffer",
    value: function getUniformBuffer() {
      return this.uniformBuffer;
    }
    /**
     * Sets the {@param SamplerBinding}s in use by this render instance.
     *
     * Note that {@see RenderInst} has a method of doing late binding, intended to solve cases where live render
     * targets are used, which can have difficult control flow consequences for users. Pass a string instead of a
     * SamplerBinding to record that it can be resolved later, and use {@see RenderInst.resolveLateSamplerBinding}
     * or equivalent to fill it in later.
     */

  }, {
    key: "setSamplerBindingsFromTextureMappings",
    value: function setSamplerBindingsFromTextureMappings(mappings) {
      mappings = mappings.filter(function (m) {
        return m;
      });

      for (var i = 0; i < this.bindingDescriptors[0].samplerBindings.length; i++) {
        var dst = this.bindingDescriptors[0].samplerBindings[i];
        var binding = mappings[i];

        if (binding === undefined || binding === null) {
          dst.texture = null;
          dst.sampler = null;
          dst.lateBinding = null;
          continue;
        }

        dst.texture = binding.texture;
        dst.sampler = binding.sampler;
        dst.lateBinding = binding.lateBinding;
      }
    }
  }, {
    key: "hasLateSamplerBinding",
    value: function hasLateSamplerBinding(name) {
      for (var i = 0; i < this.bindingDescriptors[0].samplerBindings.length; i++) {
        var dst = this.bindingDescriptors[0].samplerBindings[i];
        if (dst.lateBinding === name) return true;
      }

      return false;
    }
    /**
     * Resolve a previously registered "late bound" sampler binding for the given {@param name} to the provided
     * {@param binding}, as registered through {@see setSamplerBindingsFromTextureMappings}.
     *
     * This is intended to be called by high-level code, and is especially helpful when juggling render targets
     * for framebuffer effects.
     */

  }, {
    key: "resolveLateSamplerBinding",
    value: function resolveLateSamplerBinding(name, binding) {
      for (var i = 0; i < this.bindingDescriptors[0].samplerBindings.length; i++) {
        var dst = this.bindingDescriptors[0].samplerBindings[i];

        if (dst.lateBinding === name) {
          if (binding === null) {
            dst.texture = null;
            dst.sampler = null;
          } else {
            assert(binding.lateBinding === null);
            dst.texture = binding.texture;

            if (binding.sampler !== null) {
              dst.sampler = binding.sampler;
            }
          }

          dst.lateBinding = null;
        }
      }
    }
    /**
     * Tests whether the underlying pipeline for this {@see RenderInst} is ready.
     *
     * By default, {@see RenderInstManager} will skip any insts with non-ready pipelines. If you wish
     * to override this and force the render inst to draw, please use {@see setAllowSkippingIfPipelineNotReady}.
     */

  }, {
    key: "queryPipelineReady",
    value: function queryPipelineReady(cache) {
      var gfxPipeline = cache.createRenderPipeline(this.renderPipelineDescriptor);
      return cache.device.queryPipelineReady(gfxPipeline);
    }
    /**
     * Sets whether this render inst should be skipped if the render pipeline isn't ready.
     *
     * Some draws of objects can be skipped if the pipelines aren't ready. Others are more
     * crucial to draw, and so this can be set to force for the pipeline to become available.
     *
     * By default, this is true.
     */

  }, {
    key: "setAllowSkippingIfPipelineNotReady",
    value: function setAllowSkippingIfPipelineNotReady(v) {
      this.flags = setBitFlagEnabled(this.flags, RenderInstFlags.AllowSkippingIfPipelineNotReady, v);
    }
  }, {
    key: "setAttachmentFormatsFromRenderPass",
    value: function setAttachmentFormatsFromRenderPass(device, passRenderer) {
      var passDescriptor = device.queryRenderPass(passRenderer);
      var sampleCount = -1;

      for (var i = 0; i < passDescriptor.colorAttachment.length; i++) {
        var colorAttachmentDescriptor = passDescriptor.colorAttachment[i] !== null ? device.queryRenderTarget(passDescriptor.colorAttachment[i]) : null;
        this.renderPipelineDescriptor.colorAttachmentFormats[i] = colorAttachmentDescriptor !== null ? colorAttachmentDescriptor.pixelFormat : null;

        if (colorAttachmentDescriptor !== null) {
          if (sampleCount === -1) sampleCount = colorAttachmentDescriptor.sampleCount;else assert(sampleCount === colorAttachmentDescriptor.sampleCount);
        }
      }

      var depthStencilAttachmentDescriptor = passDescriptor.depthStencilAttachment !== null ? device.queryRenderTarget(passDescriptor.depthStencilAttachment) : null;
      this.renderPipelineDescriptor.depthStencilAttachmentFormat = depthStencilAttachmentDescriptor !== null ? depthStencilAttachmentDescriptor.pixelFormat : null;

      if (depthStencilAttachmentDescriptor !== null) {
        if (sampleCount === -1) sampleCount = depthStencilAttachmentDescriptor.sampleCount;else assert(sampleCount == depthStencilAttachmentDescriptor.sampleCount);
      }

      assert(sampleCount > 0);
      this.renderPipelineDescriptor.sampleCount = sampleCount;
    }
  }, {
    key: "drawOnPass",
    value: function drawOnPass(cache, passRenderer) {
      var _this = this;

      var device = cache.device;
      this.setAttachmentFormatsFromRenderPass(device, passRenderer);
      var gfxPipeline = cache.createRenderPipeline(this.renderPipelineDescriptor);
      var pipelineReady = device.queryPipelineReady(gfxPipeline);

      if (!pipelineReady) {
        if (!!(this.flags & RenderInstFlags.AllowSkippingIfPipelineNotReady)) {
          return false;
        }

        device.pipelineForceReady(gfxPipeline);
      }

      passRenderer.setPipeline(gfxPipeline);
      passRenderer.setInputState(this.inputState); // upload uniforms

      for (var i = 0; i < this.bindingDescriptors[0].uniformBufferBindings.length; i++) {
        this.bindingDescriptors[0].uniformBufferBindings[i].buffer = assertExists(this.uniformBuffer.buffer);
      }

      if (this.renderPipelineDescriptor.program.gl_program) {
        this.uniforms.forEach(function (uniforms) {
          var uniformsMap = {};
          uniforms.forEach(function (_ref) {
            var name = _ref.name,
                value = _ref.value;
            uniformsMap[name] = value;
          });

          _this.renderPipelineDescriptor.program.setUniforms(uniformsMap);
        });
      } // TODO: Support multiple binding descriptors.


      var gfxBindings = cache.createBindings(_objectSpread2(_objectSpread2({}, this.bindingDescriptors[0]), {}, {
        pipeline: gfxPipeline
      }));
      passRenderer.setBindings(0, gfxBindings, this.dynamicUniformBufferByteOffsets); // if (this.drawInstanceCount > 0) {

      if (this.drawInstanceCount > 1) {
        assert(!!(this.flags & RenderInstFlags.Indexed));
        passRenderer.drawIndexedInstanced(this.drawCount, this.drawStart, this.drawInstanceCount);
      } else if (this.flags & RenderInstFlags.Indexed) {
        passRenderer.drawIndexed(this.drawCount, this.drawStart);
      } else {
        passRenderer.draw(this.drawCount, this.drawStart);
      }

      return true;
    }
  }]);

  return RenderInst;
}();

var renderInstCompareNone = null;
function renderInstCompareSortKey(a, b) {
  return a.sortKey - b.sortKey;
}
var RenderInstExecutionOrder;

(function (RenderInstExecutionOrder) {
  RenderInstExecutionOrder[RenderInstExecutionOrder["Forwards"] = 0] = "Forwards";
  RenderInstExecutionOrder[RenderInstExecutionOrder["Backwards"] = 1] = "Backwards";
})(RenderInstExecutionOrder || (RenderInstExecutionOrder = {}));

var RenderInstList = /*#__PURE__*/function () {
  function RenderInstList() {
    var compareFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : renderInstCompareSortKey;
    var executionOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RenderInstExecutionOrder.Forwards;

    _classCallCheck(this, RenderInstList);

    this.renderInsts = [];
    this.compareFunction = void 0;
    this.executionOrder = void 0;
    this.usePostSort = false;
    this.compareFunction = compareFunction;
    this.executionOrder = executionOrder;
  }
  /**
   * Determine whether to use post-sorting, based on some heuristics.
   */


  _createClass(RenderInstList, [{
    key: "checkUsePostSort",
    value: function checkUsePostSort() {
      // Over a certain threshold, it's faster to push and then sort than insort directly...
      this.usePostSort = this.compareFunction !== null && this.renderInsts.length >= 500;
    }
    /**
     * Insert a render inst to the list. This directly inserts the render inst to
     * the position specified by the compare function, so the render inst must be
     * fully constructed at this point.
     */

  }, {
    key: "insertSorted",
    value: function insertSorted(renderInst) {
      if (this.compareFunction === null) {
        this.renderInsts.push(renderInst);
      } else if (this.usePostSort) {
        this.renderInsts.push(renderInst);
      } else {
        spliceBisectRight(this.renderInsts, renderInst, this.compareFunction);
      }

      this.checkUsePostSort();
    }
  }, {
    key: "submitRenderInst",
    value: function submitRenderInst(renderInst) {
      renderInst.flags |= RenderInstFlags.Draw;
      this.insertSorted(renderInst);
    }
  }, {
    key: "hasLateSamplerBinding",
    value: function hasLateSamplerBinding(name) {
      for (var i = 0; i < this.renderInsts.length; i++) {
        if (this.renderInsts[i].hasLateSamplerBinding(name)) {
          return true;
        }
      }

      return false;
    }
    /**
     * Resolve sampler bindings for all render insts on this render inst list.
     */

  }, {
    key: "resolveLateSamplerBinding",
    value: function resolveLateSamplerBinding(name, binding) {
      for (var i = 0; i < this.renderInsts.length; i++) {
        this.renderInsts[i].resolveLateSamplerBinding(name, binding);
      }
    }
  }, {
    key: "ensureSorted",
    value: function ensureSorted() {
      if (this.usePostSort) {
        if (this.renderInsts.length !== 0) this.renderInsts.sort(this.compareFunction);
        this.usePostSort = false;
      }
    }
  }, {
    key: "drawOnPassRendererNoReset",
    value: function drawOnPassRendererNoReset(cache, passRenderer) {
      this.ensureSorted();
      var numDrawn = 0;

      if (this.executionOrder === RenderInstExecutionOrder.Forwards) {
        for (var i = 0; i < this.renderInsts.length; i++) {
          if (this.renderInsts[i].drawOnPass(cache, passRenderer)) numDrawn++;
        }
      } else {
        for (var _i = this.renderInsts.length - 1; _i >= 0; _i--) {
          if (this.renderInsts[_i].drawOnPass(cache, passRenderer)) numDrawn++;
        }
      }

      return numDrawn;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.renderInsts.length = 0;
    }
  }, {
    key: "drawOnPassRenderer",
    value: function drawOnPassRenderer(cache, passRenderer) {
      var numDrawn = this.drawOnPassRendererNoReset(cache, passRenderer);
      this.reset();
      return numDrawn;
    }
  }]);

  return RenderInstList;
}();

var RenderInstPool = /*#__PURE__*/function () {
  function RenderInstPool() {
    _classCallCheck(this, RenderInstPool);

    this.pool = [];
    this.allocCount = 0;
  }

  _createClass(RenderInstPool, [{
    key: "allocRenderInstIndex",
    value: function allocRenderInstIndex() {
      this.allocCount++;

      if (this.allocCount > this.pool.length) {
        this.pool.push(new RenderInst());
      }

      return this.allocCount - 1;
    }
  }, {
    key: "popRenderInst",
    value: function popRenderInst() {
      this.allocCount--;
    }
  }, {
    key: "reset",
    value: function reset() {
      for (var i = 0; i < this.pool.length; i++) {
        this.pool[i].reset();
      }

      this.allocCount = 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.pool.length = 0;
      this.allocCount = 0;
    }
  }]);

  return RenderInstPool;
}();

var RenderInstManager = /*#__PURE__*/function () {
  function RenderInstManager(renderCache) {
    _classCallCheck(this, RenderInstManager);

    this.renderCache = void 0;
    this.instPool = new RenderInstPool();
    this.templatePool = new RenderInstPool();
    this.simpleRenderInstList = new RenderInstList();
    this.currentRenderInstList = this.simpleRenderInstList;
    this.renderCache = renderCache;
  }
  /**
   * Creates a new RenderInst object and returns it. If there is a template
   * pushed onto the template stack, then its values will be used as a base for this
   * render inst.
   */


  _createClass(RenderInstManager, [{
    key: "newRenderInst",
    value: function newRenderInst() {
      var templateIndex = this.templatePool.allocCount - 1;
      var renderInstIndex = this.instPool.allocRenderInstIndex();
      var renderInst = this.instPool.pool[renderInstIndex];
      renderInst.debug = null;
      if (templateIndex >= 0) renderInst.setFromTemplate(this.templatePool.pool[templateIndex]);
      return renderInst;
    }
    /**
     * Submits RenderInst to the current render inst list. Note that
     * this assumes the render inst was fully filled in, so do not modify it
     * after submitting it.
     */

  }, {
    key: "submitRenderInst",
    value: function submitRenderInst(renderInst) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentRenderInstList;
      list.submitRenderInst(renderInst);
    }
    /**
     * Sets the currently active render inst list. This is the list that will
     * be used by @param submitRenderInst}. If you use this function, please
     * make sure to call {@see disableSimpleMode} when the RenderInstManager
     * is created, to ensure that nobody uses the "legacy" APIs. Failure to do
     * so might cause memory leaks or other problems.
     */

  }, {
    key: "setCurrentRenderInstList",
    value: function setCurrentRenderInstList(list) {
      assert(this.simpleRenderInstList === null);
      this.currentRenderInstList = list;
    }
    /**
     * Pushes a new template render inst to the template stack. All properties set
     * on the topmost template on the template stack will be the defaults for both
     * for any future render insts created. Once done with a template, call
     * {@param popTemplateRenderInst} to pop it off the template stack.
     */

  }, {
    key: "pushTemplateRenderInst",
    value: function pushTemplateRenderInst() {
      var templateIndex = this.templatePool.allocCount - 1;
      var newTemplateIndex = this.templatePool.allocRenderInstIndex();
      var newTemplate = this.templatePool.pool[newTemplateIndex];
      if (templateIndex >= 0) newTemplate.setFromTemplate(this.templatePool.pool[templateIndex]);
      newTemplate.flags |= RenderInstFlags.Template;
      return newTemplate;
    }
  }, {
    key: "popTemplateRenderInst",
    value: function popTemplateRenderInst() {
      this.templatePool.popRenderInst();
    }
    /**
     * Retrieves the current template render inst on the top of the template stack.
     */

  }, {
    key: "getTemplateRenderInst",
    value: function getTemplateRenderInst() {
      var templateIndex = this.templatePool.allocCount - 1;
      return this.templatePool.pool[templateIndex];
    }
    /**
     * Reset all allocated render insts. This should be called at the end of the frame,
     * once done with all of the allocated render insts and render inst lists.
     */

  }, {
    key: "resetRenderInsts",
    value: function resetRenderInsts() {
      // Retire the existing render insts.
      this.instPool.reset();
      if (this.simpleRenderInstList !== null) this.simpleRenderInstList.reset(); // Ensure we aren't leaking templates.

      assert(this.templatePool.allocCount === 0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.instPool.destroy();
      this.renderCache.destroy();
    }
    /**
     * Disables the "simple" render inst list management API.
     */

  }, {
    key: "disableSimpleMode",
    value: function disableSimpleMode() {
      // This is a one-way street!
      this.simpleRenderInstList = null;
    }
    /**
     * Execute all scheduled render insts in {@param list} onto the {@param RenderPass},
     * using {@param device} and {@param cache} to create any device-specific resources
     * necessary to complete the draws.
     */

  }, {
    key: "drawListOnPassRenderer",
    value: function drawListOnPassRenderer(list, passRenderer) {
      list.drawOnPassRenderer(this.renderCache, passRenderer);
    }
  }, {
    key: "drawOnPassRenderer",
    value: function drawOnPassRenderer(passRenderer) {
      var list = assertExists(this.simpleRenderInstList);
      list.drawOnPassRenderer(this.renderCache, passRenderer);
    }
  }, {
    key: "drawOnPassRendererNoReset",
    value: function drawOnPassRendererNoReset(passRenderer) {
      var list = assertExists(this.simpleRenderInstList);
      list.drawOnPassRendererNoReset(this.renderCache, passRenderer);
    }
  }]);

  return RenderInstManager;
}();

var RenderHelper = /*#__PURE__*/function () {
  function RenderHelper() {
    _classCallCheck(this, RenderHelper);

    this.renderCache = void 0;
    this.renderGraph = void 0;
    this.renderInstManager = void 0;
    this.uniformBuffer = void 0;
    this.device = void 0;
  }

  _createClass(RenderHelper, [{
    key: "getDevice",
    value: function getDevice() {
      return this.device;
    }
  }, {
    key: "setDevice",
    value: function setDevice(device) {
      this.device = device;
      this.renderCache = new RenderCache(device);
      this.renderGraph = new RenderGraph(this.device);
      this.renderInstManager = new RenderInstManager(this.renderCache);
      this.uniformBuffer = new DynamicUniformBuffer(this.device); // this.debugThumbnails = new DebugThumbnailDrawer(this);
    }
  }, {
    key: "pushTemplateRenderInst",
    value: function pushTemplateRenderInst() {
      var template = this.renderInstManager.pushTemplateRenderInst();
      template.setUniformBuffer(this.uniformBuffer);
      return template;
    }
  }, {
    key: "prepareToRender",
    value: function prepareToRender() {
      this.uniformBuffer.prepareToRender();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.uniformBuffer) {
        this.uniformBuffer.destroy();
      }

      this.renderInstManager.destroy();
      this.renderCache.destroy();
      this.renderGraph.destroy();
    } // getDebugTextDrawer(): TextDrawer | null {
    //   return null;
    // }

  }, {
    key: "getCache",
    value: function getCache() {
      return this.renderCache;
    }
  }]);

  return RenderHelper;
}();

RenderHelper = __decorate([singleton()], RenderHelper);

var TexturePool = /*#__PURE__*/function () {
  function TexturePool() {
    _classCallCheck(this, TexturePool);

    this.offscreenCanvas = void 0;
    this.textureCache = {};
    this.gradientCache = {};
  }

  _createClass(TexturePool, [{
    key: "getOrCreateTexture",
    value: function getOrCreateTexture(device, src, descriptor, successCallback) {
      var _this = this;

      // @ts-ignore
      var id = typeof src === 'string' ? src : src.src || '';

      if (!this.textureCache[id]) {
        this.textureCache[id] = device.createTexture(_objectSpread2({
          pixelFormat: Format.U8_RGBA_NORM,
          width: 1,
          height: 1,
          depth: 1,
          numLevels: 1,
          dimension: TextureDimension.n2D,
          usage: TextureUsage.Sampled,
          pixelStore: {
            unpackFlipY: false
          },
          immutable: false
        }, descriptor));

        if (typeof src !== 'string') {
          this.textureCache[id].setImageData(src);
        } else {
          var image = new window.Image();

          image.onload = function () {
            _this.textureCache[id].setImageData(image);

            if (successCallback) {
              successCallback();
            }
          };

          image.onerror = function () {};

          image.crossOrigin = 'Anonymous';
          image.src = src;
        }
      }

      return this.textureCache[id];
    }
  }, {
    key: "getOrCreateCanvas",
    value: function getOrCreateCanvas() {
      return this.offscreenCanvas.getOrCreateCanvas();
    }
  }, {
    key: "getOrCreateGradient",
    value: function getOrCreateGradient(params) {
      var key = this.generateCacheKey(params);
      var type = params.type,
          x0 = params.x0,
          y0 = params.y0,
          x1 = params.x1,
          y1 = params.y1,
          steps = params.steps,
          width = params.width,
          height = params.height;
      var gradient = this.gradientCache[key];
      var canvas = this.offscreenCanvas.getOrCreateCanvas();
      var context = this.offscreenCanvas.getOrCreateContext();

      if (!gradient) {
        canvas.width = width;
        canvas.height = height; // needs only 1px height

        if (type === PARSED_COLOR_TYPE.LinearGradient) {
          // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createLinearGradient
          gradient = context.createLinearGradient(x0 * width, y0 * height, x1 * width, y1 * height);
        } else if (type === PARSED_COLOR_TYPE.RadialGradient) {
          var r = Math.sqrt(width * width + height * height) / 2; // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createRadialGradient

          gradient = context.createRadialGradient(x0 * width, y0 * height, 0, x1 * width, y1 * height, params.r1 * r);
        }

        steps.forEach(function (_ref) {
          var _gradient;

          var _ref2 = _slicedToArray(_ref, 2),
              offset = _ref2[0],
              color = _ref2[1];

          (_gradient = gradient) === null || _gradient === void 0 ? void 0 : _gradient.addColorStop(Number(offset), color);
        });
        this.gradientCache[key] = gradient;
      } // used as canvas' ID
      // @ts-ignore


      canvas.src = key;

      if (gradient) {
        context.fillStyle = gradient;
        context.fillRect(0, 0, width, height);
      }
    }
  }, {
    key: "generateCacheKey",
    value: function generateCacheKey(params) {
      // @ts-ignore
      var type = params.type,
          x0 = params.x0,
          y0 = params.y0,
          x1 = params.x1,
          y1 = params.y1,
          r1 = params.r1,
          steps = params.steps,
          width = params.width,
          height = params.height;
      return "gradient-".concat(type, "-").concat(x0, "-").concat(y0, "-").concat(x1, "-").concat(y1, "-").concat(r1 || 0, "-").concat(width, "-").concat(height, "-").concat(steps.map(function (step) {
        return step.join('');
      }).join('-'));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      for (var key in this.textureCache) {
        this.textureCache[key].destroy();
      }

      this.textureCache = {};
      this.gradientCache = {};
    }
  }]);

  return TexturePool;
}();

__decorate([inject(OffscreenCanvasCreator), __metadata("design:type", OffscreenCanvasCreator)], TexturePool.prototype, "offscreenCanvas", void 0);

TexturePool = __decorate([singleton()], TexturePool);

var LightPool = /*#__PURE__*/function () {
  function LightPool() {
    _classCallCheck(this, LightPool);

    this.lights = [];
    this.fog = void 0;
  }

  _createClass(LightPool, [{
    key: "addLight",
    value: function addLight(light) {
      this.lights.push(light);
      this.sortLights();
    }
  }, {
    key: "removeLight",
    value: function removeLight(light) {
      var i = this.lights.indexOf(light);
      this.lights.splice(i, 1);
      this.sortLights();
    }
  }, {
    key: "addFog",
    value: function addFog(fog) {
      this.fog = fog;
    }
  }, {
    key: "removeFog",
    value: function removeFog(fog) {
      this.fog = null;
    }
  }, {
    key: "getFog",
    value: function getFog() {
      return this.fog;
    }
  }, {
    key: "getAllLights",
    value: function getAllLights() {
      return this.lights;
    }
    /**
     * USE_LIGHT
     * NUM_AMBIENT_LIGHTS
     * NUM_DIR_LIGHTS
     */

  }, {
    key: "getDefines",
    value: function getDefines() {
      var defines = {
        USE_LIGHT: !!this.lights.length
      };
      this.lights.forEach(function (light) {
        if (!defines[light.define]) {
          defines[light.define] = 0;
        }

        defines[light.define]++;
      });
      return defines;
    }
  }, {
    key: "sortLights",
    value: function sortLights() {
      this.lights.sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }]);

  return LightPool;
}();

LightPool = __decorate([singleton()], LightPool);

var RendererFactory = Syringe.defineToken('RendererFactory');
var ShapeRenderer = Syringe.defineToken('ShapeRenderer');
var MeshFactory = Syringe.defineToken('MeshFactory'); // export const ShapeMesh = Syringe.defineToken('ShapeMesh');

var ES100_REPLACEMENTS = [// In GLSL 1.00 ES these functions are provided by an extension
[/\btexture(2D|2DProj|Cube)Lod\(/g, 'texture$1LodEXT('], // Overloads in GLSL 3.00 map to individual functions. Note that we cannot
// differentiate 2D,2DProj,Cube without type analysis so we choose the most common variant.
[/\btexture\(/g, 'texture2D('], [/\btextureLod\(/g, 'texture2DLodEXT(']];

function defineStr(k, v) {
  return "#define ".concat(k, " ").concat(v);
}

function getDefines(shader) {
  var defines = {};
  shader.replace(/^\s*#define\s*(\S*)\s*(\S*)\s*$/gm, function (_, name, value) {
    var v = Number(value);
    defines[name] = isNaN(v) ? value : v;
    return '';
  });
  return defines;
}
function getAttributeLocations(vert, defines) {
  var locations = [];
  vert.replace(/^\s*layout\(location\s*=\s*(\S*)\)\s*in\s+\S+\s*(.*);$/gm, function (_, location, name) {
    var l = Number(location);
    locations.push({
      location: isNaN(l) ? defines[location] : l,
      name: name
    });
    return '';
  });
  return locations;
}
function getUniforms(vert) {
  var uniformNames = [];
  var structs = [];
  vert.replace(/\s*struct\s*(.*)\s*{((?:\s*.*\s*)*?)};/g, function (_, type, uniformStr) {
    var uniforms = [];
    uniformStr.trim().split('\n').forEach(function (line) {
      var _line$trim$split = line.trim().split(/\s+/),
          _line$trim$split2 = _slicedToArray(_line$trim$split, 2),
          type = _line$trim$split2[0],
          name = _line$trim$split2[1];

      uniforms.push({
        type: type.trim(),
        name: name.replace(';', '').trim()
      });
    });
    structs.push({
      type: type.trim(),
      uniforms: uniforms
    });
    return '';
  });
  vert.replace(/\s*uniform\s*.*\s*{((?:\s*.*\s*)*?)};/g, function (_, uniforms) {
    uniforms.trim().split('\n').forEach(function (line) {
      var _line$trim$split3 = line.trim().split(' '),
          _line$trim$split4 = _slicedToArray(_line$trim$split3, 2),
          _line$trim$split4$ = _line$trim$split4[0],
          type = _line$trim$split4$ === void 0 ? '' : _line$trim$split4$,
          _line$trim$split4$2 = _line$trim$split4[1],
          name = _line$trim$split4$2 === void 0 ? '' : _line$trim$split4$2; // DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];


      var isArray = name.indexOf('[') > -1;
      name = name.replace(';', '').replace('[', '').trim(); // ignore conditional comments

      if (type.startsWith('#')) {
        return;
      } // account for structs


      if (type) {
        var struct = structs.find(function (struct) {
          return type === struct.type;
        });

        if (struct) {
          if (isArray) {
            var _loop = function _loop(i) {
              struct.uniforms.forEach(function (uniform) {
                uniformNames.push("".concat(name, "[").concat(i, "].").concat(uniform.name));
              });
            };

            for (var i = 0; i < 5; i++) {
              _loop(i);
            }
          } else {
            struct.uniforms.forEach(function (uniform) {
              uniformNames.push("".concat(name, ".").concat(uniform.name));
            });
          }
        }
      }

      if (name) {
        uniformNames.push(name);
      }
    });
    return '';
  });
  return uniformNames;
}
function preprocessShader_GLSL(vendorInfo, type, source) {
  var defines = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var features = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var isGLSL100 = vendorInfo.glslVersion === '#version 100';
  var supportMRT = vendorInfo.supportMRT && !!features.MRT;
  var needPicking = features.PICKING;
  var lines = source.split('\n').map(function (n) {
    // Remove comments.
    return n.replace(/[/][/].*$/, '');
  }).filter(function (n) {
    // Filter whitespace.
    var isEmpty = !n || /^\s+$/.test(n);
    return !isEmpty;
  }); // #define KEY VAR

  var definesString = '';
  if (defines !== null) definesString = _toConsumableArray(defines.entries()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return defineStr(k, v);
  }).join('\n');
  var precision = lines.find(function (line) {
    return line.startsWith('precision');
  }) || 'precision mediump float;';
  var rest = lines.filter(function (line) {
    return !line.startsWith('precision');
  }).join('\n');
  var extraDefines = '';

  if (vendorInfo.viewportOrigin === ViewportOrigin.UpperLeft) {
    extraDefines += "".concat(defineStr("VIEWPORT_ORIGIN_TL", "1"), "\n");
  }

  if (vendorInfo.clipSpaceNearZ === ClipSpaceNearZ.Zero) {
    extraDefines += "".concat(defineStr("CLIPSPACE_NEAR_ZERO", "1"), "\n");
  }

  if (vendorInfo.explicitBindingLocations) {
    var set = 0,
        binding = 0,
        location = 0;
    rest = rest.replace(/^(layout\((.*)\))?\s*uniform(.+{)$/gm, function (substr, cap, layout, rest) {
      var layout2 = layout ? "".concat(layout, ", ") : "";
      return "layout(".concat(layout2, "set = ").concat(set, ", binding = ").concat(binding++, ") uniform ").concat(rest);
    }); // XXX(jstpierre): WebGPU now binds UBOs and textures in different sets as a porting hack, hrm...

    set++;
    binding = 0;
    assert(vendorInfo.separateSamplerTextures);
    rest = rest.replace(/uniform sampler2D (.*);/g, function (substr, samplerName) {
      // Can't have samplers in vertex for some reason.
      return type === 'frag' ? "\nlayout(set = ".concat(set, ", binding = ").concat(binding++, ") uniform texture2D T_").concat(samplerName, ";\nlayout(set = ").concat(set, ", binding = ").concat(binding++, ") uniform sampler S_").concat(samplerName, ";\n") : '';
    });
    rest = rest.replace(type === 'frag' ? /^\b(varying|in)\b/gm : /^\b(varying|out)\b/gm, function (substr, tok) {
      return "layout(location = ".concat(location++, ") ").concat(tok);
    });
    extraDefines += "".concat(defineStr("gl_VertexID", "gl_VertexIndex"), "\n");
  }

  if (vendorInfo.separateSamplerTextures) {
    rest = rest.replace(/\bPD_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "texture2D T_P_".concat(samplerName, ", sampler S_P_").concat(samplerName);
    });
    rest = rest.replace(/\bPU_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "SAMPLER_2D(P_".concat(samplerName, ")");
    });
    rest = rest.replace(/\bPP_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "T_".concat(samplerName, ", S_").concat(samplerName);
    });
    rest = rest.replace(/\bSAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "sampler2D(T_".concat(samplerName, ", S_").concat(samplerName, ")");
    });
  } else {
    rest = rest.replace(/\bPD_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "sampler2D P_".concat(samplerName);
    });
    rest = rest.replace(/\bPU_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return "SAMPLER_2D(P_".concat(samplerName, ")");
    });
    rest = rest.replace(/\bPP_SAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return samplerName;
    });
    rest = rest.replace(/\bSAMPLER_2D\((.*?)\)/g, function (substr, samplerName) {
      return samplerName;
    });
  } // using #define means we can't use `const in/out` in params
  //   ${isGLSL100 && type === 'vert' ? '#define in attribute\n#define out varying' : ''}
  // ${isGLSL100 && type === 'frag' ? '#define in varying' : ''}


  var concat = "\n".concat(vendorInfo.glslVersion, "\n").concat(isGLSL100 && supportMRT ? '#extension GL_EXT_draw_buffers : require' : '', "\n").concat(isGLSL100 && type === 'frag' ? '#extension GL_OES_standard_derivatives : enable' : '', "\n").concat(precision, "\n").concat(extraDefines, "\n").concat(definesString, "\n").concat(rest, "\n").trim();

  if (vendorInfo.explicitBindingLocations && type === 'frag') {
    concat = concat.replace(/^\b(out)\b/gm, function (substr, tok) {
      return "layout(location = 0) ".concat(tok);
    });
  } // GLSL 300 -> 100


  if (isGLSL100) {
    // in -> varying
    if (type === 'frag') {
      concat = concat.replace(/^\s*in\s+(\S+)\s*(.*);$/gm, function (_, dataType, name) {
        return "varying ".concat(dataType, " ").concat(name, ";\n");
      });
    }

    if (type === 'vert') {
      // out -> varying
      concat = concat.replace(/^\s*out\s+(\S+)\s*(.*);$/gm, function (_, dataType, name) {
        return "varying ".concat(dataType, " ").concat(name, ";\n");
      }); // in -> attribute

      concat = concat.replace( // /^\s*layout\(location\s*=\s*\d*\)\s*in\s*(.*)\s*(.*);$/gm,
      /^\s*layout\(location\s*=\s*\S*\)\s*in\s+(\S+)\s*(.*);$/gm, function (_, dataType, name) {
        return "attribute ".concat(dataType, " ").concat(name, ";\n");
      });
    } // interface blocks supported in GLSL ES 3.00 and above only


    concat = concat.replace(/\s*uniform\s*.*\s*{((?:\s*.*\s*)*?)};/g, function (substr, uniforms) {
      return uniforms.trim().replace(/^.*$/gm, function (uniform) {
        // eg. #ifdef
        var trimmed = uniform.trim();

        if (trimmed.startsWith('#')) {
          return trimmed;
        }

        return uniform ? "uniform ".concat(trimmed) : '';
      });
    }); // MRT

    if (supportMRT) {
      if (type === 'frag') {
        var gBuffers = [];
        concat = concat.replace(/^\s*layout\(location\s*=\s*\d*\)\s*out\s+vec4\s*(.*);$/gm, function (_, buffer) {
          gBuffers.push(buffer);
          return "vec4 ".concat(buffer, ";\n");
        });
        var lastIndexOfMain = concat.lastIndexOf('}');
        concat = concat.substring(0, lastIndexOfMain) + "\n    ".concat(gBuffers.map(function (gBuffer, i) {
          return "gl_FragData[".concat(i, "] = ").concat(gBuffer, ";\n    ");
        }).join('\n')) + concat.substring(lastIndexOfMain);
      }
    } // remove layout(location = 0)


    concat = concat.replace(/^\s*layout\((.*)\)/gm, ''); // replace texture with texture2D

    var _iterator = _createForOfIteratorHelper(ES100_REPLACEMENTS),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            pattern = _step$value[0],
            replacement = _step$value[1];

        concat = concat.replace(pattern, replacement);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return concat;
}
function preprocessProgram_GLSL(vendorInfo, vert, frag) {
  var defines = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var features = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var preprocessedVert = preprocessShader_GLSL(vendorInfo, 'vert', vert, defines, features);
  var preprocessedFrag = preprocessShader_GLSL(vendorInfo, 'frag', frag, defines, features);
  return {
    vert: vert,
    frag: frag,
    preprocessedVert: preprocessedVert,
    preprocessedFrag: preprocessedFrag
  };
}
function preprocessProgramObj_GLSL(device, obj) {
  var defines = obj.defines !== undefined ? obj.defines : null;
  var features = obj.features !== undefined ? obj.features : null;
  var vert = obj.both !== undefined ? obj.both + obj.vert : obj.vert;
  var frag = obj.both !== undefined ? obj.both + obj.frag : obj.frag;
  return preprocessProgram_GLSL(device.queryVendorInfo(), vert, frag, defines, features);
}

var DeviceProgram = /*#__PURE__*/function () {
  function DeviceProgram() {
    _classCallCheck(this, DeviceProgram);

    this.name = '(unnamed)';
    this.preprocessedVert = '';
    this.preprocessedFrag = '';
    this.both = '';
    this.vert = '';
    this.frag = '';
    this.defines = new Map();
    this.features = {
      MRT: true
    };
  }

  _createClass(DeviceProgram, [{
    key: "definesChanged",
    value: function definesChanged() {
      this.preprocessedVert = '';
      this.preprocessedFrag = '';
    }
  }, {
    key: "setDefineString",
    value: function setDefineString(name, v) {
      if (v !== null) {
        if (this.defines.get(name) === v) return false;
        this.defines.set(name, v);
      } else {
        if (!this.defines.has(name)) return false;
        this.defines.delete(name);
      }

      this.definesChanged();
      return true;
    }
  }, {
    key: "setDefineBool",
    value: function setDefineBool(name, v) {
      return this.setDefineString(name, v ? '1' : null);
    }
  }, {
    key: "getDefineString",
    value: function getDefineString(name) {
      return nullify(this.defines.get(name));
    }
  }, {
    key: "getDefineBool",
    value: function getDefineBool(name) {
      var str = this.getDefineString(name);
      if (str !== null) assert(str === '1');
      return str !== null;
    }
  }, {
    key: "ensurePreprocessed",
    value: function ensurePreprocessed(vendorInfo) {
      if (this.preprocessedVert === '') {
        this.preprocessedVert = preprocessShader_GLSL(vendorInfo, 'vert', this.both + this.vert, this.defines, this.features);
        this.preprocessedFrag = preprocessShader_GLSL(vendorInfo, 'frag', this.both + this.frag, this.defines, this.features);
      }
    }
  }]);

  return DeviceProgram;
}();

var TextureMapping = /*#__PURE__*/function () {
  function TextureMapping() {
    _classCallCheck(this, TextureMapping);

    this.name = void 0;
    this.texture = null;
    this.sampler = null;
    this.lateBinding = null;
    this.width = 0;
    this.height = 0;
    this.lodBias = 0;
  }

  _createClass(TextureMapping, [{
    key: "reset",
    value: // GL sucks. This is a convenience when building texture matrices.
    // The core renderer does not use this code at all.
    // flipY: boolean = false;
    function reset() {
      this.texture = null;
      this.sampler = null;
      this.lateBinding = null;
      this.width = 0;
      this.height = 0;
      this.lodBias = 0; // this.flipY = false;
    }
  }, {
    key: "copy",
    value: function copy(other) {
      this.texture = other.texture;
      this.sampler = other.sampler;
      this.lateBinding = other.lateBinding;
      this.width = other.width;
      this.height = other.height;
      this.lodBias = other.lodBias; // this.flipY = other.flipY;
    }
  }]);

  return TextureMapping;
}();

var stencilRefCounter = 1;

var BatchManager = /*#__PURE__*/function () {
  function BatchManager() {
    _classCallCheck(this, BatchManager);

    this.renderHelper = void 0;
    this.rendererFactory = void 0;
    this.meshFactory = void 0;
    this.device = void 0;
    this.renderingService = void 0;
    this.meshes = [];
    this.stencilRefCache = {};
  }

  _createClass(BatchManager, [{
    key: "render",
    value: function render(list) {
      var _this = this;

      this.meshes.forEach(function (mesh) {
        // init rendering service, create geometry & material
        mesh.init(_this.device, _this.renderingService);
        var objects = mesh.objects;

        if (mesh.clipPathTarget) {
          objects = [mesh.clipPath];
        } // new render instance


        var renderInst = _this.renderHelper.renderInstManager.newRenderInst();

        mesh.applyRenderInst(renderInst, objects);

        _this.renderHelper.renderInstManager.submitRenderInst(renderInst, list); // console.log('submit: ', mesh);
        // finish rendering...


        mesh.objects.forEach(function (object) {
          object.renderable.dirty = false;
        });
      });
    }
    /**
     * get called in RenderGraphPlugin
     */

  }, {
    key: "attach",
    value: function attach(device, renderingService) {
      this.device = device;
      this.renderingService = renderingService;
    }
  }, {
    key: "add",
    value: function add(object) {
      var _this2 = this;

      // @ts-ignore
      var renderable3D = object.renderable3D;

      if (renderable3D && !renderable3D.meshes.length) {
        var renderer = this.rendererFactory(object.nodeName);

        if (renderer) {
          renderer.meshes.forEach(function (meshTag, i) {
            renderable3D.meshes[i] = undefined;
            var shouldSubmit = renderer.shouldSubmitRenderInst(object, i);

            if (shouldSubmit) {
              var existedMesh = _this2.meshes.find(function (mesh) {
                return meshTag === mesh.constructor && mesh.index === i && mesh.shouldMerge(object, i);
              });

              if (!existedMesh) {
                existedMesh = _this2.meshFactory(meshTag);
                existedMesh.renderer = renderer;
                existedMesh.index = i;

                _this2.meshes.push(existedMesh);
              }

              if (existedMesh) {
                existedMesh.objects.push(object);
                renderable3D.meshes[i] = existedMesh;
                existedMesh.geometryDirty = true;
              }
            }
          });
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(object) {
      var _this3 = this;

      // @ts-ignore
      var renderable3D = object.renderable3D;

      if (renderable3D) {
        renderable3D.meshes.forEach(function (mesh) {
          if (mesh) {
            // remove from mesh
            var index = mesh.objects.indexOf(object);

            if (index > -1) {
              mesh.objects.splice(index, 1);
              mesh.geometryDirty = true;
            }

            if (mesh.objects.length === 0) {
              _this3.meshes.splice(_this3.meshes.indexOf(mesh), 1);
            }
          }
        });
        renderable3D.meshes = [];
      }
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, attributeName, newValue) {
      var _this4 = this;

      // @ts-ignore
      var renderable3D = object.renderable3D;
      var renderer = this.rendererFactory(object.nodeName);

      if (renderer) {
        renderer.meshes.forEach(function (meshCtor, i) {
          var shouldSubmit = renderer.shouldSubmitRenderInst(object, i);
          var existedMesh = renderable3D.meshes.find(function (mesh) {
            return mesh && mesh.index === i && mesh.constructor === meshCtor;
          }); // is this mesh already rendered in current displayobject?

          if (shouldSubmit !== !!existedMesh) {
            if (existedMesh) {
              // remove from mesh
              existedMesh.objects.splice(existedMesh.objects.indexOf(object), 1);
              existedMesh.geometryDirty = true;

              if (existedMesh.objects.length === 0) {
                _this4.meshes.splice(_this4.meshes.indexOf(existedMesh), 1);
              }

              renderable3D.meshes[renderable3D.meshes.indexOf(existedMesh)] = undefined;
            }

            if (shouldSubmit) {
              // clear first
              existedMesh = _this4.meshes.find(function (mesh) {
                return meshCtor === mesh.constructor && mesh.index === i && mesh.shouldMerge(object, i);
              });

              if (!existedMesh) {
                existedMesh = _this4.meshFactory(meshCtor);
                existedMesh.renderer = renderer;
                existedMesh.index = i;
                existedMesh.init(_this4.device, _this4.renderingService);

                _this4.meshes.push(existedMesh);
              }

              if (existedMesh) {
                existedMesh.objects.push(object);
                renderable3D.meshes[i] = existedMesh;
              }
            }
          }

          if (shouldSubmit && existedMesh && existedMesh.inited && !existedMesh.geometryDirty) {
            existedMesh.updateAttribute(object, attributeName, newValue);
          }
        });
      }
    }
  }, {
    key: "changeRenderOrder",
    value: function changeRenderOrder(object, renderOrder) {
      // @ts-ignore
      var renderable3D = object.renderable3D;

      if (renderable3D && renderable3D.meshes.length) {
        renderable3D.meshes.forEach(function (mesh) {
          if (mesh && mesh.inited && !mesh.geometryDirty) {
            var shouldSubmit = mesh.renderer.shouldSubmitRenderInst(object, mesh.index);

            if (shouldSubmit && mesh.inited) {
              mesh.changeRenderOrder(object, renderOrder);
            }
          }
        });
      }
    }
  }, {
    key: "getStencilRef",
    value: function getStencilRef(object) {
      if (!this.stencilRefCache[object.entity]) {
        this.stencilRefCache[object.entity] = stencilRefCounter++;
      }

      return this.stencilRefCache[object.entity];
    }
  }]);

  return BatchManager;
}();

__decorate([inject(RenderHelper), __metadata("design:type", RenderHelper)], BatchManager.prototype, "renderHelper", void 0);

__decorate([inject(RendererFactory), __metadata("design:type", Function)], BatchManager.prototype, "rendererFactory", void 0);

__decorate([inject(MeshFactory), __metadata("design:type", Function)], BatchManager.prototype, "meshFactory", void 0);

BatchManager = __decorate([singleton()], BatchManager);

/**
 * render order start from 0, our default camera's Z is 500
 */

var RENDER_ORDER_SCALE = 1 / 200;
var counter = 1;
/**
 * A container for multiple display objects with the same `style`,
 * eg. 1000 Circles with the same stroke color, but their position, radius can be different
 */

var Batch = /*#__PURE__*/function () {
  function Batch() {
    _classCallCheck(this, Batch);

    this.renderHelper = void 0;
    this.texturePool = void 0;
    this.camera = void 0;
    this.lightPool = void 0;
    this.batchManager = void 0;
    this.meshFactory = void 0;
    this.device = void 0;
    this.renderingService = void 0;
    this.id = counter++;
    this.meshes = [];
    this.clipPathMeshCreated = false;
  }

  _createClass(Batch, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      return true;
    }
  }, {
    key: "beforeUploadUBO",
    value: function beforeUploadUBO(renderInst, mesh, index) {}
  }, {
    key: "beforeInitMesh",
    value: function beforeInitMesh(mesh) {}
  }, {
    key: "afterInitMesh",
    value: function afterInitMesh(mesh) {}
  }]);

  return Batch;
}();

__decorate([inject(RenderHelper), __metadata("design:type", RenderHelper)], Batch.prototype, "renderHelper", void 0);

__decorate([inject(TexturePool), __metadata("design:type", TexturePool)], Batch.prototype, "texturePool", void 0);

__decorate([inject(DefaultCamera), __metadata("design:type", Camera)], Batch.prototype, "camera", void 0);

__decorate([inject(LightPool), __metadata("design:type", LightPool)], Batch.prototype, "lightPool", void 0);

__decorate([inject(BatchManager), __metadata("design:type", BatchManager)], Batch.prototype, "batchManager", void 0);

__decorate([inject(MeshFactory), __metadata("design:type", Function)], Batch.prototype, "meshFactory", void 0);

Batch = __decorate([injectable()], Batch);

function makeStaticDataBuffer(device, usage, data) {
  var buffer = device.createBuffer({
    viewOrSize: align(data.byteLength, 4) / 4,
    usage: usage,
    hint: BufferFrequencyHint.Static
  });
  buffer.setSubData(0, new Uint8Array(data));
  return buffer;
}
var VertexAttributeLocation;

(function (VertexAttributeLocation) {
  // TODO: bind mat4 in WebGL2 instead of decomposed 4 * vec4?
  // @see https://stackoverflow.com/questions/38853096/webgl-how-to-bind-values-to-a-mat4-attribute/38853623#38853623
  VertexAttributeLocation[VertexAttributeLocation["MODEL_MATRIX0"] = 0] = "MODEL_MATRIX0";
  VertexAttributeLocation[VertexAttributeLocation["MODEL_MATRIX1"] = 1] = "MODEL_MATRIX1";
  VertexAttributeLocation[VertexAttributeLocation["MODEL_MATRIX2"] = 2] = "MODEL_MATRIX2";
  VertexAttributeLocation[VertexAttributeLocation["MODEL_MATRIX3"] = 3] = "MODEL_MATRIX3";
  VertexAttributeLocation[VertexAttributeLocation["COLOR"] = 4] = "COLOR";
  VertexAttributeLocation[VertexAttributeLocation["STROKE_COLOR"] = 5] = "STROKE_COLOR";
  VertexAttributeLocation[VertexAttributeLocation["PACKED_STYLE1"] = 6] = "PACKED_STYLE1";
  VertexAttributeLocation[VertexAttributeLocation["PACKED_STYLE2"] = 7] = "PACKED_STYLE2";
  VertexAttributeLocation[VertexAttributeLocation["PICKING_COLOR"] = 8] = "PICKING_COLOR";
  VertexAttributeLocation[VertexAttributeLocation["ANCHOR"] = 9] = "ANCHOR";
  VertexAttributeLocation[VertexAttributeLocation["MAX"] = 10] = "MAX";
})(VertexAttributeLocation || (VertexAttributeLocation = {}));
/**
 * just hold descriptors of buffers & indices, won't use underlying GPU resources
 */


var BufferGeometry = /*#__PURE__*/function (_EventEmitter) {
  _inherits(BufferGeometry, _EventEmitter);

  var _super = _createSuper(BufferGeometry);

  /**
   * 绘制模式
   */

  /**
   * 存放 Attribute Buffer 列表
   */

  /**
   * 存放 Index Buffer
   */

  /**
   * 索引数组
   */
  function BufferGeometry(device) {
    var _this;

    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BufferGeometry);

    _this = _super.call(this);
    _this.device = void 0;
    _this.props = void 0;
    _this.drawMode = PrimitiveTopology.Triangles;
    _this.vertexBuffers = [];
    _this.vertices = [];
    _this.indexBuffer = void 0;
    _this.indices = void 0;
    _this.inputLayoutDescriptor = {
      vertexBufferDescriptors: [],
      vertexAttributeDescriptors: [],
      indexBufferFormat: Format.U32_R
    };
    _this.vertexCount = 0;
    _this.instancedCount = 0;
    _this.indexStart = 0;
    _this.primitiveStart = 0;
    _this.dirty = true;
    _this.meshes = [];
    _this.device = device;
    _this.props = props;
    return _this;
  }

  _createClass(BufferGeometry, [{
    key: "validate",
    value: function validate(mesh) {
      return true;
    }
  }, {
    key: "build",
    value: function build(meshes) {}
  }, {
    key: "setIndexBuffer",
    value: function setIndexBuffer(indices) {
      if (this.indexBuffer) {
        this.indexBuffer.destroy();
      }

      this.indexBuffer = makeStaticDataBuffer(this.device, BufferUsage.INDEX, new Uint32Array(ArrayBuffer.isView(indices) ? indices.buffer : indices).buffer);
      this.indices = indices;
      return this;
    }
  }, {
    key: "setVertexBuffer",
    value: function setVertexBuffer(descriptor) {
      var _this2 = this;

      var bufferIndex = descriptor.bufferIndex,
          byteStride = descriptor.byteStride,
          frequency = descriptor.frequency,
          attributes = descriptor.attributes,
          data = descriptor.data;
      this.inputLayoutDescriptor.vertexBufferDescriptors[bufferIndex] = {
        byteStride: byteStride,
        frequency: frequency
      };
      this.vertices[bufferIndex] = data;
      attributes.forEach(function (_ref) {
        var format = _ref.format,
            bufferByteOffset = _ref.bufferByteOffset,
            location = _ref.location,
            divisor = _ref.divisor,
            byteStride = _ref.byteStride;

        var existed = _this2.inputLayoutDescriptor.vertexAttributeDescriptors.find(function (e) {
          return e.bufferIndex === bufferIndex && e.location === location;
        });

        if (existed) {
          existed.format = format;
          existed.bufferByteOffset = bufferByteOffset;
          existed.byteStride = byteStride;
          existed.divisor = divisor;
        } else {
          _this2.inputLayoutDescriptor.vertexAttributeDescriptors.push({
            format: format,
            bufferIndex: bufferIndex,
            bufferByteOffset: bufferByteOffset,
            location: location,
            byteStride: byteStride,
            divisor: divisor
          });
        }
      }); // create GPUBuffer

      if (this.vertexBuffers[bufferIndex]) {
        this.vertexBuffers[bufferIndex].destroy();
      }

      var buffer = makeStaticDataBuffer(this.device, BufferUsage.VERTEX, data.buffer);
      this.vertexBuffers[bufferIndex] = buffer;
      return this;
    }
  }, {
    key: "getVertexBuffer",
    value: function getVertexBuffer(bufferIndex) {
      return this.vertexBuffers[bufferIndex];
    }
  }, {
    key: "updateVertexBuffer",
    value: function updateVertexBuffer(bufferIndex, location, index, data) {
      var byteStride = this.inputLayoutDescriptor.vertexBufferDescriptors[bufferIndex].byteStride;
      var descriptor = this.inputLayoutDescriptor.vertexAttributeDescriptors.find(function (d) {
        return d.location === location;
      });

      if (descriptor) {
        var vertexBuffer = this.getVertexBuffer(bufferIndex);
        var offset = index * byteStride;
        vertexBuffer.setSubData(descriptor.bufferByteOffset + offset, data); // TODO: update vertices
        // this.vertices[bufferIndex] = data;
      } // trigger re-render


      this.meshes.forEach(function (mesh) {
        // mesh.emit(ElementEvent.ATTR_MODIFIED, {
        //   attributeName: 'geometry',
        // });
        mesh.dispatchEvent(new MutationEvent(ElementEvent.ATTR_MODIFIED, mesh, null, null, 'geometry', MutationEvent.MODIFICATION, null, null));
      });
    }
  }, {
    key: "updateIndices",
    value: function updateIndices(indices) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.indexBuffer) {
        this.indexBuffer.setSubData(offset, ArrayBuffer.isView(indices) ? indices : new Uint32Array(indices));
      }

      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.vertexBuffers.forEach(function (buffer) {
        if (buffer) {
          buffer.destroy();
        }
      });

      if (this.indexBuffer) {
        this.indexBuffer.destroy();
      }

      this.inputLayoutDescriptor.vertexAttributeDescriptors = [];
      this.inputLayoutDescriptor.vertexBufferDescriptors = [];
      this.indexBuffer = undefined;
      this.vertexBuffers = [];
      this.indices = undefined;
      this.vertices = [];
      this.vertexCount = 0;
      this.instancedCount = 0;
    }
  }]);

  return BufferGeometry;
}(EventEmitter);

function isTexture(t) {
  return !!(t && t.type);
}
/**
 * an encapsulation on top of shaders
 * @see https://doc.babylonjs.com/divingDeeper/materials/using/materials_introduction
 */


var Material = /*#__PURE__*/function () {
  function Material(device, props) {
    _classCallCheck(this, Material);

    this.device = void 0;
    this.props = {};
    this.meshes = [];
    this.defines = {};
    this.uniforms = {};
    this.uniformNames = void 0;
    this.uboBuffer = [];
    this.textures = {};
    this.samplers = [];
    this.programDirty = true;
    this.textureDirty = true;
    this.geometryDirty = true;

    var _copyMegaState = copyMegaState(defaultMegaState),
        cullMode = _copyMegaState.cullMode,
        depthCompare = _copyMegaState.depthCompare,
        depthWrite = _copyMegaState.depthWrite,
        stencilCompare = _copyMegaState.stencilCompare,
        stencilWrite = _copyMegaState.stencilWrite,
        stencilPassOp = _copyMegaState.stencilPassOp,
        frontFace = _copyMegaState.frontFace,
        polygonOffset = _copyMegaState.polygonOffset,
        attachmentsState = _copyMegaState.attachmentsState;

    this.device = device; // @ts-ignore

    this.props = _objectSpread2({
      cullMode: cullMode,
      depthTest: true,
      depthCompare: depthCompare,
      depthWrite: depthWrite,
      stencilCompare: stencilCompare,
      stencilWrite: stencilWrite,
      stencilPassOp: stencilPassOp,
      frontFace: frontFace,
      polygonOffset: polygonOffset,
      attachmentsState: attachmentsState,
      blendEquation: BlendMode.Add,
      blendEquationAlpha: BlendMode.Add,
      blendSrc: BlendFactor.SrcAlpha,
      blendDst: BlendFactor.OneMinusSrcAlpha,
      blendSrcAlpha: BlendFactor.Zero,
      blendDstAlpha: BlendFactor.One,
      dithering: false,
      wireframe: false,
      wireframeColor: 'black',
      wireframeLineWidth: 1,
      vertexShader: '',
      fragmentShader: ''
    }, props);
    this.compile();
  }

  _createClass(Material, [{
    key: "cullMode",
    get:
    /**
     * relative meshes
     */

    /**
     * cullFace
     */
    function get() {
      return this.props.cullMode;
    },
    set: function set(value) {
      this.props.cullMode = value;
    }
  }, {
    key: "frontFace",
    get: function get() {
      return this.props.frontFace;
    },
    set: function set(value) {
      this.props.frontFace = value;
    }
    /**
     * Blending state
     */

  }, {
    key: "blendEquation",
    get: function get() {
      return this.props.blendEquation;
    },
    set: function set(value) {
      this.props.blendEquation = value;
    }
  }, {
    key: "blendEquationAlpha",
    get: function get() {
      return this.props.blendEquationAlpha;
    },
    set: function set(value) {
      this.props.blendEquationAlpha = value;
    }
  }, {
    key: "blendSrc",
    get: function get() {
      return this.props.blendSrc;
    },
    set: function set(value) {
      this.props.blendSrc = value;
    }
  }, {
    key: "blendDst",
    get: function get() {
      return this.props.blendDst;
    },
    set: function set(value) {
      this.props.blendDst = value;
    }
  }, {
    key: "blendSrcAlpha",
    get: function get() {
      return this.props.blendSrcAlpha;
    },
    set: function set(value) {
      this.props.blendSrcAlpha = value;
    }
  }, {
    key: "blendDstAlpha",
    get: function get() {
      return this.props.blendDstAlpha;
    },
    set: function set(value) {
      this.props.blendDstAlpha = value;
    }
  }, {
    key: "depthCompare",
    get: function get() {
      return this.props.depthCompare;
    },
    set: function set(value) {
      this.props.depthCompare = value;
    }
  }, {
    key: "depthTest",
    get: function get() {
      return this.props.depthTest;
    },
    set: function set(value) {
      this.props.depthTest = value;
    }
  }, {
    key: "depthWrite",
    get: function get() {
      return this.props.depthWrite;
    },
    set: function set(value) {
      this.props.depthWrite = value;
    }
  }, {
    key: "stencilCompare",
    get: function get() {
      return this.props.stencilCompare;
    },
    set: function set(value) {
      this.props.stencilCompare = value;
    }
  }, {
    key: "stencilWrite",
    get: function get() {
      return this.props.stencilWrite;
    },
    set: function set(value) {
      this.props.stencilWrite = value;
    }
  }, {
    key: "stencilPassOp",
    get: function get() {
      return this.props.stencilPassOp;
    },
    set: function set(value) {
      this.props.stencilPassOp = value;
    }
  }, {
    key: "stencilRef",
    get: function get() {
      return this.props.stencilRef;
    },
    set: function set(value) {
      this.props.stencilRef = value;
    } // @see https://developer.mozilla.org/zh-CN/docs/Web/API/WebGLRenderingContext/polygonOffset

  }, {
    key: "polygonOffset",
    get: function get() {
      return this.props.polygonOffset;
    },
    set: function set(value) {
      this.props.polygonOffset = value;
    } // gl.DITHER

  }, {
    key: "dithering",
    get: function get() {
      return this.props.dithering;
    },
    set: function set(value) {
      this.props.dithering = value;
    } // @see https://doc.babylonjs.com/divingDeeper/materials/using/materials_introduction#wireframe

  }, {
    key: "wireframe",
    get: function get() {
      return this.props.wireframe;
    },
    set: function set(value) {
      if (this.props.wireframe !== value) {
        // need re-generate geometry
        this.geometryDirty = true;
        this.programDirty = true;
        this.props.wireframe = value;
      }

      this.defines.USE_WIREFRAME = !!value;
    }
  }, {
    key: "wireframeColor",
    get: function get() {
      return this.props.wireframeColor;
    },
    set: function set(value) {
      this.props.wireframeColor = value;
    }
  }, {
    key: "wireframeLineWidth",
    get: function get() {
      return this.props.wireframeLineWidth;
    },
    set: function set(value) {
      this.props.wireframeLineWidth = value;
    } // shader pairs

  }, {
    key: "vertexShader",
    get: function get() {
      return this.props.vertexShader;
    },
    set: function set(value) {
      if (this.props.vertexShader !== value) {
        this.programDirty = true;
        this.props.vertexShader = value;
        this.compile();
      }
    }
  }, {
    key: "fragmentShader",
    get: function get() {
      return this.props.fragmentShader;
    },
    set: function set(value) {
      if (this.props.fragmentShader !== value) {
        this.programDirty = true;
        this.props.fragmentShader = value;
        this.compile();
      }
    } // USE_XXX

  }, {
    key: "compile",
    value: function compile() {
      var _this = this;

      // uniform sampler2D u_Texture0;
      this.props.fragmentShader.replace(/^\s*uniform\s*sampler2D\s*(.*)\s*;$/gm, function (_, name) {
        _this.samplers.push(name);

        return '';
      });
      /**
       * extract from uniform buffer object, should account for struct & pre-defines, eg.
       * layout(std140) uniform ub_ObjectParams {
       *   mat4 u_ModelMatrix;
       *   vec4 u_Color;
       *   vec4 u_StrokeColor;
       *   #ifdef NUM_DIR_LIGHTS
       *     DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
       *   #endif
       * }
       */

      this.uniformNames = getUniforms(this.props.fragmentShader);
    }
    /**
     * @example
     * material.setUniforms({
     *   u_ModelMatrix: [1, 2, 3, 4],
     *   u_Time: 1,
     *   u_Map: texture,
     * })
     */

  }, {
    key: "setUniforms",
    value: function setUniforms(uniforms) {
      var _this2 = this;

      Object.keys(uniforms).forEach(function (key) {
        var value = uniforms[key];
        var existedTexture = _this2.textures[key];

        if (existedTexture && existedTexture !== value) {
          // existedTexture.destroy();
          _this2.textureDirty = true;
        }

        if (isTexture(value)) {
          _this2.textures[key] = value;
          _this2.textureDirty = true;
        } else {
          _this2.uniforms[key] = value;
        }

        if (isNil(uniforms[key])) {
          delete _this2.textures[key];
          delete _this2.uniforms[key];
        }
      }); // trigger re-render

      this.meshes.forEach(function (mesh) {
        // mesh.emit(ElementEvent.ATTR_MODIFIED, {
        //   attributeName: 'material',
        // });
        mesh.dispatchEvent(new MutationEvent(ElementEvent.ATTR_MODIFIED, mesh, null, null, 'material', MutationEvent.MODIFICATION, null, null));
      });
    }
  }]);

  return Material;
}();

var ShaderMaterial = /*#__PURE__*/function (_Material) {
  _inherits(ShaderMaterial, _Material);

  var _super = _createSuper(ShaderMaterial);

  function ShaderMaterial(device, props) {
    var _this;

    _classCallCheck(this, ShaderMaterial);

    _this = _super.call(this, device, _objectSpread2({}, props));
    _this.defines = _objectSpread2(_objectSpread2({}, _this.defines), {}, {
      USE_UV: false,
      USE_MAP: false,
      USE_WIREFRAME: false,
      USE_FOG: false,
      USE_LIGHT: false
    });
    return _this;
  }

  return _createClass(ShaderMaterial);
}(Material);

function enumToObject(enumObject) {
  var result = {};
  Object.keys(enumObject).forEach(function (key) {
    if (typeof enumObject[key] === 'number') {
      result[key] = enumObject[key];
    }
  });
  return result;
}

var counter$1 = 1;
var FILL_TEXTURE_MAPPING = 'FillTextureMapping';
var VertexAttributeBufferIndex;

(function (VertexAttributeBufferIndex) {
  VertexAttributeBufferIndex[VertexAttributeBufferIndex["INSTANCED"] = 0] = "INSTANCED";
  VertexAttributeBufferIndex[VertexAttributeBufferIndex["MAX"] = 1] = "MAX";
})(VertexAttributeBufferIndex || (VertexAttributeBufferIndex = {}));
/**
 * Instanced mesh
 */


var Instanced = /*#__PURE__*/function () {
  function Instanced() {
    _classCallCheck(this, Instanced);

    this.id = counter$1++;
    this.renderer = void 0;
    this.index = -1;
    this.renderHelper = void 0;
    this.texturePool = void 0;
    this.camera = void 0;
    this.lightPool = void 0;
    this.device = void 0;
    this.renderingService = void 0;
    this.objects = [];
    this.material = void 0;
    this.geometry = void 0;
    this.clipPath = void 0;
    this.clipPathTarget = void 0;
    this.inputState = void 0;
    this.program = new DeviceProgram();
    this.programDescriptorSimpleWithOrig = void 0;
    this.geometryDirty = true;
    this.materialDirty = true;
    this.inputStateDirty = true;
    this.textureMappings = [];
    this.samplerEntries = void 0;
    this.inited = false;
  }

  _createClass(Instanced, [{
    key: "instance",
    get: function get() {
      return this.objects[0];
    }
  }, {
    key: "init",
    value: function init(device, renderingService) {
      if (this.inited) {
        return;
      }

      this.renderer.beforeInitMesh(this);
      this.device = device;
      this.renderingService = renderingService;
      this.material = new ShaderMaterial(this.device);
      this.geometry = new BufferGeometry(this.device);
      this.inited = true;
      this.renderer.afterInitMesh(this);
    }
    /**
     * should be merged into current InstancedMesh
     */

  }, {
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      if (!this.instance) {
        return true;
      }

      if (this.instance.nodeName !== object.nodeName) {
        return false;
      } // can't be merged when using clipPath


      if (object.parsedStyle.clipPath) {
        return false;
      }

      return true;
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var _this = this;

      var modelMatrix = create();
      var modelViewMatrix = create(); // const normalMatrix = mat3.create();

      var packed = []; // const useNormal = this.material.defines.NORMAL;

      objects.forEach(function (object) {
        var _object$renderable3D;

        var _object$parsedStyle = object.parsedStyle,
            fill = _object$parsedStyle.fill,
            stroke = _object$parsedStyle.stroke,
            opacity = _object$parsedStyle.opacity,
            fillOpacity = _object$parsedStyle.fillOpacity,
            strokeOpacity = _object$parsedStyle.strokeOpacity,
            lineWidth = _object$parsedStyle.lineWidth,
            lineDash = _object$parsedStyle.lineDash,
            anchor = _object$parsedStyle.anchor,
            visibility = _object$parsedStyle.visibility;
        var fillColor = [0, 0, 0, 0];

        if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
          fillColor = fill.value;
        }

        var strokeColor = [0, 0, 0, 0];

        if ((stroke === null || stroke === void 0 ? void 0 : stroke.type) === PARSED_COLOR_TYPE.Constant) {
          // if (object.)
          strokeColor = stroke.value;
        }

        if (_this.clipPathTarget) {
          // account for target's rts
          copy(modelMatrix, object.getLocalTransform());
          fillColor = [1, 1, 1, 1];
          mul(modelMatrix, _this.clipPathTarget.getWorldTransform(), modelMatrix);
        } else {
          copy(modelMatrix, object.getWorldTransform());
        }

        mul(modelViewMatrix, _this.camera.getViewTransform(), modelMatrix); // @ts-ignore

        var encodedPickingColor = ((_object$renderable3D = object.renderable3D) === null || _object$renderable3D === void 0 ? void 0 : _object$renderable3D.encodedPickingColor) || [0, 0, 0];
        packed.push.apply(packed, _toConsumableArray(modelMatrix).concat(_toConsumableArray(fillColor), _toConsumableArray(strokeColor), [opacity, fillOpacity, strokeOpacity, lineWidth.value, visibility === 'visible' ? 1 : 0, 0, 0, 0], _toConsumableArray(encodedPickingColor), [object.sortable.renderOrder * RENDER_ORDER_SCALE, anchor[0], anchor[1]])); // if (useNormal) {
        //   // should not calc normal matrix in shader, mat3.invert is not cheap
        //   // @see https://stackoverflow.com/a/21079741
        //   mat3.fromMat4(normalMatrix, modelViewMatrix);
        //   mat3.invert(normalMatrix, normalMatrix);
        //   mat3.transpose(normalMatrix, normalMatrix);
        //   const { NORMAL_MATRIX0, NORMAL_MATRIX1, NORMAL_MATRIX2 } = this.material.defines;
        //   this.bufferGeometry.setVertexBuffer({
        //     bufferIndex: 4,
        //     byteStride: 4 * (3 * 3),
        //     frequency: VertexBufferFrequency.PerInstance,
        //     attributes: [
        //       {
        //         format: Format.F32_RGB,
        //         bufferByteOffset: 4 * 0,
        //         location: Number(NORMAL_MATRIX0),
        //         divisor: 1,
        //       },
        //       {
        //         format: Format.F32_RGB,
        //         bufferByteOffset: 4 * 3,
        //         location: Number(NORMAL_MATRIX1),
        //         divisor: 1,
        //       },
        //       {
        //         format: Format.F32_RGB,
        //         bufferByteOffset: 4 * 6,
        //         location: Number(NORMAL_MATRIX2),
        //         divisor: 1,
        //       },
        //     ],
        //     data: new Float32Array(normalMatrix),
        //   });
        // }
      });
      this.geometry.instancedCount = objects.length;
      this.geometry.setVertexBuffer({
        bufferIndex: VertexAttributeBufferIndex.INSTANCED,
        byteStride: 4 * (4 * 4 + 4 + 4 + 4 + 4 + 4 + 2),
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 0,
          location: VertexAttributeLocation.MODEL_MATRIX0,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 4,
          location: VertexAttributeLocation.MODEL_MATRIX1,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 8,
          location: VertexAttributeLocation.MODEL_MATRIX2,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 12,
          location: VertexAttributeLocation.MODEL_MATRIX3,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 16,
          location: VertexAttributeLocation.COLOR,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 20,
          location: VertexAttributeLocation.STROKE_COLOR,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 24,
          location: VertexAttributeLocation.PACKED_STYLE1,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 28,
          location: VertexAttributeLocation.PACKED_STYLE2,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 32,
          location: VertexAttributeLocation.PICKING_COLOR,
          divisor: 1
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 36,
          location: VertexAttributeLocation.ANCHOR,
          divisor: 1
        }],
        data: new Float32Array(packed)
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.geometry) {
        this.geometry.destroy();
      }

      if (this.inputState) {
        this.inputState.destroy();
      }
    }
  }, {
    key: "applyRenderInst",
    value: function applyRenderInst(renderInst, objects) {
      var _this2 = this;

      // detect if scene changed, eg. lights & fog
      var lights = this.lightPool.getAllLights();
      var fog = this.lightPool.getFog();
      var useFog = !!fog;
      var useLight = !!lights.length;
      var useWireframe = this.material.defines.USE_WIREFRAME; // toggle fog, need re-compile material

      if (useFog !== this.material.defines.USE_FOG || useLight !== this.material.defines.USE_LIGHT) {
        this.material.programDirty = true;
      }

      this.material.defines.USE_FOG = useFog;
      this.material.defines.USE_LIGHT = useLight;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), this.lightPool.getDefines());

      if (this.clipPathTarget || this.clipPath) {
        if (this.clipPathTarget) {
          this.material.stencilWrite = true; // @see https://open.gl/depthstencils

          this.material.depthWrite = false;
          this.material.stencilCompare = CompareMode.Always;
          this.material.stencilPassOp = StencilOp.Replace;
        } else {
          this.material.stencilWrite = false;
          this.material.depthWrite = true;
          this.material.stencilCompare = CompareMode.Equal;
          this.material.stencilPassOp = StencilOp.Keep;
        }
      } else {
        this.material.stencilWrite = false;
      } // re-upload textures


      if (this.material.textureDirty || this.materialDirty) {
        this.textureMappings = []; // set texture mappings

        var fillTextureMapping = this.createFillGradientTextureMapping(objects);

        if (fillTextureMapping) {
          this.material.defines.USE_UV = true;
          this.material.defines.USE_MAP = true;
          this.textureMappings.push(fillTextureMapping);
        }
      } // re-compile program, eg. DEFINE changed


      if (this.material.programDirty || this.materialDirty) {
        this.createMaterial(objects); // set defines

        this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(VertexAttributeLocation));
        Object.keys(this.material.defines).forEach(function (key) {
          var value = _this2.material.defines[key];

          if (typeof value === 'number') {
            _this2.program.setDefineString(key, "".concat(value));
          } else {
            _this2.program.setDefineBool(key, value);
          }
        }); // build shaders

        this.program.vert = this.material.vertexShader;
        this.program.frag = this.material.fragmentShader; // use cached program

        this.programDescriptorSimpleWithOrig = preprocessProgramObj_GLSL(this.device, this.program);
        this.material.programDirty = false;
      }

      if (this.material.textureDirty || this.materialDirty) {
        Object.keys(this.material.textures).sort(function (a, b) {
          return _this2.material.samplers.indexOf(a) - _this2.material.samplers.indexOf(b);
        }).forEach(function (key) {
          var mapping = new TextureMapping();
          mapping.name = key;
          mapping.texture = _this2.material.textures[key];

          _this2.device.setResourceName(mapping.texture, 'Material Texture ' + key);

          mapping.sampler = _this2.renderHelper.getCache().createSampler({
            wrapS: WrapMode.Clamp,
            wrapT: WrapMode.Clamp,
            minFilter: TexFilterMode.Point,
            magFilter: TexFilterMode.Bilinear,
            mipFilter: MipFilterMode.Linear,
            minLOD: 0,
            maxLOD: 0
          });

          _this2.textureMappings.push(mapping);
        });
        this.material.textureDirty = false;
        this.materialDirty = false;
      }

      if (this.material.geometryDirty) {
        // wireframe 需要额外生成 geometry 重心坐标
        this.geometryDirty = true;
        this.inputStateDirty = true;
        this.material.geometryDirty = false;
      }

      if (this.geometryDirty || this.geometry.dirty) {
        // destroy first
        if (this.geometry) {
          this.geometry.destroy();
        } // re-create buffer geometry


        this.createGeometry(objects); // generate wireframe

        if (this.material.wireframe) {
          this.generateWireframe(this.geometry);
        } // sync to internal Geometry


        this.geometryDirty = false;
        this.geometry.dirty = false;
        this.inputStateDirty = true;
      } // cached input layout


      var inputLayout = this.renderHelper.getCache().createInputLayout(this.geometry.inputLayoutDescriptor);
      var program = this.renderHelper.getCache().createProgramSimple(this.programDescriptorSimpleWithOrig);
      var useIndexes = !!this.geometry.indexBuffer; // prevent rebinding VAO too many times

      if (this.inputStateDirty) {
        if (this.inputState) {
          this.inputState.destroy();
        }

        this.inputState = this.device.createInputState(inputLayout, this.geometry.vertexBuffers.map(function (buffer) {
          return {
            buffer: buffer,
            byteOffset: 0
          };
        }), useIndexes ? {
          buffer: this.geometry.indexBuffer,
          byteOffset: 0
        } : null, program);
        this.inputStateDirty = false;
      }

      renderInst.renderPipelineDescriptor.topology = this.geometry.drawMode;
      renderInst.setProgram(program);
      renderInst.setInputLayoutAndState(inputLayout, this.inputState);
      this.renderer.beforeUploadUBO(renderInst, this, this.index); // upload uniform buffer object

      this.uploadUBO(renderInst);

      if (useIndexes) {
        // drawElements
        renderInst.drawIndexesInstanced(this.geometry.vertexCount, this.geometry.instancedCount, this.geometry.indexStart);
      } else {
        // drawArrays
        renderInst.drawPrimitives(this.geometry.vertexCount, this.geometry.primitiveStart);
      } // FIXME: 暂时都当作非透明物体，按照创建顺序排序


      renderInst.sortKey = makeSortKeyOpaque(RendererLayer.OPAQUE, objects[0].sortable.renderOrder);
    }
  }, {
    key: "updateBatchedAttribute",
    value: function updateBatchedAttribute(object, index, name, value) {
      var stylePacked1 = ['opacity', 'fillOpacity', 'strokeOpacity', 'lineWidth'];

      if (name === 'fill') {
        var fill = object.parsedStyle.fill;
        var i = this.textureMappings.findIndex(function (m) {
          return m.name === FILL_TEXTURE_MAPPING;
        });
        var fillColor = [0, 0, 0, 0];

        if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
          fillColor = fill.value;
          this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.COLOR, index, new Uint8Array(new Float32Array(_toConsumableArray(fillColor)).buffer));

          if (i >= 0) {
            // remove original fill texture mapping
            this.textureMappings.splice(i, -1);
          }
        } else {
          var fillTextureMapping = this.createFillGradientTextureMapping([object]);

          if (i >= 0) {
            this.textureMappings.splice(i, 1, fillTextureMapping);
          }

          this.material.textureDirty = true;
        }
      } else if (name === 'stroke') {
        var stroke = object.parsedStyle.stroke;
        var strokeColor = [0, 0, 0, 0];

        if ((stroke === null || stroke === void 0 ? void 0 : stroke.type) === PARSED_COLOR_TYPE.Constant) {
          strokeColor = stroke.value;
        }

        this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.STROKE_COLOR, index, new Uint8Array(new Float32Array(_toConsumableArray(strokeColor)).buffer));
      } else if (stylePacked1.indexOf(name) > -1) {
        var _object$parsedStyle2 = object.parsedStyle,
            opacity = _object$parsedStyle2.opacity,
            fillOpacity = _object$parsedStyle2.fillOpacity,
            strokeOpacity = _object$parsedStyle2.strokeOpacity,
            lineWidth = _object$parsedStyle2.lineWidth;
        this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.PACKED_STYLE1, index, new Uint8Array(new Float32Array([opacity, fillOpacity, strokeOpacity, lineWidth.value]).buffer));
      } else if (name === 'modelMatrix') {
        var modelMatrix = copy(create(), object.getWorldTransform());
        this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.MODEL_MATRIX0, index, new Uint8Array(new Float32Array(modelMatrix).buffer));
      } else if (name === 'anchor') {
        var anchor = object.parsedStyle.anchor;
        this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.ANCHOR, index, new Uint8Array(new Float32Array([anchor[0], anchor[1]]).buffer));
      } else if (name === 'visibility') {
        var visibility = object.parsedStyle.visibility;
        this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.PACKED_STYLE2, index, new Uint8Array(new Float32Array([visibility === 'visible' ? 1 : 0]).buffer));
      }
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      if (name === 'clipPath') {
        if (this.clipPath) {
          this.geometryDirty = true;
        }
      }
    }
  }, {
    key: "changeRenderOrder",
    value: function changeRenderOrder(object, renderOrder) {
      var _object$renderable3D2;

      var index = this.objects.indexOf(object); // @ts-ignore

      var encodedPickingColor = ((_object$renderable3D2 = object.renderable3D) === null || _object$renderable3D2 === void 0 ? void 0 : _object$renderable3D2.encodedPickingColor) || [0, 0, 0];
      this.geometry.updateVertexBuffer(VertexAttributeBufferIndex.INSTANCED, VertexAttributeLocation.PICKING_COLOR, index, new Uint8Array(new Float32Array([].concat(_toConsumableArray(encodedPickingColor), [renderOrder * RENDER_ORDER_SCALE])).buffer));
    }
  }, {
    key: "generateWireframe",
    value: function generateWireframe(geometry) {
      // need generate barycentric coordinates
      var indices = geometry.indices;
      var indiceNum = geometry.indices.length;
      var originalVertexBuffers = geometry.vertices.map(function (buffer) {
        // @ts-ignore
        return buffer.slice();
      });

      for (var _i = 1; _i < geometry.vertexBuffers.length; _i++) {
        var byteStride = geometry.inputLayoutDescriptor.vertexBufferDescriptors[_i].byteStride;
        geometry.vertices[_i] = new Float32Array(byteStride / 4 * indiceNum);
      } // reallocate attribute data


      var cursor = 0;
      var uniqueIndices = new Uint32Array(indiceNum);

      for (var i = 0; i < indiceNum; i++) {
        var ii = indices[i];

        for (var j = 1; j < geometry.vertices.length; j++) {
          var _byteStride = geometry.inputLayoutDescriptor.vertexBufferDescriptors[j].byteStride;
          var size = _byteStride / 4;

          for (var k = 0; k < size; k++) {
            geometry.vertices[j][cursor * size + k] = originalVertexBuffers[j][ii * size + k];
          }
        }

        uniqueIndices[i] = cursor;
        cursor++;
      }

      var _loop = function _loop(_i2) {
        if (_i2 === 4) {
          return "continue";
        }

        var _geometry$inputLayout = geometry.inputLayoutDescriptor.vertexBufferDescriptors[_i2],
            frequency = _geometry$inputLayout.frequency,
            byteStride = _geometry$inputLayout.byteStride;
        var descriptor = geometry.inputLayoutDescriptor.vertexAttributeDescriptors.find(function (_ref) {
          var bufferIndex = _ref.bufferIndex;
          return bufferIndex === _i2;
        });

        if (descriptor) {
          var location = descriptor.location,
              bufferIndex = descriptor.bufferIndex,
              bufferByteOffset = descriptor.bufferByteOffset,
              format = descriptor.format,
              divisor = descriptor.divisor;
          geometry.setVertexBuffer({
            bufferIndex: bufferIndex,
            byteStride: byteStride,
            frequency: frequency,
            attributes: [{
              format: format,
              bufferByteOffset: bufferByteOffset,
              location: location,
              divisor: divisor
            }],
            data: geometry.vertices[_i2]
          }); // geometry.updateVertexBuffer(
          //   bufferIndex,
          //   location,
          //   0,
          //   new Uint8Array(geometry.vertices[i].buffer),
          // );
        }
      };

      for (var _i2 = 1; _i2 < geometry.vertexBuffers.length; _i2++) {
        var _ret = _loop(_i2);

        if (_ret === "continue") continue;
      } // create barycentric attributes


      var barycentricBuffer = new Float32Array(indiceNum * 3);

      for (var _i3 = 0; _i3 < indiceNum;) {
        for (var _j = 0; _j < 3; _j++) {
          var _ii = uniqueIndices[_i3++];
          barycentricBuffer[_ii * 3 + _j] = 1;
        }
      }

      geometry.setVertexBuffer({
        bufferIndex: 4,
        byteStride: 4 * 3,
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RGB,
          bufferByteOffset: 4 * 0,
          location: Number(this.material.defines.BARYCENTRIC)
        }],
        data: barycentricBuffer
      });
      geometry.setIndexBuffer(uniqueIndices);
    }
  }, {
    key: "beforeUploadUBO",
    value: function beforeUploadUBO(renderInst, objects, i) {}
  }, {
    key: "uploadUBO",
    value: function uploadUBO(renderInst) {
      var _this3 = this;

      var numUniformBuffers = 1; // Scene UBO

      var material = this.material;
      var lights = this.lightPool.getAllLights();
      var fog = this.lightPool.getFog();
      var useFog = !!fog;
      var useLight = !!lights.length;
      var useWireframe = material.defines.USE_WIREFRAME; // collect uniforms

      var uniforms = [];

      if (useWireframe) {
        var wireframeColor = parseColor(material.wireframeColor).value;
        uniforms.push({
          name: 'u_WireframeLineColor',
          value: wireframeColor.slice(0, 3)
        });
        uniforms.push({
          name: 'u_WireframeLineWidth',
          value: material.wireframeLineWidth
        });
      }

      if (useFog) {
        this.uploadFog(uniforms, fog);
      }

      this.uploadMaterial(uniforms, material);

      if (useLight) {
        var _counter = {};
        lights.forEach(function (light) {
          if (!_counter[light.define]) {
            _counter[light.define] = -1;
          }

          _counter[light.define]++;
          light.uploadUBO(uniforms, _counter[light.define]);
        });
      }

      uniforms.sort(function (a, b) {
        return _this3.material.uniformNames.indexOf(a.name) - _this3.material.uniformNames.indexOf(b.name);
      });
      renderInst.setUniforms(numUniformBuffers, uniforms);
      var depthCompare = material.depthCompare,
          depthWrite = material.depthWrite,
          stencilCompare = material.stencilCompare,
          stencilWrite = material.stencilWrite,
          stencilPassOp = material.stencilPassOp,
          stencilRef = material.stencilRef,
          cullMode = material.cullMode,
          frontFace = material.frontFace,
          polygonOffset = material.polygonOffset,
          blendEquation = material.blendEquation,
          blendEquationAlpha = material.blendEquationAlpha,
          blendSrc = material.blendSrc,
          blendDst = material.blendDst,
          blendSrcAlpha = material.blendSrcAlpha,
          blendDstAlpha = material.blendDstAlpha;
      renderInst.setMegaStateFlags({
        attachmentsState: [{
          // should not affect color buffer when drawing stencil
          channelWriteMask: this.material.stencilWrite ? ChannelWriteMask.None : ChannelWriteMask.AllChannels,
          // channelWriteMask: ChannelWriteMask.AllChannels,
          rgbBlendState: {
            blendMode: blendEquation,
            blendSrcFactor: blendSrc,
            blendDstFactor: blendDst
          },
          alphaBlendState: {
            blendMode: blendEquationAlpha,
            blendSrcFactor: blendSrcAlpha,
            blendDstFactor: blendDstAlpha
          }
        }],
        // blendConstant: Color;
        depthCompare: depthCompare,
        depthWrite: depthWrite,
        stencilCompare: stencilCompare,
        stencilWrite: stencilWrite,
        stencilPassOp: stencilPassOp,
        stencilRef: stencilRef,
        cullMode: cullMode,
        frontFace: frontFace,
        polygonOffset: polygonOffset
      });
      renderInst.setBindingLayouts([{
        numUniformBuffers: numUniformBuffers,
        numSamplers: this.textureMappings.length,
        samplerEntries: this.samplerEntries
      }]);
      renderInst.setSamplerBindingsFromTextureMappings(this.textureMappings);
    }
  }, {
    key: "uploadFog",
    value: function uploadFog(uniforms, fog) {
      var _fog$parsedStyle = fog.parsedStyle,
          type = _fog$parsedStyle.type,
          fill = _fog$parsedStyle.fill,
          start = _fog$parsedStyle.start,
          end = _fog$parsedStyle.end,
          density = _fog$parsedStyle.density;

      if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
        var fillColor = fill.value;
        uniforms.push({
          name: 'u_FogInfos',
          value: [type, start, end, density]
        });
        uniforms.push({
          name: 'u_FogColor',
          value: fillColor
        });
      }
    }
  }, {
    key: "uploadMaterial",
    value: function uploadMaterial(uniforms, material) {
      // sort
      var materialUniforms = Object.keys(material.uniforms).map(function (name) {
        return {
          name: name,
          value: material.uniforms[name]
        };
      });
      uniforms.push.apply(uniforms, _toConsumableArray(materialUniforms));
    }
  }, {
    key: "createFillGradientTextureMapping",
    value: function createFillGradientTextureMapping(objects) {
      var _this4 = this;

      var instance = objects[0];
      var fill = instance.nodeName === Shape.LINE ? instance.parsedStyle.stroke : instance.parsedStyle.fill; // use pattern & gradient

      if (fill && (fill.type === PARSED_COLOR_TYPE.Pattern || fill.type === PARSED_COLOR_TYPE.LinearGradient || fill.type === PARSED_COLOR_TYPE.RadialGradient)) {
        this.program.setDefineBool('USE_UV', true);
        this.program.setDefineBool('USE_MAP', true);
        var texImageSource;

        if (fill.type === PARSED_COLOR_TYPE.LinearGradient || fill.type === PARSED_COLOR_TYPE.RadialGradient) {
          this.texturePool.getOrCreateGradient(_objectSpread2(_objectSpread2({
            type: fill.type
          }, fill.value), {}, {
            width: 128,
            height: 128
          }));
          texImageSource = this.texturePool.getOrCreateCanvas();
        } else {
          // FIXME: support repeat
          texImageSource = fill.value.src;
        }

        var fillMapping = new TextureMapping();
        fillMapping.name = FILL_TEXTURE_MAPPING;
        fillMapping.texture = this.texturePool.getOrCreateTexture(this.device, texImageSource, makeTextureDescriptor2D(Format.U8_RGBA_NORM, 1, 1, 1), function () {
          // need re-render
          objects.forEach(function (object) {
            object.renderable.dirty = true;

            _this4.renderingService.dirtify();
          });
        });
        this.device.setResourceName(fillMapping.texture, 'Fill Texture' + this.id);
        fillMapping.sampler = this.renderHelper.getCache().createSampler({
          // wrapS: WrapMode.Clamp,
          // wrapT: WrapMode.Clamp,
          wrapS: WrapMode.Repeat,
          wrapT: WrapMode.Repeat,
          minFilter: TexFilterMode.Point,
          magFilter: TexFilterMode.Bilinear,
          mipFilter: MipFilterMode.Linear,
          minLOD: 0,
          maxLOD: 0
        });
        return fillMapping;
      }

      return null;
    }
  }]);

  return Instanced;
}();

__decorate([inject(RenderHelper), __metadata("design:type", RenderHelper)], Instanced.prototype, "renderHelper", void 0);

__decorate([inject(TexturePool), __metadata("design:type", TexturePool)], Instanced.prototype, "texturePool", void 0);

__decorate([inject(DefaultCamera), __metadata("design:type", Camera)], Instanced.prototype, "camera", void 0);

__decorate([inject(LightPool), __metadata("design:type", LightPool)], Instanced.prototype, "lightPool", void 0);

Instanced = __decorate([injectable()], Instanced);

var vert = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\n\nlayout(location = MODEL_MATRIX0) in vec4 a_ModelMatrix0;\nlayout(location = MODEL_MATRIX1) in vec4 a_ModelMatrix1;\nlayout(location = MODEL_MATRIX2) in vec4 a_ModelMatrix2;\nlayout(location = MODEL_MATRIX3) in vec4 a_ModelMatrix3;\nlayout(location = COLOR) in vec4 a_Color;\nlayout(location = STROKE_COLOR) in vec4 a_StrokeColor;\nlayout(location = PACKED_STYLE1) in vec4 a_StylePacked1;\nlayout(location = PACKED_STYLE2) in vec4 a_StylePacked2;\nlayout(location = PICKING_COLOR) in vec4 a_PickingColor;\nlayout(location = ANCHOR) in vec2 a_Anchor;\n\nout vec4 v_PickingResult;\nout vec4 v_Color;\nout vec4 v_StrokeColor;\nout vec4 v_StylePacked1;\nout vec4 v_StylePacked2;\n\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\nvec4 project(vec4 pos, mat4 pm, mat4 vm, mat4 mm) {\n  return pm * vm * mm * pos;\n}\n\nlayout(location = EXTRUDE) in vec2 a_Extrude;\nlayout(location = PACKED_STYLE3) in vec4 a_StylePacked3;\nlayout(location = SIZE) in vec2 a_Size;\n#ifdef USE_UV\n  layout(location = UV) in vec2 a_Uv;\n  out vec2 v_Uv;\n#endif\n\nout vec4 v_Data;\nout vec2 v_Radius;\nout vec4 v_StylePacked3;\n\nvoid main() {\n  mat4 u_ModelMatrix = mat4(a_ModelMatrix0, a_ModelMatrix1, a_ModelMatrix2, a_ModelMatrix3);\nvec4 u_StrokeColor = a_StrokeColor;\nfloat u_Opacity = a_StylePacked1.x;\nfloat u_FillOpacity = a_StylePacked1.y;\nfloat u_StrokeOpacity = a_StylePacked1.z;\nfloat u_StrokeWidth = a_StylePacked1.w;\nfloat u_ZIndex = a_PickingColor.w;\n\nsetPickingColor(a_PickingColor.xyz);\n\nv_Color = a_Color;\nv_StrokeColor = a_StrokeColor;\nv_StylePacked1 = a_StylePacked1;\nv_StylePacked2 = a_StylePacked2;\n\n#ifdef CLIPSPACE_NEAR_ZERO\n    gl_Position.z = gl_Position.z * 0.5 + 0.5;\n#endif\n  #ifdef USE_UV\n  v_Uv = a_Uv;\n  #ifdef VIEWPORT_ORIGIN_TL\n    v_Uv.y = 1.0 - v_Uv.y;\n  #endif\n#endif\n\n  float antialiasblur = 1.0 / (a_Size.x + u_StrokeWidth);\n\n  bool omitStroke = a_StylePacked3.z == 1.0;\n  vec2 radius = a_Size + vec2(omitStroke ? 0.0 : u_StrokeWidth / 2.0);\n  vec2 offset = (a_Extrude + vec2(1.0) - 2.0 * a_Anchor.xy) * radius;\n\n  gl_Position = project(vec4(offset, u_ZIndex, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n  \n  v_Radius = radius;\n  v_Data = vec4(a_Extrude, antialiasblur, a_StylePacked3.x);\n  v_StylePacked3 = a_StylePacked3;\n}"; // eslint-disable-line

var frag = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\n\nin vec4 v_PickingResult;\nin vec4 v_Color;\nin vec4 v_StrokeColor;\nin vec4 v_StylePacked1;\nin vec4 v_StylePacked2;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n#ifdef USE_UV\n  in vec2 v_Uv;\n#endif\n#ifdef USE_MAP\n  uniform sampler2D u_Map;\n#endif\n\nin vec4 v_Data;\nin vec2 v_Radius;\nin vec4 v_StylePacked3;\n\n/**\n * 2D signed distance field functions\n * @see http://www.iquilezles.org/www/articles/distfunctions2d/distfunctions2d.htm\n */\n\nfloat sdCircle(vec2 p, float r) {\n  return length(p) - r;\n}\n\n// @see http://www.iquilezles.org/www/articles/ellipsoids/ellipsoids.htm\nfloat sdEllipsoidApproximated(vec2 p, vec2 r) {\n  float k0 = length(p / r);\n  float k1 = length(p / (r * r));\n  return k0 * (k0 - 1.0) / k1;\n}\n\nvoid main() {\n  int shape = int(floor(v_Data.w + 0.5));\n\n  vec4 u_Color = v_Color;\nvec4 u_StrokeColor = v_StrokeColor;\nfloat u_Opacity = v_StylePacked1.x;\nfloat u_FillOpacity = v_StylePacked1.y;\nfloat u_StrokeOpacity = v_StylePacked1.z;\nfloat u_StrokeWidth = v_StylePacked1.w;\nfloat u_Visible = v_StylePacked2.x;\n\ngbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\nif (u_Visible < 1.0) {\n    discard;\n}\n  #ifdef USE_MAP\n  vec4 texelColor = texture(SAMPLER_2D(u_Map), v_Uv);\n  u_Color = texelColor;\n#endif\n\n  bool omitStroke = v_StylePacked3.z == 1.0;\n\n  float antialiasblur = v_Data.z;\n  float antialiased_blur = -max(0.0, antialiasblur);\n  vec2 r = (v_Radius - (omitStroke ? 0.0 : u_StrokeWidth)) / v_Radius;\n\n  float outer_df;\n  float inner_df;\n  // 'circle', 'ellipse', 'rect'\n  if (shape == 0) {\n    outer_df = sdCircle(v_Data.xy, 1.0);\n    inner_df = sdCircle(v_Data.xy, r.x);\n  } else if (shape == 1) {\n    outer_df = sdEllipsoidApproximated(v_Data.xy, vec2(1.0));\n    inner_df = sdEllipsoidApproximated(v_Data.xy, r);\n  }\n\n  float opacity_t = smoothstep(0.0, antialiased_blur, outer_df);\n\n  float color_t = u_StrokeWidth < 0.01 ? 0.0 : smoothstep(\n    antialiased_blur,\n    0.0,\n    inner_df\n  );\n\n  // vec2 imagecoord = mod(v_Uv, 0.1);\n  // vec4 texel = texture(SAMPLER_2D(u_Map), imagecoord);\n  // u_Color = texel;\n\n  vec4 diffuseColor = u_Color;\n\n  vec4 strokeColor = (u_StrokeColor == vec4(0) || omitStroke) ? vec4(0.0) : u_StrokeColor;\n\n  gbuf_color = mix(vec4(diffuseColor.rgb, diffuseColor.a * u_FillOpacity), strokeColor * u_StrokeOpacity, color_t);\n  gbuf_color.a = gbuf_color.a * u_Opacity * opacity_t;\n\n  if (gbuf_color.a < 0.001)\n    discard;\n}"; // eslint-disable-line

var SDFVertexAttributeBufferIndex;

(function (SDFVertexAttributeBufferIndex) {
  SDFVertexAttributeBufferIndex[SDFVertexAttributeBufferIndex["EXTRUDE_UV"] = 1] = "EXTRUDE_UV";
  SDFVertexAttributeBufferIndex[SDFVertexAttributeBufferIndex["SIZE"] = 2] = "SIZE";
  SDFVertexAttributeBufferIndex[SDFVertexAttributeBufferIndex["PACKED_STYLE3"] = 3] = "PACKED_STYLE3";
})(SDFVertexAttributeBufferIndex || (SDFVertexAttributeBufferIndex = {}));

var SDFVertexAttributeLocation;

(function (SDFVertexAttributeLocation) {
  SDFVertexAttributeLocation[SDFVertexAttributeLocation["EXTRUDE"] = 10] = "EXTRUDE";
  SDFVertexAttributeLocation[SDFVertexAttributeLocation["PACKED_STYLE3"] = 11] = "PACKED_STYLE3";
  SDFVertexAttributeLocation[SDFVertexAttributeLocation["SIZE"] = 12] = "SIZE";
  SDFVertexAttributeLocation[SDFVertexAttributeLocation["UV"] = 13] = "UV";
})(SDFVertexAttributeLocation || (SDFVertexAttributeLocation = {}));

var SDF_Shape = [Shape.CIRCLE, Shape.ELLIPSE];
/**
 * Use SDF to render 2D shapes, eg. circle, ellipse.
 * Use less triangles(2) and vertices compared with normal triangulation.
 */

var SDFMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(SDFMesh, _Instanced);

  var _super = _createSuper(SDFMesh);

  function SDFMesh() {
    _classCallCheck(this, SDFMesh);

    return _super.apply(this, arguments);
  }

  _createClass(SDFMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      var shouldMerge = _get(_getPrototypeOf(SDFMesh.prototype), "shouldMerge", this).call(this, object, index);

      if (!shouldMerge) {
        return false;
      }

      if (this.needDrawStrokeSeparately(object) || this.needDrawStrokeSeparately(this.instance)) {
        return false;
      }

      return true;
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      this.material.vertexShader = vert;
      this.material.fragmentShader = frag;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(SDFVertexAttributeLocation));
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var _this = this;

      // use default common attributes
      _get(_getPrototypeOf(SDFMesh.prototype), "createGeometry", this).call(this, objects);

      var interleaved = [];
      var instanced = [];
      var instanced2 = [];
      var indices = [];
      objects.forEach(function (object, i) {
        var circle = object;
        var offset = i * 4; // @ts-ignore

        var radius = circle.parsedStyle.radius;

        var omitStroke = _this.shouldOmitStroke(circle.parsedStyle);

        var size = _this.getSize(object.parsedStyle, circle.nodeName);

        instanced.push.apply(instanced, _toConsumableArray(size));
        instanced2.push(SDF_Shape.indexOf(circle.nodeName), radius || 0, omitStroke ? 1 : 0, 0);
        interleaved.push(-1, -1, 0, 0, 1, -1, 1, 0, 1, 1, 1, 1, -1, 1, 0, 1);
        indices.push(0 + offset, 2 + offset, 1 + offset, 0 + offset, 3 + offset, 2 + offset);
      });
      this.geometry.setIndexBuffer(new Uint32Array(indices));
      this.geometry.vertexCount = 6;
      this.geometry.setVertexBuffer({
        bufferIndex: SDFVertexAttributeBufferIndex.EXTRUDE_UV,
        byteStride: 4 * 4,
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          location: SDFVertexAttributeLocation.EXTRUDE
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 2,
          location: SDFVertexAttributeLocation.UV
        }],
        data: new Float32Array(interleaved)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: SDFVertexAttributeBufferIndex.SIZE,
        byteStride: 4 * 2,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          location: SDFVertexAttributeLocation.SIZE,
          divisor: 1
        }],
        data: new Float32Array(instanced)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: SDFVertexAttributeBufferIndex.PACKED_STYLE3,
        byteStride: 4 * 4,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 0,
          location: SDFVertexAttributeLocation.PACKED_STYLE3,
          divisor: 1
        }],
        data: new Float32Array(instanced2)
      });
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      _get(_getPrototypeOf(SDFMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var index = this.objects.indexOf(object);
      this.updateBatchedAttribute(object, index, name, value);

      if (name === 'r' || name === 'rx' || name === 'ry' || name === 'lineWidth') {
        var _this$getSize = this.getSize(object.parsedStyle, object.nodeName),
            _this$getSize2 = _slicedToArray(_this$getSize, 2),
            halfWidth = _this$getSize2[0],
            halfHeight = _this$getSize2[1];

        var size = [halfWidth, halfHeight];
        this.geometry.updateVertexBuffer(SDFVertexAttributeBufferIndex.SIZE, SDFVertexAttributeLocation.SIZE, index, new Uint8Array(new Float32Array([].concat(size)).buffer));
      } else if (name === 'stroke' || name === 'lineDash' || name === 'strokeOpacity') {
        var circle = object;
        var omitStroke = this.shouldOmitStroke(circle.parsedStyle);
        this.geometry.updateVertexBuffer(SDFVertexAttributeBufferIndex.PACKED_STYLE3, SDFVertexAttributeLocation.PACKED_STYLE3, index, new Uint8Array(new Float32Array([SDF_Shape.indexOf(object.nodeName), object.parsedStyle.radius || 0, omitStroke ? 1 : 0, 0]).buffer));
      }
    }
  }, {
    key: "getSize",
    value: function getSize(parsed, tagName) {
      var size = [0, 0];

      if (tagName === Shape.CIRCLE) {
        var rInPixels = parsed.rInPixels;
        size = [rInPixels, rInPixels];
      } else if (tagName === Shape.ELLIPSE) {
        var rxInPixels = parsed.rxInPixels,
            ryInPixels = parsed.ryInPixels;
        size = [rxInPixels, ryInPixels];
      }

      return size;
    }
  }, {
    key: "shouldOmitStroke",
    value: function shouldOmitStroke(attributes) {
      var lineDash = attributes.lineDash,
          stroke = attributes.stroke,
          strokeOpacity = attributes.strokeOpacity;
      return !!(stroke && (lineDash && lineDash.length && lineDash.every(function (item) {
        return item !== 0;
      }) || strokeOpacity !== 1));
    }
  }, {
    key: "needDrawStrokeSeparately",
    value: function needDrawStrokeSeparately(object) {
      var _object$parsedStyle = object.parsedStyle,
          stroke = _object$parsedStyle.stroke,
          lineDash = _object$parsedStyle.lineDash,
          lineWidth = _object$parsedStyle.lineWidth,
          strokeOpacity = _object$parsedStyle.strokeOpacity;
      return stroke && lineWidth.value > 0 && (strokeOpacity < 1 || lineDash && lineDash.length && lineDash.every(function (item) {
        return item !== 0;
      }));
    }
  }]);

  return SDFMesh;
}(Instanced);

SDFMesh = __decorate([injectable()], SDFMesh);

var vert$1 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\n\nlayout(location = MODEL_MATRIX0) in vec4 a_ModelMatrix0;\nlayout(location = MODEL_MATRIX1) in vec4 a_ModelMatrix1;\nlayout(location = MODEL_MATRIX2) in vec4 a_ModelMatrix2;\nlayout(location = MODEL_MATRIX3) in vec4 a_ModelMatrix3;\nlayout(location = COLOR) in vec4 a_Color;\nlayout(location = STROKE_COLOR) in vec4 a_StrokeColor;\nlayout(location = PACKED_STYLE1) in vec4 a_StylePacked1;\nlayout(location = PACKED_STYLE2) in vec4 a_StylePacked2;\nlayout(location = PICKING_COLOR) in vec4 a_PickingColor;\nlayout(location = ANCHOR) in vec2 a_Anchor;\n\nout vec4 v_PickingResult;\nout vec4 v_Color;\nout vec4 v_StrokeColor;\nout vec4 v_StylePacked1;\nout vec4 v_StylePacked2;\n\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\nvec4 project(vec4 pos, mat4 pm, mat4 vm, mat4 mm) {\n  return pm * vm * mm * pos;\n}\n\nlayout(location = POSITION) in vec3 a_Position;\nlayout(location = POINTA) in vec3 a_PointA;\nlayout(location = POINTB) in vec3 a_PointB;\nlayout(location = CAP) in float a_Cap;\n#ifdef USE_UV\n  layout(location = UV) in vec2 a_Uv;\n  out vec2 v_Uv;\n#endif\nlayout(location = DASH) in vec4 a_Dash;\n\nout vec4 v_Dash;\n// out vec2 v_Normal;\n\nvoid main() {\n  mat4 u_ModelMatrix = mat4(a_ModelMatrix0, a_ModelMatrix1, a_ModelMatrix2, a_ModelMatrix3);\nvec4 u_StrokeColor = a_StrokeColor;\nfloat u_Opacity = a_StylePacked1.x;\nfloat u_FillOpacity = a_StylePacked1.y;\nfloat u_StrokeOpacity = a_StylePacked1.z;\nfloat u_StrokeWidth = a_StylePacked1.w;\nfloat u_ZIndex = a_PickingColor.w;\n\nsetPickingColor(a_PickingColor.xyz);\n\nv_Color = a_Color;\nv_StrokeColor = a_StrokeColor;\nv_StylePacked1 = a_StylePacked1;\nv_StylePacked2 = a_StylePacked2;\n\n#ifdef CLIPSPACE_NEAR_ZERO\n    gl_Position.z = gl_Position.z * 0.5 + 0.5;\n#endif\n  #ifdef USE_UV\n  v_Uv = a_Uv;\n  #ifdef VIEWPORT_ORIGIN_TL\n    v_Uv.y = 1.0 - v_Uv.y;\n  #endif\n#endif\n\n  float isBillboard = a_Dash.w;\n  if (isBillboard < 0.5) {\n    vec2 xBasis = a_PointB.xy - a_PointA.xy;\n    vec2 yBasis = normalize(vec2(-xBasis.y, xBasis.x));\n\n    vec2 point = a_PointA.xy + xBasis * a_Position.x + yBasis * u_StrokeWidth * a_Position.y;\n    point = point - a_Anchor.xy * abs(xBasis);\n\n    // round & square\n    if (a_Cap > 1.0) {\n      point += sign(a_Position.x - 0.5) * normalize(xBasis) * vec2(u_StrokeWidth / 2.0);\n    }\n\n    gl_Position = project(vec4(point, u_ZIndex, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n  } else {\n    // clip space\n    vec4 clip0 = project(vec4(a_PointA, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n    vec4 clip1 = project(vec4(a_PointB, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n    // screen space\n    vec2 screen0 = u_Viewport * (0.5 * clip0.xy / clip0.w + 0.5);\n    vec2 screen1 = u_Viewport * (0.5 * clip1.xy / clip1.w + 0.5);\n    vec2 xBasis = normalize(screen1 - screen0);\n    vec2 yBasis = vec2(-xBasis.y, xBasis.x);\n    vec2 pt0 = screen0 + u_StrokeWidth * (a_Position.x * xBasis + a_Position.y * yBasis);\n    vec2 pt1 = screen1 + u_StrokeWidth * (a_Position.x * xBasis + a_Position.y * yBasis);\n    vec2 pt = mix(pt0, pt1, a_Position.z);\n    vec4 clip = mix(clip0, clip1, a_Position.z);\n    gl_Position = vec4(clip.w * (2.0 * pt / u_Viewport - 1.0), clip.z, clip.w);\n  }\n\n  v_Dash = vec4(a_Position.x, a_Dash.xyz);\n}"; // eslint-disable-line

var frag$1 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\n\nin vec4 v_PickingResult;\nin vec4 v_Color;\nin vec4 v_StrokeColor;\nin vec4 v_StylePacked1;\nin vec4 v_StylePacked2;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n#ifdef USE_UV\n  in vec2 v_Uv;\n#endif\n#ifdef USE_MAP\n  uniform sampler2D u_Map;\n#endif\n\nin vec4 v_Dash;\n// in vec2 v_Normal;\n\nvoid main() {\n  vec4 u_Color = v_Color;\nvec4 u_StrokeColor = v_StrokeColor;\nfloat u_Opacity = v_StylePacked1.x;\nfloat u_FillOpacity = v_StylePacked1.y;\nfloat u_StrokeOpacity = v_StylePacked1.z;\nfloat u_StrokeWidth = v_StylePacked1.w;\nfloat u_Visible = v_StylePacked2.x;\n\ngbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\nif (u_Visible < 1.0) {\n    discard;\n}\n  #ifdef USE_MAP\n  vec4 texelColor = texture(SAMPLER_2D(u_Map), v_Uv);\n  u_Color = texelColor;\n#endif\n\n  gbuf_color = u_StrokeColor;\n  #ifdef USE_MAP\n      gbuf_color = u_Color;\n  #endif\n\n  // float blur = 1. - smoothstep(0.98, 1., length(v_Normal));\n  float u_dash_offset = v_Dash.y;\n  float u_dash_array = v_Dash.z;\n  float u_dash_ratio = v_Dash.w;\n  gbuf_color.a = gbuf_color.a\n    // * blur\n    * u_Opacity * u_StrokeOpacity\n    * ceil(mod(v_Dash.x + u_dash_offset, u_dash_array) - (u_dash_array * u_dash_ratio));\n}"; // eslint-disable-line

var _LineCap_MAP;
var segmentInstanceGeometry = [0, -0.5, 0, 0, 0, 1, -0.5, 1, 1, 0, 1, 0.5, 1, 1, 1, 0, 0.5, 0, 0, 1];
var InstancedLineVertexAttributeBufferIndex;

(function (InstancedLineVertexAttributeBufferIndex) {
  InstancedLineVertexAttributeBufferIndex[InstancedLineVertexAttributeBufferIndex["POSITION_UV"] = 1] = "POSITION_UV";
  InstancedLineVertexAttributeBufferIndex[InstancedLineVertexAttributeBufferIndex["POINT_CAP_DASH"] = 2] = "POINT_CAP_DASH";
})(InstancedLineVertexAttributeBufferIndex || (InstancedLineVertexAttributeBufferIndex = {}));

var InstancedLineVertexAttributeLocation;

(function (InstancedLineVertexAttributeLocation) {
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["POSITION"] = 10] = "POSITION";
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["POINTA"] = 11] = "POINTA";
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["POINTB"] = 12] = "POINTB";
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["CAP"] = 13] = "CAP";
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["UV"] = 14] = "UV";
  InstancedLineVertexAttributeLocation[InstancedLineVertexAttributeLocation["DASH"] = 15] = "DASH";
})(InstancedLineVertexAttributeLocation || (InstancedLineVertexAttributeLocation = {}));

var LineCap_MAP = (_LineCap_MAP = {}, _defineProperty(_LineCap_MAP, LineCap.BUTT, 1), _defineProperty(_LineCap_MAP, LineCap.ROUND, 2), _defineProperty(_LineCap_MAP, LineCap.SQUARE, 3), _LineCap_MAP);

var InstancedLineMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(InstancedLineMesh, _Instanced);

  var _super = _createSuper(InstancedLineMesh);

  function InstancedLineMesh() {
    _classCallCheck(this, InstancedLineMesh);

    return _super.apply(this, arguments);
  }

  _createClass(InstancedLineMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      var shouldMerge = _get(_getPrototypeOf(InstancedLineMesh.prototype), "shouldMerge", this).call(this, object, index);

      if (!shouldMerge) {
        return false;
      } // should split when using gradient & pattern


      var instance = this.instance;

      if (instance.nodeName === Shape.LINE) {
        var source = instance.parsedStyle.stroke;
        var target = object.parsedStyle.stroke; // can't be merged if stroke's types are different

        if (source.type !== target.type) {
          return false;
        } // compare hash directly


        if (source.type !== PARSED_COLOR_TYPE.Constant && target.type !== PARSED_COLOR_TYPE.Constant) {
          return source.value.hash === target.value.hash;
        }
      }

      return true;
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      this.material.vertexShader = vert$1;
      this.material.fragmentShader = frag$1;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(InstancedLineVertexAttributeLocation));
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var _this = this;

      // use default common attributes
      _get(_getPrototypeOf(InstancedLineMesh.prototype), "createGeometry", this).call(this, objects);

      var interleaved = [];
      var indices = [];
      var offset = 0;
      objects.forEach(function (object) {
        var line = object;
        var _line$parsedStyle = line.parsedStyle,
            x1 = _line$parsedStyle.x1,
            y1 = _line$parsedStyle.y1,
            x2 = _line$parsedStyle.x2,
            y2 = _line$parsedStyle.y2,
            z1 = _line$parsedStyle.z1,
            z2 = _line$parsedStyle.z2,
            defX = _line$parsedStyle.defX,
            defY = _line$parsedStyle.defY,
            lineCap = _line$parsedStyle.lineCap,
            isBillboard = _line$parsedStyle.isBillboard;

        var _this$calcDash = _this.calcDash(object),
            dashOffset = _this$calcDash.dashOffset,
            dashSegmentPercent = _this$calcDash.dashSegmentPercent,
            dashRatioInEachSegment = _this$calcDash.dashRatioInEachSegment;

        interleaved.push(x1 - defX, y1 - defY, z1, x2 - defX, y2 - defY, z2, // caps
        LineCap_MAP[lineCap], // dash
        dashOffset, dashSegmentPercent, dashRatioInEachSegment, // isBillboard
        isBillboard ? 1 : 0);
        indices.push(0 + offset, 2 + offset, 1 + offset, 0 + offset, 3 + offset, 2 + offset);
        offset += 4;
      });
      this.geometry.setIndexBuffer(new Uint32Array(indices));
      this.geometry.vertexCount = 6;
      this.geometry.setVertexBuffer({
        bufferIndex: InstancedLineVertexAttributeBufferIndex.POSITION_UV,
        byteStride: 4 * 5,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RGB,
          bufferByteOffset: 4 * 0,
          location: InstancedLineVertexAttributeLocation.POSITION,
          divisor: 0
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 3,
          location: InstancedLineVertexAttributeLocation.UV,
          divisor: 0
        }],
        data: new Float32Array(segmentInstanceGeometry)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: InstancedLineVertexAttributeBufferIndex.POINT_CAP_DASH,
        byteStride: 4 * (3 + 3 + 1 + 4),
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RGB,
          bufferByteOffset: 4 * 0,
          location: InstancedLineVertexAttributeLocation.POINTA,
          divisor: 1
        }, {
          format: Format.F32_RGB,
          bufferByteOffset: 4 * 3,
          location: InstancedLineVertexAttributeLocation.POINTB,
          divisor: 1
        }, {
          format: Format.F32_R,
          bufferByteOffset: 4 * 6,
          location: InstancedLineVertexAttributeLocation.CAP,
          divisor: 1
        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 7,
          location: InstancedLineVertexAttributeLocation.DASH,
          divisor: 1
        }],
        data: new Float32Array(interleaved)
      });
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      _get(_getPrototypeOf(InstancedLineMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var index = this.objects.indexOf(object);
      this.updateBatchedAttribute(object, index, name, value);
      var _object$parsedStyle = object.parsedStyle,
          x1 = _object$parsedStyle.x1,
          y1 = _object$parsedStyle.y1,
          x2 = _object$parsedStyle.x2,
          y2 = _object$parsedStyle.y2,
          z1 = _object$parsedStyle.z1,
          z2 = _object$parsedStyle.z2,
          defX = _object$parsedStyle.defX,
          defY = _object$parsedStyle.defY,
          lineCap = _object$parsedStyle.lineCap;

      if (name === 'x1' || name === 'y1' || name === 'x2' || name === 'y2' || name === 'z1' || name === 'z2') {
        this.geometry.updateVertexBuffer(InstancedLineVertexAttributeBufferIndex.POINT_CAP_DASH, InstancedLineVertexAttributeLocation.POINTA, index, new Uint8Array(new Float32Array([x1 - defX, y1 - defY, z1, x2 - defX, y2 - defY, z2]).buffer));
      } else if (name === 'lineDashOffset' || name === 'lineDash') {
        var _this$calcDash2 = this.calcDash(object),
            dashOffset = _this$calcDash2.dashOffset,
            dashSegmentPercent = _this$calcDash2.dashSegmentPercent,
            dashRatioInEachSegment = _this$calcDash2.dashRatioInEachSegment;

        this.geometry.updateVertexBuffer(InstancedLineVertexAttributeBufferIndex.POINT_CAP_DASH, InstancedLineVertexAttributeLocation.DASH, index, new Uint8Array(new Float32Array([dashOffset, dashSegmentPercent, dashRatioInEachSegment]).buffer));
      } else if (name === 'lineCap') {
        this.geometry.updateVertexBuffer(InstancedLineVertexAttributeBufferIndex.POINT_CAP_DASH, InstancedLineVertexAttributeLocation.CAP, index, new Uint8Array(new Float32Array([LineCap_MAP[lineCap]]).buffer));
      }
    }
  }, {
    key: "calcDash",
    value: function calcDash(line) {
      var _line$parsedStyle2 = line.parsedStyle,
          lineDash = _line$parsedStyle2.lineDash,
          _line$parsedStyle2$li = _line$parsedStyle2.lineDashOffset,
          lineDashOffset = _line$parsedStyle2$li === void 0 ? 0 : _line$parsedStyle2$li;
      var totalLength = line.getTotalLength();
      var dashOffset = 0;
      var dashSegmentPercent = 1;
      var dashRatioInEachSegment = 0;

      if (lineDash && lineDash.length) {
        dashOffset = lineDashOffset / totalLength;
        var segmentsLength = lineDash.reduce(function (cur, prev) {
          return cur + prev;
        }, 0);
        dashSegmentPercent = segmentsLength / totalLength;
        dashRatioInEachSegment = lineDash[1] / segmentsLength;
      }

      return {
        dashOffset: dashOffset,
        dashSegmentPercent: dashSegmentPercent,
        dashRatioInEachSegment: dashRatioInEachSegment
      };
    }
  }]);

  return InstancedLineMesh;
}(Instanced);

InstancedLineMesh = __decorate([injectable()], InstancedLineMesh);

/**
 * 两点之间的距离
 * @param {number} x1 起始点 x
 * @param {number} y1 起始点 y
 * @param {number} x2 结束点 x
 * @param {number} y2 结束点 y
 * @return {number} 距离
 */

function distance(x1, y1, x2, y2) {
  var dx = x1 - x2;
  var dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}
function isNumberEqual(v1, v2) {
  return Math.abs(v1 - v2) < 0.001;
}
function getBBoxByArray(xArr, yArr) {
  var minX = min(xArr);
  var minY = min(yArr);
  var maxX = max(xArr);
  var maxY = max(yArr);
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function piMod(angle) {
  return (angle + Math.PI * 2) % (Math.PI * 2);
}

var line = {
  /**
   * 计算线段的包围盒
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @return {object} 包围盒对象
   */
  box: function box(x1, y1, x2, y2) {
    return getBBoxByArray([x1, x2], [y1, y2]);
  },

  /**
   * 线段的长度
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @return {number} 距离
   */
  length: function length(x1, y1, x2, y2) {
    return distance(x1, y1, x2, y2);
  },

  /**
   * 根据比例获取点
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @param {number} t 指定比例
   * @return {object} 包含 x, y 的点
   */
  pointAt: function pointAt(x1, y1, x2, y2, t) {
    return {
      x: (1 - t) * x1 + t * x2,
      y: (1 - t) * y1 + t * y2
    };
  },

  /**
   * 点到线段的距离
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @param {number} x  测试点 x
   * @param {number} y  测试点 y
   * @return {number} 距离
   */
  pointDistance: function pointDistance(x1, y1, x2, y2, x, y) {
    // 投影距离 x1, y1 的向量，假设 p, p1, p2 三个点，投影点为 a
    // p1a = p1p.p1p2/|p1p2| * (p1p 的单位向量)
    var cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);

    if (cross < 0) {
      return distance(x1, y1, x, y);
    }

    var lengthSquare = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);

    if (cross > lengthSquare) {
      return distance(x2, y2, x, y);
    }

    return this.pointToLine(x1, y1, x2, y2, x, y);
  },

  /**
   * 点到直线的距离，而不是点到线段的距离
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @param {number} x  测试点 x
   * @param {number} y  测试点 y
   * @return {number} 距离
   */
  pointToLine: function pointToLine(x1, y1, x2, y2, x, y) {
    var d = [x2 - x1, y2 - y1]; // 如果端点相等，则判定点到点的距离

    if (exactEquals(d, [0, 0])) {
      return Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
    }

    var u = [-d[1], d[0]];
    normalize(u, u);
    var a = [x - x1, y - y1];
    return Math.abs(dot(a, u));
  },

  /**
   * 线段的角度
   * @param {number} x1 起始点 x
   * @param {number} y1 起始点 y
   * @param {number} x2 结束点 x
   * @param {number} y2 结束点 y
   * @return {number} 导数
   */
  tangentAngle: function tangentAngle(x1, y1, x2, y2) {
    return Math.atan2(y2 - y1, x2 - x1);
  }
};

var EPSILON = 0.0001;
/**
 * 使用牛顿切割法求最近的点
 * @param {number[]} xArr      点的 x 数组
 * @param {number[]} yArr      点的 y 数组
 * @param {number}   x         指定的点 x
 * @param {number}   y         指定的点 y
 * @param {Function} tCallback 差值函数
 */

function nearestPoint(xArr, yArr, x, y, tCallback, length) {
  var t = -1;
  var d = Infinity;
  var v0 = [x, y];
  var segNum = 20;

  if (length && length > 200) {
    segNum = length / 10;
  }

  var increaseRate = 1 / segNum;
  var interval = increaseRate / 10;

  for (var i = 0; i <= segNum; i++) {
    var _t = i * increaseRate;

    var v1 = [tCallback.apply(null, xArr.concat([_t])), tCallback.apply(null, yArr.concat([_t]))];
    var d1 = distance(v0[0], v0[1], v1[0], v1[1]);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  } // 提前终止


  if (t === 0) {
    return {
      x: xArr[0],
      y: yArr[0]
    };
  }

  if (t === 1) {
    var count = xArr.length;
    return {
      x: xArr[count - 1],
      y: yArr[count - 1]
    };
  }

  d = Infinity;

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON) {
      break;
    }

    var prev = t - interval;
    var next = t + interval;
    var v1 = [tCallback.apply(null, xArr.concat([prev])), tCallback.apply(null, yArr.concat([prev]))];
    var d1 = distance(v0[0], v0[1], v1[0], v1[1]);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      var v2 = [tCallback.apply(null, xArr.concat([next])), tCallback.apply(null, yArr.concat([next]))];
      var d2 = distance(v0[0], v0[1], v2[0], v2[1]);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  }

  return {
    x: tCallback.apply(null, xArr.concat([t])),
    y: tCallback.apply(null, yArr.concat([t]))
  };
} // 近似求解 https://community.khronos.org/t/3d-cubic-bezier-segment-length/62363/2

function snapLength(xArr, yArr) {
  var totalLength = 0;
  var count = xArr.length;

  for (var i = 0; i < count; i++) {
    var x = xArr[i];
    var y = yArr[i];
    var nextX = xArr[(i + 1) % count];
    var nextY = yArr[(i + 1) % count];
    totalLength += distance(x, y, nextX, nextY);
  }

  return totalLength / 2;
}

function cubicAt(p0, p1, p2, p3, t) {
  var onet = 1 - t; // t * t * t 的性能大概是 Math.pow(t, 3) 的三倍

  return onet * onet * onet * p0 + 3 * p1 * t * onet * onet + 3 * p2 * t * t * onet + p3 * t * t * t;
}

function derivativeAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return 3 * (onet * onet * (p1 - p0) + 2 * onet * t * (p2 - p1) + t * t * (p3 - p2));
}

function extrema(p0, p1, p2, p3) {
  var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
  var b = 6 * p0 - 12 * p1 + 6 * p2;
  var c = 3 * p1 - 3 * p0;
  var extremas = [];
  var t1;
  var t2;
  var discSqrt;

  if (isNumberEqual(a, 0)) {
    if (!isNumberEqual(b, 0)) {
      t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        extremas.push(t1);
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isNumberEqual(disc, 0)) {
      extremas.push(-b / (2 * a));
    } else if (disc > 0) {
      discSqrt = Math.sqrt(disc);
      t1 = (-b + discSqrt) / (2 * a);
      t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        extremas.push(t1);
      }

      if (t2 >= 0 && t2 <= 1) {
        extremas.push(t2);
      }
    }
  }

  return extremas;
} // 分割贝塞尔曲线


function divideCubic(x1, y1, x2, y2, x3, y3, x4, y4, t) {
  // 划分点
  var xt = cubicAt(x1, x2, x3, x4, t);
  var yt = cubicAt(y1, y2, y3, y4, t); // 计算两点之间的差值点

  var c1 = line.pointAt(x1, y1, x2, y2, t);
  var c2 = line.pointAt(x2, y2, x3, y3, t);
  var c3 = line.pointAt(x3, y3, x4, y4, t);
  var c12 = line.pointAt(c1.x, c1.y, c2.x, c2.y, t);
  var c23 = line.pointAt(c2.x, c2.y, c3.x, c3.y, t);
  return [[x1, y1, c1.x, c1.y, c12.x, c12.y, xt, yt], [xt, yt, c23.x, c23.y, c3.x, c3.y, x4, y4]];
} // 使用迭代法取贝塞尔曲线的长度，二阶和三阶分开写，更清晰和便于调试


function cubicLength(x1, y1, x2, y2, x3, y3, x4, y4, iterationCount) {
  if (iterationCount === 0) {
    return snapLength([x1, x2, x3, x4], [y1, y2, y3, y4]);
  }

  var cubics = divideCubic(x1, y1, x2, y2, x3, y3, x4, y4, 0.5);

  var left = __spreadArray(__spreadArray([], __read(cubics[0]), false), [iterationCount - 1], false);

  var right = __spreadArray(__spreadArray([], __read(cubics[1]), false), [iterationCount - 1], false);

  return cubicLength.apply(null, left) + cubicLength.apply(null, right);
}

var CubicUtil = {
  extrema: extrema,
  box: function box(x1, y1, x2, y2, x3, y3, x4, y4) {
    var xArr = [x1, x4];
    var yArr = [y1, y4];
    var xExtrema = extrema(x1, x2, x3, x4);
    var yExtrema = extrema(y1, y2, y3, y4);

    for (var i = 0; i < xExtrema.length; i++) {
      xArr.push(cubicAt(x1, x2, x3, x4, xExtrema[i]));
    }

    for (var i = 0; i < yExtrema.length; i++) {
      yArr.push(cubicAt(y1, y2, y3, y4, yExtrema[i]));
    }

    return getBBoxByArray(xArr, yArr);
  },
  length: function length(x1, y1, x2, y2, x3, y3, x4, y4) {
    // 迭代三次，划分成 8 段求长度
    return cubicLength(x1, y1, x2, y2, x3, y3, x4, y4, 3);
  },
  nearestPoint: function nearestPoint$1(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length) {
    return nearestPoint([x1, x2, x3, x4], [y1, y2, y3, y4], x0, y0, cubicAt, length);
  },
  pointDistance: function pointDistance(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length) {
    var point = this.nearestPoint(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length);
    return distance(point.x, point.y, x0, y0);
  },
  interpolationAt: cubicAt,
  pointAt: function pointAt(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    return {
      x: cubicAt(x1, x2, x3, x4, t),
      y: cubicAt(y1, y2, y3, y4, t)
    };
  },
  divide: function divide(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    return divideCubic(x1, y1, x2, y2, x3, y3, x4, y4, t);
  },
  tangentAngle: function tangentAngle(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    var dx = derivativeAt(x1, x2, x3, x4, t);
    var dy = derivativeAt(y1, y2, y3, y4, t);
    return piMod(Math.atan2(dy, dx));
  }
};

var vert$2 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  mat4 u_ModelMatrix;\n  vec4 u_Color;\n  vec4 u_StrokeColor;\n  float u_StrokeWidth;\n  float u_Opacity;\n  float u_FillOpacity;\n  float u_StrokeOpacity;\n  float u_Expand;\n  float u_MiterLimit;\n  float u_ScaleMode;\n  float u_Alignment;\n  vec3 u_PickingColor;\n  float u_Dash;\n  float u_Gap;\n  float u_DashOffset;\n  float u_Visible;\n  float u_ZIndex;\n};\n\nlayout(location = PREV) in vec2 a_Prev;\nlayout(location = POINT1) in vec2 a_Point1;\nlayout(location = POINT2) in vec2 a_Point2;\nlayout(location = NEXT) in vec2 a_Next;\nlayout(location = VERTEX_JOINT) in float a_VertexJoint;\nlayout(location = VERTEX_NUM) in float a_VertexNum;\nlayout(location = TRAVEL) in float a_Travel;\n\nconst float FILL = 1.0;\nconst float BEVEL = 4.0;\nconst float MITER = 8.0;\nconst float ROUND = 12.0;\nconst float JOINT_CAP_BUTT = 16.0;\nconst float JOINT_CAP_SQUARE = 18.0;\nconst float JOINT_CAP_ROUND = 20.0;\nconst float FILL_EXPAND = 24.0;\nconst float CAP_BUTT = 1.0;\nconst float CAP_SQUARE = 2.0;\nconst float CAP_ROUND = 3.0;\nconst float CAP_BUTT2 = 4.0;\n\nout vec4 v_Distance;\nout vec4 v_Arc;\nout float v_Type;\nout float v_Travel;\n\nout vec4 v_PickingResult;\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\n\nvec2 doBisect(\n  vec2 norm, float len, vec2 norm2, float len2, float dy, float inner\n) {\n  vec2 bisect = (norm + norm2) / 2.0;\n  bisect /= dot(norm, bisect);\n  vec2 shift = dy * bisect;\n  if (inner > 0.5) {\n    if (len < len2) {\n      if (abs(dy * (bisect.x * norm.y - bisect.y * norm.x)) > len) {\n        return dy * norm;\n      }\n    } else {\n      if (abs(dy * (bisect.x * norm2.y - bisect.y * norm2.x)) > len2) {\n        return dy * norm;\n      }\n    }\n  }\n  return dy * bisect;\n}\n\nvoid main() {\n  vec2 pointA = (u_ModelMatrix * vec4(a_Point1, 0., 1.0)).xy;\n  vec2 pointB = (u_ModelMatrix * vec4(a_Point2, 0., 1.0)).xy;\n\n  vec2 xBasis = pointB - pointA;\n  float len = length(xBasis);\n  vec2 forward = xBasis / len;\n  vec2 norm = vec2(forward.y, -forward.x);\n\n  float type = a_VertexJoint;\n  float lineWidth = u_StrokeWidth;\n\n  if (u_ScaleMode > 2.5) {\n      lineWidth *= length(u_ModelMatrix * vec4(1.0, 0.0, 0.0, 0.0));\n  } else if (u_ScaleMode > 1.5) {\n      lineWidth *= length(u_ModelMatrix * vec4(0.0, 1.0, 0.0, 0.0));\n  } else if (u_ScaleMode > 0.5) {\n      vec2 avgDiag = (u_ModelMatrix * vec4(1.0, 1.0, 0.0, 0.0)).xy;\n      lineWidth *= sqrt(dot(avgDiag, avgDiag) * 0.5);\n  }\n  float capType = floor(type / 32.0);\n  type -= capType * 32.0;\n  v_Arc = vec4(0.0);\n  lineWidth *= 0.5;\n  float lineAlignment = 2.0 * u_Alignment - 1.0;\n\n  vec2 pos;\n\n  if (capType == CAP_ROUND) {\n      if (a_VertexNum < 3.5) {\n      gl_Position = vec4(0.0, 0.0, 0.0, 1.0);\n      return;\n      }\n      type = JOINT_CAP_ROUND;\n      capType = 0.0;\n  }\n\n  if (type >= BEVEL) {\n      float dy = lineWidth + u_Expand;\n      float inner = 0.0;\n      if (a_VertexNum >= 1.5) {\n      dy = -dy;\n      inner = 1.0;\n      }\n\n      vec2 base, next, xBasis2, bisect;\n      float flag = 0.0;\n      float sign2 = 1.0;\n      if (a_VertexNum < 0.5 || a_VertexNum > 2.5 && a_VertexNum < 3.5) {\n      next = (u_ModelMatrix * vec4(a_Prev, 0.0, 1.0)).xy;\n      base = pointA;\n      flag = type - floor(type / 2.0) * 2.0;\n      sign2 = -1.0;\n\n      } else {\n      next = (u_ModelMatrix * vec4(a_Next, 0.0, 1.0)).xy;\n      base = pointB;\n      if (type >= MITER && type < MITER + 3.5) {\n          flag = step(MITER + 1.5, type);\n          // check miter limit here?\n      }\n      }\n      xBasis2 = next - base;\n      float len2 = length(xBasis2);\n      vec2 norm2 = vec2(xBasis2.y, -xBasis2.x) / len2;\n      float D = norm.x * norm2.y - norm.y * norm2.x;\n      if (D < 0.0) {\n      inner = 1.0 - inner;\n      }\n      norm2 *= sign2;\n\n      if (abs(lineAlignment) > 0.01) {\n      float shift = lineWidth * lineAlignment;\n      pointA += norm * shift;\n      pointB += norm * shift;\n      if (abs(D) < 0.01) {\n          base += norm * shift;\n      } else {\n          base += doBisect(norm, len, norm2, len2, shift, 0.0);\n      }\n      }\n\n      float collinear = step(0.0, dot(norm, norm2));\n      v_Type = 0.0;\n      float dy2 = -1000.0;\n      float dy3 = -1000.0;\n      if (abs(D) < 0.01 && collinear < 0.5) {\n      if (type >= ROUND && type < ROUND + 1.5) {\n          type = JOINT_CAP_ROUND;\n      }\n      //TODO: BUTT here too\n      }\n\n      if (a_VertexNum < 3.5) {\n      if (abs(D) < 0.01) {\n          pos = dy * norm;\n      } else {\n          if (flag < 0.5 && inner < 0.5) {\n          pos = dy * norm;\n          } else {\n          pos = doBisect(norm, len, norm2, len2, dy, inner);\n          }\n      }\n      if (capType >= CAP_BUTT && capType < CAP_ROUND) {\n          float extra = step(CAP_SQUARE, capType) * lineWidth;\n          vec2 back = -forward;\n          if (a_VertexNum < 0.5 || a_VertexNum > 2.5) {\n          pos += back * (u_Expand + extra);\n          dy2 = u_Expand;\n          } else {\n          dy2 = dot(pos + base - pointA, back) - extra;\n          }\n      }\n      if (type >= JOINT_CAP_BUTT && type < JOINT_CAP_SQUARE + 0.5) {\n          float extra = step(JOINT_CAP_SQUARE, type) * lineWidth;\n          if (a_VertexNum < 0.5 || a_VertexNum > 2.5) {\n          dy3 = dot(pos + base - pointB, forward) - extra;\n          } else {\n          pos += forward * (u_Expand + extra);\n          dy3 = u_Expand;\n          if (capType >= CAP_BUTT) {\n              dy2 -= u_Expand + extra;\n          }\n          }\n      }\n      } else if (type >= JOINT_CAP_ROUND && type < JOINT_CAP_ROUND + 1.5) {\n      if (inner > 0.5) {\n          dy = -dy;\n          inner = 0.0;\n      }\n      vec2 d2 = abs(dy) * forward;\n      if (a_VertexNum < 4.5) {\n          dy = -dy;\n          pos = dy * norm;\n      } else if (a_VertexNum < 5.5) {\n          pos = dy * norm;\n      } else if (a_VertexNum < 6.5) {\n          pos = dy * norm + d2;\n          v_Arc.x = abs(dy);\n      } else {\n          dy = -dy;\n          pos = dy * norm + d2;\n          v_Arc.x = abs(dy);\n      }\n      dy2 = 0.0;\n      v_Arc.y = dy;\n      v_Arc.z = 0.0;\n      v_Arc.w = lineWidth;\n      v_Type = 3.0;\n      } else if (abs(D) < 0.01) {\n      pos = dy * norm;\n      } else {\n      if (type >= ROUND && type < ROUND + 1.5) {\n          if (inner > 0.5) {\n          dy = -dy;\n          inner = 0.0;\n          }\n          if (a_VertexNum < 4.5) {\n          pos = doBisect(norm, len, norm2, len2, -dy, 1.0);\n          } else if (a_VertexNum < 5.5) {\n          pos = dy * norm;\n          } else if (a_VertexNum > 7.5) {\n          pos = dy * norm2;\n          } else {\n          pos = doBisect(norm, len, norm2, len2, dy, 0.0);\n          float d2 = abs(dy);\n          if (length(pos) > abs(dy) * 1.5) {\n              if (a_VertexNum < 6.5) {\n              pos.x = dy * norm.x - d2 * norm.y;\n              pos.y = dy * norm.y + d2 * norm.x;\n              } else {\n              pos.x = dy * norm2.x + d2 * norm2.y;\n              pos.y = dy * norm2.y - d2 * norm2.x;\n              }\n          }\n          }\n          vec2 norm3 = normalize(norm + norm2);\n          float sign = step(0.0, dy) * 2.0 - 1.0;\n          v_Arc.x = sign * dot(pos, norm3);\n          v_Arc.y = pos.x * norm3.y - pos.y * norm3.x;\n          v_Arc.z = dot(norm, norm3) * lineWidth;\n          v_Arc.w = lineWidth;\n          dy = -sign * dot(pos, norm);\n          dy2 = -sign * dot(pos, norm2);\n          dy3 = v_Arc.z - v_Arc.x;\n          v_Type = 3.0;\n      } else {\n          float hit = 0.0;\n          if (type >= BEVEL && type < BEVEL + 1.5) {\n          if (dot(norm, norm2) > 0.0) {\n              type = MITER;\n          }\n          }\n          if (type >= MITER && type < MITER + 3.5) {\n          if (inner > 0.5) {\n              dy = -dy;\n              inner = 0.0;\n          }\n          float sign = step(0.0, dy) * 2.0 - 1.0;\n          pos = doBisect(norm, len, norm2, len2, dy, 0.0);\n          if (length(pos) > abs(dy) * u_MiterLimit) {\n              type = BEVEL;\n          } else {\n              if (a_VertexNum < 4.5) {\n              dy = -dy;\n              pos = doBisect(norm, len, norm2, len2, dy, 1.0);\n              } else if (a_VertexNum < 5.5) {\n              pos = dy * norm;\n              } else if (a_VertexNum > 6.5) {\n              pos = dy * norm2;\n              }\n              v_Type = 1.0;\n              dy = -sign * dot(pos, norm);\n              dy2 = -sign * dot(pos, norm2);\n              hit = 1.0;\n          }\n          }\n          if (type >= BEVEL && type < BEVEL + 1.5) {\n          if (inner > 0.5) {\n              dy = -dy;\n              inner = 0.0;\n          }\n          float d2 = abs(dy);\n          vec2 pos3 = vec2(dy * norm.x - d2 * norm.y, dy * norm.y + d2 * norm.x);\n          vec2 pos4 = vec2(dy * norm2.x + d2 * norm2.y, dy * norm2.y - d2 * norm2.x);\n          if (a_VertexNum < 4.5) {\n              pos = doBisect(norm, len, norm2, len2, -dy, 1.0);\n          } else if (a_VertexNum < 5.5) {\n              pos = dy * norm;\n          } else if (a_VertexNum > 7.5) {\n              pos = dy * norm2;\n          } else {\n              if (a_VertexNum < 6.5) {\n              pos = pos3;\n              } else {\n              pos = pos4;\n              }\n          }\n          vec2 norm3 = normalize(norm + norm2);\n          float sign = step(0.0, dy) * 2.0 - 1.0;\n          dy = -sign * dot(pos, norm);\n          dy2 = -sign * dot(pos, norm2);\n          dy3 = (-sign * dot(pos, norm3)) + lineWidth;\n          v_Type = 4.0;\n          hit = 1.0;\n          }\n          if (hit < 0.5) {\n          gl_Position = vec4(0.0, 0.0, 0.0, 1.0);\n          return;\n          }\n      }\n      }\n      pos += base;\n      v_Distance = vec4(dy, dy2, dy3, lineWidth) * u_DevicePixelRatio;\n      v_Arc = v_Arc * u_DevicePixelRatio;\n      v_Travel = a_Travel + dot(pos - pointA, vec2(-norm.y, norm.x));\n  }\n\n  gl_Position = u_ProjectionMatrix * u_ViewMatrix * vec4(pos, u_ZIndex, 1.0);\n\n  setPickingColor(u_PickingColor.xyz);\n}"; // eslint-disable-line

var frag$2 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  mat4 u_ModelMatrix;\n  vec4 u_Color;\n  vec4 u_StrokeColor;\n  float u_StrokeWidth;\n  float u_Opacity;\n  float u_FillOpacity;\n  float u_StrokeOpacity;\n  float u_Expand;\n  float u_MiterLimit;\n  float u_ScaleMode;\n  float u_Alignment;\n  vec3 u_PickingColor;\n  float u_Dash;\n  float u_Gap;\n  float u_DashOffset;\n  float u_Visible;\n  float u_ZIndex;\n};\n\nin vec4 v_Distance;\nin vec4 v_Arc;\nin float v_Type;\nin float v_Travel;\nin vec4 v_PickingResult;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n\nvoid main(){\n  if (u_Visible < 1.0) {\n    discard;\n  }\n\n  gbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\n  float alpha = 1.0;\n  float lineWidth = v_Distance.w;\n  if (v_Type < 0.5) {\n    float left = max(v_Distance.x - 0.5, -v_Distance.w);\n    float right = min(v_Distance.x + 0.5, v_Distance.w);\n    float near = v_Distance.y - 0.5;\n    float far = min(v_Distance.y + 0.5, 0.0);\n    float top = v_Distance.z - 0.5;\n    float bottom = min(v_Distance.z + 0.5, 0.0);\n    alpha = max(right - left, 0.0) * max(bottom - top, 0.0) * max(far - near, 0.0);\n  } else if (v_Type < 1.5) {\n    float a1 = clamp(v_Distance.x + 0.5 - lineWidth, 0.0, 1.0);\n    float a2 = clamp(v_Distance.x + 0.5 + lineWidth, 0.0, 1.0);\n    float b1 = clamp(v_Distance.y + 0.5 - lineWidth, 0.0, 1.0);\n    float b2 = clamp(v_Distance.y + 0.5 + lineWidth, 0.0, 1.0);\n    alpha = a2 * b2 - a1 * b1;\n  } else if (v_Type < 2.5) {\n    alpha *= max(min(v_Distance.x + 0.5, 1.0), 0.0);\n    alpha *= max(min(v_Distance.y + 0.5, 1.0), 0.0);\n    alpha *= max(min(v_Distance.z + 0.5, 1.0), 0.0);\n  } else if (v_Type < 3.5) {\n    float a1 = clamp(v_Distance.x + 0.5 - lineWidth, 0.0, 1.0);\n    float a2 = clamp(v_Distance.x + 0.5 + lineWidth, 0.0, 1.0);\n    float b1 = clamp(v_Distance.y + 0.5 - lineWidth, 0.0, 1.0);\n    float b2 = clamp(v_Distance.y + 0.5 + lineWidth, 0.0, 1.0);\n    float alpha_miter = a2 * b2 - a1 * b1;\n    float alpha_plane = max(min(v_Distance.z + 0.5, 1.0), 0.0);\n    float d = length(v_Arc.xy);\n    float circle_hor = max(min(v_Arc.w, d + 0.5) - max(-v_Arc.w, d - 0.5), 0.0);\n    float circle_vert = min(v_Arc.w * 2.0, 1.0);\n    float alpha_circle = circle_hor * circle_vert;\n    alpha = min(alpha_miter, max(alpha_circle, alpha_plane));\n  } else {\n    float a1 = clamp(v_Distance.x + 0.5 - lineWidth, 0.0, 1.0);\n    float a2 = clamp(v_Distance.x + 0.5 + lineWidth, 0.0, 1.0);\n    float b1 = clamp(v_Distance.y + 0.5 - lineWidth, 0.0, 1.0);\n    float b2 = clamp(v_Distance.y + 0.5 + lineWidth, 0.0, 1.0);\n    alpha = a2 * b2 - a1 * b1;\n    alpha *= max(min(v_Distance.z + 0.5, 1.0), 0.0);\n  }\n\n  if (u_Dash + u_Gap > 1.0) {\n    float travel = mod(v_Travel + u_Gap * 0.5 + u_DashOffset, u_Dash + u_Gap) - (u_Gap * 0.5);\n    float left = max(travel - 0.5, -0.5);\n    float right = min(travel + 0.5, u_Gap + 0.5);\n    alpha *= max(0.0, right - left);\n  }\n\n  gbuf_color = u_StrokeColor;\n  gbuf_color.a *= alpha * u_Opacity * u_StrokeOpacity;\n}"; // eslint-disable-line

var JOINT_TYPE;

(function (JOINT_TYPE) {
  JOINT_TYPE[JOINT_TYPE["NONE"] = 0] = "NONE";
  JOINT_TYPE[JOINT_TYPE["FILL"] = 1] = "FILL";
  JOINT_TYPE[JOINT_TYPE["JOINT_BEVEL"] = 4] = "JOINT_BEVEL";
  JOINT_TYPE[JOINT_TYPE["JOINT_MITER"] = 8] = "JOINT_MITER";
  JOINT_TYPE[JOINT_TYPE["JOINT_ROUND"] = 12] = "JOINT_ROUND";
  JOINT_TYPE[JOINT_TYPE["JOINT_CAP_BUTT"] = 16] = "JOINT_CAP_BUTT";
  JOINT_TYPE[JOINT_TYPE["JOINT_CAP_SQUARE"] = 18] = "JOINT_CAP_SQUARE";
  JOINT_TYPE[JOINT_TYPE["JOINT_CAP_ROUND"] = 20] = "JOINT_CAP_ROUND";
  JOINT_TYPE[JOINT_TYPE["FILL_EXPAND"] = 24] = "FILL_EXPAND";
  JOINT_TYPE[JOINT_TYPE["CAP_BUTT"] = 32] = "CAP_BUTT";
  JOINT_TYPE[JOINT_TYPE["CAP_SQUARE"] = 64] = "CAP_SQUARE";
  JOINT_TYPE[JOINT_TYPE["CAP_ROUND"] = 96] = "CAP_ROUND";
  JOINT_TYPE[JOINT_TYPE["CAP_BUTT2"] = 128] = "CAP_BUTT2";
})(JOINT_TYPE || (JOINT_TYPE = {}));

var stridePoints = 2;
var strideFloats = 3;
var LineVertexAttributeLocation;

(function (LineVertexAttributeLocation) {
  LineVertexAttributeLocation[LineVertexAttributeLocation["PREV"] = 0] = "PREV";
  LineVertexAttributeLocation[LineVertexAttributeLocation["POINT1"] = 1] = "POINT1";
  LineVertexAttributeLocation[LineVertexAttributeLocation["POINT2"] = 2] = "POINT2";
  LineVertexAttributeLocation[LineVertexAttributeLocation["NEXT"] = 3] = "NEXT";
  LineVertexAttributeLocation[LineVertexAttributeLocation["VERTEX_JOINT"] = 4] = "VERTEX_JOINT";
  LineVertexAttributeLocation[LineVertexAttributeLocation["VERTEX_NUM"] = 5] = "VERTEX_NUM";
  LineVertexAttributeLocation[LineVertexAttributeLocation["TRAVEL"] = 6] = "TRAVEL";
})(LineVertexAttributeLocation || (LineVertexAttributeLocation = {}));

var Uniform;

(function (Uniform) {
  Uniform["MODEL_MATRIX"] = "u_ModelMatrix";
  Uniform["COLOR"] = "u_Color";
  Uniform["STROKE_COLOR"] = "u_StrokeColor";
  Uniform["STROKE_WIDTH"] = "u_StrokeWidth";
  Uniform["OPACITY"] = "u_Opacity";
  Uniform["FILL_OPACITY"] = "u_FillOpacity";
  Uniform["STROKE_OPACITY"] = "u_StrokeOpacity";
  Uniform["EXPAND"] = "u_Expand";
  Uniform["MITER_LIMIT"] = "u_MiterLimit";
  Uniform["SCALE_MODE"] = "u_ScaleMode";
  Uniform["ALIGNMENT"] = "u_Alignment";
  Uniform["PICKING_COLOR"] = "u_PickingColor";
  Uniform["DASH"] = "u_Dash";
  Uniform["GAP"] = "u_Gap";
  Uniform["DASH_OFFSET"] = "u_DashOffset";
  Uniform["VISIBLE"] = "u_Visible";
  Uniform["Z_INDEX"] = "u_ZIndex";
})(Uniform || (Uniform = {}));

var LineMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(LineMesh, _Instanced);

  var _super = _createSuper(LineMesh);

  function LineMesh() {
    _classCallCheck(this, LineMesh);

    return _super.apply(this, arguments);
  }

  _createClass(LineMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      return false;
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      _get(_getPrototypeOf(LineMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var _object$parsedStyle = object.parsedStyle,
          fill = _object$parsedStyle.fill,
          stroke = _object$parsedStyle.stroke,
          opacity = _object$parsedStyle.opacity,
          fillOpacity = _object$parsedStyle.fillOpacity,
          strokeOpacity = _object$parsedStyle.strokeOpacity,
          lineWidth = _object$parsedStyle.lineWidth,
          anchor = _object$parsedStyle.anchor,
          _object$parsedStyle$l = _object$parsedStyle.lineDash,
          lineDash = _object$parsedStyle$l === void 0 ? [] : _object$parsedStyle$l,
          _object$parsedStyle$l2 = _object$parsedStyle.lineDashOffset,
          lineDashOffset = _object$parsedStyle$l2 === void 0 ? 0 : _object$parsedStyle$l2,
          visibility = _object$parsedStyle.visibility;

      if (name === 'lineJoin' || name === 'lineCap' || name === 'lineDash' || object.nodeName === Shape.CIRCLE && name === 'r' || object.nodeName === Shape.ELLIPSE && (name === 'rx' || name === 'ry') || object.nodeName === Shape.RECT && (name === 'width' || name === 'height' || name === 'radius') || object.nodeName === Shape.LINE && (name === 'x1' || name === 'y1' || name === 'x2' || name === 'y2') || object.nodeName === Shape.POLYLINE && name === 'points' || object.nodeName === Shape.POLYGON && name === 'points' || object.nodeName === Shape.PATH && name === 'path') {
        // need re-calc geometry
        this.material.geometryDirty = true;
        this.material.programDirty = true;
      } else if (name === 'stroke') {
        var strokeColor = [0, 0, 0, 0];

        if ((stroke === null || stroke === void 0 ? void 0 : stroke.type) === PARSED_COLOR_TYPE.Constant) {
          strokeColor = stroke.value;
        }

        this.material.setUniforms(_defineProperty({}, Uniform.STROKE_COLOR, strokeColor));
      } else if (name === 'opacity') {
        this.material.setUniforms(_defineProperty({}, Uniform.OPACITY, opacity));
      } else if (name === 'fillOpacity') {
        this.material.setUniforms(_defineProperty({}, Uniform.FILL_OPACITY, fillOpacity));
      } else if (name === 'strokeOpacity') {
        this.material.setUniforms(_defineProperty({}, Uniform.STROKE_OPACITY, strokeOpacity));
      } else if (name === 'lineWidth') {
        this.material.setUniforms(_defineProperty({}, Uniform.STROKE_WIDTH, lineWidth.value));
      } else if (name === 'anchor' || name === 'modelMatrix') {
        var translateX = 0;
        var translateY = 0;
        var contentBounds = object.getGeometryBounds();

        if (contentBounds) {
          var halfExtents = contentBounds.halfExtents;
          translateX = -halfExtents[0] * anchor[0] * 2;
          translateY = -halfExtents[1] * anchor[1] * 2;
        }

        var m = create();
        mul(m, object.getWorldTransform(), // apply anchor
        fromTranslation(m, fromValues$1(translateX, translateY, 0)));
        this.material.setUniforms(_defineProperty({}, Uniform.MODEL_MATRIX, m));
      } else if (name === 'visibility') {
        this.material.setUniforms(_defineProperty({}, Uniform.VISIBLE, visibility === 'visible' ? 1 : 0));
      } else if (name === 'lineDash') {
        var _this$material$setUni8;

        this.material.setUniforms((_this$material$setUni8 = {}, _defineProperty(_this$material$setUni8, Uniform.DASH, lineDash[0] || 0), _defineProperty(_this$material$setUni8, Uniform.GAP, lineDash[1] || 0), _this$material$setUni8));
      } else if (name === 'lineDashOffset') {
        this.material.setUniforms(_defineProperty({}, Uniform.DASH_OFFSET, lineDashOffset));
      }
    }
  }, {
    key: "changeRenderOrder",
    value: function changeRenderOrder(object, renderOrder) {
      if (this.material) {
        this.material.setUniforms(_defineProperty({}, Uniform.Z_INDEX, renderOrder * RENDER_ORDER_SCALE));
      }
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      var _instance$renderable, _this$material$setUni11;

      this.material.vertexShader = vert$2;
      this.material.fragmentShader = frag$2;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(LineVertexAttributeLocation));
      var instance = objects[0];
      var _instance$parsedStyle = instance.parsedStyle,
          fill = _instance$parsedStyle.fill,
          stroke = _instance$parsedStyle.stroke,
          opacity = _instance$parsedStyle.opacity,
          fillOpacity = _instance$parsedStyle.fillOpacity,
          strokeOpacity = _instance$parsedStyle.strokeOpacity,
          lineWidth = _instance$parsedStyle.lineWidth,
          anchor = _instance$parsedStyle.anchor,
          _instance$parsedStyle2 = _instance$parsedStyle.lineDash,
          lineDash = _instance$parsedStyle2 === void 0 ? [] : _instance$parsedStyle2,
          _instance$parsedStyle3 = _instance$parsedStyle.lineDashOffset,
          lineDashOffset = _instance$parsedStyle3 === void 0 ? 0 : _instance$parsedStyle3,
          visibility = _instance$parsedStyle.visibility;
      var fillColor = [0, 0, 0, 0];

      if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
        fillColor = fill.value;
      }

      var strokeColor = [0, 0, 0, 0];

      if ((stroke === null || stroke === void 0 ? void 0 : stroke.type) === PARSED_COLOR_TYPE.Constant) {
        strokeColor = stroke.value;
      } // @ts-ignore


      var encodedPickingColor = ((_instance$renderable = instance.renderable3D) === null || _instance$renderable === void 0 ? void 0 : _instance$renderable.encodedPickingColor) || [0, 0, 0];
      var translateX = 0;
      var translateY = 0;
      var contentBounds = instance.getGeometryBounds();

      if (contentBounds) {
        var halfExtents = contentBounds.halfExtents;
        translateX = -halfExtents[0] * anchor[0] * 2;
        translateY = -halfExtents[1] * anchor[1] * 2;
      }

      var m = create();
      mul(m, instance.getWorldTransform(), // apply anchor
      fromTranslation(m, fromValues$1(translateX, translateY, 0)));
      this.material.setUniforms((_this$material$setUni11 = {}, _defineProperty(_this$material$setUni11, Uniform.MODEL_MATRIX, m), _defineProperty(_this$material$setUni11, Uniform.COLOR, fillColor), _defineProperty(_this$material$setUni11, Uniform.STROKE_COLOR, strokeColor), _defineProperty(_this$material$setUni11, Uniform.STROKE_WIDTH, lineWidth.value), _defineProperty(_this$material$setUni11, Uniform.OPACITY, opacity), _defineProperty(_this$material$setUni11, Uniform.FILL_OPACITY, fillOpacity), _defineProperty(_this$material$setUni11, Uniform.STROKE_OPACITY, strokeOpacity), _defineProperty(_this$material$setUni11, Uniform.EXPAND, 1), _defineProperty(_this$material$setUni11, Uniform.MITER_LIMIT, 5), _defineProperty(_this$material$setUni11, Uniform.SCALE_MODE, 1), _defineProperty(_this$material$setUni11, Uniform.ALIGNMENT, 0.5), _defineProperty(_this$material$setUni11, Uniform.PICKING_COLOR, encodedPickingColor), _defineProperty(_this$material$setUni11, Uniform.DASH, lineDash[0] || 0), _defineProperty(_this$material$setUni11, Uniform.GAP, lineDash[1] || 0), _defineProperty(_this$material$setUni11, Uniform.DASH_OFFSET, lineDashOffset), _defineProperty(_this$material$setUni11, Uniform.VISIBLE, visibility === 'visible' ? 1 : 0), _defineProperty(_this$material$setUni11, Uniform.Z_INDEX, instance.sortable.renderOrder * RENDER_ORDER_SCALE), _this$material$setUni11));
      this.material.cullMode = CullMode.None;
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var instance = objects[0]; // use triangles for Polygon

      var _updateBuffer = updateBuffer(instance),
          pointsBuffer = _updateBuffer.pointsBuffer,
          travelBuffer = _updateBuffer.travelBuffer,
          instancedCount = _updateBuffer.instancedCount;

      this.geometry.setVertexBuffer({
        bufferIndex: 0,
        byteStride: 4 * (3 + 3 + 3 + 3),
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          byteStride: 4 * 3,
          location: LineVertexAttributeLocation.PREV,
          divisor: 1
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 3,
          byteStride: 4 * 3,
          location: LineVertexAttributeLocation.POINT1,
          divisor: 1
        }, {
          format: Format.F32_R,
          bufferByteOffset: 4 * 5,
          byteStride: 4 * 3,
          location: LineVertexAttributeLocation.VERTEX_JOINT,
          divisor: 1
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 6,
          byteStride: 4 * 3,
          location: LineVertexAttributeLocation.POINT2,
          divisor: 1
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 9,
          byteStride: 4 * 3,
          location: LineVertexAttributeLocation.NEXT,
          divisor: 1
        }],
        data: new Float32Array(pointsBuffer)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: 1,
        byteStride: 4 * 1,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_R,
          bufferByteOffset: 4 * 0,
          byteStride: 4 * 1,
          location: LineVertexAttributeLocation.VERTEX_NUM,
          divisor: 0
        }],
        data: new Float32Array([0, 1, 2, 3, 4, 5, 6, 7, 8])
      });
      this.geometry.setVertexBuffer({
        bufferIndex: 2,
        byteStride: 4 * 1,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_R,
          bufferByteOffset: 4 * 0,
          byteStride: 4 * 1,
          location: LineVertexAttributeLocation.TRAVEL,
          divisor: 1
        }],
        data: new Float32Array(travelBuffer)
      });
      this.geometry.vertexCount = 15;
      this.geometry.instancedCount = instancedCount;
      this.geometry.setIndexBuffer(new Uint32Array([0, 2, 1, 0, 3, 2, 4, 6, 5, 4, 7, 6, 4, 7, 8]));
    }
  }]);

  return LineMesh;
}(Instanced);

LineMesh = __decorate([injectable()], LineMesh);

function curveTo(cpX, cpY, cpX2, cpY2, toX, toY, points) {
  var fromX = points[points.length - 2];
  var fromY = points[points.length - 1];
  points.length -= 2;
  var l = CubicUtil.length(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY);
  var n = segmentsCount(l);
  var dt = 0;
  var dt2 = 0;
  var dt3 = 0;
  var t2 = 0;
  var t3 = 0;
  points.push(fromX, fromY);

  for (var i = 1, j = 0; i <= n; ++i) {
    j = i / n;
    dt = 1 - j;
    dt2 = dt * dt;
    dt3 = dt2 * dt;
    t2 = j * j;
    t3 = t2 * j;
    points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
  }
}
var maxLength = 10;
var minSegments = 8;
var maxSegments = 2048;

function segmentsCount(length) {
  // if (!adaptive || !length || isNaN(length)) {
  //   return defaultSegments;
  // }
  var result = Math.ceil(length / maxLength);

  if (result < minSegments) {
    result = minSegments;
  } else if (result > maxSegments) {
    result = maxSegments;
  }

  return result;
}

function updateBuffer(object) {
  var needEarcut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _object$parsedStyle2 = object.parsedStyle,
      lineCap = _object$parsedStyle2.lineCap,
      lineJoin = _object$parsedStyle2.lineJoin,
      defX = _object$parsedStyle2.defX,
      defY = _object$parsedStyle2.defY;
  var points = [];
  var triangles = [];

  if (object.nodeName === Shape.POLYLINE || object.nodeName === Shape.POLYGON) {
    points = object.parsedStyle.points.points.reduce(function (prev, cur) {
      prev.push(cur[0] - defX, cur[1] - defY);
      return prev;
    }, []); // close polygon, dealing with extra joint

    if (object.nodeName === Shape.POLYGON) {
      if (needEarcut) {
        // use earcut for triangulation
        triangles = earcut(points, [], 2);
        return {
          pointsBuffer: points,
          travelBuffer: [],
          triangles: triangles,
          instancedCount: Math.round(points.length / stridePoints)
        };
      } else {
        var _points;

        points.push(points[0], points[1]);

        (_points = points).push.apply(_points, _toConsumableArray(addTailSegment(points[0], points[1], points[2], points[3])));
      }
    }
  } else if (object.nodeName === Shape.PATH || object.nodeName === Shape.CIRCLE || object.nodeName === Shape.ELLIPSE || object.nodeName === Shape.RECT) {
    var path;

    if (object.nodeName !== Shape.PATH) {
      path = parsePath(convertToPath(object));
      defX = path.rect.x;
      defY = path.rect.y;
    } else {
      path = object.parsedStyle.path;
    }

    var _path = path,
        zCommandIndexes = _path.zCommandIndexes;

    var curve = _toConsumableArray(path.curve).map(function (c, i) {
      return zCommandIndexes.includes(i) ? ['Z'] : c;
    });

    var startPointIndex = -1;
    curve.forEach(function (_ref) {
      var _ref2 = _toArray(_ref),
          command = _ref2[0],
          params = _ref2.slice(1);

      if (command === 'M') {
        startPointIndex = points.length;
        points.push(params[0] - defX, params[1] - defY);
      } else if (command === 'C') {
        curveTo(params[0] - defX, params[1] - defY, params[2] - defX, params[3] - defY, params[4] - defX, params[5] - defY, points);
      } else if (command === 'Z' && (object.nodeName === Shape.PATH || object.nodeName === Shape.RECT)) {
        var _points2;

        points.push(points[startPointIndex], points[startPointIndex + 1]);

        (_points2 = points).push.apply(_points2, _toConsumableArray(addTailSegment(points[startPointIndex], points[startPointIndex + 1], points[startPointIndex + 2], points[startPointIndex + 3])));
      }
    });

    if (needEarcut) {
      // use earcut for triangulation
      triangles = earcut(points, [], 2);
      return {
        pointsBuffer: points,
        travelBuffer: [],
        triangles: triangles,
        instancedCount: Math.round(points.length / stridePoints)
      };
    }
  }

  var jointType = getJointType(lineJoin);
  var capType = getCapType(lineCap);
  var endJoint = capType;

  if (capType === JOINT_TYPE.CAP_ROUND) {
    endJoint = JOINT_TYPE.JOINT_CAP_ROUND;
  }

  if (capType === JOINT_TYPE.CAP_BUTT) {
    endJoint = JOINT_TYPE.JOINT_CAP_BUTT;
  }

  if (capType === JOINT_TYPE.CAP_SQUARE) {
    endJoint = JOINT_TYPE.JOINT_CAP_SQUARE;
  }

  var j = (Math.round(0 / stridePoints) + 2) * strideFloats; // const needDash = !isNil(lineDash);

  var dist = 0;
  var pointsBuffer = [];
  var travelBuffer = [];

  for (var i = 0; i < points.length; i += stridePoints) {
    // calc travel
    // if (needDash) {
    if (i > 1) {
      dist += Math.sqrt(Math.pow(points[i] - points[i - 2], 2) + Math.pow(points[i + 1] - points[i + 1 - 2], 2));
    }

    travelBuffer.push(dist); // } else {
    //   travelBuffer.push(0);
    // }

    pointsBuffer[j++] = points[i];
    pointsBuffer[j++] = points[i + 1];
    pointsBuffer[j] = jointType;

    if (i == 0 && capType !== JOINT_TYPE.CAP_ROUND) {
      pointsBuffer[j] += capType;
    }

    if (i + stridePoints * 2 >= points.length) {
      pointsBuffer[j] += endJoint - jointType;
    } else if (i + stridePoints >= points.length) {
      pointsBuffer[j] = 0;
    }

    j++;
  }

  pointsBuffer[j++] = points[points.length - 4];
  pointsBuffer[j++] = points[points.length - 3];
  pointsBuffer[j++] = 0;
  pointsBuffer[0] = points[0];
  pointsBuffer[1] = points[1];
  pointsBuffer[2] = 0;
  pointsBuffer[3] = points[2];
  pointsBuffer[4] = points[3];
  pointsBuffer[5] = capType === JOINT_TYPE.CAP_ROUND ? capType : 0;
  var instancedCount = Math.round(points.length / stridePoints);
  return {
    pointsBuffer: pointsBuffer,
    travelBuffer: travelBuffer,
    triangles: triangles,
    instancedCount: instancedCount
  };
}

function getJointType(lineJoin) {
  var joint;

  switch (lineJoin) {
    case LineJoin.BEVEL:
      joint = JOINT_TYPE.JOINT_BEVEL;
      break;

    case LineJoin.ROUND:
      joint = JOINT_TYPE.JOINT_ROUND;
      break;

    default:
      joint = JOINT_TYPE.JOINT_MITER;
      break;
  }

  return joint;
}

function getCapType(lineCap) {
  var cap;

  switch (lineCap) {
    case LineCap.SQUARE:
      cap = JOINT_TYPE.CAP_SQUARE;
      break;

    case LineCap.ROUND:
      cap = JOINT_TYPE.CAP_ROUND;
      break;

    default:
      cap = JOINT_TYPE.CAP_BUTT;
      break;
  }

  return cap;
}

function addTailSegment(x1, y1) {
  var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x1;
  var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : y1;
  var vec = [x2 - x1, y2 - y1];
  var length = 0.01;
  return [x1 + vec[0] * length, y1 + vec[1] * length];
}

var meshVert = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  mat4 u_ModelMatrix;\n  vec4 u_Color;\n  vec3 u_PickingColor;\n  float u_Opacity;\n  float u_FillOpacity;\n  float u_Visible;\n  float u_ZIndex;\n};\n\nlayout(location = POSITION) in vec2 a_Position;\n\nout vec4 v_PickingResult;\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\n\nvoid main() {\n  gl_Position = u_ProjectionMatrix * u_ViewMatrix * u_ModelMatrix * vec4(a_Position, u_ZIndex, 1.0);\n\n  setPickingColor(u_PickingColor.xyz);\n}"; // eslint-disable-line

var meshFrag = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  mat4 u_ModelMatrix;\n  vec4 u_Color;\n  vec3 u_PickingColor;\n  float u_Opacity;\n  float u_FillOpacity;\n  float u_Visible;\n  float u_ZIndex;\n};\n\nin vec4 v_PickingResult;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n\nvoid main(){\n  if (u_Visible < 1.0) {\n    discard;\n  }\n\n  gbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\n  gbuf_color = u_Color;\n  gbuf_color.a = gbuf_color.a * u_Opacity * u_FillOpacity;\n}"; // eslint-disable-line

var MeshVertexAttributeLocation;

(function (MeshVertexAttributeLocation) {
  MeshVertexAttributeLocation[MeshVertexAttributeLocation["POSITION"] = 0] = "POSITION";
})(MeshVertexAttributeLocation || (MeshVertexAttributeLocation = {}));

var FillMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(FillMesh, _Instanced);

  var _super = _createSuper(FillMesh);

  function FillMesh() {
    _classCallCheck(this, FillMesh);

    return _super.apply(this, arguments);
  }

  _createClass(FillMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      return false;
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var instance = objects[0]; // use triangles for Polygon

      var _updateBuffer = updateBuffer(instance, true),
          triangles = _updateBuffer.triangles,
          pointsBuffer = _updateBuffer.pointsBuffer;

      this.geometry.setVertexBuffer({
        bufferIndex: 0,
        byteStride: 4 * 2,
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          byteStride: 4 * 2,
          location: MeshVertexAttributeLocation.POSITION
        }],
        data: new Float32Array(pointsBuffer)
      });
      this.geometry.vertexCount = triangles.length;
      this.geometry.setIndexBuffer(new Uint32Array(triangles));
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      var _instance$renderable, _this$material$setUni;

      this.material.vertexShader = meshVert;
      this.material.fragmentShader = meshFrag;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(MeshVertexAttributeLocation));
      var instance = objects[0];
      var _instance$parsedStyle = instance.parsedStyle,
          fill = _instance$parsedStyle.fill,
          opacity = _instance$parsedStyle.opacity,
          fillOpacity = _instance$parsedStyle.fillOpacity,
          anchor = _instance$parsedStyle.anchor,
          visibility = _instance$parsedStyle.visibility;
      var fillColor = [0, 0, 0, 0];

      if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
        fillColor = fill.value;
      } // @ts-ignore


      var encodedPickingColor = ((_instance$renderable = instance.renderable3D) === null || _instance$renderable === void 0 ? void 0 : _instance$renderable.encodedPickingColor) || [0, 0, 0];
      var translateX = 0;
      var translateY = 0;
      var contentBounds = instance.getGeometryBounds();

      if (contentBounds) {
        var halfExtents = contentBounds.halfExtents;
        translateX = -halfExtents[0] * anchor[0] * 2;
        translateY = -halfExtents[1] * anchor[1] * 2;
      }

      var m = create();
      mul(m, instance.getWorldTransform(), // apply anchor
      fromTranslation(m, fromValues$1(translateX, translateY, 0)));
      this.material.setUniforms((_this$material$setUni = {}, _defineProperty(_this$material$setUni, Uniform.MODEL_MATRIX, m), _defineProperty(_this$material$setUni, Uniform.COLOR, fillColor), _defineProperty(_this$material$setUni, Uniform.PICKING_COLOR, encodedPickingColor), _defineProperty(_this$material$setUni, Uniform.OPACITY, opacity), _defineProperty(_this$material$setUni, Uniform.FILL_OPACITY, fillOpacity), _defineProperty(_this$material$setUni, Uniform.VISIBLE, visibility === 'visible' ? 1 : 0), _defineProperty(_this$material$setUni, Uniform.Z_INDEX, instance.sortable.renderOrder * RENDER_ORDER_SCALE), _this$material$setUni));
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      _get(_getPrototypeOf(FillMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var _object$parsedStyle = object.parsedStyle,
          fill = _object$parsedStyle.fill,
          opacity = _object$parsedStyle.opacity,
          fillOpacity = _object$parsedStyle.fillOpacity,
          anchor = _object$parsedStyle.anchor,
          visibility = _object$parsedStyle.visibility;

      if (name === 'lineJoin' || name === 'lineCap' || object.nodeName === Shape.RECT && (name === 'width' || name === 'height' || name === 'radius') || object.nodeName === Shape.LINE && (name === 'x1' || name === 'y1' || name === 'x2' || name === 'y2') || object.nodeName === Shape.POLYLINE && name === 'points' || object.nodeName === Shape.POLYGON && name === 'points' || object.nodeName === Shape.PATH && name === 'path') {
        // need re-calc geometry
        this.material.geometryDirty = true;
        this.material.programDirty = true;
      } else if (name === 'fill') {
        var fillColor = [0, 0, 0, 0];

        if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
          fillColor = fill.value;
        }

        this.material.setUniforms(_defineProperty({}, Uniform.COLOR, fillColor));
      } else if (name === 'opacity') {
        this.material.setUniforms(_defineProperty({}, Uniform.OPACITY, opacity));
      } else if (name === 'fillOpacity') {
        this.material.setUniforms(_defineProperty({}, Uniform.FILL_OPACITY, fillOpacity));
      } else if (name === 'anchor' || name === 'modelMatrix') {
        var translateX = 0;
        var translateY = 0;
        var contentBounds = object.getGeometryBounds();

        if (contentBounds) {
          var halfExtents = contentBounds.halfExtents;
          translateX = -halfExtents[0] * anchor[0] * 2;
          translateY = -halfExtents[1] * anchor[1] * 2;
        }

        var m = create();
        mul(m, object.getWorldTransform(), // apply anchor
        fromTranslation(m, fromValues$1(translateX, translateY, 0)));
        this.material.setUniforms(_defineProperty({}, Uniform.MODEL_MATRIX, m));
      } else if (name === 'visibility') {
        this.material.setUniforms(_defineProperty({}, Uniform.VISIBLE, visibility === 'visible' ? 1 : 0));
      }
    }
  }, {
    key: "changeRenderOrder",
    value: function changeRenderOrder(object, renderOrder) {
      if (this.material) {
        this.material.setUniforms(_defineProperty({}, Uniform.Z_INDEX, renderOrder * RENDER_ORDER_SCALE));
      }
    }
  }]);

  return FillMesh;
}(Instanced);

FillMesh = __decorate([injectable()], FillMesh);

var vert$3 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(location = MODEL_MATRIX0) in vec4 a_ModelMatrix0;\nlayout(location = MODEL_MATRIX1) in vec4 a_ModelMatrix1;\nlayout(location = MODEL_MATRIX2) in vec4 a_ModelMatrix2;\nlayout(location = MODEL_MATRIX3) in vec4 a_ModelMatrix3;\nlayout(location = COLOR) in vec4 a_Color;\nlayout(location = STROKE_COLOR) in vec4 a_StrokeColor;\nlayout(location = PACKED_STYLE1) in vec4 a_StylePacked1;\nlayout(location = PACKED_STYLE2) in vec4 a_StylePacked2;\nlayout(location = PICKING_COLOR) in vec4 a_PickingColor;\nlayout(location = ANCHOR) in vec2 a_Anchor;\n\nout vec4 v_PickingResult;\nout vec4 v_Color;\nout vec4 v_StrokeColor;\nout vec4 v_StylePacked1;\nout vec4 v_StylePacked2;\n\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\nvec4 project(vec4 pos, mat4 pm, mat4 vm, mat4 mm) {\n  return pm * vm * mm * pos;\n}\n\nlayout(location = SIZE) in vec2 a_Size;\n\n#ifdef USE_UV\n  layout(location = UV) in vec2 a_Uv;\n  out vec2 v_Uv;\n#endif\n\nvoid main() {\n  mat4 u_ModelMatrix = mat4(a_ModelMatrix0, a_ModelMatrix1, a_ModelMatrix2, a_ModelMatrix3);\nvec4 u_StrokeColor = a_StrokeColor;\nfloat u_Opacity = a_StylePacked1.x;\nfloat u_FillOpacity = a_StylePacked1.y;\nfloat u_StrokeOpacity = a_StylePacked1.z;\nfloat u_StrokeWidth = a_StylePacked1.w;\nfloat u_ZIndex = a_PickingColor.w;\n\nsetPickingColor(a_PickingColor.xyz);\n\nv_Color = a_Color;\nv_StrokeColor = a_StrokeColor;\nv_StylePacked1 = a_StylePacked1;\nv_StylePacked2 = a_StylePacked2;\n\n#ifdef CLIPSPACE_NEAR_ZERO\n    gl_Position.z = gl_Position.z * 0.5 + 0.5;\n#endif\n\n  vec2 offset = (a_Uv - a_Anchor.xy) * a_Size;\n\n  gl_Position = project(vec4(offset, u_ZIndex, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n\n  #ifdef USE_UV\n  v_Uv = a_Uv;\n  #ifdef VIEWPORT_ORIGIN_TL\n    v_Uv.y = 1.0 - v_Uv.y;\n  #endif\n#endif\n\n}"; // eslint-disable-line

var frag$3 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\n\nin vec4 v_PickingResult;\nin vec4 v_Color;\nin vec4 v_StrokeColor;\nin vec4 v_StylePacked1;\nin vec4 v_StylePacked2;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n#ifdef USE_UV\n  in vec2 v_Uv;\n#endif\n#ifdef USE_MAP\n  uniform sampler2D u_Map;\n#endif\n\nvoid main() {\n  vec4 u_Color = v_Color;\nvec4 u_StrokeColor = v_StrokeColor;\nfloat u_Opacity = v_StylePacked1.x;\nfloat u_FillOpacity = v_StylePacked1.y;\nfloat u_StrokeOpacity = v_StylePacked1.z;\nfloat u_StrokeWidth = v_StylePacked1.w;\nfloat u_Visible = v_StylePacked2.x;\n\ngbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\nif (u_Visible < 1.0) {\n    discard;\n}\n  #ifdef USE_MAP\n  vec4 texelColor = texture(SAMPLER_2D(u_Map), v_Uv);\n  u_Color = texelColor;\n#endif\n\n  gbuf_color = u_Color;\n  gbuf_color.a = gbuf_color.a * u_Opacity;\n}"; // eslint-disable-line

var ImageVertexAttributeLocation;

(function (ImageVertexAttributeLocation) {
  ImageVertexAttributeLocation[ImageVertexAttributeLocation["SIZE"] = 10] = "SIZE";
  ImageVertexAttributeLocation[ImageVertexAttributeLocation["UV"] = 11] = "UV";
})(ImageVertexAttributeLocation || (ImageVertexAttributeLocation = {}));

var ImageMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(ImageMesh, _Instanced);

  var _super = _createSuper(ImageMesh);

  function ImageMesh() {
    _classCallCheck(this, ImageMesh);

    return _super.apply(this, arguments);
  }

  _createClass(ImageMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      var shouldMerge = _get(_getPrototypeOf(ImageMesh.prototype), "shouldMerge", this).call(this, object, index);

      if (!shouldMerge) {
        return false;
      }

      if (this.instance.parsedStyle.img !== object.parsedStyle.img) {
        return false;
      }

      return true;
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      var _this = this;

      var instance = objects[0];
      var img = instance.parsedStyle.img; // @ts-ignore

      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), {}, {
        USE_UV: true,
        USE_MAP: true
      }, enumToObject(ImageVertexAttributeLocation));
      this.material.vertexShader = vert$3;
      this.material.fragmentShader = frag$3;
      var map = this.texturePool.getOrCreateTexture(this.device, img, undefined, function () {
        // need re-render
        objects.forEach(function (object) {
          var renderable = object.renderable;
          renderable.dirty = true;

          _this.renderingService.dirtify();
        });
      });
      this.material.setUniforms({
        u_Map: map
      });
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      // use default common attributes
      _get(_getPrototypeOf(ImageMesh.prototype), "createGeometry", this).call(this, objects);

      var instanced = [];
      var interleaved = [];
      var indices = [];
      objects.forEach(function (object, i) {
        var image = object;
        var offset = i * 4;
        var _image$parsedStyle = image.parsedStyle,
            widthInPixels = _image$parsedStyle.widthInPixels,
            heightInPixels = _image$parsedStyle.heightInPixels;
        instanced.push(widthInPixels, heightInPixels);
        interleaved.push(0, 0, 1, 0, 1, 1, 0, 1);
        indices.push(0 + offset, 2 + offset, 1 + offset, 0 + offset, 3 + offset, 2 + offset);
      });
      this.geometry.setIndexBuffer(new Uint32Array(indices));
      this.geometry.vertexCount = 6;
      this.geometry.setVertexBuffer({
        bufferIndex: 1,
        byteStride: 4 * 2,
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          location: ImageVertexAttributeLocation.UV
        }],
        data: new Float32Array(interleaved)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: 2,
        byteStride: 4 * 2,
        frequency: VertexBufferFrequency.PerInstance,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          location: ImageVertexAttributeLocation.SIZE
        }],
        data: new Float32Array(instanced)
      });
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      var _this2 = this;

      _get(_getPrototypeOf(ImageMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var index = this.objects.indexOf(object);
      this.updateBatchedAttribute(object, index, name, value);
      var image = object;
      var _image$parsedStyle2 = image.parsedStyle,
          widthInPixels = _image$parsedStyle2.widthInPixels,
          heightInPixels = _image$parsedStyle2.heightInPixels;

      if (name === 'width' || name === 'height') {
        this.geometry.updateVertexBuffer(2, ImageVertexAttributeLocation.SIZE, index, new Uint8Array(new Float32Array([widthInPixels, heightInPixels]).buffer));
      } else if (name === 'img') {
        var map = this.texturePool.getOrCreateTexture(this.device, value, undefined, function () {
          // need re-render
          var renderable = object.renderable;
          renderable.dirty = true;

          _this2.renderingService.dirtify();
        });
        this.material.setUniforms({
          u_Map: map
        });
      }
    }
  }]);

  return ImageMesh;
}(Instanced);

ImageMesh = __decorate([injectable()], ImageMesh);

// borrow from mapbox/src/symbol
function createImage(image, _ref, channels, data) {
  var width = _ref.width,
      height = _ref.height;

  if (!data) {
    data = new Uint8Array(width * height * channels);
  } else if (data.length !== width * height * channels) {
    throw new RangeError('mismatched image size');
  }

  image.width = width;
  image.height = height;
  image.data = data;
  return image;
}

function resizeImage(image, _ref2, channels) {
  var width = _ref2.width,
      height = _ref2.height;

  if (width === image.width && height === image.height) {
    return;
  }

  var newImage = createImage({}, {
    width: width,
    height: height
  }, channels);
  copyImage(image, newImage, {
    x: 0,
    y: 0
  }, {
    x: 0,
    y: 0
  }, {
    width: Math.min(image.width, width),
    height: Math.min(image.height, height)
  }, channels);
  image.width = width;
  image.height = height;
  image.data = newImage.data;
}

function copyImage(srcImg, dstImg, srcPt, dstPt, size, channels) {
  if (size.width === 0 || size.height === 0) {
    return dstImg;
  }

  if (size.width > srcImg.width || size.height > srcImg.height || srcPt.x > srcImg.width - size.width || srcPt.y > srcImg.height - size.height) {
    throw new RangeError('out of range source coordinates for image copy');
  }

  if (size.width > dstImg.width || size.height > dstImg.height || dstPt.x > dstImg.width - size.width || dstPt.y > dstImg.height - size.height) {
    throw new RangeError('out of range destination coordinates for image copy');
  }

  var srcData = srcImg.data;
  var dstData = dstImg.data;

  for (var y = 0; y < size.height; y++) {
    var srcOffset = ((srcPt.y + y) * srcImg.width + srcPt.x) * channels;
    var dstOffset = ((dstPt.y + y) * dstImg.width + dstPt.x) * channels;

    for (var i = 0; i < size.width * channels; i++) {
      dstData[dstOffset + i] = srcData[srcOffset + i];
    }
  }

  return dstImg;
}

var AlphaImage = /*#__PURE__*/function () {
  function AlphaImage(size, data) {
    _classCallCheck(this, AlphaImage);

    this.width = void 0;
    this.height = void 0;
    this.data = void 0;
    createImage(this, size, 1, data);
  }

  _createClass(AlphaImage, [{
    key: "resize",
    value: function resize(size) {
      resizeImage(this, size, 1);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new AlphaImage({
        width: this.width,
        height: this.height
      }, new Uint8Array(this.data));
    }
  }], [{
    key: "copy",
    value: function copy(srcImg, dstImg, srcPt, dstPt, size) {
      copyImage(srcImg, dstImg, srcPt, dstPt, size, 1);
    }
  }]);

  return AlphaImage;
}();

// @see https://github.com/antvis/g/issues/836

function potpack(boxes) {
  // calculate total box area and maximum box width
  var area = 0;
  var maxWidth = 0;

  var _iterator = _createForOfIteratorHelper(boxes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var box = _step.value;
      area += box.w * box.h;
      maxWidth = Math.max(maxWidth, box.w);
    } // sort the boxes for insertion by height, descending

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  boxes.sort(function (a, b) {
    return b.h - a.h;
  }); // aim for a squarish resulting container,
  // slightly adjusted for sub-100% space utilization

  var startWidth = Math.max(Math.ceil(Math.sqrt(area / 0.95)), maxWidth); // start with a single empty space, unbounded at the bottom

  var spaces = [{
    x: 0,
    y: 0,
    w: startWidth,
    h: Infinity
  }];
  var width = 0;
  var height = 0;

  var _iterator2 = _createForOfIteratorHelper(boxes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _box = _step2.value;

      // look through spaces backwards so that we check smaller spaces first
      for (var i = spaces.length - 1; i >= 0; i--) {
        var space = spaces[i]; // look for empty spaces that can accommodate the current box

        if (_box.w > space.w || _box.h > space.h) continue; // found the space; add the box to its top-left corner
        // |-------|-------|
        // |  box  |       |
        // |_______|       |
        // |         space |
        // |_______________|

        _box.x = space.x;
        _box.y = space.y;
        height = Math.max(height, _box.y + _box.h);
        width = Math.max(width, _box.x + _box.w);

        if (_box.w === space.w && _box.h === space.h) {
          // space matches the box exactly; remove it
          var last = spaces.pop();
          if (i < spaces.length) spaces[i] = last;
        } else if (_box.h === space.h) {
          // space matches the box height; update it accordingly
          // |-------|---------------|
          // |  box  | updated space |
          // |_______|_______________|
          space.x += _box.w;
          space.w -= _box.w;
        } else if (_box.w === space.w) {
          // space matches the box width; update it accordingly
          // |---------------|
          // |      box      |
          // |_______________|
          // | updated space |
          // |_______________|
          space.y += _box.h;
          space.h -= _box.h;
        } else {
          // otherwise the box splits the space into two spaces
          // |-------|-----------|
          // |  box  | new space |
          // |_______|___________|
          // | updated space     |
          // |___________________|
          spaces.push({
            x: space.x + _box.w,
            y: space.y,
            w: space.w - _box.w,
            h: _box.h
          });
          space.y += _box.h;
          space.h -= _box.h;
        }

        break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    w: width,
    h: height,
    fill: area / (width * height) || 0 // space utilization

  };
}

var padding = 1;
/**
 * Merge SDFs into a large squared atlas with `potpack`,
 * because on WebGL1 context, all textures are resized to a power of two to produce the best quality.
 *
 * @see https://doc.babylonjs.com/advanced_topics/webGL2#power-of-two-textures
 */

var GlyphAtlas = /*#__PURE__*/_createClass(function GlyphAtlas(stacks) {
  _classCallCheck(this, GlyphAtlas);

  this.image = void 0;
  this.positions = void 0;
  var positions = {};
  var bins = [];

  for (var stack in stacks) {
    var glyphs = stacks[stack]; // @ts-ignore

    var stackPositions = positions[stack] = {};

    for (var id in glyphs) {
      var src = glyphs[+id];
      if (!src || src.bitmap.width === 0 || src.bitmap.height === 0) continue;
      var bin = {
        x: 0,
        y: 0,
        w: src.bitmap.width + 2 * padding,
        h: src.bitmap.height + 2 * padding
      };
      bins.push(bin); // @ts-ignore

      stackPositions[id] = {
        rect: bin,
        metrics: src.metrics
      };
    }
  }

  var _potpack = potpack(bins),
      w = _potpack.w,
      h = _potpack.h;

  var image = new AlphaImage({
    width: w || 1,
    height: h || 1
  });

  for (var _stack in stacks) {
    var _glyphs = stacks[_stack];

    for (var _id in _glyphs) {
      var _src = _glyphs[+_id];
      if (!_src || _src.bitmap.width === 0 || _src.bitmap.height === 0) continue; // @ts-ignore

      var _bin = positions[_stack][_id].rect;
      AlphaImage.copy(_src.bitmap, image, {
        x: 0,
        y: 0
      }, {
        x: _bin.x + padding,
        y: _bin.y + padding
      }, _src.bitmap);
    }
  }

  this.image = image;
  this.positions = positions;
});

var BASE_FONT_WIDTH = 24;
var BASE_FONT_BUFFER = 3;
var fontSize = BASE_FONT_WIDTH; // Font size in pixels

var buffer = BASE_FONT_BUFFER; // Whitespace buffer around a glyph in pixels

var radius = 8; // How many pixels around the glyph shape to use for encoding distance

var cutoff = 0.25; // How much of the radius (relative) is used for the inside part the glyph
function getDefaultCharacterSet() {
  var charSet = [];

  for (var i = 32; i < 128; i++) {
    charSet.push(String.fromCharCode(i));
  }

  return charSet;
}
/**
 * TODO: use one atlas for all fontstacks, each fontstack has one texture now
 */

var GlyphManager = /*#__PURE__*/function () {
  function GlyphManager() {
    _classCallCheck(this, GlyphManager);

    this.sdfGeneratorCache = {};
    this.textMetricsCache = {};
    this.glyphAtlas = void 0;
    this.glyphMap = {};
    this.glyphAtlasTexture = void 0;
  }

  _createClass(GlyphManager, [{
    key: "getMap",
    value: function getMap() {
      return this.glyphMap;
    }
  }, {
    key: "getAtlas",
    value: function getAtlas() {
      return this.glyphAtlas;
    }
  }, {
    key: "getAtlasTexture",
    value: function getAtlasTexture() {
      return this.glyphAtlasTexture;
    }
  }, {
    key: "layout",
    value: function layout(lines, fontStack, lineHeight, textAlign, letterSpacing, offsetX, offsetY) {
      var _this = this;

      var positionedGlyphs = [];
      var x = offsetX;
      var y = offsetY;
      var justify = textAlign === 'right' || textAlign === 'end' ? 1 : textAlign === 'left' || textAlign === 'start' ? 0 : 0.5;
      lines.forEach(function (line) {
        var lineStartIndex = positionedGlyphs.length;
        Array.from(line).forEach(function (char) {
          // fontStack
          var positions = _this.glyphMap[fontStack];
          var charCode = char.charCodeAt(0);
          var glyph = positions && positions[charCode];

          if (glyph) {
            positionedGlyphs.push({
              glyph: charCode,
              x: x,
              y: y,
              scale: 1,
              fontStack: fontStack
            });
            x += glyph.metrics.advance + letterSpacing;
          }
        });
        var lineWidth = x - letterSpacing;

        for (var i = lineStartIndex; i < positionedGlyphs.length; i++) {
          positionedGlyphs[i].x = positionedGlyphs[i].x - justify * lineWidth;
        }

        x = 0;
        y += lineHeight;
      });
      return positionedGlyphs;
    }
  }, {
    key: "generateAtlas",
    value: function generateAtlas() {
      var _this2 = this;

      var fontStack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var fontFamily = arguments.length > 1 ? arguments[1] : undefined;
      var fontWeight = arguments.length > 2 ? arguments[2] : undefined;
      var fontStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var text = arguments.length > 4 ? arguments[4] : undefined;
      var device = arguments.length > 5 ? arguments[5] : undefined;
      var newChars = [];

      if (!this.glyphMap[fontStack]) {
        newChars = getDefaultCharacterSet();
      }

      var existedChars = Object.keys(this.glyphMap[fontStack] || {});
      Array.from(new Set(text.split(''))).forEach(function (char) {
        if (existedChars.indexOf(char.charCodeAt(0).toString()) === -1) {
          newChars.push(char);
        }
      });

      if (newChars.length) {
        var glyphMap = newChars.map(function (char) {
          return _this2.generateSDF(fontStack, fontFamily, fontWeight.toString(), fontStyle, char);
        }).reduce(function (prev, cur) {
          // @ts-ignore
          prev[cur.id] = cur;
          return prev;
        }, {});
        this.glyphMap[fontStack] = _objectSpread2(_objectSpread2({}, this.glyphMap[fontStack]), glyphMap);
        this.glyphAtlas = new GlyphAtlas(this.glyphMap);
        var _this$glyphAtlas$imag = this.glyphAtlas.image,
            atlasWidth = _this$glyphAtlas$imag.width,
            atlasHeight = _this$glyphAtlas$imag.height,
            data = _this$glyphAtlas$imag.data;

        if (this.glyphAtlasTexture) {
          this.glyphAtlasTexture.destroy();
        }

        this.glyphAtlasTexture = device.createTexture(_objectSpread2(_objectSpread2({}, makeTextureDescriptor2D(Format.ALPHA, atlasWidth, atlasHeight, 1)), {}, {
          pixelStore: {
            unpackFlipY: false,
            unpackAlignment: 1
          },
          immutable: false
        }));
        this.glyphAtlasTexture.setImageData([data], 0);
      }
    }
  }, {
    key: "generateSDF",
    value: function generateSDF() {
      var fontStack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var fontFamily = arguments.length > 1 ? arguments[1] : undefined;
      var fontWeight = arguments.length > 2 ? arguments[2] : undefined;
      var fontStyle = arguments.length > 3 ? arguments[3] : undefined;
      var char = arguments.length > 4 ? arguments[4] : undefined;
      var charCode = char.charCodeAt(0);
      var sdfGenerator = this.sdfGeneratorCache[fontStack];

      if (!sdfGenerator) {
        // 创建 SDF
        sdfGenerator = this.sdfGeneratorCache[fontStack] = // TODO: use OffscreenCanvas in TextService
        new TinySDF({
          fontSize: fontSize,
          fontFamily: fontFamily,
          fontWeight: fontWeight,
          fontStyle: fontStyle,
          buffer: buffer,
          radius: radius,
          cutoff: cutoff
        });
      }

      if (!this.textMetricsCache[fontStack]) {
        this.textMetricsCache[fontStack] = {};
      }

      if (!this.textMetricsCache[fontStack][char]) {
        // 使用 mapbox/tiny-sdf 中的 context
        // @see https://stackoverflow.com/questions/46126565/how-to-get-font-glyphs-metrics-details-in-javascript
        // @ts-ignore
        this.textMetricsCache[fontStack][char] = sdfGenerator.ctx.measureText(char).width;
      } // use sdf 2.x @see https://github.com/mapbox/tiny-sdf


      var _sdfGenerator$draw = sdfGenerator.draw(char),
          data = _sdfGenerator$draw.data,
          width = _sdfGenerator$draw.width,
          height = _sdfGenerator$draw.height,
          glyphWidth = _sdfGenerator$draw.glyphWidth,
          glyphHeight = _sdfGenerator$draw.glyphHeight,
          glyphLeft = _sdfGenerator$draw.glyphLeft,
          glyphTop = _sdfGenerator$draw.glyphTop,
          glyphAdvance = _sdfGenerator$draw.glyphAdvance;

      return {
        id: charCode,
        // 在 canvas 中绘制字符，使用 Uint8Array 存储 30*30 sdf 数据
        bitmap: new AlphaImage({
          width: width,
          height: height
        }, data),
        metrics: {
          width: glyphWidth,
          height: glyphHeight,
          left: glyphLeft,
          top: glyphTop - BASE_FONT_WIDTH + BASE_FONT_BUFFER,
          advance: glyphAdvance
        }
      };
    }
  }]);

  return GlyphManager;
}();

GlyphManager = __decorate([injectable()], GlyphManager);

/**
 * Create the quads used for rendering a text label.
 */

function getGlyphQuads(positionedGlyphs, positions) {
  var quads = [];

  for (var k = 0; k < positionedGlyphs.length; k++) {
    var positionedGlyph = positionedGlyphs[k];
    var glyphPositions = positions[positionedGlyph.fontStack];
    var glyph = glyphPositions && glyphPositions[positionedGlyph.glyph];
    if (!glyph) continue;
    var rect = glyph.rect;
    if (!rect) continue; // The rects have an addditional buffer that is not included in their size.

    var glyphPadding = 1.0; // const glyphPadding = 0.0;

    var rectBuffer = BASE_FONT_BUFFER + glyphPadding;
    var halfAdvance = glyph.metrics.advance * positionedGlyph.scale / 2;
    var glyphOffset = [0, 0];
    var builtInOffset = [positionedGlyph.x + halfAdvance, positionedGlyph.y];
    var x1 = (glyph.metrics.left - rectBuffer) * positionedGlyph.scale - halfAdvance + builtInOffset[0];
    var y1 = (-glyph.metrics.top - rectBuffer) * positionedGlyph.scale + builtInOffset[1];
    var x2 = x1 + rect.w * positionedGlyph.scale;
    var y2 = y1 + rect.h * positionedGlyph.scale;
    var tl = {
      x: x1,
      y: y1
    };
    var tr = {
      x: x2,
      y: y1
    };
    var bl = {
      x: x1,
      y: y2
    };
    var br = {
      x: x2,
      y: y2
    };
    quads.push({
      tl: tl,
      tr: tr,
      bl: bl,
      br: br,
      tex: rect,
      glyphOffset: glyphOffset
    });
  }

  return quads;
}

var vert$4 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  vec2 u_SDFMapSize;\n  float u_FontSize;\n  float u_GammaScale;\n  float u_StrokeBlur;\n  float u_HasStroke;\n};\n\nlayout(location = MODEL_MATRIX0) in vec4 a_ModelMatrix0;\nlayout(location = MODEL_MATRIX1) in vec4 a_ModelMatrix1;\nlayout(location = MODEL_MATRIX2) in vec4 a_ModelMatrix2;\nlayout(location = MODEL_MATRIX3) in vec4 a_ModelMatrix3;\nlayout(location = COLOR) in vec4 a_Color;\nlayout(location = STROKE_COLOR) in vec4 a_StrokeColor;\nlayout(location = PACKED_STYLE1) in vec4 a_StylePacked1;\nlayout(location = PACKED_STYLE2) in vec4 a_StylePacked2;\nlayout(location = PICKING_COLOR) in vec4 a_PickingColor;\nlayout(location = ANCHOR) in vec2 a_Anchor;\n\nout vec4 v_PickingResult;\nout vec4 v_Color;\nout vec4 v_StrokeColor;\nout vec4 v_StylePacked1;\nout vec4 v_StylePacked2;\n\n#define COLOR_SCALE 1. / 255.\nvoid setPickingColor(vec3 pickingColor) {\n  v_PickingResult.rgb = pickingColor * COLOR_SCALE;\n}\nvec4 project(vec4 pos, mat4 pm, mat4 vm, mat4 mm) {\n  return pm * vm * mm * pos;\n}\n\nlayout(location = TEX) in vec2 a_Tex;\nlayout(location = OFFSET) in vec2 a_Offset;\n\nout vec2 v_UV;\nout float v_GammaScale;\n\nvoid main() {\n  mat4 u_ModelMatrix = mat4(a_ModelMatrix0, a_ModelMatrix1, a_ModelMatrix2, a_ModelMatrix3);\nvec4 u_StrokeColor = a_StrokeColor;\nfloat u_Opacity = a_StylePacked1.x;\nfloat u_FillOpacity = a_StylePacked1.y;\nfloat u_StrokeOpacity = a_StylePacked1.z;\nfloat u_StrokeWidth = a_StylePacked1.w;\nfloat u_ZIndex = a_PickingColor.w;\n\nsetPickingColor(a_PickingColor.xyz);\n\nv_Color = a_Color;\nv_StrokeColor = a_StrokeColor;\nv_StylePacked1 = a_StylePacked1;\nv_StylePacked2 = a_StylePacked2;\n\n#ifdef CLIPSPACE_NEAR_ZERO\n    gl_Position.z = gl_Position.z * 0.5 + 0.5;\n#endif\n\n  v_UV = a_Tex / u_SDFMapSize;\n\n  float fontScale = u_FontSize / 24.;\n\n  gl_Position = project(vec4(a_Offset * fontScale, u_ZIndex, 1.0), u_ProjectionMatrix, u_ViewMatrix, u_ModelMatrix);\n  v_GammaScale = gl_Position.w;\n}"; // eslint-disable-line

var frag$4 = "#define GLSLIFY 1\nlayout(std140) uniform ub_SceneParams {\n  mat4 u_ProjectionMatrix;\n  mat4 u_ViewMatrix;\n  vec3 u_CameraPosition;\n  float u_DevicePixelRatio;\n  vec2 u_Viewport;\n  float u_IsOrtho;\n};\nlayout(std140) uniform ub_ObjectParams {\n  vec2 u_SDFMapSize;\n  float u_FontSize;\n  float u_GammaScale;\n  float u_StrokeBlur;\n  float u_HasStroke;\n};\n\nin vec4 v_PickingResult;\nin vec4 v_Color;\nin vec4 v_StrokeColor;\nin vec4 v_StylePacked1;\nin vec4 v_StylePacked2;\n\nlayout(location = 0) out vec4 gbuf_color;\nlayout(location = 1) out vec4 gbuf_picking;\n\nin vec2 v_UV;\nin float v_GammaScale;\n\nuniform sampler2D u_SDFMap;\n\n#define SDF_PX 8.0\n\nvoid main() {\n  vec4 u_Color = v_Color;\nvec4 u_StrokeColor = v_StrokeColor;\nfloat u_Opacity = v_StylePacked1.x;\nfloat u_FillOpacity = v_StylePacked1.y;\nfloat u_StrokeOpacity = v_StylePacked1.z;\nfloat u_StrokeWidth = v_StylePacked1.w;\nfloat u_Visible = v_StylePacked2.x;\n\ngbuf_picking = vec4(v_PickingResult.rgb, 1.0);\n\nif (u_Visible < 1.0) {\n    discard;\n}\n\n  float dist = texture(SAMPLER_2D(u_SDFMap), v_UV).a;\n\n  float EDGE_GAMMA = 0.105 / u_DevicePixelRatio;\n  float fontScale = u_FontSize / 24.0;\n  highp float gamma = EDGE_GAMMA / (fontScale * u_GammaScale);\n  lowp vec4 color = u_Color;\n  lowp float buff = (256.0 - 64.0) / 256.0;\n  float opacity = u_FillOpacity;\n  if (u_HasStroke > 0.5 && u_StrokeWidth > 0.0) {\n    color = u_StrokeColor;\n    gamma = (u_StrokeBlur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * u_GammaScale);\n    buff = (6.0 - u_StrokeWidth / fontScale / 2.0) / SDF_PX;\n    opacity = u_StrokeOpacity;\n  }\n\n  highp float gamma_scaled = gamma * v_GammaScale;\n  highp float alpha = smoothstep(buff - gamma_scaled, buff + gamma_scaled, dist);\n\n  opacity *= alpha * u_Opacity;\n  if (opacity < 0.001) {\n    discard;\n  }\n\n  gbuf_color = color;\n  gbuf_color.a *= opacity;\n}"; // eslint-disable-line

var TextVertexAttributeLocation;

(function (TextVertexAttributeLocation) {
  TextVertexAttributeLocation[TextVertexAttributeLocation["TEX"] = 10] = "TEX";
  TextVertexAttributeLocation[TextVertexAttributeLocation["OFFSET"] = 11] = "OFFSET";
})(TextVertexAttributeLocation || (TextVertexAttributeLocation = {}));

var TextUniform;

(function (TextUniform) {
  TextUniform["SDF_MAP"] = "u_SDFMap";
  TextUniform["SDF_MAP_SIZE"] = "u_SDFMapSize";
  TextUniform["FONT_SIZE"] = "u_FontSize";
  TextUniform["GAMMA_SCALE"] = "u_GammaScale";
  TextUniform["STROKE_BLUR"] = "u_StrokeBlur";
  TextUniform["HAS_STROKE"] = "u_HasStroke";
})(TextUniform || (TextUniform = {}));

var TextMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(TextMesh, _Instanced);

  var _super = _createSuper(TextMesh);

  function TextMesh() {
    var _this;

    _classCallCheck(this, TextMesh);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.glyphManager = void 0;
    return _this;
  }

  _createClass(TextMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      var shouldMerge = _get(_getPrototypeOf(TextMesh.prototype), "shouldMerge", this).call(this, object, index);

      if (!shouldMerge) {
        return false;
      }

      if (this.index !== index) {
        return false;
      }

      var instance = this.instance;
      var instancedAttributes = ['fontFamily', 'fontWeight', 'textBaseline', 'letterSpacing']; // fontStack & fontSize should be same

      if (instance.parsedStyle.fontSize.value !== object.parsedStyle.fontSize.value) {
        return false;
      }

      if (instance.parsedStyle.metrics.font !== object.parsedStyle.metrics.font || instancedAttributes.some(function (name) {
        return instance.parsedStyle[name] !== object.parsedStyle[name];
      })) {
        return false;
      }

      return true;
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var _this2 = this;

      var object = this.instance;
      var _object$parsedStyle = object.parsedStyle,
          textBaseline = _object$parsedStyle.textBaseline,
          fontSize = _object$parsedStyle.fontSize,
          _object$parsedStyle$l = _object$parsedStyle.letterSpacing,
          letterSpacing = _object$parsedStyle$l === void 0 ? 0 : _object$parsedStyle$l; // scale current font size to base(24)

      var fontScale = BASE_FONT_WIDTH / fontSize.value;
      var indices = [];
      var uvOffsets = [];
      var packed = [];
      var indicesOff = 0;
      objects.forEach(function (object) {
        var _object$parsedStyle2 = object.parsedStyle,
            metrics = _object$parsedStyle2.metrics,
            dx = _object$parsedStyle2.dx,
            dy = _object$parsedStyle2.dy;
        var font = metrics.font,
            lines = metrics.lines,
            height = metrics.height,
            lineHeight = metrics.lineHeight; // account for dx & dy

        var offsetX = 0;
        var offsetY = 0;

        if (dx && dx.unit === 'px') {
          offsetX += dx.value;
        }

        if (dy && dy.unit === 'px') {
          offsetY += dy.value;
        }

        var linePositionY = 0; // handle vertical text baseline

        if (textBaseline === 'middle') {
          linePositionY = -height / 2;
        } else if (textBaseline === 'bottom') {
          linePositionY = -height;
        } else if (textBaseline === 'top' || textBaseline === 'hanging') {
          linePositionY = 0;
        } else if (textBaseline === 'alphabetic') {
          linePositionY = -height + lineHeight * 0.25;
        } else if (textBaseline === 'ideographic') {
          linePositionY = -height;
        }

        var glyphAtlas = _this2.glyphManager.getAtlas();

        var _this2$buildTextBuffe = _this2.buildTextBuffers({
          object: object,
          lines: lines,
          fontStack: font,
          lineHeight: fontScale * lineHeight,
          offsetX: fontScale * offsetX,
          offsetY: fontScale * (linePositionY + offsetY),
          letterSpacing: fontScale * letterSpacing,
          glyphAtlas: glyphAtlas,
          indicesOffset: indicesOff
        }),
            indicesOffset = _this2$buildTextBuffe.indicesOffset,
            indexBuffer = _this2$buildTextBuffe.indexBuffer,
            charUVOffsetBuffer = _this2$buildTextBuffe.charUVOffsetBuffer,
            charPackedBuffer = _this2$buildTextBuffe.charPackedBuffer;

        indicesOff = indicesOffset;
        packed.push.apply(packed, _toConsumableArray(charPackedBuffer));
        uvOffsets.push.apply(uvOffsets, _toConsumableArray(charUVOffsetBuffer));
        indices.push.apply(indices, _toConsumableArray(indexBuffer));
      });
      this.geometry.vertexCount = indices.length;
      this.geometry.setIndexBuffer(new Uint32Array(indices));
      this.geometry.setVertexBuffer({
        bufferIndex: 0,
        byteStride: 4 * (4 * 4 + 4 + 4 + 4 + 4 + 4),
        // frequency: VertexBufferFrequency.PerInstance,
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 0,
          location: VertexAttributeLocation.MODEL_MATRIX0 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 4,
          location: VertexAttributeLocation.MODEL_MATRIX1 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 8,
          location: VertexAttributeLocation.MODEL_MATRIX2 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 12,
          location: VertexAttributeLocation.MODEL_MATRIX3 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 16,
          location: VertexAttributeLocation.COLOR // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 20,
          location: VertexAttributeLocation.STROKE_COLOR // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 24,
          location: VertexAttributeLocation.PACKED_STYLE1 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 28,
          location: VertexAttributeLocation.PACKED_STYLE2 // byteStride: 4 * 4,
          //          divisor: 1,

        }, {
          format: Format.F32_RGBA,
          bufferByteOffset: 4 * 32,
          location: VertexAttributeLocation.PICKING_COLOR // byteStride: 4 * 4,
          //          divisor: 1,

        }],
        data: new Float32Array(packed)
      });
      this.geometry.setVertexBuffer({
        bufferIndex: 1,
        byteStride: 4 * (2 + 2),
        frequency: VertexBufferFrequency.PerVertex,
        attributes: [{
          format: Format.F32_RG,
          bufferByteOffset: 4 * 0,
          location: TextVertexAttributeLocation.TEX
        }, {
          format: Format.F32_RG,
          bufferByteOffset: 4 * 2,
          location: TextVertexAttributeLocation.OFFSET
        }],
        data: new Float32Array(uvOffsets)
      });
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      var _this$material$setUni;

      this.material.vertexShader = vert$4;
      this.material.fragmentShader = frag$4;
      this.material.cullMode = CullMode.Back;
      this.material.defines = _objectSpread2(_objectSpread2({}, this.material.defines), enumToObject(TextVertexAttributeLocation));
      var object = this.instance;
      var _object$parsedStyle3 = object.parsedStyle,
          fontSize = _object$parsedStyle3.fontSize,
          _object$parsedStyle3$ = _object$parsedStyle3.fontFamily,
          fontFamily = _object$parsedStyle3$ === void 0 ? '' : _object$parsedStyle3$,
          _object$parsedStyle3$2 = _object$parsedStyle3.fontWeight,
          fontWeight = _object$parsedStyle3$2 === void 0 ? 'normal' : _object$parsedStyle3$2,
          fontStyle = _object$parsedStyle3.fontStyle,
          metrics = _object$parsedStyle3.metrics;
      var font = metrics.font;
      var allText = objects.map(function (object) {
        return object.parsedStyle.text;
      }).join('');
      this.glyphManager.generateAtlas(font, fontFamily, fontWeight, fontStyle, allText, this.device);
      var glyphAtlasTexture = this.glyphManager.getAtlasTexture();
      var glyphAtlas = this.glyphManager.getAtlas();
      this.device.setResourceName(glyphAtlasTexture, 'TextSDF Texture');
      var _glyphAtlas$image = glyphAtlas.image,
          atlasWidth = _glyphAtlas$image.width,
          atlasHeight = _glyphAtlas$image.height;
      this.material.setUniforms((_this$material$setUni = {}, _defineProperty(_this$material$setUni, TextUniform.SDF_MAP, glyphAtlasTexture), _defineProperty(_this$material$setUni, TextUniform.SDF_MAP_SIZE, [atlasWidth, atlasHeight]), _defineProperty(_this$material$setUni, TextUniform.FONT_SIZE, fontSize.value), _defineProperty(_this$material$setUni, TextUniform.GAMMA_SCALE, 1), _defineProperty(_this$material$setUni, TextUniform.STROKE_BLUR, 0.2), _defineProperty(_this$material$setUni, TextUniform.HAS_STROKE, this.index), _this$material$setUni));
    }
  }, {
    key: "changeRenderOrder",
    value: function changeRenderOrder(object, renderOrder) {
      if (this.material) {
        this.material.programDirty = true;
        this.material.geometryDirty = true;
      }
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      if (name === 'text' || name === 'fontFamily' || name === 'fontSize' || name === 'fontWeight' || name === 'fontStyle' || name === 'fontVariant' || name === 'textBaseline' || name === 'letterSpacing' || name === 'wordWrapWidth' || name === 'lineHeight' || name === 'wordWrap' || name === 'textAlign' || name === 'modelMatrix' || name === 'visibility' || name === 'dx' || name === 'dy') {
        this.material.programDirty = true;
        this.material.geometryDirty = true; // need re-upload SDF texture

        this.material.textureDirty = true;
      } else if (name === 'fill' || name === 'fillOpacity' || name === 'stroke' || name === 'strokeOpacity' || name === 'opacity' || name === 'lineWidth' || name === 'visibility') {
        this.material.geometryDirty = true;
      }
    }
  }, {
    key: "buildTextBuffers",
    value: function buildTextBuffers(_ref) {
      var _object$renderable3D;

      var object = _ref.object,
          lines = _ref.lines,
          fontStack = _ref.fontStack,
          lineHeight = _ref.lineHeight,
          letterSpacing = _ref.letterSpacing,
          offsetX = _ref.offsetX,
          offsetY = _ref.offsetY,
          glyphAtlas = _ref.glyphAtlas,
          indicesOffset = _ref.indicesOffset;
      var _object$parsedStyle$t = object.parsedStyle.textAlign,
          textAlign = _object$parsedStyle$t === void 0 ? 'start' : _object$parsedStyle$t;
      var _object$parsedStyle4 = object.parsedStyle,
          fill = _object$parsedStyle4.fill,
          stroke = _object$parsedStyle4.stroke,
          opacity = _object$parsedStyle4.opacity,
          fillOpacity = _object$parsedStyle4.fillOpacity,
          strokeOpacity = _object$parsedStyle4.strokeOpacity,
          lineWidth = _object$parsedStyle4.lineWidth,
          visibility = _object$parsedStyle4.visibility;
      var fillColor = [0, 0, 0, 0];

      if ((fill === null || fill === void 0 ? void 0 : fill.type) === PARSED_COLOR_TYPE.Constant) {
        fillColor = fill.value;
      }

      var strokeColor = [0, 0, 0, 0];

      if ((stroke === null || stroke === void 0 ? void 0 : stroke.type) === PARSED_COLOR_TYPE.Constant) {
        strokeColor = stroke.value;
      } // @ts-ignore


      var encodedPickingColor = ((_object$renderable3D = object.renderable3D) === null || _object$renderable3D === void 0 ? void 0 : _object$renderable3D.encodedPickingColor) || [0, 0, 0];
      var modelMatrix = copy(create(), object.getWorldTransform());
      var charPackedBuffer = [];
      var charUVOffsetBuffer = [];
      var indexBuffer = [];
      var i = indicesOffset;
      var positionedGlyphs = this.glyphManager.layout(lines, fontStack, lineHeight, textAlign, letterSpacing, offsetX, offsetY); // 计算每个独立字符相对于锚点的位置信息

      var glyphQuads = getGlyphQuads(positionedGlyphs, glyphAtlas.positions);
      glyphQuads.forEach(function (quad) {
        var packed = [].concat(_toConsumableArray(modelMatrix), _toConsumableArray(fillColor), _toConsumableArray(strokeColor), [opacity, fillOpacity, strokeOpacity, lineWidth.value, visibility === 'visible' ? 1 : 0, 0, 0, 0], _toConsumableArray(encodedPickingColor), [object.sortable.renderOrder * RENDER_ORDER_SCALE]); // FIXME: instanced

        charPackedBuffer.push.apply(charPackedBuffer, _toConsumableArray(packed).concat(_toConsumableArray(packed), _toConsumableArray(packed), _toConsumableArray(packed))); // interleaved uv & offsets

        charUVOffsetBuffer.push(quad.tex.x, quad.tex.y, quad.tl.x, quad.tl.y);
        charUVOffsetBuffer.push(quad.tex.x + quad.tex.w, quad.tex.y, quad.tr.x, quad.tr.y);
        charUVOffsetBuffer.push(quad.tex.x + quad.tex.w, quad.tex.y + quad.tex.h, quad.br.x, quad.br.y);
        charUVOffsetBuffer.push(quad.tex.x, quad.tex.y + quad.tex.h, quad.bl.x, quad.bl.y);
        indexBuffer.push(0 + i, 2 + i, 1 + i);
        indexBuffer.push(2 + i, 0 + i, 3 + i);
        i += 4;
      });
      return {
        indexBuffer: indexBuffer,
        charUVOffsetBuffer: charUVOffsetBuffer,
        charPackedBuffer: charPackedBuffer,
        indicesOffset: i
      };
    }
  }]);

  return TextMesh;
}(Instanced);

__decorate([inject(GlyphManager), __metadata("design:type", GlyphManager)], TextMesh.prototype, "glyphManager", void 0);

TextMesh = __decorate([injectable()], TextMesh);

var _excluded = ["style"];
var Mesh = /*#__PURE__*/function (_DisplayObject) {
  _inherits(Mesh, _DisplayObject);

  var _super = _createSuper(Mesh);

  function Mesh(_ref) {
    var _this;

    var style = _ref.style,
        rest = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, Mesh);

    _this = _super.call(this, _objectSpread2({
      type: Mesh.tag,
      style: _objectSpread2({}, style)
    }, rest));

    _this.style.geometry.meshes.push(_assertThisInitialized(_this));

    _this.style.material.meshes.push(_assertThisInitialized(_this));

    return _this;
  } // getVertexBufferData(bufferIndex: number) {
  //   return this.style.geometry.vertexBuffers[bufferIndex];
  // }
  // setVertexBufferData(descriptor: {
  //   bufferIndex: number;
  //   byteOffset: number;
  //   data: ArrayBufferView;
  // }) {}


  _createClass(Mesh, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Mesh.prototype), "destroy", this).call(this); // detach from geometry


      var meshes = this.style.geometry.meshes;
      var index = meshes.indexOf(this);
      meshes.splice(index, 1); // detach from material

      meshes = this.style.material.meshes;
      index = meshes.indexOf(this);
      meshes.splice(index, 1);
    }
  }]);

  return Mesh;
}(DisplayObject);
Mesh.tag = 'mesh';

var MeshMesh = /*#__PURE__*/function (_Instanced) {
  _inherits(MeshMesh, _Instanced);

  var _super = _createSuper(MeshMesh);

  function MeshMesh() {
    _classCallCheck(this, MeshMesh);

    return _super.apply(this, arguments);
  }

  _createClass(MeshMesh, [{
    key: "shouldMerge",
    value: function shouldMerge(object, index) {
      var shouldMerge = _get(_getPrototypeOf(MeshMesh.prototype), "shouldMerge", this).call(this, object, index);

      if (!shouldMerge) {
        return false;
      }

      if (this.instance.nodeName === Mesh.tag) {
        if (this.instance.parsedStyle.material !== object.parsedStyle.material || this.instance.parsedStyle.geometry !== object.parsedStyle.geometry) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "updateAttribute",
    value: function updateAttribute(object, name, value) {
      _get(_getPrototypeOf(MeshMesh.prototype), "updateAttribute", this).call(this, object, name, value);

      var index = this.objects.indexOf(object);
      this.updateBatchedAttribute(object, index, name, value);
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(objects) {
      var material = this.instance.parsedStyle.material;
      this.material = material;
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(objects) {
      var geometry = this.instance.parsedStyle.geometry;
      this.geometry = geometry; // use default common attributes

      _get(_getPrototypeOf(MeshMesh.prototype), "createGeometry", this).call(this, objects);

      this.geometry.build(objects);
    }
  }]);

  return MeshMesh;
}(Instanced);

MeshMesh = __decorate([injectable()], MeshMesh);

/**
 * Use 2 meshes:
 * * SDF to draw fill
 * * InstancedLine
 */

var CircleRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(CircleRenderer, _Batch);

  var _super = _createSuper(CircleRenderer);

  function CircleRenderer() {
    var _this;

    _classCallCheck(this, CircleRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [SDFMesh, LineMesh];
    return _this;
  }

  _createClass(CircleRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      if (index === 1) {
        return this.needDrawStrokeSeparately(object);
      }

      return true;
    }
    /**
     * need an additional mesh to draw stroke:
     * 1. strokeOpacity < 1
     * 2. lineDash used
     */

  }, {
    key: "needDrawStrokeSeparately",
    value: function needDrawStrokeSeparately(object) {
      var _object$parsedStyle = object.parsedStyle,
          stroke = _object$parsedStyle.stroke,
          lineDash = _object$parsedStyle.lineDash,
          lineWidth = _object$parsedStyle.lineWidth,
          strokeOpacity = _object$parsedStyle.strokeOpacity;
      return stroke && lineWidth.value > 0 && (strokeOpacity < 1 || lineDash && lineDash.length && lineDash.every(function (item) {
        return item !== 0;
      }));
    }
  }]);

  return CircleRenderer;
}(Batch);

CircleRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Shape.CIRCLE
  }, {
    token: ShapeRenderer,
    named: Shape.ELLIPSE
  }]
})], CircleRenderer);

var PathRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(PathRenderer, _Batch);

  var _super = _createSuper(PathRenderer);

  function PathRenderer() {
    var _this;

    _classCallCheck(this, PathRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [FillMesh, LineMesh];
    return _this;
  }

  _createClass(PathRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      var _object$parsedStyle = object.parsedStyle,
          strokeOpacity = _object$parsedStyle.strokeOpacity,
          lineDash = _object$parsedStyle.lineDash,
          lineWidth = _object$parsedStyle.lineWidth;
      var nodeName = object.nodeName; // Polyline don't need fill

      if (index === 0 && object.nodeName === Shape.POLYLINE) {
        return false;
      } // stroke mesh


      if (index === 1) {
        if (strokeOpacity === 0 || lineWidth.value === 0) {
          return false;
        }

        var hasDash = lineDash && lineDash.length && lineDash.every(function (item) {
          return item !== 0;
        });

        if (nodeName === Shape.CIRCLE || nodeName === Shape.ELLIPSE) {
          // @see https://github.com/antvis/g/issues/824
          return hasDash;
        }
      }

      return true;
    }
  }]);

  return PathRenderer;
}(Batch);

PathRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Shape.POLYLINE
  }, {
    token: ShapeRenderer,
    named: Shape.PATH
  }, {
    token: ShapeRenderer,
    named: Shape.POLYGON
  }, {
    token: ShapeRenderer,
    named: Shape.RECT
  }]
})], PathRenderer);

// @injectable({
//   token: [{ token: ShapeMesh, named: Shape.GROUP }],
// })
// export class GroupBatchMesh extends BatchMesh {
//   protected createMaterial(objects: DisplayObject[]): void {}
//   protected createGeometry(objects: DisplayObject[]): void {}
//   protected updateMeshAttribute(object: DisplayObject, index: number, name: string, value: any) {}
// }

var GroupRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(GroupRenderer, _Batch);

  var _super = _createSuper(GroupRenderer);

  function GroupRenderer() {
    var _this;

    _classCallCheck(this, GroupRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [];
    return _this;
  }

  _createClass(GroupRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      return true;
    }
  }]);

  return GroupRenderer;
}(Batch);

GroupRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Shape.GROUP
  }]
})], GroupRenderer);

var ImageRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(ImageRenderer, _Batch);

  var _super = _createSuper(ImageRenderer);

  function ImageRenderer() {
    var _this;

    _classCallCheck(this, ImageRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [ImageMesh];
    return _this;
  }

  _createClass(ImageRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      return true;
    }
  }]);

  return ImageRenderer;
}(Batch);

ImageRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Shape.IMAGE
  }]
})], ImageRenderer);

var TextRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(TextRenderer, _Batch);

  var _super = _createSuper(TextRenderer);

  function TextRenderer() {
    var _this;

    _classCallCheck(this, TextRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [TextMesh, TextMesh];
    return _this;
  }

  _createClass(TextRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      var _object$parsedStyle = object.parsedStyle,
          stroke = _object$parsedStyle.stroke,
          lineWidth = _object$parsedStyle.lineWidth;
      var hasStroke = !!(stroke && lineWidth && lineWidth.value);

      if (!hasStroke && index === 0) {
        // skip rendering stroke
        return false;
      }

      return true;
    }
  }, {
    key: "beforeUploadUBO",
    value: function beforeUploadUBO(renderInst, mesh, index) {
      mesh.material.setUniforms(_defineProperty({}, TextUniform.HAS_STROKE, 1 - mesh.index));
    }
  }]);

  return TextRenderer;
}(Batch);

TextRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Shape.TEXT
  }]
})], TextRenderer);

/**
 * use instanced for each segment
 * @see https://blog.scottlogic.com/2019/11/18/drawing-lines-with-webgl.html
 *
 * support dash array
 * TODO: joint & cap
 */

var LineRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(LineRenderer, _Batch);

  var _super = _createSuper(LineRenderer);

  function LineRenderer() {
    var _this;

    _classCallCheck(this, LineRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [InstancedLineMesh];
    return _this;
  }

  _createClass(LineRenderer, [{
    key: "shouldSubmitRenderInst",
    value: function shouldSubmitRenderInst(object, index) {
      return true;
    }
  }]);

  return LineRenderer;
}(Batch);

LineRenderer = __decorate([injectable({
  token: {
    token: ShapeRenderer,
    named: Shape.LINE
  }
})], LineRenderer);

var MeshRenderer = /*#__PURE__*/function (_Batch) {
  _inherits(MeshRenderer, _Batch);

  var _super = _createSuper(MeshRenderer);

  function MeshRenderer() {
    var _this;

    _classCallCheck(this, MeshRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.meshes = [MeshMesh];
    return _this;
  }

  return _createClass(MeshRenderer);
}(Batch);

MeshRenderer = __decorate([injectable({
  token: [{
    token: ShapeRenderer,
    named: Mesh.tag
  }]
})], MeshRenderer);

var WebGLRendererPluginOptions = 'WebGLRendererPluginOptions';

var vert$5 = "#define GLSLIFY 1\nlayout(location = 0) in vec2 a_Position;\n\nout vec2 v_TexCoord;\n\nvoid main() {\n  v_TexCoord = 0.5 * (a_Position + 1.0);\n  gl_Position = vec4(a_Position, 0., 1.);\n\n  #ifdef VIEWPORT_ORIGIN_TL\n    v_TexCoord.y = 1.0 - v_TexCoord.y;\n  #endif\n}"; // eslint-disable-line

var frag$5 = "#define GLSLIFY 1\nuniform sampler2D u_Texture;\nin vec2 v_TexCoord;\n\nlayout(location = 0) out vec4 gbuf_color;\n\nvoid main() {\n  gbuf_color = texture(SAMPLER_2D(u_Texture), v_TexCoord);\n}"; // eslint-disable-line

var CopyProgram = /*#__PURE__*/function (_DeviceProgram) {
  _inherits(CopyProgram, _DeviceProgram);

  var _super = _createSuper(CopyProgram);

  function CopyProgram() {
    var _this;

    _classCallCheck(this, CopyProgram);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.vert = vert$5;
    _this.frag = frag$5;
    _this.features = {
      MRT: true // PICKING: false,

    };
    return _this;
  }

  return _createClass(CopyProgram);
}(DeviceProgram); // interface RenderInput {
//   backbufferWidth: number;
//   backbufferHeight: number;
// }
// const textureMapping = nArray(1, () => new TextureMapping());
// let geometry: Geometry;
// let inputState: InputState;
// let inputLayout: InputLayout;
// export function useCopyPass(
//   // builder: RGGraphBuilder,
//   renderHelper: RenderHelper,
//   // renderInput: RenderInput,
//   // mainColorTargetID: number,
// ): void {
//   // const mainColorResolveTextureID = builder.resolveRenderTarget(mainColorTargetID);
//   // pass.attachResolveTexture(mainColorResolveTextureID);
//   const renderInst = renderHelper.renderInstManager.newRenderInst();
//   renderInst.setUniformBuffer(renderHelper.uniformBuffer);
//   renderInst.setAllowSkippingIfPipelineNotReady(false);
//   renderInst.setMegaStateFlags(fullscreenMegaState);
//   renderInst.setBindingLayouts([{ numUniformBuffers: 0, numSamplers: 1 }]);
//   renderInst.drawPrimitives(3);
//   const copyProgram = new CopyProgram();
//   const program = renderHelper.renderCache.createProgram(copyProgram);
//   renderInst.setProgram(program);
//   if (!geometry) {
//     geometry = new Geometry();
//     geometry.device = renderHelper.getDevice();
//     geometry.setVertexBuffer({
//       bufferIndex: 0,
//       byteStride: 4 * 2,
//       frequency: VertexBufferFrequency.PerVertex,
//       attributes: [
//         {
//           format: Format.F32_RG,
//           bufferByteOffset: 4 * 0,
//           location: 0,
//         },
//       ],
//       // rendering a fullscreen triangle instead of quad
//       // @see https://www.saschawillems.de/blog/2016/08/13/vulkan-tutorial-on-rendering-a-fullscreen-quad-without-buffers/
//       data: new Float32Array([-4, -4, 4, -4, 0, 4]),
//     });
//     geometry.vertexCount = 3;
//     inputLayout = renderHelper.getCache().createInputLayout(geometry.inputLayoutDescriptor);
//     inputState = renderHelper.getDevice().createInputState(
//       inputLayout,
//       geometry.vertexBuffers.map((buffer) => ({
//         buffer,
//         byteOffset: 0,
//       })),
//       null,
//       program,
//     );
//   }
//   // textureMapping[0].texture = scope.getResolveTextureForID(mainColorResolveTextureID);
//   // renderInst.setSamplerBindingsFromTextureMappings(textureMapping);
//   renderInst.setInputLayoutAndState(inputLayout, inputState);
//   renderInst.drawPrimitives(3);
// }

var ResourceBase_GL = /*#__PURE__*/function () {
  function ResourceBase_GL(_ref) {
    var id = _ref.id,
        device = _ref.device;

    _classCallCheck(this, ResourceBase_GL);

    this.id = void 0;
    this.name = void 0;
    this.device = void 0;
    this.id = id;
    this.device = device;

    if (this.device.resourceCreationTracker !== null) {
      this.device.resourceCreationTracker.trackResourceCreated(this);
    }
  }

  _createClass(ResourceBase_GL, [{
    key: "destroy",
    value: function destroy() {
      if (this.device.resourceCreationTracker !== null) {
        this.device.resourceCreationTracker.trackResourceDestroyed(this);
      }
    }
  }]);

  return ResourceBase_GL;
}();

var Bindings_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Bindings_GL, _ResourceBase_GL);

  var _super = _createSuper(Bindings_GL);

  function Bindings_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Bindings_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Bindings;
    _this.uniformBufferBindings = void 0;
    _this.samplerBindings = void 0;
    var bindingLayout = descriptor.bindingLayout,
        uniformBufferBindings = descriptor.uniformBufferBindings,
        samplerBindings = descriptor.samplerBindings;
    assert(uniformBufferBindings.length >= bindingLayout.numUniformBuffers);
    assert(samplerBindings.length >= bindingLayout.numSamplers);

    for (var i = 0; i < bindingLayout.numUniformBuffers; i++) {
      assert(uniformBufferBindings[i].wordCount > 0);
    }

    _this.uniformBufferBindings = descriptor.uniformBufferBindings;
    _this.samplerBindings = descriptor.samplerBindings;
    return _this;
  }

  return _createClass(Bindings_GL);
}(ResourceBase_GL);

function isWebGL2(gl) {
  if (typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext) {
    return true;
  } // Look for debug contexts, headless gl etc
  // @ts-ignore


  return Boolean(gl && gl._version === 2);
}
function isTextureFormatCompressed(fmt) {
  var typeFlags = getFormatTypeFlags(fmt);

  switch (typeFlags) {
    case FormatTypeFlags.BC1:
    case FormatTypeFlags.BC2:
    case FormatTypeFlags.BC3:
    case FormatTypeFlags.BC4_UNORM:
    case FormatTypeFlags.BC4_SNORM:
    case FormatTypeFlags.BC5_UNORM:
    case FormatTypeFlags.BC5_SNORM:
      return true;

    default:
      return false;
  }
}
function isFormatSizedInteger(fmt) {
  var flags = getFormatFlags(fmt);
  if (!!(flags & FormatFlags.Normalized)) return false;
  var typeFlags = getFormatTypeFlags(fmt); // Check for integer types.

  if (typeFlags === FormatTypeFlags.S8 || typeFlags === FormatTypeFlags.S16 || typeFlags === FormatTypeFlags.S32) return true;
  if (typeFlags === FormatTypeFlags.U8 || typeFlags === FormatTypeFlags.U16 || typeFlags === FormatTypeFlags.U32) return true;
  return false;
}
function translateBufferHint(hint) {
  switch (hint) {
    case BufferFrequencyHint.Static:
      return GL.STATIC_DRAW;

    case BufferFrequencyHint.Dynamic:
      return GL.DYNAMIC_DRAW;
  }
}
function translateBufferUsageToTarget(usage) {
  if (usage & BufferUsage.INDEX) {
    return GL.ELEMENT_ARRAY_BUFFER;
  } else if (usage & BufferUsage.VERTEX) {
    return GL.ARRAY_BUFFER;
  } else if (usage & BufferUsage.UNIFORM) {
    return GL.UNIFORM_BUFFER;
  }
}
function translatePrimitiveTopology(topology) {
  switch (topology) {
    case PrimitiveTopology.Triangles:
      return GL.TRIANGLES;

    case PrimitiveTopology.Points:
      return GL.POINTS;

    case PrimitiveTopology.TriangleStrip:
      return GL.TRIANGLE_STRIP;

    case PrimitiveTopology.Lines:
      return GL.LINES;

    case PrimitiveTopology.LineStrip:
      return GL.LINE_STRIP;

    default:
      throw new Error('Unknown primitive topology mode');
  }
}

function translateType(flags) {
  switch (flags) {
    case FormatTypeFlags.U8:
      return GL.UNSIGNED_BYTE;

    case FormatTypeFlags.U16:
      return GL.UNSIGNED_SHORT;

    case FormatTypeFlags.U32:
      return GL.UNSIGNED_INT;

    case FormatTypeFlags.S8:
      return GL.BYTE;

    case FormatTypeFlags.S16:
      return GL.SHORT;

    case FormatTypeFlags.S32:
      return GL.INT;

    case FormatTypeFlags.F16:
      return GL.HALF_FLOAT;

    case FormatTypeFlags.F32:
      return GL.FLOAT;

    default:
      throw 'whoops';
  }
}

function translateSize(flags) {
  switch (flags) {
    case FormatCompFlags.R:
      return 1;

    case FormatCompFlags.RG:
      return 2;

    case FormatCompFlags.RGB:
      return 3;

    case FormatCompFlags.RGBA:
      return 4;
  }
}

function translateVertexFormat(fmt) {
  var typeFlags = getFormatTypeFlags(fmt);
  var compFlags = getFormatCompFlags(fmt);
  var flags = getFormatFlags(fmt);
  var type = translateType(typeFlags);
  var size = translateSize(compFlags);
  var normalized = !!(flags & FormatFlags.Normalized);
  return {
    size: size,
    type: type,
    normalized: normalized
  };
}
function translateIndexFormat(format) {
  switch (format) {
    case Format.U8_R:
      return GL.UNSIGNED_BYTE;

    case Format.U16_R:
      return GL.UNSIGNED_SHORT;

    case Format.U32_R:
      return GL.UNSIGNED_INT;

    default:
      throw 'whoops';
  }
}
function translateWrapMode(wrapMode) {
  switch (wrapMode) {
    case WrapMode.Clamp:
      return GL.CLAMP_TO_EDGE;

    case WrapMode.Repeat:
      return GL.REPEAT;

    case WrapMode.Mirror:
      return GL.MIRRORED_REPEAT;

    default:
      throw 'whoops';
  }
}
function translateFilterMode(filter, mipFilter) {
  if (mipFilter === MipFilterMode.Linear && filter === TexFilterMode.Bilinear) return GL.LINEAR_MIPMAP_LINEAR;
  if (mipFilter === MipFilterMode.Linear && filter === TexFilterMode.Point) return GL.NEAREST_MIPMAP_LINEAR;
  if (mipFilter === MipFilterMode.Nearest && filter === TexFilterMode.Bilinear) return GL.LINEAR_MIPMAP_NEAREST;
  if (mipFilter === MipFilterMode.Nearest && filter === TexFilterMode.Point) return GL.NEAREST_MIPMAP_NEAREST;
  if (mipFilter === MipFilterMode.NoMip && filter === TexFilterMode.Bilinear) return GL.LINEAR;
  if (mipFilter === MipFilterMode.NoMip && filter === TexFilterMode.Point) return GL.NEAREST;
  throw new Error('Unknown texture filter mode');
}
function getPlatformBuffer(buffer_) {
  var byteOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var buffer = buffer_;
  return buffer.gl_buffer_pages[byteOffset / buffer.pageByteSize | 0];
}
function getPlatformTexture(texture_) {
  var texture = texture_;
  return texture.gl_texture;
}
function getPlatformSampler(sampler_) {
  var sampler = sampler_;
  return sampler.gl_sampler;
}
function assignPlatformName(o, name) {
  o.name = name;
  o.__SPECTOR_Metadata = {
    name: name
  };
}
function findall(haystack, needle) {
  var results = [];

  while (true) {
    var result = needle.exec(haystack);
    if (!result) break;
    results.push(result);
  }

  return results;
}
function isBlendStateNone(blendState) {
  return blendState.blendMode == BlendMode.Add && blendState.blendSrcFactor == BlendFactor.One && blendState.blendDstFactor === BlendFactor.Zero;
}
function translateQueryPoolType(type) {
  switch (type) {
    case QueryPoolType.OcclusionConservative:
      return GL.ANY_SAMPLES_PASSED_CONSERVATIVE;

    default:
      throw 'whoops';
  }
}
function translateTextureDimension(dimension) {
  if (dimension === TextureDimension.n2D) return GL.TEXTURE_2D;else if (dimension === TextureDimension.n2DArray) return GL.TEXTURE_2D_ARRAY;else if (dimension === TextureDimension.Cube) return GL.TEXTURE_CUBE_MAP;else if (dimension === TextureDimension.n3D) return GL.TEXTURE_3D;else throw 'whoops';
}

var Buffer_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Buffer_GL, _ResourceBase_GL);

  var _super = _createSuper(Buffer_GL);

  function Buffer_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Buffer_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Buffer;
    _this.gl_buffer_pages = void 0;
    _this.gl_target = void 0;
    _this.usage = void 0;
    _this.byteSize = void 0;
    _this.pageByteSize = void 0;
    var viewOrSize = descriptor.viewOrSize,
        usage = descriptor.usage,
        hint = descriptor.hint;
    var uniformBufferMaxPageByteSize = device.uniformBufferMaxPageByteSize,
        gl = device.gl;
    var isUBO = usage & BufferUsage.UNIFORM;

    if (!isUBO) {
      if (isWebGL2(gl)) {
        // Temporarily unbind VAO when creating buffers to not stomp on the VAO configuration.
        gl.bindVertexArray(null);
      } else {
        device.OES_vertex_array_object.bindVertexArrayOES(null);
      }
    }

    var byteSize = isNumber(viewOrSize) ? viewOrSize * 4 : viewOrSize.byteLength * 4;
    _this.gl_buffer_pages = [];
    var pageByteSize;

    if (isUBO) {
      assert(byteSize % uniformBufferMaxPageByteSize === 0);
      var byteSizeLeft = byteSize;

      while (byteSizeLeft > 0) {
        _this.gl_buffer_pages.push(_this.createBufferPage(Math.min(byteSizeLeft, uniformBufferMaxPageByteSize), usage, hint));

        byteSizeLeft -= uniformBufferMaxPageByteSize;
      }

      pageByteSize = uniformBufferMaxPageByteSize; // TODO: uniform in WebGL1
    } else {
      _this.gl_buffer_pages.push(_this.createBufferPage(byteSize, usage, hint));

      pageByteSize = byteSize;
    }

    _this.pageByteSize = pageByteSize;
    _this.byteSize = byteSize;
    _this.usage = usage;
    _this.gl_target = translateBufferUsageToTarget(usage);

    if (!isUBO) {
      if (isWebGL2(gl)) {
        gl.bindVertexArray(_this.device.currentBoundVAO);
      } else {
        device.OES_vertex_array_object.bindVertexArrayOES(_this.device.currentBoundVAO);
      }
    }

    return _this;
  }

  _createClass(Buffer_GL, [{
    key: "setSubData",
    value: function setSubData(dstByteOffset, data) {
      var srcByteOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var byteSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : data.byteLength - srcByteOffset;
      var gl = this.device.gl;
      var gl_target = this.gl_target,
          dstByteSize = this.byteSize,
          dstPageByteSize = this.pageByteSize;

      if (isWebGL2(gl) && gl_target === gl.UNIFORM_BUFFER) {
        // Manually check asserts for speed.
        if (!(dstByteOffset % dstPageByteSize === 0)) throw new Error("Assert fail: (dstByteOffset [".concat(dstByteOffset, "] % dstPageByteSize [").concat(dstPageByteSize, "]) === 0"));
        if (!(byteSize % dstPageByteSize === 0)) throw new Error("Assert fail: (byteSize [".concat(byteSize, "] % dstPageByteSize [").concat(dstPageByteSize, "]) === 0"));
      }

      if (!(dstByteOffset + byteSize <= dstByteSize)) {
        throw new Error("Assert fail: (dstByteOffset [".concat(dstByteOffset, "] + byteSize [").concat(byteSize, "]) <= dstByteSize [").concat(dstByteSize, "], gl_target ").concat(gl_target)); // exceed, need to recreate
      }

      var virtBufferByteOffsetEnd = dstByteOffset + byteSize;
      var virtBufferByteOffset = dstByteOffset;
      var physBufferByteOffset = dstByteOffset % dstPageByteSize;

      while (virtBufferByteOffset < virtBufferByteOffsetEnd) {
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindBuffer#parameters
        var target = isWebGL2(gl) ? gl.COPY_WRITE_BUFFER : this.gl_target;
        gl.bindBuffer(target, getPlatformBuffer(this, virtBufferByteOffset)); // only WebGL2 support srcOffset & length
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bufferSubData

        if (isWebGL2(gl)) {
          gl.bufferSubData(target, physBufferByteOffset, data, srcByteOffset, Math.min(virtBufferByteOffsetEnd - virtBufferByteOffset, dstPageByteSize));
        } else {
          gl.bufferSubData(target, physBufferByteOffset, data);
        }

        virtBufferByteOffset += dstPageByteSize;
        physBufferByteOffset = 0;
        srcByteOffset += dstPageByteSize;
        this.device.debugGroupStatisticsBufferUpload();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Buffer_GL.prototype), "destroy", this).call(this);

      for (var i = 0; i < this.gl_buffer_pages.length; i++) {
        // no ubo in WebGL1
        // @ts-ignore
        if (!this.gl_buffer_pages[i].ubo) {
          this.device.gl.deleteBuffer(this.gl_buffer_pages[i]);
        }
      }
    }
  }, {
    key: "createBufferPage",
    value: function createBufferPage(byteSize, usage, hint) {
      var gl = this.device.gl;
      var isUBO = usage & BufferUsage.UNIFORM;

      if (!isWebGL2(gl) && isUBO) {
        return {
          ubo: true
        };
      } else {
        var gl_buffer = this.device.ensureResourceExists(gl.createBuffer());
        var gl_target = translateBufferUsageToTarget(usage);
        var gl_hint = translateBufferHint(hint);
        gl.bindBuffer(gl_target, gl_buffer);
        gl.bufferData(gl_target, byteSize, gl_hint);
        return gl_buffer;
      }
    }
  }]);

  return Buffer_GL;
}(ResourceBase_GL);

var InputLayout_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(InputLayout_GL, _ResourceBase_GL);

  var _super = _createSuper(InputLayout_GL);

  function InputLayout_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, InputLayout_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.InputLayout;
    _this.vertexAttributeDescriptors = void 0;
    _this.vertexBufferDescriptors = void 0;
    _this.indexBufferFormat = void 0;
    var vertexAttributeDescriptors = descriptor.vertexAttributeDescriptors,
        vertexBufferDescriptors = descriptor.vertexBufferDescriptors,
        indexBufferFormat = descriptor.indexBufferFormat;
    assert(indexBufferFormat === Format.U16_R || indexBufferFormat === Format.U32_R || indexBufferFormat === null);
    _this.vertexAttributeDescriptors = vertexAttributeDescriptors;
    _this.vertexBufferDescriptors = vertexBufferDescriptors;
    _this.indexBufferFormat = indexBufferFormat;
    return _this;
  }

  return _createClass(InputLayout_GL);
}(ResourceBase_GL);

var InputState_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(InputState_GL, _ResourceBase_GL);

  var _super = _createSuper(InputState_GL);

  function InputState_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        inputLayout = _ref.inputLayout,
        vertexBuffers = _ref.vertexBuffers,
        indexBufferBinding = _ref.indexBufferBinding,
        program = _ref.program;

    _classCallCheck(this, InputState_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.InputState;
    _this.vao = void 0;
    _this.indexBufferByteOffset = void 0;
    _this.indexBufferType = void 0;
    _this.indexBufferCompByteSize = void 0;
    _this.inputLayout = void 0;
    _this.vertexBuffers = void 0;
    var gl = _this.device.gl;

    var vao = _this.device.ensureResourceExists(isWebGL2(gl) ? gl.createVertexArray() : device.OES_vertex_array_object.createVertexArrayOES());

    if (isWebGL2(gl)) {
      gl.bindVertexArray(vao);
    } else {
      device.OES_vertex_array_object.bindVertexArrayOES(vao);
    }

    device.currentBoundVAO = vao;

    for (var i = 0; i < inputLayout.vertexAttributeDescriptors.length; i++) {
      var _program$attributes$a;

      var attr = inputLayout.vertexAttributeDescriptors[i];
      var format = attr.format,
          _attr$divisor = attr.divisor,
          divisor = _attr$divisor === void 0 ? 1 : _attr$divisor,
          byteStride = attr.byteStride,
          bufferByteOffset = attr.bufferByteOffset,
          bufferIndex = attr.bufferIndex; // find location by name in WebGL1

      var location = isWebGL2(gl) ? attr.location : (_program$attributes$a = program.attributes[attr.location]) === null || _program$attributes$a === void 0 ? void 0 : _program$attributes$a.location;

      if (!isNil(location)) {
        if (isFormatSizedInteger(format)) ;

        var _translateVertexForma = translateVertexFormat(format),
            size = _translateVertexForma.size,
            type = _translateVertexForma.type,
            normalized = _translateVertexForma.normalized;

        var vertexBuffer = vertexBuffers[bufferIndex];
        if (vertexBuffer === null) continue;
        var inputLayoutBuffer = assertExists(inputLayout.vertexBufferDescriptors[bufferIndex]);
        var buffer = vertexBuffer.buffer;
        assert(!!(buffer.usage & BufferUsage.VERTEX));
        gl.bindBuffer(gl.ARRAY_BUFFER, getPlatformBuffer(vertexBuffer.buffer));
        var bufferOffset = vertexBuffer.byteOffset + bufferByteOffset;
        gl.vertexAttribPointer(location, size, type, normalized, byteStride || inputLayoutBuffer.byteStride, bufferOffset);

        if (inputLayoutBuffer.frequency === VertexBufferFrequency.PerInstance) {
          if (isWebGL2(gl)) {
            // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/vertexAttribDivisor
            gl.vertexAttribDivisor(location, divisor);
          } else {
            device.ANGLE_instanced_arrays.vertexAttribDivisorANGLE(location, divisor);
          }
        }

        gl.enableVertexAttribArray(location);
      }
    }

    var indexBufferType = null;
    var indexBufferCompByteSize = null;
    var indexBufferByteOffset = null;

    if (indexBufferBinding !== null) {
      var _buffer = indexBufferBinding.buffer;
      assert(!!(_buffer.usage & BufferUsage.INDEX));
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, getPlatformBuffer(indexBufferBinding.buffer));
      indexBufferType = translateIndexFormat(assertExists(inputLayout.indexBufferFormat));
      indexBufferCompByteSize = getFormatCompByteSize(inputLayout.indexBufferFormat);
      indexBufferByteOffset = indexBufferBinding.byteOffset;
    }

    if (isWebGL2(gl)) {
      gl.bindVertexArray(null);
    } else {
      device.OES_vertex_array_object.bindVertexArrayOES(null);
    }

    device.currentBoundVAO = null;
    _this.vao = vao;
    _this.indexBufferByteOffset = indexBufferByteOffset;
    _this.indexBufferType = indexBufferType;
    _this.indexBufferCompByteSize = indexBufferCompByteSize;
    _this.inputLayout = inputLayout;
    _this.vertexBuffers = vertexBuffers;
    return _this;
  }

  _createClass(InputState_GL, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(InputState_GL.prototype), "destroy", this).call(this);

      if (this.device.currentBoundVAO === this.vao) {
        if (isWebGL2(this.device.gl)) {
          this.device.gl.bindVertexArray(null);
          this.device.gl.deleteVertexArray(this.vao);
        } else {
          this.device.OES_vertex_array_object.bindVertexArrayOES(null);
          this.device.OES_vertex_array_object.deleteVertexArrayOES(this.vao);
        }

        this.device.currentBoundVAO = null;
      }
    }
  }]);

  return InputState_GL;
}(ResourceBase_GL);

var Texture_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Texture_GL, _ResourceBase_GL);

  var _super = _createSuper(Texture_GL);

  // @see https://developer.mozilla.org/zh-CN/docs/Web/API/WebGLRenderingContext/pixelStorei
  // used in WebGL1
  function Texture_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor,
        fake = _ref.fake;

    _classCallCheck(this, Texture_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Texture;
    _this.gl_texture = void 0;
    _this.gl_target = void 0;
    _this.pixelFormat = void 0;
    _this.width = void 0;
    _this.height = void 0;
    _this.depth = void 0;
    _this.numLevels = void 0;
    _this.immutable = void 0;
    _this.pixelStore = void 0;
    _this.mipmaps = void 0;
    _this.formatKind = void 0;
    _this.textureIndex = void 0;
    var gl = _this.device.gl;
    var gl_target;
    var gl_texture;

    var numLevels = _this.clampNumLevels(descriptor);

    _this.immutable = !!descriptor.immutable;
    _this.pixelStore = descriptor.pixelStore;
    _this.pixelFormat = descriptor.pixelFormat;
    _this.formatKind = getFormatSamplerKind(descriptor.pixelFormat);
    _this.width = descriptor.width;
    _this.height = descriptor.height;
    _this.depth = descriptor.depth;
    _this.mipmaps = numLevels >= 1;

    if (!fake) {
      gl_texture = _this.device.ensureResourceExists(gl.createTexture());

      var gl_type = _this.device.translateTextureType(descriptor.pixelFormat);

      var internalformat = _this.device.translateTextureInternalFormat(descriptor.pixelFormat);

      _this.device.setActiveTexture(gl.TEXTURE0);

      _this.device.currentTextures[0] = null;

      _this.preprocessImage();

      if (descriptor.dimension === TextureDimension.n2D) {
        gl_target = GL.TEXTURE_2D;
        gl.bindTexture(gl_target, gl_texture);

        if (_this.immutable) {
          if (isWebGL2(gl)) {
            // texStorage2D will create an immutable texture(fixed size)
            // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/texStorage2D
            // @see https://github.com/visgl/luma.gl/issues/193
            // @see https://github.com/WebGLSamples/WebGL2Samples/blob/master/samples/texture_immutable.html
            gl.texStorage2D(gl_target, numLevels, internalformat, descriptor.width, descriptor.height);
          } else {
            // texImage2D: level must be 0 for DEPTH_COMPONENT format
            // const level = internalformat === GL.DEPTH_COMPONENT || this.isNPOT() ? 0 : numLevels;
            var level = internalformat === GL.DEPTH_COMPONENT || _this.isNPOT() ? 0 : 0; // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texImage2D

            gl.texImage2D(gl_target, level, internalformat, descriptor.width, descriptor.height, 0, internalformat, gl_type, null); // @see https://stackoverflow.com/questions/21954036/dartweb-gl-render-warning-texture-bound-to-texture-unit-0-is-not-renderable
            // [.WebGL-0x106ad0400]RENDER WARNING: texture bound to texture unit 0 is not renderable. It might be non-power-of-2 or have incompatible texture filtering (maybe)?

            if (_this.mipmaps && _this.isNPOT()) {
              _this.mipmaps = false;
              gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, GL.LINEAR);
              gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_S, GL.CLAMP_TO_EDGE);
              gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_T, GL.CLAMP_TO_EDGE);
            }
          }
        }

        assert(descriptor.depth === 1);
      } else if (descriptor.dimension === TextureDimension.n2DArray) {
        gl_target = GL.TEXTURE_2D_ARRAY;
        gl.bindTexture(gl_target, gl_texture);

        if (isWebGL2(gl)) {
          // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/texStorage3D
          gl.texStorage3D(gl_target, numLevels, internalformat, descriptor.width, descriptor.height, descriptor.depth);
        }
      } else if (descriptor.dimension === TextureDimension.n3D) {
        gl_target = GL.TEXTURE_3D;
        gl.bindTexture(gl_target, gl_texture);

        if (isWebGL2(gl)) {
          gl.texStorage3D(gl_target, numLevels, internalformat, descriptor.width, descriptor.height, descriptor.depth);
        }
      } else if (descriptor.dimension === TextureDimension.Cube) {
        gl_target = GL.TEXTURE_CUBE_MAP;
        gl.bindTexture(gl_target, gl_texture);

        if (isWebGL2(gl)) {
          gl.texStorage2D(gl_target, numLevels, internalformat, descriptor.width, descriptor.height);
        }

        assert(descriptor.depth === 6);
      } else {
        throw 'whoops';
      }
    }

    _this.gl_texture = gl_texture;
    _this.gl_target = gl_target;
    _this.numLevels = numLevels;
    return _this;
  }

  _createClass(Texture_GL, [{
    key: "setImageData",
    value: function setImageData(data, level) {
      var gl = this.device.gl;
      var isCompressed = isTextureFormatCompressed(this.pixelFormat);
      var is3D = this.gl_target === GL.TEXTURE_3D || this.gl_target === GL.TEXTURE_2D_ARRAY;
      var isCube = this.gl_target === GL.TEXTURE_CUBE_MAP;
      var isArray = Array.isArray(data);
      this.device.setActiveTexture(gl.TEXTURE0);
      this.device.currentTextures[0] = null;
      var width;
      var height;

      if (isArray) {
        width = this.width;
        height = this.height;
      } else {
        width = data.width;
        height = data.height; // update size

        this.width = width;
        this.height = height;
      }

      gl.bindTexture(this.gl_target, this.gl_texture); // let w = this.width;
      // let h = this.height;
      // let d = this.depth;
      // const maxMipLevel = Math.min(firstMipLevel + levelDatasSize, this.numLevels);

      var gl_format = this.device.translateTextureFormat(this.pixelFormat);
      var gl_type = this.device.translateTextureType(this.pixelFormat);
      this.preprocessImage();

      if (this.immutable) {
        // must use texSubImage2D instead of texImage2D, since texture is immutable
        // @see https://stackoverflow.com/questions/56123201/unity-plugin-texture-is-immutable?rq=1
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texSubImage2D
        gl.texSubImage2D(this.gl_target, 0, 0, 0, width, height, gl_format, gl_type, // @ts-ignore
        isArray ? data[0] : data);
      } else {
        if (isWebGL2(gl)) {
          // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texImage2D
          gl.texImage2D(this.gl_target, // level,
          0, gl_format, width, height, 0, // border must be 0
          gl_format, // TODO: can be different with gl_format
          gl_type, // @ts-ignore
          isArray ? data[0] : data);
        } else {
          // WebGL1: upload Array & Image separately
          if (isArray) {
            gl.texImage2D(this.gl_target, 0, gl_format, width, height, 0, gl_format, gl_type, data[0]);
          } else {
            gl.texImage2D(this.gl_target, 0, gl_format, gl_format, gl_type, data);
          }
        }
      }

      if (this.mipmaps) {
        this.generateMipmap();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Texture_GL.prototype), "destroy", this).call(this);

      this.device.gl.deleteTexture(getPlatformTexture(this));
    }
  }, {
    key: "clampNumLevels",
    value: function clampNumLevels(descriptor) {
      if (descriptor.dimension === TextureDimension.n2DArray && descriptor.depth > 1) {
        var typeFlags = getFormatTypeFlags(descriptor.pixelFormat);

        if (typeFlags === FormatTypeFlags.BC1) {
          // Chrome/ANGLE seems to have issues with compressed miplevels of size 1/2, so clamp before they arrive...
          // https://bugs.chromium.org/p/angleproject/issues/detail?id=4056
          var w = descriptor.width,
              h = descriptor.height;

          for (var i = 0; i < descriptor.numLevels; i++) {
            if (w <= 2 || h <= 2) return i - 1;
            w = Math.max(w / 2 | 0, 1);
            h = Math.max(h / 2 | 0, 1);
          }
        }
      }

      return descriptor.numLevels;
    }
  }, {
    key: "preprocessImage",
    value: function preprocessImage() {
      var gl = this.device.gl;

      if (this.pixelStore) {
        if (this.pixelStore.unpackFlipY) {
          gl.pixelStorei(GL.UNPACK_FLIP_Y_WEBGL, true);
        }

        if (this.pixelStore.packAlignment) {
          gl.pixelStorei(GL.PACK_ALIGNMENT, this.pixelStore.packAlignment);
        }

        if (this.pixelStore.unpackAlignment) {
          gl.pixelStorei(GL.UNPACK_ALIGNMENT, this.pixelStore.unpackAlignment);
        }
      }
    }
  }, {
    key: "generateMipmap",
    value: function generateMipmap() {
      var gl = this.device.gl;

      if (!isWebGL2(gl) && this.isNPOT()) {
        return this;
      }

      if (this.gl_texture && this.gl_target) {
        gl.bindTexture(this.gl_target, this.gl_texture);
        gl.generateMipmap(this.gl_target);
        gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, GL.NEAREST_MIPMAP_LINEAR);
        gl.bindTexture(this.gl_target, null);
      }

      return this;
    }
  }, {
    key: "isNPOT",
    value: function isNPOT() {
      var gl = this.device.gl;

      if (isWebGL2(gl)) {
        // NPOT restriction is only for WebGL1
        return false;
      }

      return !isPowerOfTwo(this.width) || !isPowerOfTwo(this.height);
    }
  }]);

  return Texture_GL;
}(ResourceBase_GL);

var ProgramCompileState_GL;

(function (ProgramCompileState_GL) {
  ProgramCompileState_GL[ProgramCompileState_GL["NeedsCompile"] = 0] = "NeedsCompile";
  ProgramCompileState_GL[ProgramCompileState_GL["Compiling"] = 1] = "Compiling";
  ProgramCompileState_GL[ProgramCompileState_GL["NeedsBind"] = 2] = "NeedsBind";
  ProgramCompileState_GL[ProgramCompileState_GL["ReadyToUse"] = 3] = "ReadyToUse";
})(ProgramCompileState_GL || (ProgramCompileState_GL = {}));

var Program_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Program_GL, _ResourceBase_GL);

  var _super = _createSuper(Program_GL);

  function Program_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Program_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Program;
    _this.gl_program = void 0;
    _this.gl_shader_vert = void 0;
    _this.gl_shader_frag = void 0;
    _this.compileState = void 0;
    _this.descriptor = void 0;
    _this.uniformSetters = {};
    _this.attributes = [];
    var gl = _this.device.gl;
    _this.descriptor = descriptor;
    _this.gl_program = _this.device.ensureResourceExists(gl.createProgram());
    _this.gl_shader_vert = null;
    _this.gl_shader_frag = null;
    _this.compileState = ProgramCompileState_GL.NeedsCompile;

    _this.tryCompileProgram();

    return _this;
  }

  _createClass(Program_GL, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Program_GL.prototype), "destroy", this).call(this);

      this.device.gl.deleteProgram(this.gl_program);
      this.device.gl.deleteShader(this.gl_shader_vert);
      this.device.gl.deleteShader(this.gl_shader_frag);
    }
  }, {
    key: "tryCompileProgram",
    value: function tryCompileProgram() {
      assert(this.compileState === ProgramCompileState_GL.NeedsCompile);
      var descriptor = this.descriptor;
      var gl = this.device.gl;
      if (this.gl_shader_vert !== null) gl.deleteShader(this.gl_shader_vert);
      if (this.gl_shader_frag !== null) gl.deleteShader(this.gl_shader_frag);
      this.gl_shader_vert = this.compileShader(descriptor.preprocessedVert, gl.VERTEX_SHADER);
      this.gl_shader_frag = this.compileShader(descriptor.preprocessedFrag, gl.FRAGMENT_SHADER);
      gl.attachShader(this.gl_program, this.gl_shader_vert);
      gl.attachShader(this.gl_program, this.gl_shader_frag);
      gl.linkProgram(this.gl_program);
      this.compileState = ProgramCompileState_GL.Compiling;

      if (!isWebGL2(gl)) {
        // extract uniforms
        this.readUniformLocationsFromLinkedProgram(); // extract attributes

        this.readAttributesFromLinkedProgram();
      }
    }
  }, {
    key: "readAttributesFromLinkedProgram",
    value: function readAttributesFromLinkedProgram() {
      var _this2 = this;

      var gl = this.device.gl;
      var count = gl.getProgramParameter(this.gl_program, gl.ACTIVE_ATTRIBUTES);
      var defines = getDefines(this.descriptor.preprocessedVert);
      var locations = getAttributeLocations(this.descriptor.vert, defines);

      var _loop = function _loop(index) {
        var _locations$find;

        var _gl$getActiveAttrib = gl.getActiveAttrib(_this2.gl_program, index),
            name = _gl$getActiveAttrib.name,
            type = _gl$getActiveAttrib.type,
            size = _gl$getActiveAttrib.size;

        var location = gl.getAttribLocation(_this2.gl_program, name);
        var definedLocation = (_locations$find = locations.find(function (l) {
          return l.name === name;
        })) === null || _locations$find === void 0 ? void 0 : _locations$find.location; // Add only user provided attributes, for built-in attributes like
        // `gl_InstanceID` locaiton will be < 0

        if (location >= 0 && !isNil(definedLocation)) {
          _this2.attributes[definedLocation] = {
            name: name,
            location: location,
            type: type,
            size: size
          };
        }
      };

      for (var index = 0; index < count; index++) {
        _loop(index);
      }
    }
  }, {
    key: "readUniformLocationsFromLinkedProgram",
    value: function readUniformLocationsFromLinkedProgram() {
      var gl = this.device.gl;
      var numUniforms = gl.getProgramParameter(this.gl_program, gl.ACTIVE_UNIFORMS);

      for (var i = 0; i < numUniforms; i++) {
        var info = gl.getActiveUniform(this.gl_program, i);

        var _parseUniformName = parseUniformName(info.name),
            name = _parseUniformName.name;

        var location = gl.getUniformLocation(this.gl_program, name);
        this.uniformSetters[name] = getUniformSetter(gl, location, info);

        if (info && info.size > 1) {
          for (var l = 0; l < info.size; l++) {
            location = gl.getUniformLocation(this.gl_program, "".concat(name, "[").concat(l, "]"));
            this.uniformSetters["".concat(name, "[").concat(l, "]")] = getUniformSetter(gl, location, info);
          }
        }
      }
    }
  }, {
    key: "compileShader",
    value: function compileShader(contents, type) {
      var gl = this.device.gl;
      var shader = this.device.ensureResourceExists(gl.createShader(type));
      gl.shaderSource(shader, contents);
      gl.compileShader(shader);
      return shader;
    }
  }, {
    key: "setUniforms",
    value: function setUniforms() {
      var uniforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var gl = this.device.gl;

      if (!isWebGL2(gl)) {
        var programUsed = false;

        for (var uniformName in uniforms) {
          if (!programUsed) {
            gl.useProgram(this.gl_program);
            programUsed = true;
          }

          var uniform = uniforms[uniformName];
          var uniformSetter = this.uniformSetters[uniformName];

          if (uniformSetter) {
            var value = uniform;

            if (value instanceof Texture_GL) {
              value = value.textureIndex;
            }

            uniformSetter(value);
          }
        }
      }

      return this;
    }
  }]);

  return Program_GL;
}(ResourceBase_GL);

function translateTextureUsage(usage) {
  var gpuUsage = 0;
  if (!!(usage & TextureUsage.Sampled)) gpuUsage |= GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
  if (!!(usage & TextureUsage.RenderTarget)) gpuUsage |= GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
  return gpuUsage;
}
function translateTextureFormat(format) {
  if (format === Format.U8_RGBA_RT) return 'bgra8unorm';else if (format === Format.U8_RGBA_NORM) return 'rgba8unorm';else if (format === Format.U8_RG_NORM) return 'rg8unorm';else if (format === Format.U32_R) return 'r32uint';else if (format === Format.D24) return 'depth24plus';else if (format === Format.D24_S8) return 'depth24plus-stencil8';else if (format === Format.D32F) return 'depth32float';else if (format === Format.D32F_S8) return 'depth32float-stencil8';else if (format === Format.BC1) return 'bc1-rgba-unorm';else if (format === Format.BC1_SRGB) return 'bc1-rgba-unorm-srgb';else if (format === Format.BC2) return 'bc2-rgba-unorm';else if (format === Format.BC2_SRGB) return 'bc2-rgba-unorm-srgb';else if (format === Format.BC3) return 'bc3-rgba-unorm';else if (format === Format.BC3_SRGB) return 'bc3-rgba-unorm-srgb';else if (format === Format.BC4_SNORM) return 'bc4-r-snorm';else if (format === Format.BC4_UNORM) return 'bc4-r-unorm';else if (format === Format.BC5_SNORM) return 'bc5-rg-snorm';else if (format === Format.BC5_UNORM) return 'bc5-rg-unorm';else throw 'whoops';
}
function translateTextureDimension$1(dimension) {
  if (dimension === TextureDimension.n2D) return '2d';else if (dimension === TextureDimension.Cube) return '3d';else if (dimension === TextureDimension.n2DArray) return '3d';else if (dimension === TextureDimension.n3D) return '3d';else throw 'whoops';
}
function translateWrapMode$1(wrapMode) {
  if (wrapMode === WrapMode.Clamp) return 'clamp-to-edge';else if (wrapMode === WrapMode.Repeat) return 'repeat';else if (wrapMode === WrapMode.Mirror) return 'mirror-repeat';else throw 'whoops';
}
function translateMinMagFilter(texFilter) {
  if (texFilter === TexFilterMode.Bilinear) return 'linear';else if (texFilter === TexFilterMode.Point) return 'nearest';else throw 'whoops';
}
function translateMipFilter(mipFilter) {
  if (mipFilter === MipFilterMode.Linear) return 'linear';else if (mipFilter === MipFilterMode.Nearest) return 'nearest';else if (mipFilter === MipFilterMode.NoMip) return 'nearest';else throw 'whoops';
}

function translateSampleType(type) {
  if (type === SamplerFormatKind.Float) return 'float';else if (type === SamplerFormatKind.Depth) return 'depth';else throw 'whoops';
}

function translateViewDimension(dimension) {
  if (dimension === TextureDimension.n2D) return '2d';else if (dimension === TextureDimension.n2DArray) return '2d-array';else if (dimension === TextureDimension.n3D) return '3d';else if (dimension === TextureDimension.Cube) return 'cube';else throw 'whoops';
}

function translateBindGroupTextureBinding(sampler) {
  return {
    sampleType: translateSampleType(sampler.formatKind),
    viewDimension: translateViewDimension(sampler.dimension)
  };
}
function getPlatformBuffer$1(buffer_) {
  var buffer = buffer_;
  return buffer.gpuBuffer;
}
function getPlatformSampler$1(sampler_) {
  var sampler = sampler_;
  return sampler.gpuSampler;
}
function getPlatformQuerySet(queryPool_) {
  var queryPool = queryPool_;
  return queryPool.querySet;
}
function translateQueryPoolType$1(type) {
  if (type === QueryPoolType.OcclusionConservative) return 'occlusion';else throw 'whoops';
} // @see https://www.w3.org/TR/webgpu/#primitive-state

function translateTopology(topology) {
  switch (topology) {
    case PrimitiveTopology.Triangles:
      return 'triangle-list';

    case PrimitiveTopology.Points:
      return 'point-list';

    case PrimitiveTopology.TriangleStrip:
      return 'triangle-strip';

    case PrimitiveTopology.Lines:
      return 'line-list';

    case PrimitiveTopology.LineStrip:
      return 'line-strip';

    default:
      throw new Error('Unknown primitive topology mode');
  }
}
function translateCullMode(cullMode) {
  if (cullMode === CullMode.None) return 'none';else if (cullMode === CullMode.Front) return 'front';else if (cullMode === CullMode.Back) return 'back';else throw 'whoops';
}
function translateFrontFace(frontFaceMode) {
  if (frontFaceMode === FrontFaceMode.CCW) return 'ccw';else if (frontFaceMode === FrontFaceMode.CW) return 'cw';else throw 'whoops';
}
function translatePrimitiveState(topology, megaStateDescriptor) {
  return {
    topology: translateTopology(topology),
    cullMode: translateCullMode(megaStateDescriptor.cullMode),
    frontFace: translateFrontFace(megaStateDescriptor.frontFace)
  };
}
function translateBlendFactor(factor) {
  if (factor === BlendFactor.Zero) return 'zero';else if (factor === BlendFactor.One) return 'one';else if (factor === BlendFactor.Src) return 'src';else if (factor === BlendFactor.OneMinusSrc) return 'one-minus-src';else if (factor === BlendFactor.Dst) return 'dst';else if (factor === BlendFactor.OneMinusDst) return 'one-minus-dst';else if (factor === BlendFactor.SrcAlpha) return 'src-alpha';else if (factor === BlendFactor.OneMinusSrcAlpha) return 'one-minus-src-alpha';else if (factor === BlendFactor.DstAlpha) return 'dst-alpha';else if (factor === BlendFactor.OneMinusDstAlpha) return 'one-minus-dst-alpha';else throw 'whoops';
}
function translateBlendMode(mode) {
  if (mode === BlendMode.Add) return 'add';else if (mode === BlendMode.Subtract) return 'subtract';else if (mode === BlendMode.ReverseSubtract) return 'reverse-subtract';else throw 'whoops';
}
function translateBlendState(blendState) {
  return {
    operation: translateBlendMode(blendState.blendMode),
    srcFactor: translateBlendFactor(blendState.blendSrcFactor),
    dstFactor: translateBlendFactor(blendState.blendDstFactor)
  };
}
function translateColorState(attachmentState, format) {
  return {
    format: translateTextureFormat(format),
    blend: {
      color: translateBlendState(attachmentState.rgbBlendState),
      alpha: translateBlendState(attachmentState.alphaBlendState)
    },
    writeMask: attachmentState.channelWriteMask
  };
}
function translateTargets(colorAttachmentFormats, megaStateDescriptor) {
  return megaStateDescriptor.attachmentsState.map(function (attachmentState, i) {
    return translateColorState(attachmentState, colorAttachmentFormats[i]);
  });
}
function translateCompareMode(compareMode) {
  if (compareMode === CompareMode.Never) return 'never';else if (compareMode === CompareMode.Less) return 'less';else if (compareMode === CompareMode.Equal) return 'equal';else if (compareMode === CompareMode.LessEqual) return 'less-equal';else if (compareMode === CompareMode.Greater) return 'greater';else if (compareMode === CompareMode.NotEqual) return 'not-equal';else if (compareMode === CompareMode.GreaterEqual) return 'greater-equal';else if (compareMode === CompareMode.Always) return 'always';else throw 'whoops';
}
function translateDepthStencilState(format, megaStateDescriptor) {
  if (format === null) return undefined;
  return {
    format: translateTextureFormat(format),
    depthWriteEnabled: megaStateDescriptor.depthWrite,
    depthCompare: translateCompareMode(megaStateDescriptor.depthCompare),
    depthBias: megaStateDescriptor.polygonOffset ? 1 : 0,
    depthBiasSlopeScale: megaStateDescriptor.polygonOffset ? 1 : 0
  };
}
function translateIndexFormat$1(format) {
  if (format === null) return undefined;else if (format === Format.U16_R) return 'uint16';else if (format === Format.U32_R) return 'uint32';else throw 'whoops';
}
function translateVertexBufferFrequency(frequency) {
  if (frequency === VertexBufferFrequency.PerVertex) return 'vertex';else if (frequency === VertexBufferFrequency.PerInstance) return 'instance';else throw 'whoops';
}
function translateVertexFormat$1(format) {
  if (format === Format.U8_R) return 'uint8x2';else if (format === Format.U8_RG) return 'uint8x2';else if (format === Format.U8_RGB) return 'uint8x4';else if (format === Format.U8_RGBA) return 'uint8x4';else if (format === Format.U8_RGBA_NORM) return 'unorm8x4';else if (format === Format.S8_RGB_NORM) return 'snorm8x4';else if (format === Format.S8_RGBA_NORM) return 'snorm8x4';else if (format === Format.S16_RG) return 'uint16x2';else if (format === Format.F32_R) return 'float32';else if (format === Format.F32_RG) return 'float32x2';else if (format === Format.F32_RGB) return 'float32x3';else if (format === Format.F32_RGBA) return 'float32x4';else throw 'whoops';
}
function isFormatTextureCompressionBC(format) {
  var formatTypeFlags = getFormatTypeFlags(format);

  switch (formatTypeFlags) {
    case FormatTypeFlags.BC1:
    case FormatTypeFlags.BC2:
    case FormatTypeFlags.BC3:
    case FormatTypeFlags.BC4_SNORM:
    case FormatTypeFlags.BC4_UNORM:
    case FormatTypeFlags.BC5_SNORM:
    case FormatTypeFlags.BC5_UNORM:
      return true;
  }

  return false;
}
function getFormatBlockSize(format) {
  var formatTypeFlags = getFormatTypeFlags(format);

  switch (formatTypeFlags) {
    case FormatTypeFlags.BC1:
    case FormatTypeFlags.BC2:
    case FormatTypeFlags.BC3:
    case FormatTypeFlags.BC4_SNORM:
    case FormatTypeFlags.BC4_UNORM:
    case FormatTypeFlags.BC5_SNORM:
    case FormatTypeFlags.BC5_UNORM:
      return 4;
  }

  return 1;
}
function allocateAndCopyTypedBuffer(type, sizeOrDstBuffer) {
  var sizeInBytes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var copyBuffer = arguments.length > 3 ? arguments[3] : undefined;

  switch (type) {
    case Format.S8_R:
    case Format.S8_R_NORM:
    case Format.S8_RG_NORM:
    case Format.S8_RGB_NORM:
    case Format.S8_RGBA_NORM:
      {
        var _buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int8Array(sizeOrDstBuffer) : new Int8Array(sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer.set(new Int8Array(copyBuffer));
        }

        return _buffer;
      }

    case Format.U8_R:
    case Format.U8_R_NORM:
    case Format.U8_RG:
    case Format.U8_RG_NORM:
    case Format.U8_RGB:
    case Format.U8_RGB_NORM:
    case Format.U8_RGB_SRGB:
    case Format.U8_RGBA:
    case Format.U8_RGBA_NORM:
    case Format.U8_RGBA_SRGB:
      {
        var _buffer2 = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer2.set(new Uint8Array(copyBuffer));
        }

        return _buffer2;
      }

    case Format.S16_R:
    case Format.S16_RG:
    case Format.S16_RG_NORM:
    case Format.S16_RGB_NORM:
    case Format.S16_RGBA:
    case Format.S16_RGBA_NORM:
      {
        var _buffer3 = sizeOrDstBuffer instanceof ArrayBuffer ? new Int16Array(sizeOrDstBuffer) : new Int16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer3.set(new Int16Array(copyBuffer));
        }

        return _buffer3;
      }

    case Format.U16_R:
    case Format.U16_RGB:
    case Format.U16_RGBA_5551:
    case Format.U16_RGBA_NORM:
    case Format.U16_RG_NORM:
    case Format.U16_R_NORM:
      {
        var _buffer4 = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint16Array(sizeOrDstBuffer) : new Uint16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer4.set(new Uint16Array(copyBuffer));
        }

        return _buffer4;
      }

    case Format.S32_R:
      {
        var _buffer5 = sizeOrDstBuffer instanceof ArrayBuffer ? new Int32Array(sizeOrDstBuffer) : new Int32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer5.set(new Int32Array(copyBuffer));
        }

        return _buffer5;
      }

    case Format.U32_R:
    case Format.U32_RG:
      {
        var _buffer6 = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint32Array(sizeOrDstBuffer) : new Uint32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer6.set(new Uint32Array(copyBuffer));
        }

        return _buffer6;
      }

    case Format.F32_R:
    case Format.F32_RG:
    case Format.F32_RGB:
    case Format.F32_RGBA:
      {
        var _buffer7 = sizeOrDstBuffer instanceof ArrayBuffer ? new Float32Array(sizeOrDstBuffer) : new Float32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);

        if (copyBuffer) {
          _buffer7.set(new Float32Array(copyBuffer));
        }

        return _buffer7;
      }
  }

  var buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);

  if (copyBuffer) {
    buffer.set(new Uint8Array(copyBuffer));
  }

  return buffer;
}
/**
 * Converts a half float to a number
 * @param value half float to convert
 * @returns converted half float
 */

function halfFloat2Number(value) {
  var s = (value & 0x8000) >> 15;
  var e = (value & 0x7c00) >> 10;
  var f = value & 0x03ff;

  if (e === 0) {
    return (s ? -1 : 1) * Math.pow(2, -14) * (f / Math.pow(2, 10));
  } else if (e == 0x1f) {
    return f ? NaN : (s ? -1 : 1) * Infinity;
  }

  return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / Math.pow(2, 10));
}

var QueryPool_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(QueryPool_GL, _ResourceBase_GL);

  var _super = _createSuper(QueryPool_GL);

  function QueryPool_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, QueryPool_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.QueryPool;
    _this.gl_query_type = void 0;
    _this.gl_query = void 0;
    var gl = _this.device.gl;

    if (isWebGL2(gl)) {
      var elemCount = descriptor.elemCount,
          type = descriptor.type;
      _this.gl_query = nArray(elemCount, function () {
        return _this.device.ensureResourceExists(gl.createQuery());
      });
      _this.gl_query_type = translateQueryPoolType(type);
    }

    return _this;
  }

  _createClass(QueryPool_GL, [{
    key: "queryResultOcclusion",
    value: function queryResultOcclusion(dstOffs) {
      var gl = this.device.gl;

      if (isWebGL2(gl)) {
        var gl_query = this.gl_query[dstOffs];

        if (!gl.getQueryParameter(gl_query, gl.QUERY_RESULT_AVAILABLE)) {
          return null;
        }

        return !!gl.getQueryParameter(gl_query, gl.QUERY_RESULT);
      }

      return null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(QueryPool_GL.prototype), "destroy", this).call(this);

      getPlatformQuerySet(this).destroy();
    }
  }]);

  return QueryPool_GL;
}(ResourceBase_GL);

var Readback_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Readback_GL, _ResourceBase_GL);

  var _super = _createSuper(Readback_GL);

  // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLSync
  function Readback_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device;

    _classCallCheck(this, Readback_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Readback;
    _this.gl_pbo = null;
    _this.gl_sync = null;
    return _this;
  }

  _createClass(Readback_GL, [{
    key: "clientWaitAsync",
    value: function clientWaitAsync(sync) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var interval_ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var gl = this.device.gl;
      return new Promise(function (resolve, reject) {
        function test() {
          // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/clientWaitSync
          var res = gl.clientWaitSync(sync, flags, 0);

          if (res == gl.WAIT_FAILED) {
            reject();
            return;
          }

          if (res == gl.TIMEOUT_EXPIRED) {
            setTimeout(test, clamp(interval_ms, 0, gl.MAX_CLIENT_WAIT_TIMEOUT_WEBGL));
            return;
          }

          resolve();
        }

        test();
      });
    }
  }, {
    key: "getBufferSubDataAsync",
    value: function () {
      var _getBufferSubDataAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(target, buffer, srcByteOffset, dstBuffer) {
        var dstOffset,
            length,
            gl,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dstOffset = _args.length > 4 && _args[4] !== undefined ? _args[4] : 0;
                length = _args.length > 5 && _args[5] !== undefined ? _args[5] : dstBuffer.byteLength || 0;
                gl = this.device.gl;

                if (!isWebGL2(gl)) {
                  _context.next = 12;
                  break;
                }

                // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/fenceSync
                this.gl_sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                gl.flush();
                _context.next = 8;
                return this.clientWaitAsync(this.gl_sync, 0, 10);

              case 8:
                gl.bindBuffer(target, buffer);
                gl.getBufferSubData(target, srcByteOffset, dstBuffer, dstOffset, length);
                gl.bindBuffer(target, null);
                return _context.abrupt("return", dstBuffer);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBufferSubDataAsync(_x, _x2, _x3, _x4) {
        return _getBufferSubDataAsync.apply(this, arguments);
      }

      return getBufferSubDataAsync;
    }()
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#use_non-blocking_async_data_readback
     */

  }, {
    key: "readTexture",
    value: function () {
      var _readTexture = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t, x, y, width, height, dstBuffer) {
        var dstOffset,
            length,
            gl,
            texture,
            gl_format,
            gl_type,
            formatByteSize,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dstOffset = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : 0;
                length = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : dstBuffer.byteLength || 0;
                gl = this.device.gl;
                texture = t;
                gl_format = this.device.translateTextureFormat(texture.pixelFormat);
                gl_type = this.device.translateTextureType(texture.pixelFormat);
                formatByteSize = getFormatByteSize(texture.pixelFormat);

                if (!isWebGL2(gl)) {
                  _context2.next = 20;
                  break;
                }

                this.gl_pbo = this.device.ensureResourceExists(gl.createBuffer()); // PIXEL_PACK_BUFFER: Buffer used for pixel transfer operations
                // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindBuffer

                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, this.gl_pbo); // STREAM_READ: The contents are intended to be specified once by reading data from WebGL, and queried at most a few times by the application
                // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bufferData

                gl.bufferData(gl.PIXEL_PACK_BUFFER, length, gl.STREAM_READ);
                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
                gl.bindFramebuffer(GL.READ_FRAMEBUFFER, this.device.readbackFramebuffer);
                gl.framebufferTexture2D(GL.READ_FRAMEBUFFER, GL.COLOR_ATTACHMENT0, GL.TEXTURE_2D, texture.gl_texture, 0);
                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, this.gl_pbo);
                gl.readPixels(x, y, width, height, gl_format, gl_type, dstOffset * formatByteSize);
                gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
                return _context2.abrupt("return", this.getBufferSubDataAsync(gl.PIXEL_PACK_BUFFER, this.gl_pbo, 0, dstBuffer, dstOffset, length));

              case 20:
                gl.bindFramebuffer(GL.FRAMEBUFFER, this.device.readbackFramebuffer);
                gl.framebufferTexture2D(GL.FRAMEBUFFER, GL.COLOR_ATTACHMENT0, GL.TEXTURE_2D, texture.gl_texture, 0); // slow requires roundtrip to GPU
                // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/pixelStorei

                gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
                gl.readPixels(x, y, width, height, gl.RGBA, gl_type, dstBuffer);
                return _context2.abrupt("return", Promise.resolve(dstBuffer));

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readTexture(_x5, _x6, _x7, _x8, _x9, _x10) {
        return _readTexture.apply(this, arguments);
      }

      return readTexture;
    }()
  }, {
    key: "readBuffer",
    value: function () {
      var _readBuffer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(b, srcByteOffset, dstBuffer, dstOffset, length) {
        var gl;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                gl = this.device.gl;

                if (!isWebGL2(gl)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", this.getBufferSubDataAsync(gl.ARRAY_BUFFER, getPlatformBuffer(b, srcByteOffset), srcByteOffset, dstBuffer, dstOffset, length));

              case 3:
                return _context3.abrupt("return", Promise.reject());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function readBuffer(_x11, _x12, _x13, _x14, _x15) {
        return _readBuffer.apply(this, arguments);
      }

      return readBuffer;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Readback_GL.prototype), "destroy", this).call(this);

      if (isWebGL2(this.device.gl)) {
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/deleteSync
        if (this.gl_sync !== null) {
          this.device.gl.deleteSync(this.gl_sync);
        }

        if (this.gl_pbo !== null) {
          this.device.gl.deleteBuffer(this.gl_pbo);
        }
      }
    }
  }]);

  return Readback_GL;
}(ResourceBase_GL);

var ResourceBase_WebGPU = /*#__PURE__*/function () {
  function ResourceBase_WebGPU(_ref) {
    var id = _ref.id,
        device = _ref.device;

    _classCallCheck(this, ResourceBase_WebGPU);

    this.type = void 0;
    this.id = void 0;
    this.name = void 0;
    this.device = void 0;
    this.id = id;
    this.device = device;
  }

  _createClass(ResourceBase_WebGPU, [{
    key: "destroy",
    value: function destroy() {}
  }]);

  return ResourceBase_WebGPU;
}();

var defaultBindingLayoutSamplerDescriptor = {
  formatKind: SamplerFormatKind.Float,
  dimension: TextureDimension.n2D
};
var Bindings_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Bindings_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Bindings_WebGPU);

  function Bindings_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Bindings_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Bindings;
    _this.bindingLayout = void 0;
    _this.gpuBindGroup = void 0;
    var pipeline = descriptor.pipeline,
        bindingLayout = descriptor.bindingLayout;
    assert(!!pipeline);

    var bindGroupLayout = _this._createBindGroupLayout(bindingLayout); // entries orders: Storage(read-only storage) Uniform Sampler


    var gpuBindGroupEntries = [[], []];
    var numBindings = 0;

    for (var i = 0; i < bindingLayout.storageEntries.length; i++) {
      var binding = descriptor.storageBufferBindings[i];
      assert(binding.wordCount > 0);
      var gpuBufferBinding = {
        buffer: getPlatformBuffer$1(binding.buffer),
        offset: 0,
        size: binding.wordCount << 2
      };
      gpuBindGroupEntries[0].push({
        binding: numBindings++,
        resource: gpuBufferBinding
      });
    }

    for (var _i = 0; _i < bindingLayout.numUniformBuffers; _i++) {
      var _binding = descriptor.uniformBufferBindings[_i];
      assert(_binding.wordCount > 0);
      var _gpuBufferBinding = {
        buffer: getPlatformBuffer$1(_binding.buffer),
        offset: 0,
        size: _binding.wordCount << 2
      };
      gpuBindGroupEntries[0].push({
        binding: numBindings++,
        resource: _gpuBufferBinding
      });
    }

    numBindings = 0;

    for (var _i2 = 0; _i2 < bindingLayout.numSamplers; _i2++) {
      var samplerEntry = bindingLayout.samplerEntries !== undefined ? bindingLayout.samplerEntries[_i2] : defaultBindingLayoutSamplerDescriptor;
      var _binding2 = descriptor.samplerBindings[_i2];
      var texture = _binding2.texture !== null ? _binding2.texture : _this.device.getFallbackTexture(samplerEntry);
      assert(samplerEntry.dimension === texture.dimension);
      assert(samplerEntry.formatKind === getFormatSamplerKind(texture.pixelFormat));
      var gpuTextureView = texture.gpuTextureView;
      gpuBindGroupEntries[1].push({
        binding: numBindings++,
        resource: gpuTextureView
      });
      var sampler = _binding2.sampler !== null ? _binding2.sampler : _this.device.fallbackSampler;
      var gpuSampler = getPlatformSampler$1(sampler);
      gpuBindGroupEntries[1].push({
        binding: numBindings++,
        resource: gpuSampler
      });
    }

    _this.gpuBindGroup = gpuBindGroupEntries.map(function (gpuBindGroupEntry, i) {
      return _this.device.device.createBindGroup({
        layout: pipeline.getBindGroupLayout(i),
        // layout: bindGroupLayout.gpuBindGroupLayout[i],
        entries: gpuBindGroupEntry
      });
    });
    _this.bindingLayout = descriptor.bindingLayout;
    return _this;
  }

  _createClass(Bindings_WebGPU, [{
    key: "_createBindGroupLayout",
    value: function _createBindGroupLayout(bindingLayout) {
      var gpuBindGroupLayout = this.device.bindGroupLayoutCache.get(bindingLayout);

      if (gpuBindGroupLayout === null) {
        gpuBindGroupLayout = this._createBindGroupLayoutInternal(bindingLayout);
        this.device.bindGroupLayoutCache.add(bindingLayout, gpuBindGroupLayout);
      }

      return gpuBindGroupLayout;
    }
  }, {
    key: "_createBindGroupLayoutInternal",
    value: function _createBindGroupLayoutInternal(bindingLayout) {
      var _this2 = this;

      var entries = [[], []];

      if (bindingLayout.storageEntries) {
        for (var i = 0; i < bindingLayout.storageEntries.length; i++) {
          entries[0].push({
            binding: entries[0].length,
            visibility: GPUShaderStage.COMPUTE,
            buffer: {
              type: bindingLayout.storageEntries[i].type
            }
          });
        }
      }

      for (var _i3 = 0; _i3 < bindingLayout.numUniformBuffers; _i3++) {
        entries[0].push({
          binding: entries[0].length,
          visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
          buffer: {
            type: 'uniform',
            hasDynamicOffset: true
          }
        });
      }

      for (var _i4 = 0; _i4 < bindingLayout.numSamplers; _i4++) {
        var samplerEntry = bindingLayout.samplerEntries !== undefined ? bindingLayout.samplerEntries[_i4] : defaultBindingLayoutSamplerDescriptor;
        entries[1].push({
          binding: entries[1].length,
          visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
          texture: translateBindGroupTextureBinding(samplerEntry)
        });
        entries[1].push({
          binding: entries[1].length,
          visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
          sampler: {
            type: 'filtering'
          }
        });
      }

      var gpuBindGroupLayout = entries.map(function (entries) {
        return _this2.device.device.createBindGroupLayout({
          entries: entries
        });
      });
      return {
        gpuBindGroupLayout: gpuBindGroupLayout
      };
    }
  }]);

  return Bindings_WebGPU;
}(ResourceBase_WebGPU);

var RenderPipeline_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(RenderPipeline_GL, _ResourceBase_GL);

  var _super = _createSuper(RenderPipeline_GL);

  // Attachment data.
  function RenderPipeline_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, RenderPipeline_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.RenderPipeline;
    _this.bindingLayouts = void 0;
    _this.program = void 0;
    _this.drawMode = void 0;
    _this.megaState = void 0;
    _this.inputLayout = void 0;
    _this.colorAttachmentFormats = void 0;
    _this.depthStencilAttachmentFormat = void 0;
    _this.sampleCount = void 0;
    _this.bindingLayouts = _this.createBindingLayouts(descriptor.bindingLayouts);
    _this.drawMode = translatePrimitiveTopology(descriptor.topology);
    _this.program = descriptor.program;
    _this.inputLayout = descriptor.inputLayout;
    _this.megaState = descriptor.megaStateDescriptor;
    _this.colorAttachmentFormats = descriptor.colorAttachmentFormats.slice();
    _this.depthStencilAttachmentFormat = descriptor.depthStencilAttachmentFormat;
    _this.sampleCount = descriptor.sampleCount;
    return _this;
  }

  _createClass(RenderPipeline_GL, [{
    key: "createBindingLayouts",
    value: function createBindingLayouts(bindingLayouts) {
      var firstUniformBuffer = 0;
      var firstSampler = 0;
      var bindingLayoutTables = [];

      for (var i = 0; i < bindingLayouts.length; i++) {
        var _bindingLayouts$i = bindingLayouts[i],
            numUniformBuffers = _bindingLayouts$i.numUniformBuffers,
            numSamplers = _bindingLayouts$i.numSamplers,
            samplerEntries = _bindingLayouts$i.samplerEntries;
        var bindingSamplerEntries = [];

        if (samplerEntries !== undefined) {
          assert(samplerEntries.length === numSamplers);
        }

        for (var j = 0; j < numSamplers; j++) {
          var samplerEntry = samplerEntries !== undefined ? samplerEntries[j] : defaultBindingLayoutSamplerDescriptor;
          var dimension = samplerEntry.dimension,
              formatKind = samplerEntry.formatKind;
          bindingSamplerEntries.push({
            gl_target: translateTextureDimension(dimension),
            formatKind: formatKind
          });
        }

        bindingLayoutTables.push({
          firstUniformBuffer: firstUniformBuffer,
          numUniformBuffers: numUniformBuffers,
          firstSampler: firstSampler,
          numSamplers: numSamplers,
          samplerEntries: bindingSamplerEntries
        });
        firstUniformBuffer += numUniformBuffers;
        firstSampler += numSamplers;
      }

      return {
        numUniformBuffers: firstUniformBuffer,
        numSamplers: firstSampler,
        bindingLayoutTables: bindingLayoutTables
      };
    }
  }]);

  return RenderPipeline_GL;
}(ResourceBase_GL);

var RenderTarget_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(RenderTarget_GL, _ResourceBase_GL);

  var _super = _createSuper(RenderTarget_GL);

  function RenderTarget_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, RenderTarget_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.RenderTarget;
    _this.gl_renderbuffer = null;
    _this.texture = null;
    _this.pixelFormat = void 0;
    _this.width = void 0;
    _this.height = void 0;
    _this.sampleCount = void 0;
    var gl = _this.device.gl;
    var pixelFormat = descriptor.pixelFormat,
        width = descriptor.width,
        height = descriptor.height,
        texture = descriptor.texture,
        sampleCount = descriptor.sampleCount;

    if (texture) {
      _this.texture = texture;
    } else {
      _this.gl_renderbuffer = _this.device.ensureResourceExists(gl.createRenderbuffer());
      gl.bindRenderbuffer(gl.RENDERBUFFER, _this.gl_renderbuffer);

      var gl_format = _this.device.translateTextureInternalFormat(pixelFormat);

      if (isWebGL2(gl) && sampleCount > 0) {
        // @see https://github.com/shrekshao/MoveWebGL1EngineToWebGL2/blob/master/Move-a-WebGL-1-Engine-To-WebGL-2-Blog-2.md#multisampled-renderbuffers
        gl.renderbufferStorageMultisample(GL.RENDERBUFFER, sampleCount, gl_format, width, height);
      } else {
        // WebGL1 can only use FXAA or other post-processing methods
        gl.renderbufferStorage(GL.RENDERBUFFER, gl_format, width, height);
      }
    }

    _this.pixelFormat = pixelFormat;
    _this.width = width;
    _this.height = height;
    _this.sampleCount = sampleCount;
    return _this;
  }

  _createClass(RenderTarget_GL, [{
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(RenderTarget_GL.prototype), "destroy", this).call(this);

      if (this.gl_renderbuffer !== null) {
        this.device.gl.deleteRenderbuffer(this.gl_renderbuffer);
      }
    }
  }]);

  return RenderTarget_GL;
}(ResourceBase_GL);

var ResourceCreationTracker = /*#__PURE__*/function () {
  function ResourceCreationTracker() {
    _classCallCheck(this, ResourceCreationTracker);

    this.liveObjects = new Set();
    this.creationStacks = new Map();
    this.deletionStacks = new Map();
  }

  _createClass(ResourceCreationTracker, [{
    key: "trackResourceCreated",
    value: function trackResourceCreated(o) {
      this.creationStacks.set(o, new Error().stack);
      this.liveObjects.add(o);
    }
  }, {
    key: "trackResourceDestroyed",
    value: function trackResourceDestroyed(o) {
      if (this.deletionStacks.has(o)) console.warn("Object double freed:", o, "\n\nCreation stack: ", this.creationStacks.get(o), "\n\nDeletion stack: ", this.deletionStacks.get(o), "\n\nThis stack: ", new Error().stack);
      this.deletionStacks.set(o, new Error().stack);
      this.liveObjects.delete(o);
    }
  }, {
    key: "checkForLeaks",
    value: function checkForLeaks() {
      var _iterator = _createForOfIteratorHelper(this.liveObjects.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var o = _step.value;
          console.warn('Object leaked:', o, 'Creation stack:', this.creationStacks.get(o));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setResourceLeakCheck",
    value: function setResourceLeakCheck(o, v) {
      if (v) {
        this.liveObjects.add(o);
      } else {
        this.liveObjects.delete(o);
      }
    }
  }]);

  return ResourceCreationTracker;
}();

/**
 * In WebGL 1 texture image data and sampling information are both stored in texture objects
 * @see https://github.com/shrekshao/MoveWebGL1EngineToWebGL2/blob/master/Move-a-WebGL-1-Engine-To-WebGL-2-Blog-2.md#sampler-objects
 */

var Sampler_GL = /*#__PURE__*/function (_ResourceBase_GL) {
  _inherits(Sampler_GL, _ResourceBase_GL);

  var _super = _createSuper(Sampler_GL);

  function Sampler_GL(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Sampler_GL);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Sampler;
    _this.gl_sampler = void 0;
    _this.descriptor = void 0;
    var gl = _this.device.gl;

    if (isWebGL2(gl)) {
      var _descriptor$wrapQ, _descriptor$maxAnisot;

      var gl_sampler = _this.device.ensureResourceExists(gl.createSampler());

      gl.samplerParameteri(gl_sampler, GL.TEXTURE_WRAP_S, translateWrapMode(descriptor.wrapS));
      gl.samplerParameteri(gl_sampler, GL.TEXTURE_WRAP_T, translateWrapMode(descriptor.wrapT));
      gl.samplerParameteri(gl_sampler, GL.TEXTURE_WRAP_R, translateWrapMode((_descriptor$wrapQ = descriptor.wrapQ) !== null && _descriptor$wrapQ !== void 0 ? _descriptor$wrapQ : descriptor.wrapS));
      gl.samplerParameteri(gl_sampler, GL.TEXTURE_MIN_FILTER, translateFilterMode(descriptor.minFilter, descriptor.mipFilter));
      gl.samplerParameteri(gl_sampler, GL.TEXTURE_MAG_FILTER, translateFilterMode(descriptor.magFilter, MipFilterMode.NoMip));

      if (descriptor.minLOD !== undefined) {
        gl.samplerParameterf(gl_sampler, GL.TEXTURE_MIN_LOD, descriptor.minLOD);
      }

      if (descriptor.maxLOD !== undefined) {
        gl.samplerParameterf(gl_sampler, GL.TEXTURE_MAX_LOD, descriptor.maxLOD);
      }

      if (descriptor.compareMode !== undefined) {
        gl.samplerParameteri(gl_sampler, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
        gl.samplerParameteri(gl_sampler, gl.TEXTURE_COMPARE_FUNC, descriptor.compareMode);
      }

      var maxAnisotropy = (_descriptor$maxAnisot = descriptor.maxAnisotropy) !== null && _descriptor$maxAnisot !== void 0 ? _descriptor$maxAnisot : 1;

      if (maxAnisotropy > 1 && _this.device.EXT_texture_filter_anisotropic !== null) {
        assert(descriptor.minFilter === TexFilterMode.Bilinear && descriptor.magFilter === TexFilterMode.Bilinear && descriptor.mipFilter === MipFilterMode.Linear);
        gl.samplerParameterf(gl_sampler, _this.device.EXT_texture_filter_anisotropic.TEXTURE_MAX_ANISOTROPY_EXT, maxAnisotropy);
      }

      _this.gl_sampler = gl_sampler;
    } else {
      // use later in WebGL1
      _this.descriptor = descriptor;
    }

    return _this;
  }

  _createClass(Sampler_GL, [{
    key: "setTextureParameters",
    value: function setTextureParameters(gl_target, width, height) {
      var _descriptor$maxAnisot2;

      var gl = this.device.gl;
      var descriptor = this.descriptor; // @see https://developer.mozilla.org/zh-CN/docs/Web/API/WebGL_API/Tutorial/Using_textures_in_WebGL#%E9%9D%9E2%E7%9A%84%E5%B9%82%E7%BA%B9%E7%90%86

      if (this.isNPOT(width, height)) {
        gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, GL.LINEAR);
      } else {
        gl.texParameteri(gl_target, GL.TEXTURE_MIN_FILTER, translateFilterMode(descriptor.minFilter, descriptor.mipFilter));
      }

      gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_S, translateWrapMode(descriptor.wrapS));
      gl.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_T, translateWrapMode(descriptor.wrapT));
      gl.texParameteri(gl_target, GL.TEXTURE_MAG_FILTER, translateFilterMode(descriptor.magFilter, MipFilterMode.NoMip)); // if (descriptor.minLOD !== undefined) {
      //   gl.texParameterf(gl_target, GL.TEXTURE_MIN_LOD, descriptor.minLOD);
      // }
      // if (descriptor.maxLOD !== undefined) {
      //   gl.texParameterf(gl_target, GL.TEXTURE_MAX_LOD, descriptor.maxLOD);
      // }

      var maxAnisotropy = (_descriptor$maxAnisot2 = descriptor.maxAnisotropy) !== null && _descriptor$maxAnisot2 !== void 0 ? _descriptor$maxAnisot2 : 1;

      if (maxAnisotropy > 1 && this.device.EXT_texture_filter_anisotropic !== null) {
        assert(descriptor.minFilter === TexFilterMode.Bilinear && descriptor.magFilter === TexFilterMode.Bilinear && descriptor.mipFilter === MipFilterMode.Linear);
        gl.texParameteri(gl_target, this.device.EXT_texture_filter_anisotropic.TEXTURE_MAX_ANISOTROPY_EXT, maxAnisotropy);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Sampler_GL.prototype), "destroy", this).call(this);

      if (isWebGL2(this.device.gl)) {
        this.device.gl.deleteSampler(getPlatformSampler(this));
      }
    }
  }, {
    key: "isNPOT",
    value: function isNPOT(width, height) {
      return !isPowerOfTwo(width) || !isPowerOfTwo(height);
    }
  }]);

  return Sampler_GL;
}(ResourceBase_GL);

// https://bugs.chromium.org/p/angleproject/issues/detail?id=3388

var UBO_PAGE_MAX_BYTE_SIZE = 0x10000;
var Device_GL = /*#__PURE__*/function () {
  // Configuration
  // GL extensions
  // @see https://developer.mozilla.org/zh-CN/docs/Web/API/OES_vertex_array_object
  // @see https://developer.mozilla.org/en-US/docs/Web/API/ANGLE_instanced_arrays
  // @see https://developer.mozilla.org/en-US/docs/Web/API/OES_texture_float
  // @see https://www.khronos.org/registry/webgl/extensions/OES_draw_buffers_indexed/
  // @see https://developer.mozilla.org/en-US/docs/Web/API/WEBGL_draw_buffers
  // @see https://developer.mozilla.org/en-US/docs/Web/API/WEBGL_depth_texture
  // @see https://developer.mozilla.org/en-US/docs/Web/API/EXT_texture_norm16
  // Swap Chain
  // Device
  // Cached GL driver state
  // Pass Execution

  /**
   * use DRAW_FRAMEBUFFER in WebGL2
   */
  // VendorInfo
  // GLimits

  /**
   * @see https://github.com/shrekshao/MoveWebGL1EngineToWebGL2/blob/master/Move-a-WebGL-1-Engine-To-WebGL-2-Blog-2.md#uniform-buffer
   */
  function Device_GL(gl, configuration) {
    _classCallCheck(this, Device_GL);

    this.shaderDebug = false;
    this.contextAttributes = void 0;
    this.OES_vertex_array_object = null;
    this.ANGLE_instanced_arrays = null;
    this.OES_texture_float = null;
    this.OES_draw_buffers_indexed = null;
    this.WEBGL_draw_buffers = null;
    this.WEBGL_depth_texture = null;
    this.WEBGL_compressed_texture_s3tc = null;
    this.WEBGL_compressed_texture_s3tc_srgb = null;
    this.EXT_texture_compression_rgtc = null;
    this.EXT_texture_filter_anisotropic = null;
    this.KHR_parallel_shader_compile = null;
    this.EXT_texture_norm16 = null;
    this.scTexture = null;
    this.scPlatformFramebuffer = null;
    this.currentActiveTexture = null;
    this.currentBoundVAO = null;
    this.currentProgram = null;
    this.resourceCreationTracker = null;
    this.resourceUniqueId = 0;
    this.currentColorAttachments = [];
    this.currentColorResolveTos = [];
    this.currentDepthStencilAttachment = void 0;
    this.currentDepthStencilResolveTo = null;
    this.currentSampleCount = -1;
    this.currentPipeline = void 0;
    this.currentInputState = void 0;
    this.currentMegaState = copyMegaState(defaultMegaState);
    this.currentSamplers = [];
    this.currentTextures = [];
    this.currentUniformBuffers = [];
    this.currentUniformBufferByteOffsets = [];
    this.currentUniformBufferByteSizes = [];
    this.currentScissorEnabled = false;
    this.currentStencilRef = null;
    this.currentRenderPassDescriptor = null;
    this.debugGroupStack = [];
    this.resolveColorAttachmentsChanged = false;
    this.resolveColorReadFramebuffer = void 0;
    this.resolveColorDrawFramebuffer = void 0;
    this.resolveDepthStencilAttachmentsChanged = false;
    this.resolveDepthStencilReadFramebuffer = void 0;
    this.resolveDepthStencilDrawFramebuffer = void 0;
    this.renderPassDrawFramebuffer = void 0;
    this.readbackFramebuffer = void 0;
    this.fallbackTexture2D = void 0;
    this.fallbackTexture2DDepth = void 0;
    this.fallbackTexture2DArray = void 0;
    this.fallbackTexture3D = void 0;
    this.fallbackTextureCube = void 0;
    this.platformString = void 0;
    this.glslVersion = void 0;
    this.explicitBindingLocations = false;
    this.separateSamplerTextures = false;
    this.viewportOrigin = ViewportOrigin.LowerLeft;
    this.clipSpaceNearZ = ClipSpaceNearZ.NegativeOne;
    this.supportMRT = false;
    this.inBlitRenderPass = false;
    this.blitRenderPipeline = void 0;
    this.blitInputState = void 0;
    this.blitBindings = void 0;
    this.uniformBufferMaxPageByteSize = void 0;
    this.uniformBufferWordAlignment = void 0;
    this.uniformBufferMaxPageWordSize = void 0;
    this.supportedSampleCounts = [];
    this.maxVertexAttribs = void 0;
    this.gl = void 0;
    this.gl = gl;
    this.contextAttributes = assertExists(gl.getContextAttributes());

    if (!isWebGL2(gl)) {
      this.OES_vertex_array_object = gl.getExtension('OES_vertex_array_object');
      this.ANGLE_instanced_arrays = gl.getExtension('ANGLE_instanced_arrays');
      this.OES_texture_float = gl.getExtension('OES_texture_float');
      this.WEBGL_draw_buffers = gl.getExtension('WEBGL_draw_buffers');
      this.WEBGL_depth_texture = gl.getExtension('WEBGL_depth_texture'); // @see https://developer.mozilla.org/en-US/docs/Web/API/EXT_frag_depth

      gl.getExtension('EXT_frag_depth'); // @see https://developer.mozilla.org/en-US/docs/Web/API/OES_element_index_uint

      gl.getExtension('OES_element_index_uint'); // @see https://developer.mozilla.org/en-US/docs/Web/API/OES_standard_derivatives

      gl.getExtension('OES_standard_derivatives');

      if (this.WEBGL_draw_buffers) {
        this.supportMRT = true;
      }
    } else {
      this.EXT_texture_norm16 = gl.getExtension('EXT_texture_norm16');
      this.supportMRT = true;
    }

    this.WEBGL_compressed_texture_s3tc = gl.getExtension('WEBGL_compressed_texture_s3tc');
    this.WEBGL_compressed_texture_s3tc_srgb = gl.getExtension('WEBGL_compressed_texture_s3tc_srgb');
    this.EXT_texture_compression_rgtc = gl.getExtension('EXT_texture_compression_rgtc');
    this.EXT_texture_filter_anisotropic = gl.getExtension('EXT_texture_filter_anisotropic');
    this.KHR_parallel_shader_compile = gl.getExtension('KHR_parallel_shader_compile');
    this.OES_draw_buffers_indexed = gl.getExtension('OES_draw_buffers_indexed');

    if (isWebGL2(gl)) {
      this.platformString = 'WebGL2';
      this.glslVersion = '#version 300 es';
    } else {
      this.platformString = 'WebGL1';
      this.glslVersion = '#version 100'; // 100 es not supported
    } // Create our fake swap-chain texture.


    this.scTexture = new Texture_GL({
      id: this.getNextUniqueId(),
      device: this,
      descriptor: {
        width: 0,
        height: 0,
        depth: 1,
        dimension: TextureDimension.n2D,
        numLevels: 1,
        usage: TextureUsage.RenderTarget,
        pixelFormat: this.contextAttributes.alpha === false ? Format.U8_RGB_RT : Format.U8_RGBA_RT
      },
      fake: true
    });
    this.scTexture.formatKind = SamplerFormatKind.Float;
    this.scTexture.gl_target = null;
    this.scTexture.gl_texture = null;
    this.resolveColorReadFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.resolveColorDrawFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.resolveDepthStencilReadFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.resolveDepthStencilDrawFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.renderPassDrawFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.readbackFramebuffer = this.ensureResourceExists(gl.createFramebuffer());
    this.fallbackTexture2D = this.createFallbackTexture(TextureDimension.n2D, SamplerFormatKind.Float);
    this.fallbackTexture2DDepth = this.createFallbackTexture(TextureDimension.n2D, SamplerFormatKind.Depth);

    if (isWebGL2(gl)) ; // Adjust for GL defaults.


    this.currentMegaState.depthCompare = CompareMode.Less;
    this.currentMegaState.depthWrite = false;
    this.currentMegaState.attachmentsState[0].channelWriteMask = ChannelWriteMask.AllChannels; // always have depth test enabled.

    gl.enable(gl.DEPTH_TEST);
    gl.enable(gl.STENCIL_TEST);
    this.checkLimits();

    if (configuration.shaderDebug) {
      this.shaderDebug = true;
    }

    if (configuration.trackResources) {
      this.resourceCreationTracker = new ResourceCreationTracker();
    }
  }

  _createClass(Device_GL, [{
    key: "createFallbackTexture",
    value: function createFallbackTexture(dimension, formatKind) {
      var depth = dimension === TextureDimension.Cube ? 6 : 1;
      var pixelFormat = formatKind === SamplerFormatKind.Depth ? Format.D24 : Format.U8_RGBA_NORM;
      var texture = this.createTexture({
        dimension: dimension,
        pixelFormat: pixelFormat,
        usage: TextureUsage.Sampled,
        width: 1,
        height: 1,
        depth: depth,
        numLevels: 1,
        immutable: true
      }); // this.blackTexture = this.ensureResourceExists(gl.createTexture());
      // gl.bindTexture(GL.TEXTURE_2D, this.blackTexture);
      // gl.texImage2D(
      //   GL.TEXTURE_2D,
      //   0,
      //   isWebGL2(gl) ? gl.RGBA8 : gl.RGBA,
      //   1,
      //   1,
      //   0,
      //   gl.RGBA,
      //   gl.UNSIGNED_BYTE,
      //   new Uint8Array(4),
      // )

      if (formatKind === SamplerFormatKind.Float) {
        texture.setImageData([new Uint8Array(4 * depth)], 0);
      }

      return getPlatformTexture(texture);
    }
  }, {
    key: "getNextUniqueId",
    value: function getNextUniqueId() {
      return ++this.resourceUniqueId;
    }
  }, {
    key: "checkLimits",
    value: function checkLimits() {
      var gl = this.gl;
      this.maxVertexAttribs = gl.getParameter(GL.MAX_VERTEX_ATTRIBS);

      if (isWebGL2(gl)) {
        this.uniformBufferMaxPageByteSize = Math.min(gl.getParameter(GL.MAX_UNIFORM_BLOCK_SIZE), UBO_PAGE_MAX_BYTE_SIZE);
        this.uniformBufferWordAlignment = gl.getParameter(gl.UNIFORM_BUFFER_OFFSET_ALIGNMENT) / 4;
        var supportedSampleCounts = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.DEPTH32F_STENCIL8, gl.SAMPLES);
        this.supportedSampleCounts = supportedSampleCounts ? _toConsumableArray(supportedSampleCounts) : [];
      } else {
        // mock ubo in WebGL1
        this.uniformBufferWordAlignment = 64;
        this.uniformBufferMaxPageByteSize = UBO_PAGE_MAX_BYTE_SIZE;
      }

      this.uniformBufferMaxPageWordSize = this.uniformBufferMaxPageByteSize / 4;

      if (!this.supportedSampleCounts.includes(1)) {
        this.supportedSampleCounts.push(1);
      }

      this.supportedSampleCounts.sort(function (a, b) {
        return a - b;
      });
    } //#region SwapChain

  }, {
    key: "configureSwapChain",
    value: function configureSwapChain(width, height, platformFramebuffer) {
      var texture = this.scTexture;
      texture.width = width;
      texture.height = height;
      this.scPlatformFramebuffer = nullify(platformFramebuffer);
    }
  }, {
    key: "getDevice",
    value: function getDevice() {
      return this;
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this.gl.canvas;
    }
  }, {
    key: "getOnscreenTexture",
    value: function getOnscreenTexture() {
      return this.scTexture;
    }
  }, {
    key: "present",
    value: function present() {
      var gl = this.gl; // Force alpha to white.

      if (this.currentMegaState.attachmentsState[0].channelWriteMask !== ChannelWriteMask.Alpha) {
        gl.colorMask(false, false, false, true);
        this.currentMegaState.attachmentsState[0].channelWriteMask = ChannelWriteMask.Alpha;
      } // TODO: clear depth & stencil
      // @see https://github.com/visgl/luma.gl/blob/30a1039573/modules/webgl/src/classes/clear.ts


      var r = OpaqueWhite.r,
          g = OpaqueWhite.g,
          b = OpaqueWhite.b,
          a = OpaqueWhite.a; // gl.clearColor(r, g, b, a);
      // gl.clear(gl.COLOR_BUFFER_BIT);

      if (isWebGL2(gl)) {
        gl.clearBufferfv(gl.COLOR, 0, [r, g, b, a]);
      } else {
        this.submitBlitRenderPass();
      } // @see https://stackoverflow.com/questions/2143240/opengl-glflush-vs-glfinish
      // gl.flush();

    } //#endregion
    //#region Device
    // @see https://webgl2fundamentals.org/webgl/lessons/webgl-data-textures.html

  }, {
    key: "translateTextureInternalFormat",
    value: function translateTextureInternalFormat(fmt) {
      switch (fmt) {
        case Format.ALPHA:
          return GL.ALPHA;

        case Format.F16_RGBA:
          return GL.RGBA16F;

        case Format.F32_R:
          return GL.R32F;

        case Format.F32_RG:
          return GL.RG32F;

        case Format.F32_RGB:
          return GL.RGB32F;

        case Format.F32_RGBA:
          return GL.RGBA32F;

        case Format.U8_R_NORM:
          return GL.R8;

        case Format.U8_RG_NORM:
          return GL.RG8;

        case Format.U8_RGB_NORM:
        case Format.U8_RGB_RT:
          return GL.RGB8;

        case Format.U8_RGB_SRGB:
          return GL.SRGB8;

        case Format.U8_RGBA_NORM:
        case Format.U8_RGBA_RT:
          return isWebGL2(this.gl) ? GL.RGBA8 : GL.RGBA;

        case Format.U8_RGBA_SRGB:
        case Format.U8_RGBA_RT_SRGB:
          return GL.SRGB8_ALPHA8;

        case Format.U16_R:
          return GL.R16UI;

        case Format.U16_R_NORM:
          return this.EXT_texture_norm16.R16_EXT;

        case Format.U16_RG_NORM:
          return this.EXT_texture_norm16.RG16_EXT;

        case Format.U16_RGBA_NORM:
          return this.EXT_texture_norm16.RGBA16_EXT;

        case Format.U16_RGBA_5551:
          return GL.RGB5_A1;

        case Format.U32_R:
          return GL.R32UI;

        case Format.S8_RGBA_NORM:
          return GL.RGBA8_SNORM;

        case Format.S8_RG_NORM:
          return GL.RG8_SNORM;

        case Format.U16_RGBA_5551:
          return GL.UNSIGNED_SHORT_5_5_5_1;

        case Format.BC1:
          return this.WEBGL_compressed_texture_s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT;

        case Format.BC1_SRGB:
          return this.WEBGL_compressed_texture_s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;

        case Format.BC2:
          return this.WEBGL_compressed_texture_s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT;

        case Format.BC2_SRGB:
          return this.WEBGL_compressed_texture_s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;

        case Format.BC3:
          return this.WEBGL_compressed_texture_s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT;

        case Format.BC3_SRGB:
          return this.WEBGL_compressed_texture_s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;

        case Format.BC4_UNORM:
          return this.EXT_texture_compression_rgtc.COMPRESSED_RED_RGTC1_EXT;

        case Format.BC4_SNORM:
          return this.EXT_texture_compression_rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT;

        case Format.BC5_UNORM:
          return this.EXT_texture_compression_rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT;

        case Format.BC5_SNORM:
          return this.EXT_texture_compression_rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;

        case Format.D32F_S8:
          return isWebGL2(this.gl) ? GL.DEPTH32F_STENCIL8 : GL.DEPTH_STENCIL;

        case Format.D24_S8:
          return isWebGL2(this.gl) ? GL.DEPTH24_STENCIL8 : GL.DEPTH_STENCIL;

        case Format.D32F:
          return isWebGL2(this.gl) ? GL.DEPTH_COMPONENT32F : GL.DEPTH_COMPONENT;

        case Format.D24:
          return isWebGL2(this.gl) ? GL.DEPTH_COMPONENT24 : GL.DEPTH_COMPONENT;

        default:
          throw 'whoops';
      }
    }
  }, {
    key: "translateTextureType",
    value: function translateTextureType(fmt) {
      var typeFlags = getFormatTypeFlags(fmt);

      switch (typeFlags) {
        case FormatTypeFlags.U8:
          return GL.UNSIGNED_BYTE;

        case FormatTypeFlags.U16:
          return GL.UNSIGNED_SHORT;

        case FormatTypeFlags.U32:
          return GL.UNSIGNED_INT;

        case FormatTypeFlags.S8:
          return GL.BYTE;

        case FormatTypeFlags.F16:
          return GL.HALF_FLOAT;

        case FormatTypeFlags.F32:
          return GL.FLOAT;

        case FormatTypeFlags.U16_PACKED_5551:
          return GL.UNSIGNED_SHORT_5_5_5_1;

        case FormatTypeFlags.D32F:
          return GL.FLOAT;

        case FormatTypeFlags.D24:
          return isWebGL2(this.gl) ? GL.UNSIGNED_INT_24_8 : GL.UNSIGNED_SHORT;

        case FormatTypeFlags.D24S8:
          // @see https://developer.mozilla.org/en-US/docs/Web/API/WEBGL_depth_texture
          return isWebGL2(this.gl) ? GL.UNSIGNED_INT_24_8 : GL.UNSIGNED_INT_24_8_WEBGL;

        case FormatTypeFlags.D32FS8:
          return GL.FLOAT_32_UNSIGNED_INT_24_8_REV;

        default:
          throw 'whoops';
      }
    }
  }, {
    key: "translateTextureFormat",
    value: function translateTextureFormat(fmt) {
      if (isTextureFormatCompressed(fmt)) return this.translateTextureInternalFormat(fmt);

      switch (fmt) {
        case Format.D24_S8:
        case Format.D32F_S8:
          return GL.DEPTH_STENCIL;

        case Format.D24:
        case Format.D32F:
          return GL.DEPTH_COMPONENT;
      }

      var isInteger = isFormatSizedInteger(fmt);
      var compFlags = getFormatCompFlags(fmt);

      switch (compFlags) {
        case FormatCompFlags.A:
          return GL.ALPHA;

        case FormatCompFlags.R:
          return isInteger ? GL.RED_INTEGER : GL.RED;

        case FormatCompFlags.RG:
          return isInteger ? GL.RG_INTEGER : GL.RG;

        case FormatCompFlags.RGB:
          return isInteger ? GL.RGB_INTEGER : GL.RGB;

        case FormatCompFlags.RGBA:
          // TODO: Chrome throw error when readPixels RGBA_INTEGER and UNSIGNED_BYTE
          // @see https://github.com/KhronosGroup/WebGL/issues/2747
          // return isInteger ? GL.RGBA_INTEGER : GL.RGBA;
          return GL.RGBA;
      }
    }
  }, {
    key: "setActiveTexture",
    value: function setActiveTexture(texture) {
      if (this.currentActiveTexture !== texture) {
        this.gl.activeTexture(texture);
        this.currentActiveTexture = texture;
      }
    }
  }, {
    key: "bindVAO",
    value: function bindVAO(vao) {
      if (this.currentBoundVAO !== vao) {
        if (isWebGL2(this.gl)) {
          this.gl.bindVertexArray(vao);
        } else {
          this.OES_vertex_array_object.bindVertexArrayOES(vao);
        }

        this.currentBoundVAO = vao;
      }
    }
  }, {
    key: "programCompiled",
    value: function programCompiled(program) {
      assert(program.compileState !== ProgramCompileState_GL.NeedsCompile);

      if (program.compileState === ProgramCompileState_GL.Compiling) {
        program.compileState = ProgramCompileState_GL.NeedsBind;

        if (this.shaderDebug) {
          this.checkProgramCompilationForErrors(program);
        }
      }
    }
  }, {
    key: "useProgram",
    value: function useProgram(program) {
      if (this.currentProgram === program) return;
      this.programCompiled(program);
      this.gl.useProgram(program.gl_program);
      this.currentProgram = program;
    }
  }, {
    key: "ensureResourceExists",
    value: function ensureResourceExists(resource) {
      if (resource === null) {
        var error = this.gl.getError();
        throw new Error("Created resource is null; GL error encountered: ".concat(error));
      } else {
        return resource;
      }
    }
  }, {
    key: "createBuffer",
    value: function createBuffer(descriptor) {
      return new Buffer_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createTexture",
    value: function createTexture(descriptor) {
      return new Texture_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createSampler",
    value: function createSampler(descriptor) {
      return new Sampler_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createRenderTarget",
    value: function createRenderTarget(descriptor) {
      return new RenderTarget_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createRenderTargetFromTexture",
    value: function createRenderTargetFromTexture(texture) {
      var pixelFormat = texture.pixelFormat,
          width = texture.width,
          height = texture.height,
          numLevels = texture.numLevels; // Render targets cannot have a mip chain currently.

      assert(numLevels === 1);
      return this.createRenderTarget({
        pixelFormat: pixelFormat,
        width: width,
        height: height,
        sampleCount: 1,
        texture: texture
      });
    }
  }, {
    key: "createProgram",
    value: function createProgram(descriptor) {
      descriptor.ensurePreprocessed(this.queryVendorInfo());
      return this.createProgramSimple(descriptor);
    }
  }, {
    key: "createProgramSimple",
    value: function createProgramSimple(descriptor) {
      return new Program_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createBindings",
    value: function createBindings(descriptor) {
      var bindingLayout = descriptor.bindingLayout,
          uniformBufferBindings = descriptor.uniformBufferBindings,
          samplerBindings = descriptor.samplerBindings;
      assert(uniformBufferBindings.length >= bindingLayout.numUniformBuffers);
      assert(samplerBindings.length >= bindingLayout.numSamplers);
      return new Bindings_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createInputLayout",
    value: function createInputLayout(descriptor) {
      return new InputLayout_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createInputState",
    value: function createInputState(_inputLayout, vertexBuffers, indexBufferBinding, program) {
      var inputLayout = _inputLayout;
      return new InputState_GL({
        id: this.getNextUniqueId(),
        device: this,
        inputLayout: inputLayout,
        vertexBuffers: vertexBuffers,
        indexBufferBinding: indexBufferBinding,
        program: program
      });
    }
  }, {
    key: "createRenderPipeline",
    value: function createRenderPipeline(descriptor) {
      return new RenderPipeline_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createComputePass",
    value: function createComputePass(computePassDescriptor) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "createComputePipeline",
    value: function createComputePipeline(descriptor) {
      throw new Error('Method not implemented.');
    } // createReadback(byteCount: number): Readback {

  }, {
    key: "createReadback",
    value: function createReadback() {
      return new Readback_GL({
        id: this.getNextUniqueId(),
        device: this // byteCount,

      });
    }
  }, {
    key: "createQueryPool",
    value: function createQueryPool(type, elemCount) {
      return new QueryPool_GL({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: {
          type: type,
          elemCount: elemCount
        }
      });
    }
  }, {
    key: "createRenderPass",
    value: function createRenderPass(descriptor) {
      assert(this.currentRenderPassDescriptor === null);
      this.currentRenderPassDescriptor = descriptor;
      var colorAttachment = descriptor.colorAttachment,
          colorClearColor = descriptor.colorClearColor,
          colorResolveTo = descriptor.colorResolveTo,
          depthStencilAttachment = descriptor.depthStencilAttachment,
          depthClearValue = descriptor.depthClearValue,
          stencilClearValue = descriptor.stencilClearValue,
          depthStencilResolveTo = descriptor.depthStencilResolveTo;
      this.setRenderPassParametersBegin(colorAttachment.length);

      for (var i = 0; i < colorAttachment.length; i++) {
        this.setRenderPassParametersColor(i, colorAttachment[i], colorResolveTo[i]);
      }

      this.setRenderPassParametersDepthStencil(depthStencilAttachment, depthStencilResolveTo);
      this.validateCurrentAttachments();

      for (var _i = 0; _i < colorAttachment.length; _i++) {
        var clearColor = colorClearColor[_i];
        if (clearColor === 'load') continue;
        this.setRenderPassParametersClearColor(_i, clearColor.r, clearColor.g, clearColor.b, clearColor.a);
      }

      this.setRenderPassParametersClearDepthStencil(depthClearValue, stencilClearValue);
      return this;
    }
  }, {
    key: "submitPass",
    value: function submitPass(pass) {
      assert(this.currentRenderPassDescriptor !== null);
      this.endPass();
      this.currentRenderPassDescriptor = null;
    }
  }, {
    key: "copySubTexture2D",
    value: function copySubTexture2D(dst_, dstX, dstY, src_, srcX, srcY) {
      var gl = this.gl;
      var dst = dst_;
      var src = src_;
      assert(src.numLevels === 1);
      assert(dst.numLevels === 1);

      if (isWebGL2(gl)) {
        if (dst === this.scTexture) {
          gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.scPlatformFramebuffer);
        } else {
          gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.resolveColorDrawFramebuffer);
          this.bindFramebufferAttachment(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, dst);
        }

        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveColorReadFramebuffer);
        this.bindFramebufferAttachment(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, src);
        gl.blitFramebuffer(srcX, srcY, srcX + src.width, srcY + src.height, dstX, dstY, dstX + src.width, dstY + src.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
      }
    }
  }, {
    key: "queryLimits",
    value: function queryLimits() {
      return this;
    }
  }, {
    key: "queryTextureFormatSupported",
    value: function queryTextureFormatSupported(format) {
      switch (format) {
        case Format.BC1_SRGB:
        case Format.BC2_SRGB:
        case Format.BC3_SRGB:
          return this.WEBGL_compressed_texture_s3tc_srgb !== null;

        case Format.BC1:
        case Format.BC2:
        case Format.BC3:
          return this.WEBGL_compressed_texture_s3tc !== null;

        case Format.BC4_UNORM:
        case Format.BC4_SNORM:
        case Format.BC5_UNORM:
        case Format.BC5_SNORM:
          return this.EXT_texture_compression_rgtc !== null;

        default:
          return true;
      }
    }
  }, {
    key: "queryProgramReady",
    value: function queryProgramReady(program) {
      var gl = this.gl;

      if (program.compileState === ProgramCompileState_GL.NeedsCompile) {
        // This should not happen.
        throw 'whoops';
      }

      if (program.compileState === ProgramCompileState_GL.Compiling) {
        var complete;

        if (this.KHR_parallel_shader_compile !== null) {
          complete = gl.getProgramParameter(program.gl_program, this.KHR_parallel_shader_compile.COMPLETION_STATUS_KHR);
        } else {
          // If we don't have async shader compilation, assume all compilation is done immediately :/
          complete = true;
        }

        if (complete) this.programCompiled(program);
        return complete;
      }

      return program.compileState === ProgramCompileState_GL.NeedsBind || program.compileState === ProgramCompileState_GL.ReadyToUse;
    }
  }, {
    key: "queryPipelineReady",
    value: function queryPipelineReady(o) {
      var pipeline = o;
      return this.queryProgramReady(pipeline.program);
    }
  }, {
    key: "queryPlatformAvailable",
    value: function queryPlatformAvailable() {
      return this.gl.isContextLost();
    }
  }, {
    key: "queryVendorInfo",
    value: function queryVendorInfo() {
      return this;
    }
  }, {
    key: "queryRenderPass",
    value: function queryRenderPass(o) {
      return this.currentRenderPassDescriptor;
    }
  }, {
    key: "queryRenderTarget",
    value: function queryRenderTarget(o) {
      var renderTarget = o;
      return renderTarget;
    } //#endregion
    //#region Debugging

  }, {
    key: "setResourceName",
    value: function setResourceName(o, name) {
      o.name = name;

      if (o.type === ResourceType.Buffer) {
        var gl_buffer_pages = o.gl_buffer_pages;

        for (var i = 0; i < gl_buffer_pages.length; i++) {
          assignPlatformName(gl_buffer_pages[i], "".concat(name, " Page ").concat(i));
        }
      } else if (o.type === ResourceType.Texture) {
        assignPlatformName(getPlatformTexture(o), name);
      } else if (o.type === ResourceType.Sampler) {
        assignPlatformName(getPlatformSampler(o), name);
      } else if (o.type === ResourceType.RenderTarget) {
        var gl_renderbuffer = o.gl_renderbuffer;
        if (gl_renderbuffer !== null) assignPlatformName(gl_renderbuffer, name);
      } else if (o.type === ResourceType.InputState) {
        assignPlatformName(o.vao, name);
      }
    }
  }, {
    key: "setResourceLeakCheck",
    value: function setResourceLeakCheck(o, v) {
      if (this.resourceCreationTracker !== null) this.resourceCreationTracker.setResourceLeakCheck(o, v);
    }
  }, {
    key: "checkForLeaks",
    value: function checkForLeaks() {
      if (this.resourceCreationTracker !== null) this.resourceCreationTracker.checkForLeaks();
    }
  }, {
    key: "pushDebugGroup",
    value: function pushDebugGroup(debugGroup) {
      this.debugGroupStack.push(debugGroup);
    }
  }, {
    key: "popDebugGroup",
    value: function popDebugGroup() {
      this.debugGroupStack.pop();
    }
  }, {
    key: "programPatched",
    value: function programPatched(o, descriptor) {
      assert(this.shaderDebug); // const program = o as Program_GL;
      // const gl = this.gl;
      // gl.deleteProgram(program.gl_program);
      // program.descriptor = descriptor;
      // program.gl_program = this.ensureResourceExists(gl.createProgram());
      // program.compileState = ProgramCompileState_GL.NeedsCompile;
      // this.tryCompileProgram(program);
      // this.checkProgramCompilationForErrors(program);
    }
  }, {
    key: "getBufferData",
    value: function getBufferData(buffer, dstBuffer) {
      var wordOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var gl = this.gl;

      if (isWebGL2(gl)) {
        gl.bindBuffer(gl.COPY_READ_BUFFER, getPlatformBuffer(buffer, wordOffset * 4));
        gl.getBufferSubData(gl.COPY_READ_BUFFER, wordOffset * 4, dstBuffer);
      }
    } //#endregion

  }, {
    key: "debugGroupStatisticsDrawCall",
    value: function debugGroupStatisticsDrawCall() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = this.debugGroupStack.length - 1; i >= 0; i--) {
        this.debugGroupStack[i].drawCallCount += count;
      }
    }
  }, {
    key: "debugGroupStatisticsBufferUpload",
    value: function debugGroupStatisticsBufferUpload() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = this.debugGroupStack.length - 1; i >= 0; i--) {
        this.debugGroupStack[i].bufferUploadCount += count;
      }
    }
  }, {
    key: "debugGroupStatisticsTextureBind",
    value: function debugGroupStatisticsTextureBind() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = this.debugGroupStack.length - 1; i >= 0; i--) {
        this.debugGroupStack[i].textureBindCount += count;
      }
    }
  }, {
    key: "debugGroupStatisticsTriangles",
    value: function debugGroupStatisticsTriangles(count) {
      for (var i = this.debugGroupStack.length - 1; i >= 0; i--) {
        this.debugGroupStack[i].triangleCount += count;
      }
    }
  }, {
    key: "reportShaderError",
    value: function reportShaderError(shader, str) {
      var gl = this.gl;
      var status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

      if (!status) {
        console.error(prependLineNo(str));
        var debug_shaders = gl.getExtension('WEBGL_debug_shaders');
        if (debug_shaders) console.error(debug_shaders.getTranslatedShaderSource(shader));
        console.error(gl.getShaderInfoLog(shader));
      }

      return status;
    }
  }, {
    key: "checkProgramCompilationForErrors",
    value: function checkProgramCompilationForErrors(program) {
      var gl = this.gl;
      var prog = program.gl_program;

      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
        var descriptor = program.descriptor;
        if (!this.reportShaderError(program.gl_shader_vert, descriptor.preprocessedVert)) return;
        if (!this.reportShaderError(program.gl_shader_frag, descriptor.preprocessedFrag)) return; // Neither shader had an error, report the program info log.

        console.error(gl.getProgramInfoLog(program.gl_program));
      }
    }
  }, {
    key: "bindFramebufferAttachment",
    value: function bindFramebufferAttachment(framebuffer, binding, attachment) {
      var gl = this.gl;

      if (attachment === null) {
        gl.framebufferRenderbuffer(framebuffer, binding, gl.RENDERBUFFER, null);
      } else if (attachment.type === ResourceType.RenderTarget) {
        if (attachment.gl_renderbuffer !== null) {
          gl.framebufferRenderbuffer(framebuffer, binding, gl.RENDERBUFFER, attachment.gl_renderbuffer);
        } else if (attachment.texture !== null) {
          gl.framebufferTexture2D(framebuffer, binding, GL.TEXTURE_2D, getPlatformTexture(attachment.texture), 0);
        }
      } else if (attachment.type === ResourceType.Texture) {
        // TODO: use Tex2D array with gl.framebufferTextureLayer
        gl.framebufferTexture2D(framebuffer, binding, GL.TEXTURE_2D, getPlatformTexture(attachment), 0);
      }
    }
  }, {
    key: "bindFramebufferDepthStencilAttachment",
    value: function bindFramebufferDepthStencilAttachment(framebuffer, attachment) {
      var gl = this.gl;
      var flags = attachment !== null ? getFormatFlags(attachment.pixelFormat) : FormatFlags.Depth | FormatFlags.Stencil;
      var depth = !!(flags & FormatFlags.Depth),
          stencil = !!(flags & FormatFlags.Stencil);

      if (depth && stencil) {
        this.bindFramebufferAttachment(framebuffer, gl.DEPTH_STENCIL_ATTACHMENT, attachment);
      } else if (depth) {
        this.bindFramebufferAttachment(framebuffer, gl.DEPTH_ATTACHMENT, attachment);
        this.bindFramebufferAttachment(framebuffer, gl.STENCIL_ATTACHMENT, null);
      } else if (stencil) {
        this.bindFramebufferAttachment(framebuffer, gl.STENCIL_ATTACHMENT, attachment);
        this.bindFramebufferAttachment(framebuffer, gl.DEPTH_ATTACHMENT, null);
      }
    }
  }, {
    key: "validateCurrentAttachments",
    value: function validateCurrentAttachments() {
      var sampleCount = -1,
          width = -1,
          height = -1;

      for (var i = 0; i < this.currentColorAttachments.length; i++) {
        var attachment = this.currentColorAttachments[i];
        if (attachment === null) continue;

        if (sampleCount === -1) {
          sampleCount = attachment.sampleCount;
          width = attachment.width;
          height = attachment.height;
        } else {
          assert(sampleCount === attachment.sampleCount);
          assert(width === attachment.width);
          assert(height === attachment.height);
        }
      }

      if (this.currentDepthStencilAttachment !== null) {
        if (sampleCount === -1) {
          sampleCount = this.currentDepthStencilAttachment.sampleCount;
          width = this.currentDepthStencilAttachment.width;
          height = this.currentDepthStencilAttachment.height;
        } else {
          assert(sampleCount === this.currentDepthStencilAttachment.sampleCount);
          assert(width === this.currentDepthStencilAttachment.width);
          assert(height === this.currentDepthStencilAttachment.height);
        }
      }

      this.currentSampleCount = sampleCount;
    }
  }, {
    key: "setRenderPassParametersBegin",
    value: function setRenderPassParametersBegin(numColorAttachments) {
      var gl = this.gl;

      if (isWebGL2(gl)) {
        gl.bindFramebuffer(GL.DRAW_FRAMEBUFFER, this.renderPassDrawFramebuffer);
      } else {
        if (!this.inBlitRenderPass) {
          gl.bindFramebuffer(GL.FRAMEBUFFER, this.renderPassDrawFramebuffer);
        }
      }

      if (!this.inBlitRenderPass) {
        for (var i = numColorAttachments; i < this.currentColorAttachments.length; i++) {
          var target = isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER;
          var attachment = isWebGL2(gl) ? GL.COLOR_ATTACHMENT0 : GL.COLOR_ATTACHMENT0_WEBGL;
          gl.framebufferRenderbuffer(target, attachment + i, GL.RENDERBUFFER, null);
          gl.framebufferTexture2D(target, attachment + i, GL.TEXTURE_2D, null, 0);
        }
      }

      this.currentColorAttachments.length = numColorAttachments;

      if (isWebGL2(gl)) {
        gl.drawBuffers([GL.COLOR_ATTACHMENT0, GL.COLOR_ATTACHMENT1, GL.COLOR_ATTACHMENT2, GL.COLOR_ATTACHMENT3]);
      } else {
        if (!this.inBlitRenderPass) {
          // MRT @see https://github.com/shrekshao/MoveWebGL1EngineToWebGL2/blob/master/Move-a-WebGL-1-Engine-To-WebGL-2-Blog-1.md#multiple-render-targets
          this.WEBGL_draw_buffers.drawBuffersWEBGL([GL.COLOR_ATTACHMENT0_WEBGL, GL.COLOR_ATTACHMENT1_WEBGL, GL.COLOR_ATTACHMENT2_WEBGL, GL.COLOR_ATTACHMENT3_WEBGL // gl_FragData[3]
          ]);
        }
      }
    }
  }, {
    key: "setRenderPassParametersColor",
    value: function setRenderPassParametersColor(i, colorAttachment, colorResolveTo) {
      var gl = this.gl;

      if (this.currentColorAttachments[i] !== colorAttachment) {
        this.currentColorAttachments[i] = colorAttachment;
        this.bindFramebufferAttachment(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, (isWebGL2(gl) ? GL.COLOR_ATTACHMENT0 : GL.COLOR_ATTACHMENT0_WEBGL) + i, colorAttachment);
        this.resolveColorAttachmentsChanged = true;
      }

      if (this.currentColorResolveTos[i] !== colorResolveTo) {
        this.currentColorResolveTos[i] = colorResolveTo;

        if (colorResolveTo !== null) {
          this.resolveColorAttachmentsChanged = true;
        }
      }
    }
  }, {
    key: "setRenderPassParametersDepthStencil",
    value: function setRenderPassParametersDepthStencil(depthStencilAttachment, depthStencilResolveTo) {
      var gl = this.gl;

      if (this.currentDepthStencilAttachment !== depthStencilAttachment) {
        this.currentDepthStencilAttachment = depthStencilAttachment;

        if (!this.inBlitRenderPass) {
          this.bindFramebufferDepthStencilAttachment(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, this.currentDepthStencilAttachment);
        }

        this.resolveDepthStencilAttachmentsChanged = true;
      }

      if (this.currentDepthStencilResolveTo !== depthStencilResolveTo) {
        this.currentDepthStencilResolveTo = depthStencilResolveTo;

        if (depthStencilResolveTo !== null) {
          this.resolveDepthStencilAttachmentsChanged = true;
        }
      }
    }
  }, {
    key: "setRenderPassParametersClearColor",
    value: function setRenderPassParametersClearColor(slot, r, g, b, a) {
      var gl = this.gl;

      if (this.OES_draw_buffers_indexed !== null) {
        var attachment = this.currentMegaState.attachmentsState[slot];

        if (attachment && attachment.channelWriteMask !== ChannelWriteMask.AllChannels) {
          this.OES_draw_buffers_indexed.colorMaskiOES(slot, true, true, true, true);
          attachment.channelWriteMask = ChannelWriteMask.AllChannels;
        }
      } else {
        var _attachment = this.currentMegaState.attachmentsState[0];

        if (_attachment && _attachment.channelWriteMask !== ChannelWriteMask.AllChannels) {
          gl.colorMask(true, true, true, true);
          _attachment.channelWriteMask = ChannelWriteMask.AllChannels;
        }
      }

      this.setScissorEnabled(false);

      if (isWebGL2(gl)) {
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/clearBuffer
        gl.clearBufferfv(gl.COLOR, slot, [r, g, b, a]);
      } else {
        gl.clearColor(r, g, b, a);
        gl.clear(gl.COLOR_BUFFER_BIT);
      }
    }
  }, {
    key: "setRenderPassParametersClearDepthStencil",
    value: function setRenderPassParametersClearDepthStencil(depthClearValue, stencilClearValue) {
      var gl = this.gl;

      if (depthClearValue !== 'load') {
        assert(this.currentDepthStencilAttachment !== null); // GL clears obey the masks... bad API or worst API?

        if (!this.currentMegaState.depthWrite) {
          gl.depthMask(true);
          this.currentMegaState.depthWrite = true;
        }

        if (isWebGL2(gl)) {
          gl.clearBufferfv(gl.DEPTH, 0, [depthClearValue]);
        } else {
          gl.clearDepth(depthClearValue);
          gl.clear(gl.DEPTH_BUFFER_BIT);
        }
      }

      if (stencilClearValue !== 'load') {
        assert(this.currentDepthStencilAttachment !== null);

        if (!this.currentMegaState.stencilWrite) {
          gl.enable(gl.STENCIL_TEST);
          gl.stencilMask(0xff);
          this.currentMegaState.stencilWrite = true;
        }

        if (isWebGL2(gl)) {
          gl.clearBufferiv(gl.STENCIL, 0, [stencilClearValue]);
        } else {
          gl.clearStencil(stencilClearValue);
          gl.clear(gl.STENCIL_BUFFER_BIT);
        }
      }
    }
  }, {
    key: "setBindings",
    value: function setBindings(bindingLayoutIndex, bindings_, dynamicByteOffsets) {
      var gl = this.gl;
      assert(bindingLayoutIndex < this.currentPipeline.bindingLayouts.bindingLayoutTables.length);
      var bindingLayoutTable = this.currentPipeline.bindingLayouts.bindingLayoutTables[bindingLayoutIndex];
      var uniformBufferBindings = bindings_.uniformBufferBindings,
          samplerBindings = bindings_.samplerBindings; // Ignore extra bindings.

      assert(uniformBufferBindings.length >= bindingLayoutTable.numUniformBuffers);
      assert(samplerBindings.length >= bindingLayoutTable.numSamplers);
      assert(dynamicByteOffsets.length >= uniformBufferBindings.length);

      for (var i = 0; i < uniformBufferBindings.length; i++) {
        var binding = uniformBufferBindings[i];
        if (binding.wordCount === 0) continue;
        var index = bindingLayoutTable.firstUniformBuffer + i;
        var buffer = binding.buffer;
        var byteOffset = dynamicByteOffsets[i];
        var byteSize = binding.wordCount * 4;

        if (buffer !== this.currentUniformBuffers[index] || byteOffset !== this.currentUniformBufferByteOffsets[index] || byteSize !== this.currentUniformBufferByteSizes[index]) {
          var platformBufferByteOffset = byteOffset % buffer.pageByteSize;
          var platformBuffer = buffer.gl_buffer_pages[byteOffset / buffer.pageByteSize | 0];
          assert(platformBufferByteOffset + byteSize <= buffer.pageByteSize);

          if (isWebGL2(gl)) {
            gl.bindBufferRange(gl.UNIFORM_BUFFER, index, platformBuffer, platformBufferByteOffset, byteSize);
          }

          this.currentUniformBuffers[index] = buffer;
          this.currentUniformBufferByteOffsets[index] = byteOffset;
          this.currentUniformBufferByteSizes[index] = byteSize;
        }
      }

      for (var _i2 = 0; _i2 < bindingLayoutTable.numSamplers; _i2++) {
        var _binding = samplerBindings[_i2];
        var samplerIndex = bindingLayoutTable.firstSampler + _i2;
        var samplerEntry = bindingLayoutTable.samplerEntries[_i2];
        var gl_sampler = _binding !== null && _binding.sampler !== null ? getPlatformSampler(_binding.sampler) : null;
        var gl_texture = _binding !== null && _binding.texture !== null ? getPlatformTexture(_binding.texture) : null;

        if (this.currentSamplers[samplerIndex] !== gl_sampler) {
          if (isWebGL2(gl)) {
            gl.bindSampler(samplerIndex, gl_sampler);
          }

          this.currentSamplers[samplerIndex] = gl_sampler;
        }

        if (this.currentTextures[samplerIndex] !== gl_texture) {
          this.setActiveTexture(gl.TEXTURE0 + samplerIndex);

          if (gl_texture !== null) {
            // update index
            _binding.texture.textureIndex = samplerIndex;
            var _assertExists$texture = assertExists(_binding).texture,
                gl_target = _assertExists$texture.gl_target,
                formatKind = _assertExists$texture.formatKind,
                width = _assertExists$texture.width,
                height = _assertExists$texture.height;
            gl.bindTexture(gl_target, gl_texture); // In WebGL1 set tex's parameters @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texParameter

            if (!isWebGL2(gl)) {
              var _binding$sampler;

              (_binding$sampler = _binding.sampler) === null || _binding$sampler === void 0 ? void 0 : _binding$sampler.setTextureParameters(gl_target, width, height);
            }

            this.debugGroupStatisticsTextureBind();
            assert(samplerEntry.gl_target === gl_target); // assert(samplerEntry.formatKind === formatKind);
          } else {
            gl.bindTexture(samplerEntry.gl_target, this.getFallbackTexture(samplerEntry));
          }

          this.currentTextures[samplerIndex] = gl_texture;
        }
      }
    }
  }, {
    key: "setViewport",
    value: function setViewport(x, y, w, h) {
      var gl = this.gl;
      gl.viewport(x, y, w, h);
    }
  }, {
    key: "setScissor",
    value: function setScissor(x, y, w, h) {
      var gl = this.gl;
      this.setScissorEnabled(true);
      gl.scissor(x, y, w, h);
    }
  }, {
    key: "applyAttachmentStateIndexed",
    value: function applyAttachmentStateIndexed(i, currentAttachmentState, newAttachmentState) {
      var gl = this.gl;
      var dbi = this.OES_draw_buffers_indexed;

      if (currentAttachmentState.channelWriteMask !== newAttachmentState.channelWriteMask) {
        dbi.colorMaskiOES(i, !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Red), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Green), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Blue), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Alpha));
        currentAttachmentState.channelWriteMask = newAttachmentState.channelWriteMask;
      }

      var blendModeChanged = currentAttachmentState.rgbBlendState.blendMode !== newAttachmentState.rgbBlendState.blendMode || currentAttachmentState.alphaBlendState.blendMode !== newAttachmentState.alphaBlendState.blendMode;
      var blendFuncChanged = currentAttachmentState.rgbBlendState.blendSrcFactor !== newAttachmentState.rgbBlendState.blendSrcFactor || currentAttachmentState.alphaBlendState.blendSrcFactor !== newAttachmentState.alphaBlendState.blendSrcFactor || currentAttachmentState.rgbBlendState.blendDstFactor !== newAttachmentState.rgbBlendState.blendDstFactor || currentAttachmentState.alphaBlendState.blendDstFactor !== newAttachmentState.alphaBlendState.blendDstFactor;

      if (blendFuncChanged || blendModeChanged) {
        if (isBlendStateNone(currentAttachmentState.rgbBlendState) && isBlendStateNone(currentAttachmentState.alphaBlendState)) dbi.enableiOES(i, gl.BLEND);else if (isBlendStateNone(newAttachmentState.rgbBlendState) && isBlendStateNone(newAttachmentState.alphaBlendState)) dbi.disableiOES(i, gl.BLEND);
      }

      if (blendModeChanged) {
        dbi.blendEquationSeparateiOES(i, newAttachmentState.rgbBlendState.blendMode, newAttachmentState.alphaBlendState.blendMode);
        currentAttachmentState.rgbBlendState.blendMode = newAttachmentState.rgbBlendState.blendMode;
        currentAttachmentState.alphaBlendState.blendMode = newAttachmentState.alphaBlendState.blendMode;
      }

      if (blendFuncChanged) {
        dbi.blendFuncSeparateiOES(i, newAttachmentState.rgbBlendState.blendSrcFactor, newAttachmentState.rgbBlendState.blendDstFactor, newAttachmentState.alphaBlendState.blendSrcFactor, newAttachmentState.alphaBlendState.blendDstFactor);
        currentAttachmentState.rgbBlendState.blendSrcFactor = newAttachmentState.rgbBlendState.blendSrcFactor;
        currentAttachmentState.alphaBlendState.blendSrcFactor = newAttachmentState.alphaBlendState.blendSrcFactor;
        currentAttachmentState.rgbBlendState.blendDstFactor = newAttachmentState.rgbBlendState.blendDstFactor;
        currentAttachmentState.alphaBlendState.blendDstFactor = newAttachmentState.alphaBlendState.blendDstFactor;
      }
    }
  }, {
    key: "applyAttachmentState",
    value: function applyAttachmentState(currentAttachmentState, newAttachmentState) {
      var gl = this.gl;

      if (currentAttachmentState.channelWriteMask !== newAttachmentState.channelWriteMask) {
        gl.colorMask(!!(newAttachmentState.channelWriteMask & ChannelWriteMask.Red), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Green), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Blue), !!(newAttachmentState.channelWriteMask & ChannelWriteMask.Alpha));
        currentAttachmentState.channelWriteMask = newAttachmentState.channelWriteMask;
      }

      var blendModeChanged = currentAttachmentState.rgbBlendState.blendMode !== newAttachmentState.rgbBlendState.blendMode || currentAttachmentState.alphaBlendState.blendMode !== newAttachmentState.alphaBlendState.blendMode;
      var blendFuncChanged = currentAttachmentState.rgbBlendState.blendSrcFactor !== newAttachmentState.rgbBlendState.blendSrcFactor || currentAttachmentState.alphaBlendState.blendSrcFactor !== newAttachmentState.alphaBlendState.blendSrcFactor || currentAttachmentState.rgbBlendState.blendDstFactor !== newAttachmentState.rgbBlendState.blendDstFactor || currentAttachmentState.alphaBlendState.blendDstFactor !== newAttachmentState.alphaBlendState.blendDstFactor;

      if (blendFuncChanged || blendModeChanged) {
        if (isBlendStateNone(currentAttachmentState.rgbBlendState) && isBlendStateNone(currentAttachmentState.alphaBlendState)) {
          gl.enable(gl.BLEND);
        } else if (isBlendStateNone(newAttachmentState.rgbBlendState) && isBlendStateNone(newAttachmentState.alphaBlendState)) {
          gl.disable(gl.BLEND);
        }
      }

      if (blendModeChanged) {
        gl.blendEquationSeparate(newAttachmentState.rgbBlendState.blendMode, newAttachmentState.alphaBlendState.blendMode);
        currentAttachmentState.rgbBlendState.blendMode = newAttachmentState.rgbBlendState.blendMode;
        currentAttachmentState.alphaBlendState.blendMode = newAttachmentState.alphaBlendState.blendMode;
      }

      if (blendFuncChanged) {
        gl.blendFuncSeparate(newAttachmentState.rgbBlendState.blendSrcFactor, newAttachmentState.rgbBlendState.blendDstFactor, newAttachmentState.alphaBlendState.blendSrcFactor, newAttachmentState.alphaBlendState.blendDstFactor);
        currentAttachmentState.rgbBlendState.blendSrcFactor = newAttachmentState.rgbBlendState.blendSrcFactor;
        currentAttachmentState.alphaBlendState.blendSrcFactor = newAttachmentState.alphaBlendState.blendSrcFactor;
        currentAttachmentState.rgbBlendState.blendDstFactor = newAttachmentState.rgbBlendState.blendDstFactor;
        currentAttachmentState.alphaBlendState.blendDstFactor = newAttachmentState.alphaBlendState.blendDstFactor;
      }
    }
  }, {
    key: "setMegaState",
    value: function setMegaState(newMegaState) {
      var gl = this.gl;
      var currentMegaState = this.currentMegaState;

      if (this.OES_draw_buffers_indexed !== null) {
        for (var i = 0; i < newMegaState.attachmentsState.length; i++) {
          this.applyAttachmentStateIndexed(i, currentMegaState.attachmentsState[0], newMegaState.attachmentsState[0]);
        }
      } else {
        assert(newMegaState.attachmentsState.length === 1);
        this.applyAttachmentState(currentMegaState.attachmentsState[0], newMegaState.attachmentsState[0]);
      }

      if (!colorEqual(currentMegaState.blendConstant, newMegaState.blendConstant)) {
        gl.blendColor(newMegaState.blendConstant.r, newMegaState.blendConstant.g, newMegaState.blendConstant.b, newMegaState.blendConstant.a);
        colorCopy(currentMegaState.blendConstant, newMegaState.blendConstant);
      }

      if (currentMegaState.depthCompare !== newMegaState.depthCompare) {
        gl.depthFunc(newMegaState.depthCompare);
        currentMegaState.depthCompare = newMegaState.depthCompare;
      }

      if (currentMegaState.depthWrite !== newMegaState.depthWrite) {
        gl.depthMask(newMegaState.depthWrite);
        currentMegaState.depthWrite = newMegaState.depthWrite;
      }

      if (currentMegaState.stencilWrite !== newMegaState.stencilWrite) {
        // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/stencilMask
        gl.stencilMask(newMegaState.stencilWrite ? 0xff : 0x00);
        currentMegaState.stencilWrite = newMegaState.stencilWrite;
      }

      if (currentMegaState.stencilPassOp !== newMegaState.stencilPassOp) {
        gl.stencilOp(gl.KEEP, gl.KEEP, newMegaState.stencilPassOp);
        currentMegaState.stencilPassOp = newMegaState.stencilPassOp;
      }

      if (currentMegaState.stencilRef !== newMegaState.stencilRef || currentMegaState.stencilCompare !== newMegaState.stencilCompare) {
        currentMegaState.stencilCompare = newMegaState.stencilCompare;
        this.setStencilRef(newMegaState.stencilRef);
      }

      if (currentMegaState.cullMode !== newMegaState.cullMode) {
        if (currentMegaState.cullMode === CullMode.None) gl.enable(gl.CULL_FACE);else if (newMegaState.cullMode === CullMode.None) gl.disable(gl.CULL_FACE);
        if (newMegaState.cullMode === CullMode.Back) gl.cullFace(gl.BACK);else if (newMegaState.cullMode === CullMode.Front) gl.cullFace(gl.FRONT);else if (newMegaState.cullMode === CullMode.FrontAndBack) gl.cullFace(gl.FRONT_AND_BACK);
        currentMegaState.cullMode = newMegaState.cullMode;
      }

      if (currentMegaState.frontFace !== newMegaState.frontFace) {
        gl.frontFace(newMegaState.frontFace);
        currentMegaState.frontFace = newMegaState.frontFace;
      }

      if (currentMegaState.polygonOffset !== newMegaState.polygonOffset) {
        if (newMegaState.polygonOffset) {
          gl.polygonOffset(1, 1);
          gl.enable(gl.POLYGON_OFFSET_FILL);
        } else {
          gl.disable(gl.POLYGON_OFFSET_FILL);
        }

        currentMegaState.polygonOffset = newMegaState.polygonOffset;
      }
    }
  }, {
    key: "validatePipelineFormats",
    value: function validatePipelineFormats(pipeline) {
      for (var i = 0; i < this.currentColorAttachments.length; i++) {
        var attachment = this.currentColorAttachments[i];
        if (attachment === null) continue;
        assert(attachment.pixelFormat === pipeline.colorAttachmentFormats[i]);
      }

      if (this.currentDepthStencilAttachment !== null) {
        assert(this.currentDepthStencilAttachment.pixelFormat === pipeline.depthStencilAttachmentFormat);
      }

      if (this.currentSampleCount !== -1) {
        assert(this.currentSampleCount === pipeline.sampleCount);
      }
    }
  }, {
    key: "setPipeline",
    value: function setPipeline(o) {
      this.currentPipeline = o;
      this.validatePipelineFormats(this.currentPipeline); // We allow users to use "non-ready" pipelines for emergencies. In this case, there can be a bit of stuttering.
      // assert(this.queryPipelineReady(this.currentPipeline));

      this.setMegaState(this.currentPipeline.megaState);
      var program = this.currentPipeline.program;
      this.useProgram(program);

      if (program.compileState === ProgramCompileState_GL.NeedsBind) {
        var gl = this.gl;
        var prog = program.gl_program;
        var deviceProgram = program.descriptor;
        var uniformBlocks = findall(deviceProgram.preprocessedVert, /uniform (\w+) {([^]*?)}/g);

        if (isWebGL2(gl)) {
          for (var i = 0; i < uniformBlocks.length; i++) {
            var _uniformBlocks$i = _slicedToArray(uniformBlocks[i], 3),
                m = _uniformBlocks$i[0],
                blockName = _uniformBlocks$i[1],
                contents = _uniformBlocks$i[2]; // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/getUniformBlockIndex


            var blockIdx = gl.getUniformBlockIndex(prog, blockName);

            if (blockIdx !== -1 && blockIdx !== 0xffffffff) {
              // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/uniformBlockBinding
              gl.uniformBlockBinding(prog, blockIdx, i);
            }
          }
        } // TODO: uniform1iv in WebGL1


        var samplers = findall(deviceProgram.preprocessedVert, /^uniform .*sampler\S+ (\w+);\s* \/\/ BINDING=(\d+)$/gm);

        for (var _i3 = 0; _i3 < samplers.length; _i3++) {
          var _samplers$_i = _slicedToArray(samplers[_i3], 3),
              _m = _samplers$_i[0],
              name = _samplers$_i[1],
              location = _samplers$_i[2];

          var samplerUniformLocation = gl.getUniformLocation(prog, name);
          gl.uniform1i(samplerUniformLocation, parseInt(location));
        }

        program.compileState = ProgramCompileState_GL.ReadyToUse;
      }
    }
  }, {
    key: "setInputState",
    value: function setInputState(inputState_) {
      var inputState = inputState_;
      this.currentInputState = inputState;

      if (this.currentInputState !== null) {
        assert(this.currentPipeline.inputLayout === this.currentInputState.inputLayout);
        this.bindVAO(this.currentInputState.vao);
      } else {
        assert(this.currentPipeline.inputLayout === null);
        this.bindVAO(null);
      }
    }
  }, {
    key: "setStencilRef",
    value: function setStencilRef(value) {
      this.currentStencilRef = value;
      this.applyStencil();
    }
  }, {
    key: "draw",
    value: function draw(count, firstVertex) {
      var gl = this.gl;
      var pipeline = this.currentPipeline;
      gl.drawArrays(pipeline.drawMode, firstVertex, count);
      this.debugGroupStatisticsDrawCall();
      this.debugGroupStatisticsTriangles(count / 3);
    }
  }, {
    key: "drawIndexed",
    value: function drawIndexed(count, firstIndex) {
      var gl = this.gl;
      var pipeline = this.currentPipeline;
      var inputState = this.currentInputState;
      var byteOffset = assertExists(inputState.indexBufferByteOffset) + firstIndex * assertExists(inputState.indexBufferCompByteSize);
      gl.drawElements(pipeline.drawMode, count, assertExists(inputState.indexBufferType), byteOffset);
      this.debugGroupStatisticsDrawCall();
      this.debugGroupStatisticsTriangles(count / 3);
    }
  }, {
    key: "drawIndexedInstanced",
    value: function drawIndexedInstanced(count, firstIndex, instanceCount) {
      var gl = this.gl;
      var pipeline = this.currentPipeline;
      var inputState = this.currentInputState;
      var byteOffset = assertExists(inputState.indexBufferByteOffset) + firstIndex * assertExists(inputState.indexBufferCompByteSize);
      var params = [pipeline.drawMode, count, assertExists(inputState.indexBufferType), byteOffset, instanceCount];

      if (isWebGL2(gl)) {
        gl.drawElementsInstanced.apply(gl, params);
      } else {
        var _this$ANGLE_instanced;

        (_this$ANGLE_instanced = this.ANGLE_instanced_arrays).drawElementsInstancedANGLE.apply(_this$ANGLE_instanced, params);
      }

      this.debugGroupStatisticsDrawCall();
      this.debugGroupStatisticsTriangles(count / 3 * instanceCount);
    }
  }, {
    key: "beginOcclusionQuery",
    value: function beginOcclusionQuery(dstOffs) {
      var gl = this.gl;

      if (isWebGL2(gl)) {
        var queryPool = this.currentRenderPassDescriptor.occlusionQueryPool;
        gl.beginQuery(queryPool.gl_query_type, queryPool.gl_query[dstOffs]);
      }
    }
  }, {
    key: "endOcclusionQuery",
    value: function endOcclusionQuery(dstOffs) {
      var gl = this.gl;

      if (isWebGL2(gl)) {
        var queryPool = this.currentRenderPassDescriptor.occlusionQueryPool;
        gl.endQuery(queryPool.gl_query_type);
      }
    }
  }, {
    key: "beginDebugGroup",
    value: function beginDebugGroup(name) {}
  }, {
    key: "endDebugGroup",
    value: function endDebugGroup() {}
  }, {
    key: "pipelineQueryReady",
    value: function pipelineQueryReady(o) {
      var pipeline = o;
      return this.queryProgramReady(pipeline.program);
    }
  }, {
    key: "pipelineForceReady",
    value: function pipelineForceReady(o) {// No need to do anything; it will be forced to compile when used naturally.
    }
  }, {
    key: "endPass",
    value: function endPass() {
      var gl = this.gl;
      var didUnbind = false;

      for (var i = 0; i < this.currentColorAttachments.length; i++) {
        var colorResolveTo = this.currentColorResolveTos[i];

        if (colorResolveTo !== null) {
          var colorResolveFrom = assertExists(this.currentColorAttachments[i]);
          assert(colorResolveFrom.width === colorResolveTo.width && colorResolveFrom.height === colorResolveTo.height);
          assert(colorResolveFrom.pixelFormat === colorResolveTo.pixelFormat);
          gl.disable(GL.SCISSOR_TEST);

          if (isWebGL2(gl)) {
            // set read frame buffer
            gl.bindFramebuffer(GL.READ_FRAMEBUFFER, this.resolveColorReadFramebuffer);
          } // Special case: Blitting to the on-screen.


          if (colorResolveTo === this.scTexture) {
            gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, this.scPlatformFramebuffer);

            if (this.resolveColorAttachmentsChanged) {
              if (isWebGL2(gl)) {
                this.bindFramebufferAttachment(GL.READ_FRAMEBUFFER, GL.COLOR_ATTACHMENT0, colorResolveFrom);
              }
            }

            if (isWebGL2(gl)) {
              // @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/blitFramebuffer
              gl.blitFramebuffer(0, 0, colorResolveFrom.width, colorResolveFrom.height, 0, 0, colorResolveTo.width, colorResolveTo.height, GL.COLOR_BUFFER_BIT, GL.LINEAR);
            } else {
              // render target texture
              gl.bindTexture(GL.TEXTURE_2D, colorResolveFrom.texture.gl_texture);
            }

            didUnbind = true;
          } else {
            gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, this.resolveColorDrawFramebuffer);

            if (this.resolveColorAttachmentsChanged) {
              this.bindFramebufferAttachment(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, isWebGL2(gl) ? GL.COLOR_ATTACHMENT0 : GL.COLOR_ATTACHMENT0_WEBGL, colorResolveFrom);
              gl.framebufferTexture2D(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, isWebGL2(gl) ? GL.COLOR_ATTACHMENT0 : GL.COLOR_ATTACHMENT0_WEBGL, GL.TEXTURE_2D, colorResolveTo.gl_texture, 0);
            }

            if (isWebGL2(gl)) {
              gl.blitFramebuffer(0, 0, colorResolveFrom.width, colorResolveFrom.height, 0, 0, colorResolveTo.width, colorResolveTo.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            }

            gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, null);
            didUnbind = true;
          }

          if (isWebGL2(gl)) {
            gl.bindFramebuffer(GL.READ_FRAMEBUFFER, null);
          }
        }
      }

      this.resolveColorAttachmentsChanged = false;
      var depthStencilResolveFrom = this.currentDepthStencilAttachment;
      var depthStencilResolveTo = this.currentDepthStencilResolveTo;

      if (depthStencilResolveFrom !== null && depthStencilResolveTo !== null) {
        assert(depthStencilResolveFrom.width === depthStencilResolveTo.width && depthStencilResolveFrom.height === depthStencilResolveTo.height);
        gl.disable(gl.SCISSOR_TEST);
        gl.bindFramebuffer(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, this.resolveDepthStencilReadFramebuffer);
        gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, this.resolveDepthStencilDrawFramebuffer);

        if (this.resolveDepthStencilAttachmentsChanged) {
          this.bindFramebufferDepthStencilAttachment(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, depthStencilResolveFrom);
          this.bindFramebufferDepthStencilAttachment(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, depthStencilResolveTo);
        }

        if (isWebGL2(gl)) {
          gl.blitFramebuffer(0, 0, depthStencilResolveFrom.width, depthStencilResolveFrom.height, 0, 0, depthStencilResolveTo.width, depthStencilResolveTo.height, gl.DEPTH_BUFFER_BIT, gl.NEAREST);
        }

        gl.bindFramebuffer(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, null);
        gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, null);
        didUnbind = true;
      }

      this.resolveDepthStencilAttachmentsChanged = false;

      if (!didUnbind) {
        // If we did not unbind from a resolve, then we need to unbind our render pass draw FBO here.
        gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, null);
      }
    } // private endPass(): void {
    //   const gl = this.gl;
    //   let didUnbindDraw = false;
    //   for (let i = 0; i < this.currentColorAttachments.length; i++) {
    //     const colorResolveFrom = this.currentColorAttachments[i];
    //     if (colorResolveFrom !== null) {
    //       const colorResolveTo = this.currentColorResolveTos[i];
    //       let didBindRead = false;
    //       if (colorResolveTo !== null) {
    //         assert(
    //           colorResolveFrom.width === colorResolveTo.width &&
    //             colorResolveFrom.height === colorResolveTo.height,
    //         );
    //         assert(colorResolveFrom.pixelFormat === colorResolveTo.pixelFormat);
    //         this.setScissorEnabled(false);
    //         if (isWebGL2(gl)) {
    //           gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveColorReadFramebuffer);
    //         }
    //         if (this.resolveColorAttachmentsChanged) {
    //           if (isWebGL2(gl)) {
    //             this.bindFramebufferAttachment(
    //               gl.READ_FRAMEBUFFER,
    //               gl.COLOR_ATTACHMENT0,
    //               colorResolveFrom,
    //             );
    //           }
    //         }
    //         didBindRead = true;
    //         // Special case: Blitting to the on-screen.
    //         if (colorResolveTo === this.scTexture) {
    //           gl.bindFramebuffer(
    //             isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER,
    //             this.scPlatformFramebuffer,
    //           );
    //         } else {
    //           gl.bindFramebuffer(
    //             isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER,
    //             this.resolveColorDrawFramebuffer,
    //           );
    //           if (this.resolveColorAttachmentsChanged)
    //             gl.framebufferTexture2D(
    //               isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER,
    //               gl.COLOR_ATTACHMENT0,
    //               gl.TEXTURE_2D,
    //               colorResolveTo.gl_texture,
    //               0,
    //             );
    //         }
    //         if (isWebGL2(gl)) {
    //           gl.blitFramebuffer(
    //             0,
    //             0,
    //             colorResolveFrom.width,
    //             colorResolveFrom.height,
    //             0,
    //             0,
    //             colorResolveTo.width,
    //             colorResolveTo.height,
    //             gl.COLOR_BUFFER_BIT,
    //             gl.LINEAR,
    //           );
    //           gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    //         } else {
    //           // render target texture
    //           gl.bindTexture(GL.TEXTURE_2D, (colorResolveFrom.texture as Texture_GL).gl_texture);
    //         }
    //         didUnbindDraw = true;
    //       }
    //       if (!this.currentRenderPassDescriptor!.colorStore[i]) {
    //         if (!didBindRead) {
    //           gl.bindFramebuffer(
    //             isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //             this.resolveColorReadFramebuffer,
    //           );
    //           if (this.resolveColorAttachmentsChanged)
    //             this.bindFramebufferAttachment(
    //               isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //               gl.COLOR_ATTACHMENT0,
    //               colorResolveFrom,
    //             );
    //         }
    //         if (isWebGL2(gl)) {
    //           gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, [gl.COLOR_ATTACHMENT0]);
    //         }
    //       }
    //       gl.bindFramebuffer(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, null);
    //     }
    //   }
    //   this.resolveColorAttachmentsChanged = false;
    //   const depthStencilResolveFrom = this.currentDepthStencilAttachment;
    //   if (depthStencilResolveFrom !== null) {
    //     const depthStencilResolveTo = this.currentDepthStencilResolveTo;
    //     let didBindRead = false;
    //     if (depthStencilResolveTo !== null) {
    //       assert(
    //         depthStencilResolveFrom.width === depthStencilResolveTo.width &&
    //           depthStencilResolveFrom.height === depthStencilResolveTo.height,
    //       );
    //       this.setScissorEnabled(false);
    //       gl.bindFramebuffer(
    //         isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //         this.resolveDepthStencilReadFramebuffer,
    //       );
    //       gl.bindFramebuffer(
    //         isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER,
    //         this.resolveDepthStencilDrawFramebuffer,
    //       );
    //       if (this.resolveDepthStencilAttachmentsChanged) {
    //         this.bindFramebufferDepthStencilAttachment(
    //           isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //           depthStencilResolveFrom,
    //         );
    //         this.bindFramebufferDepthStencilAttachment(
    //           isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER,
    //           depthStencilResolveTo,
    //         );
    //       }
    //       didBindRead = true;
    //       if (isWebGL2(gl)) {
    //         gl.blitFramebuffer(
    //           0,
    //           0,
    //           depthStencilResolveFrom.width,
    //           depthStencilResolveFrom.height,
    //           0,
    //           0,
    //           depthStencilResolveTo.width,
    //           depthStencilResolveTo.height,
    //           gl.DEPTH_BUFFER_BIT,
    //           gl.NEAREST,
    //         );
    //       }
    //       gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, null);
    //       didUnbindDraw = true;
    //     }
    //     if (!this.currentRenderPassDescriptor!.depthStencilStore) {
    //       if (!didBindRead) {
    //         gl.bindFramebuffer(
    //           isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //           this.resolveDepthStencilReadFramebuffer,
    //         );
    //         if (this.resolveDepthStencilAttachmentsChanged)
    //           this.bindFramebufferDepthStencilAttachment(
    //             isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER,
    //             depthStencilResolveFrom,
    //           );
    //         didBindRead = true;
    //       }
    //       if (isWebGL2(gl)) {
    //         // gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, [gl.DEPTH_STENCIL_ATTACHMENT]);
    //       }
    //     }
    //     if (didBindRead)
    //       gl.bindFramebuffer(isWebGL2(gl) ? GL.READ_FRAMEBUFFER : GL.FRAMEBUFFER, null);
    //     this.resolveDepthStencilAttachmentsChanged = false;
    //   }
    //   if (!didUnbindDraw) {
    //     // If we did not unbind from a resolve, then we need to unbind our render pass draw FBO here.
    //     gl.bindFramebuffer(isWebGL2(gl) ? GL.DRAW_FRAMEBUFFER : GL.FRAMEBUFFER, null);
    //   }
    // }
    // private endPass(): void {
    //   const gl = this.gl as WebGL2RenderingContext;
    //   let didUnbindDraw = false;
    //   for (let i = 0; i < this.currentColorAttachments.length; i++) {
    //     const colorResolveFrom = this.currentColorAttachments[i];
    //     if (colorResolveFrom !== null) {
    //       const colorResolveTo = this.currentColorResolveTos[i];
    //       let didBindRead = false;
    //       if (colorResolveTo !== null) {
    //         assert(
    //           colorResolveFrom.width === colorResolveTo.width &&
    //             colorResolveFrom.height === colorResolveTo.height,
    //         );
    //         assert(colorResolveFrom.pixelFormat === colorResolveTo.pixelFormat);
    //         this.setScissorEnabled(false);
    //         gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveColorReadFramebuffer);
    //         if (this.resolveColorAttachmentsChanged)
    //           this.bindFramebufferAttachment(
    //             gl.READ_FRAMEBUFFER,
    //             gl.COLOR_ATTACHMENT0,
    //             colorResolveFrom,
    //           );
    //         didBindRead = true;
    //         // Special case: Blitting to the on-screen.
    //         if (colorResolveTo === this.scTexture) {
    //           gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.scPlatformFramebuffer);
    //         } else {
    //           gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.resolveColorDrawFramebuffer);
    //           if (this.resolveColorAttachmentsChanged)
    //             gl.framebufferTexture2D(
    //               gl.DRAW_FRAMEBUFFER,
    //               gl.COLOR_ATTACHMENT0,
    //               gl.TEXTURE_2D,
    //               colorResolveTo.gl_texture,
    //               0,
    //             );
    //         }
    //         gl.blitFramebuffer(
    //           0,
    //           0,
    //           colorResolveFrom.width,
    //           colorResolveFrom.height,
    //           0,
    //           0,
    //           colorResolveTo.width,
    //           colorResolveTo.height,
    //           gl.COLOR_BUFFER_BIT,
    //           gl.LINEAR,
    //         );
    //         gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    //         didUnbindDraw = true;
    //       }
    //       if (!this.currentRenderPassDescriptor!.colorStore[i]) {
    //         if (!didBindRead) {
    //           gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveColorReadFramebuffer);
    //           if (this.resolveColorAttachmentsChanged)
    //             this.bindFramebufferAttachment(
    //               gl.READ_FRAMEBUFFER,
    //               gl.COLOR_ATTACHMENT0,
    //               colorResolveFrom,
    //             );
    //         }
    //         gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, [gl.COLOR_ATTACHMENT0]);
    //       }
    //       gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
    //     }
    //   }
    //   this.resolveColorAttachmentsChanged = false;
    //   const depthStencilResolveFrom = this.currentDepthStencilAttachment;
    //   if (depthStencilResolveFrom !== null) {
    //     const depthStencilResolveTo = this.currentDepthStencilResolveTo;
    //     let didBindRead = false;
    //     if (depthStencilResolveTo !== null) {
    //       assert(
    //         depthStencilResolveFrom.width === depthStencilResolveTo.width &&
    //           depthStencilResolveFrom.height === depthStencilResolveTo.height,
    //       );
    //       this.setScissorEnabled(false);
    //       gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveDepthStencilReadFramebuffer);
    //       gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.resolveDepthStencilDrawFramebuffer);
    //       if (this.resolveDepthStencilAttachmentsChanged) {
    //         this.bindFramebufferDepthStencilAttachment(gl.READ_FRAMEBUFFER, depthStencilResolveFrom);
    //         this.bindFramebufferDepthStencilAttachment(gl.DRAW_FRAMEBUFFER, depthStencilResolveTo);
    //       }
    //       didBindRead = true;
    //       gl.blitFramebuffer(
    //         0,
    //         0,
    //         depthStencilResolveFrom.width,
    //         depthStencilResolveFrom.height,
    //         0,
    //         0,
    //         depthStencilResolveTo.width,
    //         depthStencilResolveTo.height,
    //         gl.DEPTH_BUFFER_BIT,
    //         gl.NEAREST,
    //       );
    //       gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    //       didUnbindDraw = true;
    //     }
    //     if (!this.currentRenderPassDescriptor!.depthStencilStore) {
    //       if (!didBindRead) {
    //         gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.resolveDepthStencilReadFramebuffer);
    //         if (this.resolveDepthStencilAttachmentsChanged)
    //           this.bindFramebufferDepthStencilAttachment(
    //             gl.READ_FRAMEBUFFER,
    //             depthStencilResolveFrom,
    //           );
    //         didBindRead = true;
    //       }
    //       gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, [gl.DEPTH_STENCIL_ATTACHMENT]);
    //     }
    //     if (didBindRead) gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
    //     this.resolveDepthStencilAttachmentsChanged = false;
    //   }
    //   if (!didUnbindDraw) {
    //     // If we did not unbind from a resolve, then we need to unbind our render pass draw FBO here.
    //     gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    //   }
    // }

  }, {
    key: "setScissorEnabled",
    value: function setScissorEnabled(v) {
      if (this.currentScissorEnabled === v) {
        return;
      }

      var gl = this.gl;

      if (v) {
        gl.enable(gl.SCISSOR_TEST);
      } else {
        gl.disable(gl.SCISSOR_TEST);
      }

      this.currentScissorEnabled = v;
    }
  }, {
    key: "applyStencil",
    value: function applyStencil() {
      if (this.currentStencilRef === null) {
        return;
      }

      this.gl.stencilFunc(this.currentMegaState.stencilCompare, this.currentStencilRef, 0xff);
    }
  }, {
    key: "getFallbackTexture",
    value: function getFallbackTexture(samplerEntry) {
      var gl_target = samplerEntry.gl_target,
          formatKind = samplerEntry.formatKind;
      if (gl_target === GL.TEXTURE_2D) return formatKind === SamplerFormatKind.Depth ? this.fallbackTexture2DDepth : this.fallbackTexture2D;else if (gl_target === GL.TEXTURE_2D_ARRAY) return this.fallbackTexture2DArray;else if (gl_target === GL.TEXTURE_3D) return this.fallbackTexture3D;else if (gl_target === GL.TEXTURE_CUBE_MAP) return this.fallbackTextureCube;else throw 'whoops';
    }
  }, {
    key: "submitBlitRenderPass",
    value: function submitBlitRenderPass() {
      if (!this.blitRenderPipeline) {
        var vertexBuffer = makeStaticDataBuffer(this, BufferUsage.VERTEX, new Float32Array([-4, -4, 4, -4, 0, 4]).buffer);
        var inputLayout = this.createInputLayout({
          vertexBufferDescriptors: [{
            byteStride: 4 * 2,
            frequency: VertexBufferFrequency.PerVertex
          }],
          vertexAttributeDescriptors: [{
            format: Format.F32_RG,
            bufferIndex: 0,
            bufferByteOffset: 4 * 0,
            location: 0
          }],
          indexBufferFormat: null
        });
        var bindingLayouts = [{
          numSamplers: 1,
          numUniformBuffers: 0
        }];
        var program = this.createProgram(_objectSpread2(_objectSpread2({}, preprocessProgramObj_GLSL(this, new CopyProgram())), {}, {
          ensurePreprocessed: function ensurePreprocessed() {},
          associate: function associate() {}
        }));
        this.blitInputState = this.createInputState(inputLayout, [{
          buffer: vertexBuffer,
          byteOffset: 0
        }], null, program);
        this.blitRenderPipeline = this.createRenderPipeline({
          topology: PrimitiveTopology.Triangles,
          sampleCount: 1,
          program: program,
          bindingLayouts: bindingLayouts,
          colorAttachmentFormats: [Format.U8_RGBA_RT],
          depthStencilAttachmentFormat: null,
          inputLayout: inputLayout,
          megaStateDescriptor: defaultMegaState
        });
        var colorTexture = this.currentColorAttachments[0].texture;
        this.blitBindings = this.createBindings({
          bindingLayout: bindingLayouts[0],
          samplerBindings: [{
            sampler: null,
            texture: colorTexture,
            lateBinding: null
          }],
          uniformBufferBindings: []
        });
        program.setUniforms({
          u_Texture: colorTexture
        });
      }

      this.inBlitRenderPass = true;
      var blitRenderPass = this.createRenderPass({
        colorAttachment: [this.currentColorAttachments[0]],
        colorResolveTo: [this.getOnscreenTexture()],
        colorClearColor: [OpaqueBlack],
        colorStore: [true],
        depthStencilAttachment: null,
        depthStencilResolveTo: null,
        depthStencilStore: true,
        depthClearValue: 'load',
        stencilClearValue: 'load',
        occlusionQueryPool: null
      });

      var _this$getCanvas = this.getCanvas(),
          width = _this$getCanvas.width,
          height = _this$getCanvas.height;

      blitRenderPass.setPipeline(this.blitRenderPipeline);
      blitRenderPass.setBindings(0, this.blitBindings, [0]);
      blitRenderPass.setInputState(this.blitInputState);
      blitRenderPass.setViewport(0, 0, width, height);
      blitRenderPass.draw(3, 0);
      this.submitPass(blitRenderPass);
      this.inBlitRenderPass = false;
    }
  }]);

  return Device_GL;
}();

function isView(viewOrSize) {
  return viewOrSize.byteLength !== undefined;
}

var Buffer_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Buffer_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Buffer_WebGPU);

  /**
   * @see https://www.w3.org/TR/webgpu/#gpubuffer
   */
  function Buffer_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Buffer_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Buffer;
    _this.gpuBuffer = void 0;
    _this.size = void 0;
    _this.view = void 0;
    _this.usage = void 0;
    var usage = descriptor.usage,
        viewOrSize = descriptor.viewOrSize;
    var alignedLength = isView(viewOrSize) ? viewOrSize.byteLength + 3 & ~3 : viewOrSize + 3 & ~3; // 4 bytes alignments (because of the upload which requires this)

    _this.usage = usage; // Buffer usages (BufferUsage::(MapRead|CopyDst|Storage)) is invalid. If a buffer usage contains BufferUsage::MapRead the only other allowed usage is BufferUsage::CopyDst.
    // @see https://www.w3.org/TR/webgpu/#dom-gpubufferusage-copy_dst

    if (_this.usage & BufferUsage.MAP_READ) {
      _this.usage = BufferUsage.MAP_READ | BufferUsage.COPY_DST;
    }

    var mapBuffer = isView(viewOrSize);
    _this.size = isView(viewOrSize) ? viewOrSize.byteLength : viewOrSize;
    _this.view = isView(viewOrSize) ? viewOrSize : null;
    _this.gpuBuffer = _this.device.device.createBuffer({
      usage: _this.usage,
      size: alignedLength,
      mappedAtCreation: mapBuffer
    });

    if (mapBuffer) {
      var arrayBuffer = _this.gpuBuffer.getMappedRange(); // @ts-expect-error


      new viewOrSize.constructor(arrayBuffer).set(viewOrSize);

      _this.gpuBuffer.unmap();
    }

    return _this;
  }

  _createClass(Buffer_WebGPU, [{
    key: "setSubData",
    value: function setSubData(dstByteOffset, src) {
      var srcByteOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var byteLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var buffer = this.gpuBuffer;
      byteLength = byteLength || src.byteLength;
      byteLength = Math.min(byteLength, this.size - dstByteOffset); // After Migration to Canary

      var chunkStart = src.byteOffset + srcByteOffset;
      var chunkEnd = chunkStart + byteLength; // 4 bytes alignments for upload

      var alignedLength = byteLength + 3 & ~3;

      if (alignedLength !== byteLength) {
        var tempView = new Uint8Array(src.buffer.slice(chunkStart, chunkEnd));
        src = new Uint8Array(alignedLength);
        src.set(tempView);
        srcByteOffset = 0;
        chunkStart = 0;
        chunkEnd = alignedLength;
        byteLength = alignedLength;
      } // Chunk


      var maxChunk = 1024 * 1024 * 15;
      var offset = 0;

      while (chunkEnd - (chunkStart + offset) > maxChunk) {
        this.device.device.queue.writeBuffer(buffer, dstByteOffset + offset, src.buffer, chunkStart + offset, maxChunk);
        offset += maxChunk;
      }

      this.device.device.queue.writeBuffer(buffer, dstByteOffset + offset, src.buffer, chunkStart + offset, byteLength - offset);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(Buffer_WebGPU.prototype), "destroy", this).call(this); // @see https://www.w3.org/TR/webgpu/#dom-gpubuffer-destroy


      this.gpuBuffer.destroy();
    }
  }]);

  return Buffer_WebGPU;
}(ResourceBase_WebGPU);

var InputLayout_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(InputLayout_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(InputLayout_WebGPU);

  function InputLayout_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, InputLayout_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.InputLayout;
    _this.buffers = void 0;
    _this.indexFormat = void 0;
    var buffers = [];

    for (var i = 0; i < descriptor.vertexBufferDescriptors.length; i++) {
      var b = descriptor.vertexBufferDescriptors[i];
      if (b === null) continue;
      var arrayStride = b.byteStride;
      var stepMode = translateVertexBufferFrequency(b.frequency);
      var attributes = [];
      buffers[i] = {
        arrayStride: arrayStride,
        stepMode: stepMode,
        attributes: attributes
      };
    }

    for (var _i = 0; _i < descriptor.vertexAttributeDescriptors.length; _i++) {
      var attr = descriptor.vertexAttributeDescriptors[_i];

      var _b = assertExists(buffers[attr.bufferIndex]);

      var attribute = {
        shaderLocation: attr.location,
        format: translateVertexFormat$1(attr.format),
        offset: attr.bufferByteOffset
      };

      _b.attributes.push(attribute);
    }

    _this.indexFormat = translateIndexFormat$1(descriptor.indexBufferFormat);
    _this.buffers = buffers;
    return _this;
  }

  return _createClass(InputLayout_WebGPU);
}(ResourceBase_WebGPU);

var Program_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Program_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Program_WebGPU);

  function Program_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Program_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Program;
    _this.descriptor = void 0;
    _this.vertexStage = null;
    _this.fragmentStage = null;
    _this.computeStage = null;
    _this.descriptor = descriptor;

    if (descriptor.preprocessedVert) {
      _this.vertexStage = _this.createShaderStage(descriptor.preprocessedVert, 'vertex');
    }

    if (descriptor.preprocessedFrag) {
      _this.fragmentStage = _this.createShaderStage(descriptor.preprocessedFrag, 'fragment');
    }

    if (descriptor.preprocessedCompute) {
      // FIXME: Only support WGSL now
      _this.computeStage = _this.createShaderStage(descriptor.preprocessedCompute, 'compute');
    }

    return _this;
  }

  _createClass(Program_WebGPU, [{
    key: "createShaderStage",
    value: function createShaderStage(sourceText, shaderStage) {
      var validationEnabled = false;
      var code = sourceText;

      if (shaderStage !== 'compute') {
        try {
          code = this.device.glsl_compile(sourceText, shaderStage, validationEnabled);
        } catch (e) {
          console.error(e, sourceText);
          throw 'whoops';
        }
      } // Workaround for https://github.com/gfx-rs/naga/issues/1355


      var _loop = function _loop() {
        var depthTextureName = _arr[_i];
        if (!code.includes(depthTextureName)) return "continue";
        code = code.replace("var T_".concat(depthTextureName, ": texture_2d<f32>;"), "var T_".concat(depthTextureName, ": texture_depth_2d;"));
        code = code.replace(new RegExp("textureSample\\(T_".concat(depthTextureName, "(.*)\\);$"), 'gm'), function (sub, cap) {
          return "vec4<f32>(textureSample(T_".concat(depthTextureName).concat(cap, "), 0.0, 0.0, 0.0);");
        });
      };

      for (var _i = 0, _arr = ['u_TextureFramebufferDepth']; _i < _arr.length; _i++) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      } // @see https://www.w3.org/TR/webgpu/#dom-gpudevice-createshadermodule


      var shaderModule = this.device.device.createShaderModule({
        code: code
      });
      return {
        module: shaderModule,
        entryPoint: 'main'
      };
    }
  }]);

  return Program_WebGPU;
}(ResourceBase_WebGPU);

var RenderPass_WebGPU = /*#__PURE__*/function () {
  function RenderPass_WebGPU() {
    _classCallCheck(this, RenderPass_WebGPU);

    this.commandEncoder = null;
    this.descriptor = void 0;
    this.gpuRenderPassEncoder = null;
    this.gpuRenderPassDescriptor = void 0;
    this.gpuColorAttachments = void 0;
    this.gpuDepthStencilAttachment = void 0;
    this.gfxColorAttachment = [];
    this.gfxColorResolveTo = [];
    this.gfxDepthStencilAttachment = null;
    this.gfxDepthStencilResolveTo = null;
    this.gpuColorAttachments = [];
    this.gpuDepthStencilAttachment = {
      view: null,
      depthLoadValue: 'load',
      depthStoreOp: 'store',
      stencilLoadValue: 'load',
      stencilStoreOp: 'store'
    };
    this.gpuRenderPassDescriptor = {
      colorAttachments: this.gpuColorAttachments,
      depthStencilAttachment: this.gpuDepthStencilAttachment
    };
  }

  _createClass(RenderPass_WebGPU, [{
    key: "setRenderPassDescriptor",
    value: function setRenderPassDescriptor(descriptor) {
      this.descriptor = descriptor;
      this.gpuRenderPassDescriptor.colorAttachments = this.gpuColorAttachments;
      var numColorAttachments = descriptor.colorAttachment.length;
      this.gfxColorAttachment.length = numColorAttachments;
      this.gfxColorResolveTo.length = numColorAttachments;

      for (var i = 0; i < descriptor.colorAttachment.length; i++) {
        var colorAttachment = descriptor.colorAttachment[i];
        var colorResolveTo = descriptor.colorResolveTo[i]; // Do some dumb juggling...

        if (colorAttachment === null && colorResolveTo !== null) {
          colorAttachment = colorResolveTo;
          colorResolveTo = null;
        }

        this.gfxColorAttachment[i] = colorAttachment;
        this.gfxColorResolveTo[i] = colorResolveTo;

        if (colorAttachment !== null) {
          if (this.gpuColorAttachments[i] === undefined) {
            this.gpuColorAttachments[i] = {};
          }

          var dstAttachment = this.gpuColorAttachments[i];
          dstAttachment.view = colorAttachment.gpuTextureView;
          dstAttachment.loadValue = descriptor.colorClearColor[i];
          dstAttachment.storeOp = descriptor.colorStore[i] ? 'store' : 'discard';
          dstAttachment.resolveTarget = undefined;

          if (colorResolveTo !== null) {
            if (colorAttachment.sampleCount > 1) {
              dstAttachment.resolveTarget = colorResolveTo.gpuTextureView;
            } else {
              dstAttachment.storeOp = 'store';
            }
          }
        } else {
          // https://github.com/gpuweb/gpuweb/issues/1250
          this.gpuColorAttachments.length = i;
          this.gfxColorAttachment.length = i;
          this.gfxColorResolveTo.length = i;
          break;
        }
      }

      this.gfxDepthStencilAttachment = descriptor.depthStencilAttachment;
      this.gfxDepthStencilResolveTo = descriptor.depthStencilResolveTo;

      if (descriptor.depthStencilAttachment !== null) {
        var dsAttachment = descriptor.depthStencilAttachment;
        var _dstAttachment = this.gpuDepthStencilAttachment;
        _dstAttachment.view = dsAttachment.gpuTextureView;
        _dstAttachment.depthLoadValue = descriptor.depthClearValue;
        _dstAttachment.stencilLoadValue = descriptor.stencilClearValue;
        _dstAttachment.depthStoreOp = descriptor.depthStencilStore ? 'store' : 'discard';
        _dstAttachment.stencilStoreOp = descriptor.depthStencilStore ? 'store' : 'discard';
        this.gpuRenderPassDescriptor.depthStencilAttachment = this.gpuDepthStencilAttachment;

        if (this.gfxDepthStencilResolveTo !== null) {
          _dstAttachment.depthStoreOp = 'store';
          _dstAttachment.stencilStoreOp = 'store';
        }
      } else {
        this.gpuRenderPassDescriptor.depthStencilAttachment = undefined;
      }

      this.gpuRenderPassDescriptor.occlusionQuerySet = descriptor.occlusionQueryPool !== null ? getPlatformQuerySet(descriptor.occlusionQueryPool) : undefined;
    }
  }, {
    key: "beginRenderPass",
    value: function beginRenderPass(renderPassDescriptor) {
      assert(this.gpuRenderPassEncoder === null);
      this.setRenderPassDescriptor(renderPassDescriptor);
      this.gpuRenderPassEncoder = this.commandEncoder.beginRenderPass(this.gpuRenderPassDescriptor);
    }
  }, {
    key: "setViewport",
    value: function setViewport(x, y, w, h) {
      this.gpuRenderPassEncoder.setViewport(x, y, w, h, 0, 1);
    }
  }, {
    key: "setScissor",
    value: function setScissor(x, y, w, h) {
      this.gpuRenderPassEncoder.setScissorRect(x, y, w, h);
    }
  }, {
    key: "setPipeline",
    value: function setPipeline(pipeline_) {
      var pipeline = pipeline_;
      var gpuRenderPipeline = assertExists(pipeline.gpuRenderPipeline);
      this.gpuRenderPassEncoder.setPipeline(gpuRenderPipeline);
    }
  }, {
    key: "setInputState",
    value: function setInputState(inputState_) {
      if (inputState_ === null) return;
      var inputState = inputState_;

      if (inputState.indexBuffer !== null) {
        var inputLayout = inputState.inputLayout;
        var indexBuffer = inputState.indexBuffer;
        this.gpuRenderPassEncoder.setIndexBuffer(getPlatformBuffer$1(indexBuffer.buffer), assertExists(inputLayout.indexFormat), indexBuffer.byteOffset);
      }

      for (var i = 0; i < inputState.vertexBuffers.length; i++) {
        var b = inputState.vertexBuffers[i];
        if (b === null) continue;
        this.gpuRenderPassEncoder.setVertexBuffer(i, getPlatformBuffer$1(b.buffer), b.byteOffset);
      }
    }
  }, {
    key: "setBindings",
    value: function setBindings(bindingLayoutIndex, bindings_, dynamicByteOffsets) {
      var bindings = bindings_;
      this.gpuRenderPassEncoder.setBindGroup(bindingLayoutIndex + 0, bindings.gpuBindGroup[0], dynamicByteOffsets.slice(0, bindings.bindingLayout.numUniformBuffers));
      this.gpuRenderPassEncoder.setBindGroup(bindingLayoutIndex + 1, bindings.gpuBindGroup[1]);
    }
  }, {
    key: "setStencilRef",
    value: function setStencilRef(ref) {
      this.gpuRenderPassEncoder.setStencilReference(ref);
    }
  }, {
    key: "draw",
    value: function draw(vertexCount, firstVertex) {
      this.gpuRenderPassEncoder.draw(vertexCount, 1, firstVertex, 0);
    }
  }, {
    key: "drawIndexed",
    value: function drawIndexed(indexCount, firstIndex) {
      this.gpuRenderPassEncoder.drawIndexed(indexCount, 1, firstIndex, 0, 0);
    }
  }, {
    key: "drawIndexedInstanced",
    value: function drawIndexedInstanced(indexCount, firstIndex, instanceCount) {
      this.gpuRenderPassEncoder.drawIndexed(indexCount, instanceCount, firstIndex, 0, 0);
    }
  }, {
    key: "beginOcclusionQuery",
    value: function beginOcclusionQuery(dstOffs) {
      this.gpuRenderPassEncoder.beginOcclusionQuery(dstOffs);
    }
  }, {
    key: "endOcclusionQuery",
    value: function endOcclusionQuery(dstOffs) {
      this.gpuRenderPassEncoder.endOcclusionQuery();
    }
  }, {
    key: "beginDebugGroup",
    value: function beginDebugGroup(name) {
      // FIREFOX MISSING
      if (this.gpuRenderPassEncoder.pushDebugGroup === undefined) return;
      this.gpuRenderPassEncoder.pushDebugGroup(name);
    }
  }, {
    key: "endDebugGroup",
    value: function endDebugGroup() {
      // FIREFOX MISSING
      if (this.gpuRenderPassEncoder.popDebugGroup === undefined) return;
      this.gpuRenderPassEncoder.popDebugGroup();
    }
  }, {
    key: "finish",
    value: function finish() {
      this.gpuRenderPassEncoder.endPass();
      this.gpuRenderPassEncoder = null; // Fake a resolve with a copy for non-MSAA.

      for (var i = 0; i < this.gfxColorAttachment.length; i++) {
        var colorAttachment = this.gfxColorAttachment[i];
        var colorResolveTo = this.gfxColorResolveTo[i];

        if (colorAttachment !== null && colorResolveTo !== null && colorAttachment.sampleCount === 1) {
          this.copyAttachment(colorResolveTo, colorAttachment);
        }
      }

      if (this.gfxDepthStencilAttachment !== null && this.gfxDepthStencilResolveTo !== null) {
        if (this.gfxDepthStencilAttachment.sampleCount > 1) ; else {
          this.copyAttachment(this.gfxDepthStencilResolveTo, this.gfxDepthStencilAttachment);
        }
      }

      return this.commandEncoder.finish();
    }
  }, {
    key: "copyAttachment",
    value: function copyAttachment(dst, src) {
      assert(src.sampleCount === 1);
      var srcCopy = {
        texture: src.gpuTexture
      };
      var dstCopy = {
        texture: dst.gpuTexture
      };
      assert(src.width === dst.width);
      assert(src.height === dst.height);
      assert(!!(src.usage & GPUTextureUsage.COPY_SRC));
      assert(!!(dst.usage & GPUTextureUsage.COPY_DST));
      this.commandEncoder.copyTextureToTexture(srcCopy, dstCopy, [dst.width, dst.height, 1]);
    }
  }]);

  return RenderPass_WebGPU;
}();

var Sampler_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Sampler_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Sampler_WebGPU);

  // @see https://www.w3.org/TR/webgpu/#gpusampler
  function Sampler_WebGPU(_ref) {
    var _descriptor$maxAnisot, _descriptor$wrapQ;

    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, Sampler_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Sampler;
    _this.gpuSampler = void 0;
    var lodMinClamp = descriptor.minLOD;
    var lodMaxClamp = descriptor.mipFilter === MipFilterMode.NoMip ? descriptor.minLOD : descriptor.maxLOD;
    var maxAnisotropy = (_descriptor$maxAnisot = descriptor.maxAnisotropy) !== null && _descriptor$maxAnisot !== void 0 ? _descriptor$maxAnisot : 1;
    if (maxAnisotropy > 1) assert(descriptor.minFilter === TexFilterMode.Bilinear && descriptor.magFilter === TexFilterMode.Bilinear && descriptor.mipFilter === MipFilterMode.Linear);
    _this.gpuSampler = _this.device.device.createSampler({
      addressModeU: translateWrapMode$1(descriptor.wrapS),
      addressModeV: translateWrapMode$1(descriptor.wrapT),
      addressModeW: translateWrapMode$1((_descriptor$wrapQ = descriptor.wrapQ) !== null && _descriptor$wrapQ !== void 0 ? _descriptor$wrapQ : descriptor.wrapS),
      lodMinClamp: lodMinClamp,
      lodMaxClamp: lodMaxClamp,
      minFilter: translateMinMagFilter(descriptor.minFilter),
      magFilter: translateMinMagFilter(descriptor.magFilter),
      mipmapFilter: translateMipFilter(descriptor.mipFilter),
      maxAnisotropy: maxAnisotropy
    });
    return _this;
  }

  return _createClass(Sampler_WebGPU);
}(ResourceBase_WebGPU);

var Texture_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Texture_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Texture_WebGPU);

  function Texture_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor,
        skipCreate = _ref.skipCreate;

    _classCallCheck(this, Texture_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Texture;
    _this.pixelFormat = void 0;
    _this.dimension = void 0;
    _this.format = void 0;
    _this.width = void 0;
    _this.height = void 0;
    _this.depthOrArrayLayers = void 0;
    _this.numLevels = void 0;
    _this.sampleCount = void 0;
    _this.usage = void 0;
    _this.gpuTexture = void 0;
    _this.gpuTextureView = void 0;

    _this.device.createTextureShared({
      pixelFormat: descriptor.pixelFormat,
      dimension: descriptor.dimension,
      width: descriptor.width,
      height: descriptor.height,
      depthOrArrayLayers: descriptor.depth,
      numLevels: descriptor.numLevels,
      usage: descriptor.usage,
      sampleCount: 1
    }, _assertThisInitialized(_this), skipCreate);

    return _this;
  }

  _createClass(Texture_WebGPU, [{
    key: "setImageData",
    value: function setImageData(data, level) {// TODO: https://www.w3.org/TR/webgpu/#image-copies
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // @see https://www.w3.org/TR/webgpu/#dom-gputexture-destroy
      this.gpuTexture.destroy();
    }
  }]);

  return Texture_WebGPU;
}(ResourceBase_WebGPU);

var InputState_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(InputState_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(InputState_WebGPU);

  function InputState_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        inputLayout = _ref.inputLayout,
        vertexBuffers = _ref.vertexBuffers,
        indexBuffer = _ref.indexBuffer;

    _classCallCheck(this, InputState_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.InputState;
    _this.inputLayout = void 0;
    _this.vertexBuffers = void 0;
    _this.indexBuffer = void 0;
    _this.inputLayout = inputLayout;
    _this.vertexBuffers = vertexBuffers;
    _this.indexBuffer = indexBuffer;
    return _this;
  }

  return _createClass(InputState_WebGPU);
}(ResourceBase_WebGPU);

var RenderPipeline_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(RenderPipeline_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(RenderPipeline_WebGPU);

  function RenderPipeline_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, RenderPipeline_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.RenderPipeline;
    _this.descriptor = void 0;
    _this.isCreating = false;
    _this.isCreatingAsync = false;
    _this.gpuRenderPipeline = null;
    _this.descriptor = descriptor;

    _this.device.ensureRenderPipeline(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(RenderPipeline_WebGPU, [{
    key: "getBindGroupLayout",
    value: function getBindGroupLayout(index) {
      return this.gpuRenderPipeline.getBindGroupLayout(index);
    }
  }]);

  return RenderPipeline_WebGPU;
}(ResourceBase_WebGPU);

var Readback_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(Readback_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(Readback_WebGPU);

  function Readback_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device;

    _classCallCheck(this, Readback_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.Readback;
    return _this;
  }

  _createClass(Readback_WebGPU, [{
    key: "readTexture",
    value: function readTexture(t, x, y, width, height, dst) {
      var dstOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var length = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
      var texture = t;
      var faceIndex = 0;
      var blockInformation = this.getBlockInformationFromFormat(texture.format);
      var bytesPerRow = Math.ceil(width / blockInformation.width) * blockInformation.length;
      var bytesPerRowAligned = Math.ceil(bytesPerRow / 256) * 256;
      var size = bytesPerRowAligned * height;
      var buffer = this.device.createBuffer({
        usage: BufferUsage.STORAGE | BufferUsage.MAP_READ | BufferUsage.COPY_DST,
        hint: BufferFrequencyHint.Static,
        viewOrSize: size
      });
      var commandEncoder = this.device.device.createCommandEncoder(); // @see https://www.w3.org/TR/webgpu/#dom-gpucommandencoder-copytexturetobuffer

      commandEncoder.copyTextureToBuffer({
        texture: texture.gpuTexture,
        mipLevel: 0,
        origin: {
          x: x,
          y: y,
          z: Math.max(faceIndex, 0)
        }
      }, {
        buffer: buffer.gpuBuffer,
        offset: 0,
        bytesPerRow: bytesPerRowAligned
      }, {
        width: width,
        height: height,
        depthOrArrayLayers: 1
      });
      this.device.device.queue.submit([commandEncoder.finish()]); // read from buffer

      return this.readBuffer(buffer, size, dst, dstOffset, length, texture.pixelFormat);
    }
  }, {
    key: "readBuffer",
    value: function readBuffer(b) {
      var _this2 = this;

      var srcByteOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var dstArrayBufferView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      var type = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Format.U8_RGB;
      var noDataConversion = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var buffer = b;
      var size = _size || buffer.size;
      var dst = dstArrayBufferView || buffer.view;
      var floatFormat = // @ts-ignore
      dst && dst.constructor && dst.constructor.BYTES_PER_ELEMENT || getFormatCompByteSize(type);
      var gpuReadBuffer = buffer; // can read buffer directly?

      if (!(buffer.usage & BufferUsage.MAP_READ && buffer.usage & BufferUsage.COPY_DST)) {
        var commandEncoder = this.device.device.createCommandEncoder();
        gpuReadBuffer = this.device.createBuffer({
          usage: BufferUsage.STORAGE | BufferUsage.MAP_READ | BufferUsage.COPY_DST,
          hint: BufferFrequencyHint.Static,
          viewOrSize: size
        }); // Encode commands for copying buffer to buffer.

        commandEncoder.copyBufferToBuffer(buffer.gpuBuffer
        /* source buffer */
        , srcByteOffset
        /* source offset */
        , gpuReadBuffer.gpuBuffer
        /* destination buffer */
        , 0
        /* destination offset */
        , size
        /* size */
        );
        this.device.device.queue.submit([commandEncoder.finish()]);
      }

      return new Promise(function (resolve, reject) {
        gpuReadBuffer.gpuBuffer.mapAsync(GPUMapMode.READ, srcByteOffset, size).then(function () {
          var copyArrayBuffer = gpuReadBuffer.gpuBuffer.getMappedRange(srcByteOffset, size);
          var data = dst;

          if (noDataConversion) {
            if (data === null) {
              data = allocateAndCopyTypedBuffer(type, size, true, copyArrayBuffer);
            } else {
              // @ts-ignore
              data = allocateAndCopyTypedBuffer(type, data.buffer, undefined, copyArrayBuffer);
            }
          } else {
            if (data === null) {
              switch (floatFormat) {
                case 1:
                  // byte format
                  data = new Uint8Array(size);
                  data.set(new Uint8Array(copyArrayBuffer));
                  break;

                case 2:
                  // half float
                  // TODO WEBGPU use computer shaders (or render pass) to make the conversion?
                  data = _this2.getHalfFloatAsFloatRGBAArrayBuffer(size / 2, copyArrayBuffer);
                  break;

                case 4:
                  // float
                  data = new Float32Array(size / 4);
                  data.set(new Float32Array(copyArrayBuffer));
                  break;
              }
            } else {
              switch (floatFormat) {
                case 1:
                  // byte format
                  data = new Uint8Array(data.buffer);
                  data.set(new Uint8Array(copyArrayBuffer));
                  break;

                case 2:
                  // half float
                  // TODO WEBGPU use computer shaders (or render pass) to make the conversion?
                  data = _this2.getHalfFloatAsFloatRGBAArrayBuffer(size / 2, copyArrayBuffer, dst);
                  break;

                case 4:
                  // float
                  var ctor = dst && dst.constructor || Float32Array; // @ts-ignore

                  data = new ctor(data.buffer); // @ts-ignore

                  data.set(new ctor(copyArrayBuffer));
                  break;
              }
            }
          } // if (bytesPerRow !== bytesPerRowAligned) {
          //   // TODO WEBGPU use computer shaders (or render pass) to build the final buffer data?
          //   if (floatFormat === 1 && !noDataConversion) {
          //     // half float have been converted to float above
          //     bytesPerRow *= 2;
          //     bytesPerRowAligned *= 2;
          //   }
          //   const data2 = new Uint8Array(data!.buffer);
          //   let offset = bytesPerRow,
          //     offset2 = 0;
          //   for (let y = 1; y < height; ++y) {
          //     offset2 = y * bytesPerRowAligned;
          //     for (let x = 0; x < bytesPerRow; ++x) {
          //       data2[offset++] = data2[offset2++];
          //     }
          //   }
          //   if (floatFormat !== 0 && !noDataConversion) {
          //     data = new Float32Array(data2.buffer, 0, offset / 4);
          //   } else {
          //     data = new Uint8Array(data2.buffer, 0, offset);
          //   }
          // }


          gpuReadBuffer.gpuBuffer.unmap();
          resolve(data);
        }, function (reason) {
          return reject(reason);
        });
      });
    }
  }, {
    key: "getHalfFloatAsFloatRGBAArrayBuffer",
    value: function getHalfFloatAsFloatRGBAArrayBuffer(dataLength, arrayBuffer, destArray) {
      if (!destArray) {
        destArray = new Float32Array(dataLength);
      }

      var srcData = new Uint16Array(arrayBuffer);

      while (dataLength--) {
        destArray[dataLength] = halfFloat2Number(srcData[dataLength]);
      }

      return destArray;
    }
  }, {
    key: "getBlockInformationFromFormat",
    value: function getBlockInformationFromFormat(format) {
      switch (format) {
        // 8 bits formats
        case 'r8unorm':
        case 'r8snorm':
        case 'r8uint':
        case 'r8sint':
          return {
            width: 1,
            height: 1,
            length: 1
          };
        // 16 bits formats

        case 'r16uint':
        case 'r16sint':
        case 'r16float':
        case 'rg8unorm':
        case 'rg8snorm':
        case 'rg8uint':
        case 'rg8sint':
          return {
            width: 1,
            height: 1,
            length: 2
          };
        // 32 bits formats

        case 'r32uint':
        case 'r32sint':
        case 'r32float':
        case 'rg16uint':
        case 'rg16sint':
        case 'rg16float':
        case 'rgba8unorm':
        case 'rgba8unorm-srgb':
        case 'rgba8snorm':
        case 'rgba8uint':
        case 'rgba8sint':
        case 'bgra8unorm':
        case 'bgra8unorm-srgb':
        case 'rgb9e5ufloat':
        case 'rgb10a2unorm':
        case 'rg11b10ufloat':
          return {
            width: 1,
            height: 1,
            length: 4
          };
        // 64 bits formats

        case 'rg32uint':
        case 'rg32sint':
        case 'rg32float':
        case 'rgba16uint':
        case 'rgba16sint':
        case 'rgba16float':
          return {
            width: 1,
            height: 1,
            length: 8
          };
        // 128 bits formats

        case 'rgba32uint':
        case 'rgba32sint':
        case 'rgba32float':
          return {
            width: 1,
            height: 1,
            length: 16
          };
        // Depth and stencil formats

        case 'stencil8':
          throw 'No fixed size for Stencil8 format!';

        case 'depth16unorm':
          return {
            width: 1,
            height: 1,
            length: 2
          };

        case 'depth24plus':
          throw 'No fixed size for Depth24Plus format!';

        case 'depth24plus-stencil8':
          throw 'No fixed size for Depth24PlusStencil8 format!';

        case 'depth32float':
          return {
            width: 1,
            height: 1,
            length: 4
          };

        case 'depth24unorm-stencil8':
          return {
            width: 1,
            height: 1,
            length: 4
          };

        case 'depth32float-stencil8':
          return {
            width: 1,
            height: 1,
            length: 5
          };
        // BC compressed formats usable if "texture-compression-bc" is both
        // supported by the device/user agent and enabled in requestDevice.

        case 'bc7-rgba-unorm':
        case 'bc7-rgba-unorm-srgb':
        case 'bc6h-rgb-ufloat':
        case 'bc6h-rgb-float':
        case 'bc2-rgba-unorm':
        case 'bc2-rgba-unorm-srgb':
        case 'bc3-rgba-unorm':
        case 'bc3-rgba-unorm-srgb':
        case 'bc5-rg-unorm':
        case 'bc5-rg-snorm':
          return {
            width: 4,
            height: 4,
            length: 16
          };

        case 'bc4-r-unorm':
        case 'bc4-r-snorm':
        case 'bc1-rgba-unorm':
        case 'bc1-rgba-unorm-srgb':
          return {
            width: 4,
            height: 4,
            length: 8
          };
      } // return { width: 1, height: 1, length: 4 };

    }
  }]);

  return Readback_WebGPU;
}(ResourceBase_WebGPU);

var ComputePass_WebGPU = /*#__PURE__*/function () {
  function ComputePass_WebGPU() {
    _classCallCheck(this, ComputePass_WebGPU);

    this.commandEncoder = null;
    this.descriptor = void 0;
    this.gpuComputePassDescriptor = void 0;
    this.gpuComputePassEncoder = null;
  }

  _createClass(ComputePass_WebGPU, [{
    key: "dispatch",
    value:
    /**
     * @see https://www.w3.org/TR/webgpu/#dom-gpucomputepassencoder-dispatch
     */
    function dispatch(x, y, z) {
      this.gpuComputePassEncoder.dispatch(x, y, z); // TODO: dispatchIndirect read from GPUBuffer
    }
  }, {
    key: "finish",
    value: function finish() {
      this.gpuComputePassEncoder.endPass();
      this.gpuComputePassEncoder = null;
      return this.commandEncoder.finish();
    }
    /**
     * @see https://www.w3.org/TR/webgpu/#dom-gpucommandencoder-begincomputepass
     */

  }, {
    key: "beginComputePass",
    value: function beginComputePass(computePassDescriptor) {
      assert(this.gpuComputePassEncoder === null);
      this.setComputePassDescriptor(computePassDescriptor);
      this.gpuComputePassEncoder = this.commandEncoder.beginComputePass(this.gpuComputePassDescriptor);
    }
  }, {
    key: "setPipeline",
    value: function setPipeline(pipeline_) {
      var pipeline = pipeline_;
      var gpuComputePipeline = assertExists(pipeline.gpuComputePipeline);
      this.gpuComputePassEncoder.setPipeline(gpuComputePipeline);
    }
  }, {
    key: "setBindings",
    value: function setBindings(bindingLayoutIndex, bindings_) {
      var bindings = bindings_;
      this.gpuComputePassEncoder.setBindGroup(bindingLayoutIndex, bindings.gpuBindGroup[0]);
    }
  }, {
    key: "setComputePassDescriptor",
    value: function setComputePassDescriptor(descriptor) {
      this.descriptor = descriptor;
    }
  }]);

  return ComputePass_WebGPU;
}();

var ComputePipeline_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(ComputePipeline_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(ComputePipeline_WebGPU);

  function ComputePipeline_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, ComputePipeline_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.ComputePipeline;
    _this.descriptor = void 0;
    _this.gpuComputePipeline = null;
    _this.descriptor = descriptor;
    var program = descriptor.program;
    var computeStage = program.computeStage;
    if (computeStage === null) return _possibleConstructorReturn(_this);
    var gpuComputePipeline = {
      compute: _objectSpread2({}, computeStage)
    }; // @see https://www.w3.org/TR/webgpu/#dom-gpudevice-createrenderpipeline

    _this.gpuComputePipeline = _this.device.device.createComputePipeline(gpuComputePipeline);

    if (_this.name !== undefined) {
      _this.gpuComputePipeline.label = _this.name;
    }

    return _this;
  }

  _createClass(ComputePipeline_WebGPU, [{
    key: "getBindGroupLayout",
    value: function getBindGroupLayout(index) {
      return this.gpuComputePipeline.getBindGroupLayout(index);
    }
  }]);

  return ComputePipeline_WebGPU;
}(ResourceBase_WebGPU);

// Hack for now until browsers implement compositingAlphaMode
// https://bugs.chromium.org/p/chromium/issues/detail?id=1241373
var FullscreenAlphaClear = /*#__PURE__*/function () {
  function FullscreenAlphaClear(device) {
    _classCallCheck(this, FullscreenAlphaClear);

    this.shaderModule = void 0;
    this.pipeline = void 0;
    this.shaderText = "\nstruct VertexOutput {\n  @builtin(position) pos: vec4<f32>;\n};\n\n@stage(vertex)\nfn vs(\n  @builtin(vertex_index) index: u32\n) -> VertexOutput {\n  var out: VertexOutput;\n  out.pos.x = select(-1.0, 3.0, index == 1u);\n  out.pos.y = select(-1.0, 3.0, index == 2u);\n  out.pos.z = 1.0;\n  out.pos.w = 1.0;\n  return out;\n}\n\nstruct FragmentOutput { @location(0) color: vec4<f32>; };\n\n@ stage(fragment)\nfn fs() -> FragmentOutput {\n  return FragmentOutput(vec4<f32>(1.0, 0.0, 1.0, 1.0));\n}\n";
    var format = 'bgra8unorm';
    this.shaderModule = device.createShaderModule({
      code: this.shaderText
    });
    this.pipeline = device.createRenderPipeline({
      vertex: {
        module: this.shaderModule,
        entryPoint: 'vs'
      },
      fragment: {
        module: this.shaderModule,
        entryPoint: 'fs',
        targets: [{
          format: format,
          writeMask: 0x08
        }]
      }
    });
  }

  _createClass(FullscreenAlphaClear, [{
    key: "render",
    value: function render(device, onscreenTexture) {
      var encoder = device.createCommandEncoder();
      var renderPass = encoder.beginRenderPass({
        colorAttachments: [{
          view: onscreenTexture,
          loadOp: 'load',
          loadValue: 'load',
          storeOp: 'store'
        }]
      });
      renderPass.setPipeline(this.pipeline);
      renderPass.draw(3);
      renderPass.endPass();
      device.queue.submit([encoder.finish()]);
    }
  }]);

  return FullscreenAlphaClear;
}();

var QueryPool_WebGPU = /*#__PURE__*/function (_ResourceBase_WebGPU) {
  _inherits(QueryPool_WebGPU, _ResourceBase_WebGPU);

  var _super = _createSuper(QueryPool_WebGPU);

  function QueryPool_WebGPU(_ref) {
    var _this;

    var id = _ref.id,
        device = _ref.device,
        descriptor = _ref.descriptor;

    _classCallCheck(this, QueryPool_WebGPU);

    _this = _super.call(this, {
      id: id,
      device: device
    });
    _this.type = ResourceType.QueryPool;
    _this.querySet = void 0;
    var elemCount = descriptor.elemCount,
        type = descriptor.type;
    _this.querySet = _this.device.device.createQuerySet({
      type: translateQueryPoolType$1(type),
      count: elemCount
    });
    return _this;
  }

  _createClass(QueryPool_WebGPU, [{
    key: "queryResultOcclusion",
    value: function queryResultOcclusion(dstOffs) {
      return true;
    }
  }]);

  return QueryPool_WebGPU;
}(ResourceBase_WebGPU);

var Device_WebGPU = /*#__PURE__*/function () {
  // VendorInfo
  function Device_WebGPU(adapter, device, canvas, canvasContext, glsl_compile) {
    _classCallCheck(this, Device_WebGPU);

    this.swapChainWidth = 0;
    this.swapChainHeight = 0;
    this.swapChainTextureUsage = GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_DST;
    this._resourceUniqueId = 0;
    this.renderPassPool = [];
    this.computePassPool = [];
    this.bindGroupLayoutCache = new HashMap(bindingLayoutDescriptorEqual, nullHashFunc);
    this.fallbackTexture2D = void 0;
    this.fallbackTexture2DDepth = void 0;
    this.fallbackTexture2DArray = void 0;
    this.fallbackTexture3D = void 0;
    this.fallbackTextureCube = void 0;
    this.fallbackSampler = void 0;
    this.featureTextureCompressionBC = false;
    this.fullscreenAlphaClear = void 0;
    this.platformString = 'WebGPU';
    this.glslVersion = "#version 440";
    this.explicitBindingLocations = true;
    this.separateSamplerTextures = true;
    this.viewportOrigin = ViewportOrigin.UpperLeft;
    this.clipSpaceNearZ = ClipSpaceNearZ.Zero;
    this.supportsSyncPipelineCompilation = false;
    this.supportMRT = true;
    this.adapter = void 0;
    this.device = void 0;
    this.canvas = void 0;
    this.canvasContext = void 0;
    this.glsl_compile = void 0;
    this.adapter = adapter;
    this.device = device;
    this.canvas = canvas;
    this.canvasContext = canvasContext;
    this.glsl_compile = glsl_compile;
    this.fallbackTexture2D = this.createFallbackTexture(TextureDimension.n2D, SamplerFormatKind.Float);
    this.fallbackTexture2DDepth = this.createFallbackTexture(TextureDimension.n2D, SamplerFormatKind.Depth);
    this.fallbackTexture2DArray = this.createFallbackTexture(TextureDimension.n2DArray, SamplerFormatKind.Float);
    this.fallbackTexture3D = this.createFallbackTexture(TextureDimension.n3D, SamplerFormatKind.Float);
    this.fallbackTextureCube = this.createFallbackTexture(TextureDimension.Cube, SamplerFormatKind.Float);
    this.fallbackSampler = this.createSampler({
      wrapS: WrapMode.Clamp,
      wrapT: WrapMode.Clamp,
      minFilter: TexFilterMode.Point,
      magFilter: TexFilterMode.Point,
      mipFilter: MipFilterMode.NoMip
    }); // Firefox doesn't support GPUDevice.features yet...

    if (this.device.features) {
      this.featureTextureCompressionBC = this.device.features.has('texture-compression-bc');
    }

    this.device.onuncapturederror = function (event) {
      console.error(event.error);
    };

    this.fullscreenAlphaClear = new FullscreenAlphaClear(this.device);
  } // SwapChain


  _createClass(Device_WebGPU, [{
    key: "configureSwapChain",
    value: function configureSwapChain(width, height) {
      if (this.swapChainWidth === width && this.swapChainHeight === height) return;
      this.swapChainWidth = width;
      this.swapChainHeight = height; // @see https://www.w3.org/TR/webgpu/#canvas-configuration

      this.canvasContext.configure({
        device: this.device,
        format: 'bgra8unorm',
        usage: this.swapChainTextureUsage // @see https://developer.chrome.com/blog/new-in-chrome-94/#canvas-colorspace
        // colorSpace: 'srgb',

      });
    }
  }, {
    key: "getOnscreenTexture",
    value: function getOnscreenTexture() {
      // @see https://www.w3.org/TR/webgpu/#dom-gpucanvascontext-getcurrenttexture
      var gpuTexture = this.canvasContext.getCurrentTexture();
      var gpuTextureView = gpuTexture.createView();
      var texture = new Texture_WebGPU({
        id: 0,
        device: this,
        descriptor: {
          pixelFormat: Format.U8_RGBA_RT,
          width: this.swapChainWidth,
          height: this.swapChainHeight,
          depth: 0,
          dimension: TextureDimension.n2D,
          numLevels: 1,
          usage: this.swapChainTextureUsage
        },
        skipCreate: true
      });
      texture.depthOrArrayLayers = 1;
      texture.sampleCount = 1;
      texture.gpuTexture = gpuTexture;
      texture.gpuTextureView = gpuTextureView;
      return texture;
    }
  }, {
    key: "getDevice",
    value: function getDevice() {
      return this;
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this.canvas;
    }
  }, {
    key: "present",
    value: function present() {
      this.fullscreenAlphaClear.render(this.device, this.canvasContext.getCurrentTexture().createView());
    }
  }, {
    key: "getNextUniqueId",
    value: function getNextUniqueId() {
      return ++this._resourceUniqueId;
    }
  }, {
    key: "createBuffer",
    value: function createBuffer(descriptor) {
      return new Buffer_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createTexture",
    value: function createTexture(descriptor) {
      return new Texture_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
    /**
     * @see https://www.w3.org/TR/webgpu/#dom-gpudevice-createsampler
     * @see https://www.w3.org/TR/webgpu/#GPUSamplerDescriptor
     */

  }, {
    key: "createSampler",
    value: function createSampler(descriptor) {
      return new Sampler_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createRenderTarget",
    value: function createRenderTarget(descriptor) {
      var texture = new Texture_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: _objectSpread2(_objectSpread2({}, descriptor), {}, {
          dimension: TextureDimension.n2D,
          numLevels: 1,
          depth: 1,
          usage: TextureUsage.RenderTarget
        })
      });
      texture.depthOrArrayLayers = 1;
      texture.type = ResourceType.RenderTarget;
      return texture;
    }
  }, {
    key: "createRenderTargetFromTexture",
    value: function createRenderTargetFromTexture(texture) {
      var pixelFormat = texture.pixelFormat,
          width = texture.width,
          height = texture.height,
          depthOrArrayLayers = texture.depthOrArrayLayers,
          sampleCount = texture.sampleCount,
          numLevels = texture.numLevels,
          gpuTexture = texture.gpuTexture,
          gpuTextureView = texture.gpuTextureView,
          usage = texture.usage;
      assert(!!(usage & GPUTextureUsage.RENDER_ATTACHMENT));
      var attachment = new Texture_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: {
          pixelFormat: pixelFormat,
          width: width,
          height: height,
          depth: depthOrArrayLayers,
          dimension: TextureDimension.n2D,
          numLevels: numLevels,
          usage: usage
        },
        skipCreate: true
      });
      attachment.depthOrArrayLayers = depthOrArrayLayers;
      attachment.sampleCount = sampleCount;
      attachment.gpuTexture = gpuTexture;
      attachment.gpuTextureView = gpuTextureView;
      return attachment;
    }
  }, {
    key: "createProgram",
    value: function createProgram(descriptor) {
      descriptor.ensurePreprocessed(this);
      return this.createProgramSimple(descriptor);
    }
  }, {
    key: "createProgramSimple",
    value: function createProgramSimple(descriptor) {
      return new Program_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createTextureShared",
    value: function createTextureShared(descriptor, texture, skipCreate) {
      var size = {
        width: descriptor.width,
        height: descriptor.height,
        depthOrArrayLayers: descriptor.depthOrArrayLayers
      };
      var mipLevelCount = descriptor.numLevels;
      var format = translateTextureFormat(descriptor.pixelFormat);
      var dimension = translateTextureDimension$1(descriptor.dimension);
      var usage = translateTextureUsage(descriptor.usage);
      texture.format = format;
      texture.dimension = descriptor.dimension;
      texture.pixelFormat = descriptor.pixelFormat;
      texture.width = descriptor.width;
      texture.height = descriptor.height;
      texture.depthOrArrayLayers = descriptor.depthOrArrayLayers;
      texture.numLevels = mipLevelCount;
      texture.usage = usage;
      texture.sampleCount = 1;

      if (!skipCreate) {
        var gpuTexture = this.device.createTexture({
          size: size,
          mipLevelCount: mipLevelCount,
          format: format,
          dimension: dimension,
          usage: usage
        });
        var gpuTextureView = gpuTexture.createView();
        texture.gpuTexture = gpuTexture;
        texture.gpuTextureView = gpuTextureView;
      }
    }
  }, {
    key: "getFallbackTexture",
    value: function getFallbackTexture(samplerEntry) {
      var dimension = samplerEntry.dimension,
          formatKind = samplerEntry.formatKind;
      if (dimension === TextureDimension.n2D) return formatKind === SamplerFormatKind.Depth ? this.fallbackTexture2DDepth : this.fallbackTexture2D;else if (dimension === TextureDimension.n2DArray) return this.fallbackTexture2DArray;else if (dimension === TextureDimension.n3D) return this.fallbackTexture3D;else if (dimension === TextureDimension.Cube) return this.fallbackTextureCube;else throw 'whoops';
    }
  }, {
    key: "createFallbackTexture",
    value: function createFallbackTexture(dimension, formatKind) {
      var depth = dimension === TextureDimension.Cube ? 6 : 1;
      var pixelFormat = formatKind === SamplerFormatKind.Float ? Format.U8_RGBA_NORM : Format.D24;
      return this.createTexture({
        dimension: dimension,
        pixelFormat: pixelFormat,
        usage: TextureUsage.Sampled,
        width: 1,
        height: 1,
        depth: depth,
        numLevels: 1
      });
    }
  }, {
    key: "createBindings",
    value: function createBindings(descriptor) {
      if (descriptor.pipeline) ;

      return new Bindings_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createInputLayout",
    value: function createInputLayout(descriptor) {
      return new InputLayout_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createInputState",
    value: function createInputState(inputLayout, vertexBuffers, indexBuffer) {
      // InputState is a GL-only thing, as VAOs suck. We emulate it with a VAO-alike here.
      return new InputState_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        inputLayout: inputLayout,
        vertexBuffers: vertexBuffers,
        indexBuffer: indexBuffer
      });
    }
  }, {
    key: "createComputePipeline",
    value: function createComputePipeline(descriptor) {
      return new ComputePipeline_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: descriptor
      });
    }
  }, {
    key: "createRenderPipeline",
    value: function createRenderPipeline(descriptor) {
      return new RenderPipeline_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: _objectSpread2({}, descriptor)
      });
    }
  }, {
    key: "createQueryPool",
    value: function createQueryPool(type, elemCount) {
      return new QueryPool_WebGPU({
        id: this.getNextUniqueId(),
        device: this,
        descriptor: {
          type: type,
          elemCount: elemCount
        }
      });
    }
  }, {
    key: "ensureRenderPipeline",
    value: function ensureRenderPipeline(renderPipeline) {
      if (renderPipeline.isCreating) return;
      if (renderPipeline.gpuRenderPipeline !== null) return;
      var descriptor = renderPipeline.descriptor;
      var program = descriptor.program;
      var vertexStage = program.vertexStage,
          fragmentStage = program.fragmentStage;
      if (vertexStage === null || fragmentStage === null) return;
      var primitive = translatePrimitiveState(descriptor.topology, descriptor.megaStateDescriptor);
      var targets = translateTargets(descriptor.colorAttachmentFormats, descriptor.megaStateDescriptor);
      var depthStencil = translateDepthStencilState(descriptor.depthStencilAttachmentFormat, descriptor.megaStateDescriptor);
      var buffers = undefined;
      if (descriptor.inputLayout !== null) buffers = descriptor.inputLayout.buffers;
      var sampleCount = descriptor.sampleCount;
      renderPipeline.isCreating = true;
      var gpuRenderPipeline = {
        vertex: _objectSpread2(_objectSpread2({}, vertexStage), {}, {
          buffers: buffers
        }),
        primitive: primitive,
        depthStencil: depthStencil,
        multisample: {
          count: sampleCount
        },
        fragment: _objectSpread2(_objectSpread2({}, fragmentStage), {}, {
          targets: targets
        })
      }; // TODO: async creation
      // @see https://www.w3.org/TR/webgpu/#dom-gpudevice-createrenderpipeline

      renderPipeline.gpuRenderPipeline = this.device.createRenderPipeline(gpuRenderPipeline);
      if (renderPipeline.name !== undefined) renderPipeline.gpuRenderPipeline.label = renderPipeline.name;
    }
  }, {
    key: "createReadback",
    value: function createReadback() {
      return new Readback_WebGPU({
        id: this.getNextUniqueId(),
        device: this
      });
    }
  }, {
    key: "destroyRenderTarget",
    value: function destroyRenderTarget(o) {
      var attachment = o;
      attachment.gpuTexture.destroy();
    }
  }, {
    key: "createRenderPass",
    value: function createRenderPass(renderPassDescriptor) {
      var pass = this.renderPassPool.pop();

      if (pass === undefined) {
        pass = new RenderPass_WebGPU();
      }

      pass.commandEncoder = this.device.createCommandEncoder();
      pass.beginRenderPass(renderPassDescriptor);
      return pass;
    }
  }, {
    key: "createComputePass",
    value: function createComputePass(computePassDescriptor) {
      var pass = this.computePassPool.pop();
      if (pass === undefined) pass = new ComputePass_WebGPU();
      pass.commandEncoder = this.device.createCommandEncoder();
      pass.beginComputePass(computePassDescriptor);
      return pass;
    }
  }, {
    key: "submitPass",
    value: function submitPass(_pass) {
      var queue = this.device.queue;
      var pass = _pass;
      var commands = pass.finish();
      queue.submit([commands]);
      pass.commandEncoder = null;

      if (pass instanceof RenderPass_WebGPU) {
        this.renderPassPool.push(pass);
      } else {
        this.computePassPool.push(pass);
      }
    }
  }, {
    key: "copySubTexture2D",
    value: function copySubTexture2D(dst_, dstX, dstY, src_, srcX, srcY) {
      var cmd = this.device.createCommandEncoder();
      var dst = dst_;
      var src = src_;
      var srcCopy = {
        texture: src.gpuTexture,
        origin: [srcX, srcY, 0]
      };
      var dstCopy = {
        texture: dst.gpuTexture,
        origin: [dstX, dstY, 0]
      };
      assert(!!(src.usage & GPUTextureUsage.COPY_SRC));
      assert(!!(dst.usage & GPUTextureUsage.COPY_DST));
      cmd.copyTextureToTexture(srcCopy, dstCopy, [src.width, src.height, 1]);
      this.device.queue.submit([cmd.finish()]);
    }
  }, {
    key: "queryLimits",
    value: function queryLimits() {
      // TODO: GPUAdapter.limits
      // @see https://www.w3.org/TR/webgpu/#gpu-supportedlimits
      return {
        uniformBufferMaxPageWordSize: 0x1000,
        uniformBufferWordAlignment: 0x40,
        supportedSampleCounts: [1]
      };
    }
  }, {
    key: "queryTextureFormatSupported",
    value: function queryTextureFormatSupported(format, width, height) {
      if (isFormatTextureCompressionBC(format)) {
        if (!this.featureTextureCompressionBC) return false;
        var bb = getFormatBlockSize(format);
        if (width % bb !== 0 || height % bb !== 0) return false;
        return this.featureTextureCompressionBC;
      }

      return true;
    }
  }, {
    key: "queryPipelineReady",
    value: function queryPipelineReady(o) {
      var renderPipeline = o;
      this.ensureRenderPipeline(renderPipeline);
      return renderPipeline.gpuRenderPipeline !== null;
    }
  }, {
    key: "queryPlatformAvailable",
    value: function queryPlatformAvailable() {
      return true;
    }
  }, {
    key: "queryVendorInfo",
    value: function queryVendorInfo() {
      return this;
    }
  }, {
    key: "queryRenderPass",
    value: function queryRenderPass(o) {
      var pass = o;
      return pass.descriptor;
    }
  }, {
    key: "queryRenderTarget",
    value: function queryRenderTarget(o) {
      var attachment = o;
      return attachment;
    }
  }, {
    key: "setResourceName",
    value: function setResourceName(o, s) {
      o.name = s;

      if (o.type === ResourceType.Buffer) {
        var r = o;
        r.gpuBuffer.label = s;
      } else if (o.type === ResourceType.Texture) {
        var _r = o;
        _r.gpuTexture.label = s;
        _r.gpuTextureView.label = s;
      } else if (o.type === ResourceType.RenderTarget) {
        var _r2 = o;
        _r2.gpuTexture.label = s;
        _r2.gpuTextureView.label = s;
      } else if (o.type === ResourceType.Sampler) {
        var _r3 = o;
        _r3.gpuSampler.label = s;
      } else if (o.type === ResourceType.RenderPipeline) {
        var _r4 = o;
        if (_r4.gpuRenderPipeline !== null) _r4.gpuRenderPipeline.label = s;
      }
    }
  }, {
    key: "setResourceLeakCheck",
    value: function setResourceLeakCheck(o, v) {}
  }, {
    key: "checkForLeaks",
    value: function checkForLeaks() {}
  }, {
    key: "programPatched",
    value: function programPatched(o) {}
  }, {
    key: "pushDebugGroup",
    value: function pushDebugGroup(debugGroup) {}
  }, {
    key: "popDebugGroup",
    value: function popDebugGroup() {}
  }, {
    key: "pipelineQueryReady",
    value: function pipelineQueryReady(o) {
      var renderPipeline = o;
      return renderPipeline.gpuRenderPipeline !== null;
    }
  }, {
    key: "pipelineForceReady",
    value: function pipelineForceReady(o) {
    }
  }]);

  return Device_WebGPU;
}();

var RGRenderTargetDescription = /*#__PURE__*/function () {
  function RGRenderTargetDescription(pixelFormat) {
    _classCallCheck(this, RGRenderTargetDescription);

    this.pixelFormat = void 0;
    this.width = 0;
    this.height = 0;
    this.sampleCount = 0;
    this.colorClearColor = 'load';
    this.depthClearValue = 'load';
    this.stencilClearValue = 'load';
    this.pixelFormat = pixelFormat;
  }
  /**
   * Set the dimensions of a render target description.
   */


  _createClass(RGRenderTargetDescription, [{
    key: "setDimensions",
    value: function setDimensions(width, height, sampleCount) {
      this.width = width;
      this.height = height;
      this.sampleCount = sampleCount;
    }
  }, {
    key: "copyDimensions",
    value: function copyDimensions(desc) {
      this.width = desc.width;
      this.height = desc.height;
      this.sampleCount = desc.sampleCount;
    }
  }]);

  return RGRenderTargetDescription;
}();

function makeAttachmentClearDescriptor(clearColor) {
  return {
    colorClearColor: clearColor,
    // depthClearValue: reverseDepthForClearValue(1.0),
    depthClearValue: 1,
    stencilClearValue: 0.0
  };
}
var opaqueWhiteFullClearRenderPassDescriptor = makeAttachmentClearDescriptor(OpaqueWhite);
var AntialiasingMode;

(function (AntialiasingMode) {
  AntialiasingMode[AntialiasingMode["None"] = 0] = "None";
  AntialiasingMode[AntialiasingMode["FXAA"] = 1] = "FXAA";
  AntialiasingMode[AntialiasingMode["MSAAx4"] = 2] = "MSAAx4";
})(AntialiasingMode || (AntialiasingMode = {}));

function selectFormatSimple(slot) {
  if (slot === RGAttachmentSlot.Color0) return Format.U8_RGBA_RT;else if (slot === RGAttachmentSlot.DepthStencil) return Format.D24_S8;else throw 'whoops';
}

function selectSampleCount(renderInput) {
  if (renderInput.antialiasingMode === AntialiasingMode.MSAAx4) return 4;else return 1;
}

function setBackbufferDescSimple(desc, renderInput) {
  var sampleCount = selectSampleCount(renderInput);
  desc.setDimensions(renderInput.backbufferWidth, renderInput.backbufferHeight, sampleCount);
}
function makeBackbufferDescSimple(slot, renderInput, clearDescriptor) {
  var pixelFormat = selectFormatSimple(slot);
  var desc = new RGRenderTargetDescription(pixelFormat);
  setBackbufferDescSimple(desc, renderInput);

  if (clearDescriptor !== null) {
    desc.colorClearColor = clearDescriptor.colorClearColor;
    desc.depthClearValue = clearDescriptor.depthClearValue;
    desc.stencilClearValue = clearDescriptor.stencilClearValue;
  }

  return desc;
}

var _excluded$1 = ["style"];
var Light = /*#__PURE__*/function (_DisplayObject) {
  _inherits(Light, _DisplayObject);

  var _super = _createSuper(Light);

  function Light() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        style = _ref.style,
        rest = _objectWithoutProperties(_ref, _excluded$1);

    _classCallCheck(this, Light);

    return _super.call(this, _objectSpread2({
      type: Light.tag,
      style: _objectSpread2({
        intensity: Math.PI
      }, style)
    }, rest));
  }

  return _createClass(Light);
}(DisplayObject);
Light.tag = 'light';

var _excluded$2 = ["style"];
var FogType;

(function (FogType) {
  FogType[FogType["NONE"] = 0] = "NONE";
  FogType[FogType["EXP"] = 1] = "EXP";
  FogType[FogType["EXP2"] = 2] = "EXP2";
  FogType[FogType["LINEAR"] = 3] = "LINEAR";
})(FogType || (FogType = {}));

var Fog = /*#__PURE__*/function (_DisplayObject) {
  _inherits(Fog, _DisplayObject);

  var _super = _createSuper(Fog);

  function Fog() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        style = _ref.style,
        rest = _objectWithoutProperties(_ref, _excluded$2);

    _classCallCheck(this, Fog);

    return _super.call(this, _objectSpread2({
      type: Fog.tag,
      style: _objectSpread2({
        type: FogType.NONE,
        fill: 'black',
        start: 1,
        end: 1000,
        density: 0
      }, style)
    }, rest));
  }

  return _createClass(Fog);
}(DisplayObject);
Fog.tag = 'fog';

var _class;

var RenderGraphPlugin_1;

var SceneUniform;

(function (SceneUniform) {
  SceneUniform["PROJECTION_MATRIX"] = "u_ProjectionMatrix";
  SceneUniform["VIEW_MATRIX"] = "u_ViewMatrix";
  SceneUniform["CAMERA_POSITION"] = "u_CameraPosition";
  SceneUniform["DEVICE_PIXEL_RATIO"] = "u_DevicePixelRatio";
  SceneUniform["VIEWPORT"] = "u_Viewport";
  SceneUniform["IS_ORTHO"] = "u_IsOrtho";
})(SceneUniform || (SceneUniform = {}));

var RenderGraphPlugin = RenderGraphPlugin_1 = (_class = /*#__PURE__*/function () {
  function RenderGraphPlugin() {
    _classCallCheck(this, RenderGraphPlugin);

    this.canvasConfig = void 0;
    this.contextService = void 0;
    this.renderingContext = void 0;
    this.camera = void 0;
    this.pluginOptions = void 0;
    this.pickingIdGenerator = void 0;
    this.renderHelper = void 0;
    this.lightPool = void 0;
    this.texturePool = void 0;
    this.batchManager = void 0;
    this.renderingService = void 0;
    this.device = void 0;
    this.swapChain = void 0;
    this.renderLists = {
      world: new RenderInstList()
    };
    this.builder = void 0;
    this.pickingTexture = void 0;
    this.firstFrame = true;
  }

  _createClass(RenderGraphPlugin, [{
    key: "getDevice",
    value: function getDevice() {
      return this.device;
    }
  }, {
    key: "apply",
    value: function apply(renderingService) {
      var _this = this;

      this.renderingService = renderingService;
      renderingService.hooks.init.tapPromise(RenderGraphPlugin_1.tag, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var $canvas, _this$canvasConfig, width, height;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.renderingContext.root.addEventListener(ElementEvent.MOUNTED, handleMounted);

                _this.renderingContext.root.addEventListener(ElementEvent.UNMOUNTED, handleUnmounted);

                _this.renderingContext.root.addEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);

                _this.renderingContext.root.addEventListener(ElementEvent.RENDER_ORDER_CHANGED, handleRenderOrderChanged);

                _this.canvasConfig.renderer.getConfig().enableDirtyRectangleRendering = false; // const dpr = this.contextService.getDPR();

                $canvas = _this.contextService.getDomElement();
                _this$canvasConfig = _this.canvasConfig, width = _this$canvasConfig.width, height = _this$canvasConfig.height;

                _this.contextService.resize(width, height);

                _context.next = 10;
                return _this.createSwapChain($canvas);

              case 10:
                _this.device = _this.swapChain.getDevice();

                _this.renderHelper.setDevice(_this.device);

                _this.renderHelper.renderInstManager.disableSimpleMode();

                _this.swapChain.configureSwapChain($canvas.width, $canvas.height);

                _this.renderingContext.root.ownerDocument.defaultView.on(CanvasEvent.RESIZE, function () {
                  _this.swapChain.configureSwapChain($canvas.width, $canvas.height);
                });

                _this.batchManager.attach(_this.device, renderingService);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      renderingService.hooks.destroy.tap(RenderGraphPlugin_1.tag, function () {
        _this.renderHelper.destroy(); // this.batches.forEach((batch) => batch.destroy());


        _this.renderingContext.root.removeEventListener(ElementEvent.MOUNTED, handleMounted);

        _this.renderingContext.root.removeEventListener(ElementEvent.UNMOUNTED, handleUnmounted);

        _this.renderingContext.root.removeEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);

        _this.renderingContext.root.removeEventListener(ElementEvent.RENDER_ORDER_CHANGED, handleRenderOrderChanged);
      });
      /**
       * build frame graph at the beginning of each frame
       */

      renderingService.hooks.beginFrame.tap(RenderGraphPlugin_1.tag, function () {
        var canvas = _this.swapChain.getCanvas();

        var renderInstManager = _this.renderHelper.renderInstManager;
        _this.builder = _this.renderHelper.renderGraph.newGraphBuilder(); // use canvas.background

        var clearColor = _this.canvasConfig.background ? colorNewFromRGBA.apply(void 0, _toConsumableArray(parseColor(_this.canvasConfig.background).value)) : TransparentWhite; // retrieve at each frame since canvas may resize

        var renderInput = {
          backbufferWidth: canvas.width,
          backbufferHeight: canvas.height,
          antialiasingMode: AntialiasingMode.None
        }; // create main Color RT

        var mainRenderDesc = makeBackbufferDescSimple(RGAttachmentSlot.Color0, renderInput, makeAttachmentClearDescriptor(clearColor)); // create main Depth RT

        var mainDepthDesc = makeBackbufferDescSimple(RGAttachmentSlot.DepthStencil, renderInput, opaqueWhiteFullClearRenderPassDescriptor);

        var mainColorTargetID = _this.builder.createRenderTargetID(mainRenderDesc, 'Main Render Target');

        var mainDepthTargetID = _this.builder.createRenderTargetID(mainDepthDesc, 'Main Depth');

        var pickingColorTargetID = _this.builder.createRenderTargetID(mainRenderDesc, 'Picking Render Target'); // main render pass


        _this.builder.pushPass(function (pass) {
          pass.setDebugName('Main Render Pass');
          pass.attachRenderTargetID(RGAttachmentSlot.Color0, mainColorTargetID);
          pass.attachRenderTargetID(RGAttachmentSlot.Color1, pickingColorTargetID);
          pass.attachRenderTargetID(RGAttachmentSlot.DepthStencil, mainDepthTargetID);
          pass.exec(function (passRenderer) {
            renderInstManager.drawListOnPassRenderer(_this.renderLists.world, passRenderer);
          });
          pass.post(function (scope) {
            _this.pickingTexture = scope.getRenderTargetTexture(RGAttachmentSlot.Color1);
          });
        }); // TODO: other post-processing passes
        // FXAA
        // pushFXAAPass(this.builder, this.renderHelper, renderInput, mainColorTargetID);
        // output to screen


        _this.builder.resolveRenderTargetToExternalTexture(mainColorTargetID, _this.swapChain.getOnscreenTexture());
      });
      renderingService.hooks.endFrame.tap(RenderGraphPlugin_1.tag, function () {
        var renderInstManager = _this.renderHelper.renderInstManager; // TODO: time for GPU Animation
        // const timeInMilliseconds = window.performance.now();
        // Push our outer template, which contains the dynamic UBO bindings...

        var template = _this.renderHelper.pushTemplateRenderInst(); // SceneParams: binding = 0, ObjectParams: binding = 1


        template.setBindingLayouts([{
          numUniformBuffers: 2,
          numSamplers: 0
        }]);
        template.setMegaStateFlags(setAttachmentStateSimple({
          depthWrite: true
        }, {
          rgbBlendMode: BlendMode.Add,
          alphaBlendMode: BlendMode.Add,
          rgbBlendSrcFactor: BlendFactor.SrcAlpha,
          alphaBlendSrcFactor: BlendFactor.Zero,
          rgbBlendDstFactor: BlendFactor.OneMinusSrcAlpha,
          alphaBlendDstFactor: BlendFactor.One
        })); // Update Scene Params

        var _this$canvasConfig2 = _this.canvasConfig,
            width = _this$canvasConfig2.width,
            height = _this$canvasConfig2.height;
        template.setUniforms(0, [{
          name: SceneUniform.PROJECTION_MATRIX,
          value: _this.camera.getPerspective()
        }, {
          name: SceneUniform.VIEW_MATRIX,
          value: _this.camera.getViewTransform()
        }, {
          name: SceneUniform.CAMERA_POSITION,
          value: _this.camera.getPosition()
        }, {
          name: SceneUniform.DEVICE_PIXEL_RATIO,
          value: _this.contextService.getDPR()
        }, {
          name: SceneUniform.VIEWPORT,
          value: [width, height]
        }, {
          name: SceneUniform.IS_ORTHO,
          value: _this.camera.isOrtho() ? 1 : 0
        }]);
        renderInstManager.setCurrentRenderInstList(_this.renderLists.world);

        _this.batchManager.render(_this.renderLists.world);

        renderInstManager.popTemplateRenderInst();

        if (_this.renderLists.world.renderInsts.length > 0) {
          _this.renderHelper.prepareToRender();
        }

        _this.renderHelper.renderGraph.execute();

        renderInstManager.resetRenderInsts(); // output to screen

        _this.swapChain.present(); // @ts-ignore
        // FIXME: this is a hack to make sure the GPU is done with the previous frame


        if (_this.device.platformString === 'WebGL2' && _this.firstFrame) {
          _this.firstFrame = false;
          setTimeout(function () {
            _this.renderingService.dirtify();
          });
        }
      });

      var handleMounted = function handleMounted(e) {
        var object = e.target; // collect lights

        if (object.nodeName === Light.tag) {
          _this.lightPool.addLight(object);

          return;
        } else if (object.nodeName === Fog.tag) {
          _this.lightPool.addFog(object);

          return;
        }

        var renderable3D = new Renderable3D(); // add geometry & material required by Renderable3D
        // object.entity.addComponent(Geometry3D);
        // object.entity.addComponent(Material3D);
        // generate picking id for later use

        var pickingId = _this.pickingIdGenerator.getId(object);

        renderable3D.pickingId = pickingId;
        renderable3D.encodedPickingColor = _this.pickingIdGenerator.encodePickingColor(pickingId); // @ts-ignore

        object.renderable3D = renderable3D;

        _this.batchManager.add(object);
      };

      var handleUnmounted = function handleUnmounted(e) {
        var object = e.target;

        if (object.nodeName === Light.tag) {
          _this.lightPool.removeLight(object);

          return;
        } else if (object.nodeName === Fog.tag) {
          _this.lightPool.removeFog(object);

          return;
        }

        _this.batchManager.remove(object); // @ts-ignore


        delete object.renderable3D; // entity.removeComponent(Geometry3D, true);
        // entity.removeComponent(Material3D, true);
        // entity.removeComponent(Renderable3D, true);
      };

      var handleAttributeChanged = function handleAttributeChanged(e) {
        var object = e.target;
        var attrName = e.attrName,
            newValue = e.newValue;

        _this.batchManager.updateAttribute(object, attrName, newValue);
      };

      var handleRenderOrderChanged = function handleRenderOrderChanged(e) {
        var object = e.target;
        var renderOrder = e.detail.renderOrder;

        _this.batchManager.changeRenderOrder(object, renderOrder);
      };
    }
    /**
     * auto downgrade from WebGPU to WebGL2 & 1
     */

  }, {
    key: "createSwapChain",
    value: function () {
      var _createSwapChain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($canvas) {
        var targets;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                targets = this.pluginOptions.targets; // use WebGPU first

                if (!targets.includes('webgpu')) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.createSwapChainForWebGPU($canvas);

              case 4:
                this.swapChain = _context2.sent;

              case 5:
                if (!this.swapChain) {
                  this.swapChain = this.createSwapChainForWebGL($canvas, targets);
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createSwapChain(_x) {
        return _createSwapChain.apply(this, arguments);
      }

      return createSwapChain;
    }()
  }, {
    key: "createSwapChainForWebGL",
    value: function createSwapChainForWebGL($canvas, targets) {
      var options = {
        antialias: false,
        // @see https://stackoverflow.com/questions/27746091/preservedrawingbuffer-false-is-it-worth-the-effort
        preserveDrawingBuffer: false,
        // @see https://webglfundamentals.org/webgl/lessons/webgl-qna-how-to-use-the-stencil-buffer.html
        stencil: true // @see https://webglfundamentals.org/webgl/lessons/webgl-and-alpha.html
        // premultipliedAlpha: false,

      };
      this.handleContextEvents($canvas);
      var gl;

      if (targets.includes('webgl2')) {
        gl = $canvas.getContext('webgl2', options) || $canvas.getContext('experimental-webgl2', options);
      }

      if (!gl && targets.includes('webgl1')) {
        gl = $canvas.getContext('webgl', options) || $canvas.getContext('experimental-webgl', options);
      }

      return new Device_GL(gl, {
        shaderDebug: true,
        trackResources: true
      });
    }
  }, {
    key: "createSwapChainForWebGPU",
    value: function () {
      var _createSwapChainForWebGPU = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(canvas) {
        var adapter, optionalFeatures, requiredFeatures, device, context;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(navigator.gpu === undefined)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", null);

              case 2:
                adapter = null;
                _context3.prev = 3;
                _context3.next = 6;
                return navigator.gpu.requestAdapter();

              case 6:
                adapter = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);
                console.log(_context3.t0);

              case 12:
                if (!(adapter === null)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", null);

              case 14:
                // @see https://www.w3.org/TR/webgpu/#dom-gpudevicedescriptor-requiredfeatures
                optionalFeatures = ['depth24unorm-stencil8', 'depth32float-stencil8', 'texture-compression-bc'];
                requiredFeatures = optionalFeatures.filter(function (feature) {
                  return adapter.features.has(feature);
                });
                _context3.next = 18;
                return adapter.requestDevice({
                  requiredFeatures: requiredFeatures
                });

              case 18:
                device = _context3.sent;

                if (!(device === null)) {
                  _context3.next = 21;
                  break;
                }

                return _context3.abrupt("return", null);

              case 21:
                context = canvas.getContext('webgpu');

                if (context) {
                  _context3.next = 24;
                  break;
                }

                return _context3.abrupt("return", null);

              case 24:
                return _context3.abrupt("return", new Device_WebGPU(adapter, device, canvas, context, function () {}));

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 9]]);
      }));

      function createSwapChainForWebGPU(_x2) {
        return _createSwapChainForWebGPU.apply(this, arguments);
      }

      return createSwapChainForWebGPU;
    }()
  }, {
    key: "handleContextEvents",
    value: function handleContextEvents($canvas) {
      var _this$pluginOptions = this.pluginOptions,
          onContextLost = _this$pluginOptions.onContextLost,
          onContextRestored = _this$pluginOptions.onContextRestored,
          onContextCreationError = _this$pluginOptions.onContextCreationError; // bind context event listeners

      if (onContextCreationError) {
        // @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/webglcontextcreationerror_event
        $canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
      }

      if (onContextLost) {
        $canvas.addEventListener('webglcontextlost', onContextLost, false);
      }

      if (onContextRestored) {
        $canvas.addEventListener('webglcontextrestored', onContextRestored, false);
      } // TODO: https://github.com/gpuweb/gpuweb/blob/main/design/ErrorHandling.md#fatal-errors-requestadapter-requestdevice-and-devicelost

    }
    /**
     * return displayobjects in target rectangle
     */

  }, {
    key: "pickByRectangle",
    value: function () {
      var _pickByRectangle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(rect) {
        var targets, readback, pickedColors, pickedFeatureIdx, pickedDisplayObject;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                targets = [];
                readback = this.device.createReadback();

                if (!this.pickingTexture) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 5;
                return readback.readTexture(this.pickingTexture, rect.x, rect.y, rect.width, rect.height, new Uint8Array(rect.width * rect.height * 4));

              case 5:
                pickedColors = _context4.sent;
                pickedFeatureIdx = -1;

                if (pickedColors && (pickedColors[0] !== 0 || pickedColors[1] !== 0 || pickedColors[2] !== 0)) {
                  pickedFeatureIdx = this.pickingIdGenerator.decodePickingColor(pickedColors);
                }

                if (pickedFeatureIdx > -1) {
                  pickedDisplayObject = this.pickingIdGenerator.getById(pickedFeatureIdx);

                  if (pickedDisplayObject && pickedDisplayObject.interactive && targets.indexOf(pickedDisplayObject) === -1) {
                    targets.push(pickedDisplayObject);
                  }
                }

                readback.destroy();

              case 10:
                return _context4.abrupt("return", targets);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function pickByRectangle(_x3) {
        return _pickByRectangle.apply(this, arguments);
      }

      return pickByRectangle;
    }()
  }, {
    key: "loadTexture",
    value: function loadTexture(src, descriptor, successCallback) {
      var _this2 = this;

      return this.texturePool.getOrCreateTexture(this.device, src, descriptor, function () {
        _this2.renderingService.dirtify();

        if (successCallback) {
          successCallback();
        }
      });
    }
  }]);

  return RenderGraphPlugin;
}(), _class.tag = 'RenderGraphPlugin', _class);

__decorate([inject(CanvasConfig), __metadata("design:type", Object)], RenderGraphPlugin.prototype, "canvasConfig", void 0);

__decorate([inject(ContextService), __metadata("design:type", Object)], RenderGraphPlugin.prototype, "contextService", void 0);

__decorate([inject(RenderingContext), __metadata("design:type", Object)], RenderGraphPlugin.prototype, "renderingContext", void 0);

__decorate([inject(DefaultCamera), __metadata("design:type", Camera)], RenderGraphPlugin.prototype, "camera", void 0);

__decorate([inject(WebGLRendererPluginOptions), __metadata("design:type", Object)], RenderGraphPlugin.prototype, "pluginOptions", void 0);

__decorate([inject(PickingIdGenerator), __metadata("design:type", PickingIdGenerator)], RenderGraphPlugin.prototype, "pickingIdGenerator", void 0);

__decorate([inject(RenderHelper), __metadata("design:type", RenderHelper)], RenderGraphPlugin.prototype, "renderHelper", void 0);

__decorate([inject(LightPool), __metadata("design:type", LightPool)], RenderGraphPlugin.prototype, "lightPool", void 0);

__decorate([inject(TexturePool), __metadata("design:type", TexturePool)], RenderGraphPlugin.prototype, "texturePool", void 0);

__decorate([inject(BatchManager), __metadata("design:type", BatchManager)], RenderGraphPlugin.prototype, "batchManager", void 0);

RenderGraphPlugin = RenderGraphPlugin_1 = __decorate([singleton({
  contrib: RenderingPluginContribution
})], RenderGraphPlugin);

var _class$1;

var PickingPlugin_1;
/**
 * Use color-based picking in GPU
 */

var PickingPlugin = PickingPlugin_1 = (_class$1 = /*#__PURE__*/function () {
  function PickingPlugin() {
    _classCallCheck(this, PickingPlugin);

    this.canvasConfig = void 0;
    this.sceneGraphService = void 0;
    this.contextService = void 0;
    this.renderGraphPlugin = void 0;
  }

  _createClass(PickingPlugin, [{
    key: "apply",
    value: function apply(renderingService) {
      var _this = this;

      renderingService.hooks.pick.tapPromise(PickingPlugin_1.tag, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
          var _result$position, x, y, dpr, width, height, xInDevicePixel, yInDevicePixel, _yield$_this$renderGr, _yield$_this$renderGr2, pickedDisplayObject;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // use viewportX/Y
                  _result$position = result.position, x = _result$position.viewportX, y = _result$position.viewportY;
                  dpr = _this.contextService.getDPR();
                  width = _this.canvasConfig.width * dpr;
                  height = _this.canvasConfig.height * dpr;
                  xInDevicePixel = x * dpr;
                  yInDevicePixel = y * dpr;

                  if (!(xInDevicePixel > width || xInDevicePixel < 0 || yInDevicePixel > height || yInDevicePixel < 0)) {
                    _context.next = 9;
                    break;
                  }

                  result.picked = null;
                  return _context.abrupt("return", result);

                case 9:
                  _context.next = 11;
                  return _this.renderGraphPlugin.pickByRectangle(new Rectangle(clamp(Math.round(xInDevicePixel), 0, width - 1), // flip Y
                  clamp(Math.round(height - (y + 1) * dpr), 0, height - 1), 1, 1));

                case 11:
                  _yield$_this$renderGr = _context.sent;
                  _yield$_this$renderGr2 = _slicedToArray(_yield$_this$renderGr, 1);
                  pickedDisplayObject = _yield$_this$renderGr2[0];
                  result.picked = pickedDisplayObject || null;
                  return _context.abrupt("return", result);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);

  return PickingPlugin;
}(), _class$1.tag = 'PickingPlugin', _class$1);

__decorate([inject(CanvasConfig), __metadata("design:type", Object)], PickingPlugin.prototype, "canvasConfig", void 0);

__decorate([inject(SceneGraphService), __metadata("design:type", Object)], PickingPlugin.prototype, "sceneGraphService", void 0);

__decorate([inject(ContextService), __metadata("design:type", Object)], PickingPlugin.prototype, "contextService", void 0);

__decorate([inject(RenderGraphPlugin), __metadata("design:type", RenderGraphPlugin)], PickingPlugin.prototype, "renderGraphPlugin", void 0);

PickingPlugin = PickingPlugin_1 = __decorate([singleton({
  contrib: RenderingPluginContribution
})], PickingPlugin);

var MeshUpdater = /*#__PURE__*/function () {
  function MeshUpdater() {
    _classCallCheck(this, MeshUpdater);
  }

  _createClass(MeshUpdater, [{
    key: "update",
    value: function update(parsedStyle) {
      var geometry = parsedStyle.geometry; // const minX = Math.min(x1, x2);
      // const maxX = Math.max(x1, x2);
      // const minY = Math.min(y1, y2);
      // const maxY = Math.max(y1, y2);
      // const width = maxX - minX;
      // const height = maxY - minY;

      return {
        width: 0,
        height: 0,
        depth: 0,
        x: 0,
        y: 0,
        z: 0
      };
    }
  }]);

  return MeshUpdater;
}();

MeshUpdater = __decorate([singleton({
  token: {
    token: GeometryAABBUpdater,
    named: Mesh.tag
  }
})], MeshUpdater);

var bindFunc;
function registerModelBuilder(builderClazz, named) {
  bindFunc({
    token: {
      token: ShapeRenderer,
      named: named
    },
    useClass: builderClazz
  });
}
var containerModule = Module(function (register) {
  bindFunc = register;
  register(RenderHelper);
  register(TexturePool);
  register(LightPool);
  register(GlyphManager);
  register(PickingIdGenerator);
  register(BatchManager);
  register(RenderGraphPlugin);
  register(PickingPlugin);
  register(SDFMesh);
  register(InstancedLineMesh);
  register(LineMesh);
  register(FillMesh);
  register(ImageMesh);
  register(TextMesh);
  register(MeshMesh);
  register({
    token: MeshFactory,
    useFactory: function useFactory(context) {
      return function (tagName) {
        if (context.container.isBound(tagName)) {
          return context.container.get(tagName) || null;
        }

        return null;
      };
    }
  });
  /**
   * bind model builder for each kind of Shape
   */

  register(CircleRenderer);
  register(PathRenderer);
  register(ImageRenderer);
  register(LineRenderer);
  register(TextRenderer);
  register(MeshRenderer); // register(GroupRenderer);

  register({
    token: RendererFactory,
    useFactory: function useFactory(context) {
      return function (tagName) {
        if (context.container.isBoundNamed(ShapeRenderer, tagName)) {
          return context.container.getNamed(ShapeRenderer, tagName) || null;
        }

        return null;
      };
    }
  });
});
var Plugin = /*#__PURE__*/function () {
  function Plugin(options) {
    _classCallCheck(this, Plugin);

    this.options = void 0;
    this.container = void 0;
    this.options = options;
  }

  _createClass(Plugin, [{
    key: "init",
    value: function init(container) {
      globalContainer.register(MeshUpdater);
      this.container = container;
      container.register({
        token: WebGLRendererPluginOptions,
        useValue: _objectSpread2({
          targets: [// 'webgpu',
          'webgl2', 'webgl1']
        }, this.options)
      });
      container.load(containerModule, true);
    }
  }, {
    key: "destroy",
    value: function destroy(container) {
      globalContainer.remove(MeshUpdater);
      container.remove(WebGLRendererPluginOptions);
      container.unload(containerModule);
    }
  }, {
    key: "getDevice",
    value: function getDevice() {
      return this.container.get(RenderGraphPlugin).getDevice();
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(src, descriptor, successCallback) {
      return this.container.get(RenderGraphPlugin).loadTexture(src, descriptor, successCallback);
    }
  }]);

  return Plugin;
}();

export { Batch, BlendFactor, BlendMode, BufferFrequencyHint, BufferGeometry, BufferUsage, ChannelWriteMask, ClipSpaceNearZ, CompareMode, CullMode, DeviceProgram, DynamicUniformBuffer, FillMesh, Fog, FogType, Format, FormatCompFlags, FormatFlags, FormatTypeFlags, FrontFaceMode, GL, GPUMapMode, GPUTextureUsage, HashMap, ImageMesh, Instanced, InstancedLineMesh, JOINT_TYPE, Light, LineMesh, Material, Mesh, MeshMesh, MipFilterMode, Plugin, PrimitiveTopology, QueryPoolType, RenderCache, RenderGraphPlugin, RenderHelper, RenderInst, RenderInstExecutionOrder, RenderInstFlags, RenderInstList, RenderInstManager, Renderable3D, RendererLayer, ResourceType, SDFMesh, SamplerFormatKind, ShaderMaterial, StencilOp, TexFilterMode, TextMesh, TextUniform, TextureDimension, TextureMapping, TexturePool, TextureUsage, Uniform, VertexAttributeBufferIndex, VertexAttributeLocation, VertexBufferFrequency, ViewportOrigin, WebGLRendererPluginOptions, WrapMode, containerModule, fillColor, fillMatrix4x4, fillVec3v, fillVec4, fillVec4v, getFormatByteSize, getFormatCompByteSize, getFormatCompFlags, getFormatCompFlagsComponentCount, getFormatComponentCount, getFormatFlags, getFormatSamplerKind, getFormatTypeFlags, getFormatTypeFlagsByteSize, getSortKeyDepth, getSortKeyLayer, hashCodeNumberFinish, hashCodeNumberUpdate, makeDepthKey, makeFormat, makeSortKey, makeSortKeyOpaque, makeSortKeyTranslucent, makeStaticDataBuffer, makeTextureDescriptor2D, nullHashFunc, projectionMatrixConvertClipSpaceNearZ, registerModelBuilder, renderInstCompareNone, renderInstCompareSortKey, segmentInstanceGeometry, setFormatComponentCount, setFormatFlags, setSortKeyBias, setSortKeyDepth, setSortKeyDepthKey, setSortKeyLayer, setSortKeyOpaqueDepth, setSortKeyProgramKey, setSortKeyTranslucentDepth, updateBuffer };
